package com.starparty.app.astro0.readers

import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.UMS
import com.starparty.app.astro0.UMSStar
import com.starparty.app.astro0.celestialobjects.Star

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
object StarReader {
    /** Column numbers in star data file.  */
    internal const val RA = 0
    internal const val DEC = 1
    internal const val CON = 2
    internal const val FLAMBAY = 3
    internal const val VMAG = 4
    internal const val BV = 5
    internal const val SPEC = 6
    internal const val NAME = 7
    internal const val SEPARATOR = '|'
    fun makeStars(time: SP_Time /*, InputStream is*/): Array<Star> {
        val starsTemp: ArrayList<Star> = createStars(time /*, is*/)
        return starsTemp.toTypedArray()
    }

    internal fun createStars(time: SP_Time /*, InputStream is*/): ArrayList<Star> {
    //    val filename: String = SkyRenderer.Companion.starDataFileName
        val stars: ArrayList<Star> = ArrayList()
        var line: String? = null
        /*
    try
    {
      BufferedReader br = new BufferedReader(new InputStreamReader(is));

      // While the BufferedReader readLine is not null
      while ((line = br.readLine()) != null) {

        if ((line != null) &&
                (line.length() > 0))
        {
          stars.add(createStar(line, time));
        }
      }

      // Close the InputStream and BufferedReader
      is.close();
      br.close();

    } catch (IOException e) {
      e.printStackTrace();
    }
*/
        for (l in mlines.indices) {
            line = mlines[l]
            stars.add(createStar(line, time, l))
        }
        return stars
    }

    internal fun createStar(data: String, time: SP_Time, listOrderNumber: Int): Star {
        val columns = breakIntoColumns(data)
        val ra: UMS = UMS.parseUMSStringToUMS(columns[RA])
        val dec: UMS = UMS.parseUMSStringToUMS(columns[DEC])
        val visMag = columns[VMAG].toDouble()
        val conNum = columns[CON].toInt()
        val bayFlam = splitFlamBay(columns[FLAMBAY])
        val bayer = bayFlam[0]
        val flamNum = bayFlam[1]
        val spec = columns[SPEC]
        val DEFAULT_BV = 0.0
        var bv = DEFAULT_BV
        if (!columns[BV].endsWith(" ")) {
            bv = columns[BV].toDouble()
        }

        var name = "star"
        if (columns.size == NAME + 1) { // Check if star has a name.
            name = columns[NAME]
        }

       // val bayerUnicode = bayerDesignationToUnicode(bayer)

        return UMSStar(time, ra, dec, conNum, bayer, flamNum, visMag, bv, spec, name/* +listOrderNumber*/)
    }

    internal fun bayerDesignationToUnicode(bayerDesig: String): String {

        val letter = StringBuilder()
        val number = StringBuilder()

        for (i in 0..bayerDesig.length-1) {
            var c: String = bayerDesig[i].toString()

            if (c.toIntOrNull() == null) {
                letter.append(c)
            } else {
                number.append(c)
            }
        }

        val letterString = letter.toString().toLowerCase()
        var unicode = ""

        unicode = when (letterString) {
            "" -> ""
            "alp" -> "α" // "\u03b1"
            "bet" -> "β" // "\u03b2"
            "gam" -> "γ" // "\u03b3"
            "del" -> "δ" // "\u03b4"
            "eps" -> "ε" // "\u03b5"
            "zet" -> "ζ" // "\u03b6"
            "eta" -> "η" // "\u03b7"
            "the" -> "θ" // "\u03b8"
            "iot" -> "ι" // "\u03b9"
            "kap" -> "κ" // "\u03ba"
            "lam" -> "λ" // "\u03bb"
            "mu"  -> "μ" // "\u03bc"
            "nu"  -> "ν" // "\u03bd"
            "xi"  -> "ξ" // "\u03be"
            "omi" -> "ο" // "\u03bf"
            "pi"  -> "π" // "\u03c0"
            "rho" -> "ρ" // "\u03c1"
            "sig" -> "σ" // "\u03c3"
            "tau" -> "τ" // "\u03c4"
            "ups" -> "υ" // "\u03c5"
            "phi" -> "φ" // "\u03c6"
            "chi" -> "χ" // "\u03c7"
            "psi" -> "ψ" // "\u03c8"
            "ome" -> "ω" // "\u03c9"
            else -> "error"
        }

        if (unicode == "error"){
            println(" NOT RECOGNISED:" + letter)
        }

        val bayerUnicode = unicode + number

        return bayerUnicode
    }

    internal fun splitFlamBay(flamBay: String): Array<String> {
        var flam = StringBuilder()
        var bay = StringBuilder()

        var isFlam = true
        for (i in 0..flamBay.length-1){
            var c:String = flamBay[i].toString()

            if (isFlam == true && c.toIntOrNull() != null){
                flam.append(c)
            }
            else {
                isFlam = false
                bay.append(c)
            }
        }

        //    console.log(" bay:"+bay+" flam:"+flam)

        return arrayOf(bay.toString(), flam.toString())
    }

    internal fun breakIntoColumns(data: String): Array<String> {

        val columns = data.split(SEPARATOR).toTypedArray()

        return columns
    }

    private val mlines = // todo figure out what's going on with first constellation, below.
        arrayOf( // N.B Not Andromeda. Should be constellation 1 not 0.
            /*          "10:27:9.1|-31:4:4|0||α|4.25|1.45|K4III|",
          "9:29:14.7|-35:57:5|0|ε|4.51|1.44|K3IIIa|",
          "10:56:43.1|-37:8:16|0|ι|4.6|1.03|K1III|",
          "9:44:12.1|-27:46:10|0|θ|4.79|0.51|A8V+F7II-III|",
          "9:58:52.3|-35:53:28|0|η|5.23|0.31|F1III-IV|",
          "10:29:35.4|-30:36:26|0|δ|5.56|-0.04|B9.5V|",
          "9:31:32.2|-31:52:19|0|ζ2|5.93|0.26|A9IV|",
          "9:30:46.1|-31:53:22|0|ζ1|6.18|0.03|A0V|",
          "9:30:45.4|-31:53:29|0|ζ1|7.0|0.09|A2V|"};
*/
            "6:45:8.9|-16:42:58|13|9α|-1.46|0.0|A1Vm|Sirius",
            "6:23:57.1|-52:41:45|16|α|-0.72|0.15|F0II|Canopus",
            "14:15:39.7|19:10:57|8|16α|-0.04|1.23|K1.5IIIFe-0.5|Arcturus",
            "14:39:35.9|-60:50:7|18|α1|-0.01|0.71|G2V|Alpha Centauri",
            "18:36:56.3|38:47:1|51|3α|0.03|0.0|A0Va|Vega",
            "5:16:41.4|45:59:53|7|13α|0.08|0.8|G5IIIe+G0III|Capella",
            "5:14:32.3|-8:12:6|59|19β|0.12|-0.03|B8Ia:|Rigel",
            "7:39:18.1|5:13:30|14|10α|0.38|0.42|F5IV-V|Procyon",
            "1:37:42.9|-57:14:12|35|α|0.46|-0.16|B3Vpe|Achernar",
            "5:55:10.3|7:24:25|59|58α|0.5|1.85|M1-2Ia-Iab|Betelgeuse",
            "14:3:49.4|-60:22:23|18|β|0.61|-0.23|B1III|Hadar",
            "19:50:47.0|8:52:6|4|53α|0.77|0.22|A7V|Altair",
            "4:35:55.2|16:30:33|77|87α|0.85|1.54|K5+III|Aldebaran",
            "16:29:24.4|-26:25:55|72|21α|0.96|1.83|M1.5Iab-Ib+B4Ve|Antares",
            "13:25:11.6|-11:9:41|85|67α|0.98|-0.23|B1III-IV+B2V|Spica",
            "7:45:18.9|28:1:34|37|78β|1.14|1.0|K0IIIb|Pollux",
            "22:57:39.1|-29:37:20|66|24α|1.16|0.09|A3V|Fomalhaut",
            "12:47:43.2|-59:41:19|29|β|1.25|-0.23|B0.5III|Mimosa",
            "20:41:25.9|45:16:49|30|50α|1.25|0.09|A2Ia|Deneb",
            "12:26:35.9|-63:5:57|29|α1|1.33|-0.24|B0.5IV|Acrux",
            "14:39:36.1|-60:50:8|18|α2|1.33|0.88|K1V|",
            "10:8:22.3|11:58:2|45|32α|1.35|-0.11|B7V|Regulus",
            "6:58:37.5|-28:58:20|13|21ε|1.5|-0.21|B2II|Adhara",
            "12:31:9.9|-57:6:48|29|γ|1.63|1.59|M3.5III|Gacrux",
            "17:33:36.5|-37:6:14|72|35λ|1.63|-0.22|B2IV+B|Shaula",
            "5:25:7.9|6:20:59|59|24γ|1.64|-0.22|B2III|Bellatrix",
            "5:26:17.5|28:36:27|77|112β|1.65|-0.13|B7III|Elnath",
            "9:13:12.0|-69:43:2|16|β|1.68|0.0|A2IV|Miaplacidus",
            "5:36:12.8|-1:12:6.9|59|46ε|1.7|-0.19|B0Ia|Alnilam",
            "12:26:36.5|-63:5:58|29|α2|1.73|-0.26|B1V|",
            "22:8:14.0|-46:57:40|38|α|1.74|-0.13|B7IV|Alnair",
            "12:54:1.7|55:57:35|82|77ε|1.77|-0.02|A0pCr|Alioth",
            "8:9:32.0|-47:20:12|84|γ2|1.78|-0.22|WC8+O9I|Regor",
            "3:24:19.4|49:51:40|62|33α|1.79|0.48|F5Ib|Mirfak",
            "11:3:43.7|61:45:3|82|50α|1.79|1.07|K0IIIa|Dubhe",
            "7:8:23.5|-26:23:36|13|25δ|1.84|0.68|F8Ia|Wezen",
            "18:24:10.3|-34:23:5|71|20ε|1.85|-0.03|B9.5III|Kaus Australis",
            "8:22:30.8|-59:30:35|16|ε|1.86|1.28|K3III+B2:V|Avior",
            "13:47:32.4|49:18:48|82|85η|1.86|-0.19|B3V|Alkaid",
            "17:37:19.2|-42:59:52|72|θ|1.87|0.4|F1II|Sargas",
            "5:59:31.7|44:56:51|7|34β|1.9|0.03|A2IV|Menkalinan",
            "16:48:39.9|-69:1:40|80|α|1.92|1.44|K2IIb-IIIa|Atria",
            "6:37:42.7|16:23:57|37|24γ|1.93|0.0|A0IV|Alhena",
            "20:25:38.9|-56:44:6|60|α|1.94|-0.2|B2IV|Peacock",
            "8:44:42.2|-54:42:30|84|δ|1.96|0.04|A1V|Alsephina",
            "6:22:42.0|-17:57:21|13|2β|1.98|-0.23|B1II-III|Mirzam",
            "7:34:36.0|31:53:18|37|66α|1.98|0.03|A1V|Castor",
            "9:27:35.2|-8:39:31|41|30α|1.98|1.44|K3II-III|Alphard",
            "2:7:10.4|23:27:45|6|13α|2.0|1.15|K2-IIICa-1|Hamal",
            "15:59:30.2|25:55:13|-1||2.0|0.1|sdBe+gM3+Q|",
            "2:31:48.7|89:15:51|83|1α|2.02|0.6|F7:Ib-II|Polaris",
            "18:55:15.9|-26:17:48|71|34σ|2.02|-0.22|B2.5V|Nunki",
            "0:43:35.4|-17:59:12|20|16β|2.04|1.02|G9.5IIICH-1|Diphda",
            "5:40:45.5|-1:56:34|59|50ζ|2.05|-0.21|O9.7Ib|Alnitak",
            "0:8:23.3|29:5:26|0|21α|2.06|-0.11|B8IVpMnHg|Alpheratz",
            "1:9:43.9|35:37:14|0|43β|2.06|1.58|M0+IIIa|Mirach",
            "5:47:45.4|-9:40:11|59|53κ|2.06|-0.17|B0.5Ia|Saiph",
            "14:6:41.0|-36:22:12|18|5θ|2.06|1.01|K0-IIIb|Menkent",
            "14:50:42.3|74:9:20|83|7β|2.08|1.47|K4-III|Kochab",
            "17:34:56.1|12:33:36|58|55α|2.08|0.15|A5III|Rasalhague",
            "22:42:40.1|-46:53:5|38|β|2.1|1.6|M5III|Tiaki",
            "3:8:10.1|40:57:20|62|26β|2.12|-0.05|B8V|Algol",
            "11:49:3.6|14:34:19|45|94β|2.14|0.09|A3V|Denebola",
            "12:41:31.0|-48:57:35|18|γ|2.17|-0.01|A1IV|Muhlifain",
            "20:22:13.7|40:15:24|30|37γ|2.2|0.68|F8Ib|Sadr",
            "9:7:59.8|-43:25:57|84|λ|2.21|1.66|K4.5Ib-II|Suhail",
            "0:40:30.5|56:32:14|17|18α|2.23|1.17|K0IIIa|Schedar",
            "5:32:0.4|-0:17:57|59|34δ|2.23|-0.22|O9.5II|Mintaka",
            "15:34:41.3|26:42:53|26|5α|2.23|-0.02|A0V+G5V|Alphecca",
            "17:56:36.4|51:29:20|33|33γ|2.23|1.52|K5III|Eltanin",
            "2:3:54.0|42:19:47|0|57γ1|2.26|1.37|K3-IIb|Almach",
            "8:3:35.1|-40:0:12|67|ζ|2.25|-0.26|O5f|Naos",
            "9:17:5.4|-59:16:31|16|ι|2.25|0.18|A8Ib|Aspidiske",
            "0:9:10.7|59:8:59|17|11β|2.27|0.34|F2III-IV|Caph",
            "13:23:55.5|54:55:31|82|79ζ|2.27|0.02|A1VpSrSi|Mizar",
            "16:50:9.8|-34:17:36|72|26ε|2.29|1.15|K2.5III|Larawag",
            "13:39:53.2|-53:27:59|18|ε|2.3|-0.22|B1III|",
            "14:41:55.8|-47:23:18|49|α|2.3|-0.2|B1.5III/Vn|",
            "14:35:30.4|-42:9:28|18|η|2.31|-0.19|B1.5Vne|",
            "16:0:20.0|-22:37:18|72|7δ|2.32|-0.12|B0.3IV|Dschubba",
            "11:1:50.5|56:22:57|82|48β|2.37|-0.02|A1V|Merak",
            "0:26:17.0|-42:18:22|63|α|2.39|1.09|K0III|Ankaa",
            "21:44:11.2|9:52:30|61|8ε|2.39|1.53|K2Ib|Enif",
            "17:42:29.3|-39:1:48|72|κ|2.41|-0.22|B1.5III|Girtab",
            "23:3:46.5|28:4:58|61|53β|2.42|1.67|M2.5II-III|Scheat",
            "17:10:22.7|-15:43:29|58|35η|2.43|0.06|A2V|Sabik",
            "11:53:49.8|53:41:41|82|64γ|2.44|0.0|A0Ve|Phecda",
            "21:18:34.8|62:35:8|19|5α|2.44|0.22|A7V|",
            "7:24:5.7|-29:18:11|13|31η|2.45|-0.08|B5Ia|Aludra",
            "20:46:12.7|33:58:13|30|53ε|2.46|1.03|K0-III|Aljanah",
            "0:56:42.5|60:43:0|17|27γ|2.47|-0.15|B0IVe|Navi",
            "23:4:45.7|15:12:19|61|54α|2.49|-0.04|B9V|Markab",
            "9:22:6.8|-55:0:39|84|κ|2.5|-0.18|B2IV-V|Markeb",
            "3:2:16.8|4:5:23|20|92α|2.53|1.64|M1.5IIIa|",
            "13:55:32.4|-47:17:18|18|ζ|2.55|-0.22|B2.5IV|",
            "11:14:6.5|20:31:25|45|68δ|2.56|0.12|A4V|",
            "16:37:9.5|-10:34:2|58|13ζ|2.56|0.02|O9.5Vn|",
            "5:32:43.8|-17:49:20|47|11α|2.58|0.21|F0Ib|",
            "12:15:48.4|-17:32:31|27|4γ|2.59|-0.11|B8IIIpHgMn|",
            "12:8:21.5|-50:43:21|18|δ|2.6|-0.12|B2IVne|",
            "19:2:36.7|-29:52:49|71|38ζ|2.6|0.08|A2III+A4IV|",
            "10:19:58.3|19:50:30|45|41γ1|2.61|1.15|K1-IIIbFe-0.5|Algieba",
            "15:17:0.4|-9:22:59|48|27β|2.61|-0.11|B8V|",
            "5:59:43.3|37:12:45|7|37θ|2.62|-0.08|A0pSi|",
            "16:5:26.2|-19:48:20|72|8β1|2.62|-0.07|B1V|Acrab",
            "1:54:38.4|20:48:29|6|6β|2.64|0.13|A5V|",
            "5:39:38.9|-34:4:27|23|α|2.64|-0.12|B7IVe|",
            "12:34:23.2|-23:23:48|27|9β|2.65|0.89|G5II|",
            "15:44:16.1|6:25:32|75|24α|2.65|1.17|K2IIIbCN1|",
            "1:25:49.0|60:14:7|17|37δ|2.68|0.13|A5III-IV|",
            "13:54:41.1|18:23:52|8|8η|2.68|0.58|G0IV|",
            "14:58:31.9|-43:8:2|49|β|2.68|-0.22|B2III/IV|",
            "4:56:59.6|33:9:58|7|3ι|2.69|1.53|K3II|",
            "10:46:46.2|-49:25:12|84|μ|2.69|0.9|G5III+G2V|",
            "12:37:11.0|-69:8:8|55|α|2.69|-0.2|B2IV-V|",
            "17:30:45.8|-37:17:45|72|34υ|2.69|-0.22|B2IV|",
            "7:17:8.6|-37:5:51|67|π|2.7|1.62|K3Ib|",
            "14:44:59.2|27:4:27|8|36ε|2.7|0.97|K0-II-III|Izar",
            "18:20:59.7|-29:49:41|71|19δ|2.7|1.38|K3-IIIa*|",
            "19:46:15.6|10:36:48|4|50γ|2.72|1.52|K3II|",
            "16:14:20.7|-3:41:40|58|1δ|2.74|1.58|M0.5III|",
            "16:23:59.5|61:30:51|33|14η|2.74|0.91|G8-IIIab|",
            "10:42:57.4|-64:23:40|16|θ|2.76|-0.22|B0Vp|",
            "13:20:35.8|-36:42:44|18|ι|2.75|0.04|A2V|",
            "14:50:52.7|-16:2:30|48|9α2|2.75|0.15|A3IV|",
            "5:35:26.0|-5:54:36|59|44ι|2.77|-0.24|O9III|",
            "16:30:13.2|21:29:23|39|27β|2.77|0.94|G7IIIa|",
            "17:43:28.4|4:34:2|58|60β|2.77|1.16|K2III|",
            "15:35:8.5|-41:10:1|49|γ|2.78|-0.2|B2IV|",
            "5:7:51.0|-5:5:11|35|67β|2.79|0.13|A3III|",
            "17:30:26.0|52:18:5|33|23β|2.79|0.98|G2Ib-IIa|",
            "0:25:45.1|-77:15:15|42|β|2.8|0.62|G2IV|",
            "12:15:8.7|-58:44:56|29|δ|2.8|-0.23|B2IV|",
            "8:7:32.6|-24:18:15|67|15ρ|2.81|0.43|F6IIpDelDel|",
            "16:41:17.2|31:36:11|39|40ζ|2.81|0.65|G0IV|",
            "18:27:58.2|-25:25:18|71|22λ|2.81|1.04|K1+IIIb|",
            "16:35:53.0|-28:12:58|72|23τ|2.82|-0.25|B0V|",
            "0:13:14.2|15:11:1|61|88γ|2.83|-0.23|B2IV|",
            "13:2:10.6|10:57:33|85|47ε|2.83|0.94|G8IIIab|",
            "5:28:14.7|-20:45:34|47|9β|2.84|0.82|G5II|",
            "3:54:7.9|31:53:1|62|44ζ|2.85|0.12|B1Ib|",
            "15:55:8.5|-63:25:50|80|β|2.85|0.29|F2III|",
            "17:25:18.0|-55:31:48|5|β|2.85|1.46|K3Ib-IIa|",
            "1:58:46.2|-61:34:11|42|α|2.86|0.28|F0V|",
            "22:18:30.1|-60:15:35|81|α|2.86|1.39|K3III|",
            "3:47:29.1|24:6:18|77|25η|2.87|-0.09|B7IIIe|",
            "19:44:58.5|45:7:51|30|18δ|2.87|-0.03|B9.5IV+F1V|",
            "21:47:2.4|-16:7:38|15|49δ|2.87|0.29|Am|",
            "6:22:57.6|22:30:49|37|13μ|2.88|1.64|M3IIIab|",
            "7:34:36.0|31:53:19|37|66α|2.88|0.04|A2Vm|",
            "3:57:51.2|40:0:37|62|45ε|2.89|-0.18|B0.5V+A2V|",
            "15:18:54.6|-68:40:46|80|γ|2.89|0.0|A1V|",
            "15:58:51.1|-26:6:51|72|6π|2.89|-0.19|B1V+B2V|",
            "16:21:11.3|-25:35:34|72|20σ|2.89|0.13|B1III|",
            "19:9:45.8|-21:1:25|71|41π|2.89|0.35|F2II|",
            "7:27:9.0|8:17:22|14|3β|2.9|-0.09|B8Ve|",
            "12:56:1.7|38:19:6|12|12α2|2.9|-0.12|A0pSiEuHg|",
            "21:31:33.5|-5:34:16|3|22β|2.91|0.83|G0Ib|",
            "3:4:47.8|53:30:23|62|23γ|2.93|0.7|G8III+A2V|",
            "6:49:56.2|-50:36:53|67|τ|2.93|1.2|K1III|",
            "22:43:0.1|30:13:17|61|44η|2.94|0.86|G2II-III+F0V|",
            "3:58:1.8|-13:30:31|35|34γ|2.95|1.59|M0.5IIICa-1Cr-1|",
            "12:29:51.9|-16:30:56|27|7δ|2.95|-0.05|B9.5V|",
            "17:31:50.5|-49:52:34|5|α|2.95|-0.17|B2Vne|",
            "22:5:47.0|0:19:11|3|34α|2.96|0.98|G2Ib|",
            "6:43:55.9|25:7:52|37|27ε|2.98|1.4|G8Ib|",
            "9:45:51.1|23:46:27|45|17ε|2.98|0.8|G1II|",
            "5:1:58.1|43:49:24|7|7ε|2.99|0.54|F0Iae+B|",
            "18:5:48.5|-30:25:27|71|10γ2|2.99|1.0|K0III|",
            "19:5:24.6|13:51:48|4|17ζ|2.99|0.01|A0Vn|",
            "2:9:32.6|34:59:14|79|4β|3.0|0.14|A5III|",
            "3:42:55.5|47:47:15|62|39δ|3.01|-0.13|B5IIIe|",
            "5:37:38.7|21:8:33|77|123ζ|3.0|-0.19|B4IIIpe|",
            "9:47:6.1|-65:4:19|16|υ|3.01|0.28|A6Ib|",
            "11:9:39.8|44:29:55|82|52ψ|3.01|1.14|K1III|",
            "12:10:7.5|-22:37:11|27|2ε|3.0|1.33|K2.5IIIaBa0.2:|",
            "13:18:55.3|-23:10:18|41|46γ|3.0|0.92|G8-IIIa|",
            "21:53:55.7|-37:21:54|38|γ|3.01|-0.12|B8III|",
            "6:20:18.8|-30:3:48|13|1ζ|3.02|-0.19|B2.5V|",
            "7:3:1.5|-23:50:0|13|24ο2|3.02|-0.08|B3Iab|",
            "14:32:4.7|38:18:30|8|27γ|3.03|0.19|A7III|",
            "17:47:35.1|-40:7:37|72|ι1|3.03|0.51|F2Iae|",
            "2:19:20.7|-2:58:39|20|68ο|3.04|1.42|M7IIIe+Bep|",
            "13:49:37.0|-42:28:26|18|μ|3.04|-0.17|B2IV-Ve|",
            "10:22:19.7|41:29:58|82|34μ|3.05|1.59|M0III|",
            "12:46:16.9|-68:6:29|55|β|3.05|-0.18|B2.5V|",
            "15:20:43.7|71:50:2|83|13γ|3.05|0.05|A3II-III|",
            "19:12:33.3|67:39:42|33|57δ|3.07|1.0|G9III|",
            "16:51:52.2|-38:2:51|72|μ1|3.08|-0.2|B1.5V+B6.5V|",
            "19:30:43.3|27:57:35|30|6β1|3.08|1.13|K3II+B9.5V|",
            "20:21:0.7|-14:46:53|15|9β|3.08|0.79|F8V+A0|",
            "8:55:23.6|5:56:44|41|16ζ|3.11|1.0|G9II-III|",
            "10:49:37.5|-16:11:37|41|ν|3.11|1.25|K2III|",
            "18:17:37.6|-36:45:42|71|η|3.11|1.56|M3.5III|",
            "20:37:34.0|-47:17:29|43|α|3.11|1.0|K0IIICNIII-IV|",
            "5:50:57.6|-35:46:6|23|β|3.12|1.16|K2III|",
            "9:21:3.3|34:23:33|50|40α|3.13|1.55|K7IIIab|",
            "9:31:13.3|-57:2:4|-1||3.13|1.55|K5III|",
            "11:35:46.8|-63:1:11|18|λ|3.13|-0.04|B9III|",
            "14:59:9.7|-42:6:15|18|κ|3.13|-0.2|B2IV|",
            "16:58:37.2|-55:59:25|5|ζ|3.13|1.6|K3III|",
            "8:59:12.4|48:2:30|82|9ι|3.14|0.19|A7IV|",
            "17:15:1.9|24:50:21|39|65δ|3.14|0.08|A3IV|",
            "17:15:2.8|36:48:33|39|67π|3.16|1.44|K3IIab|",
            "5:6:30.9|41:14:4|7|10η|3.17|-0.18|B3V|",
            "6:37:45.7|-43:11:46|67|ν|3.17|-0.11|B8III|",
            "9:32:51.4|51:40:38|82|25θ|3.17|0.46|F6IV|",
            "17:8:47.2|65:42:53|33|22ζ|3.17|-0.12|B6III|",
            "18:45:39.4|-26:59:27|71|27φ|3.17|-0.11|B8III|",
            "4:49:50.4|6:57:41|59|1π3|3.19|0.45|F6V|",
            "5:5:27.7|-22:22:16|47|2ε|3.19|1.46|K5III|",
            "14:42:30.4|-64:58:31|22|α|3.19|0.24|ApSrEuCr:|",
            "16:57:40.1|9:22:30|58|27κ|3.2|1.15|K2III|",
            "21:12:56.2|30:13:37|30|64ζ|3.2|0.99|G8+III-IIIaBa0.6|",
            "17:49:51.5|-37:2:36|-1||3.21|1.17|K2III|",
            "23:39:20.8|77:37:57|19|35γ|3.21|1.03|K1III-IV|",
            "15:21:22.3|-40:38:51|49|δ|3.22|-0.22|B1.5IV|",
            "20:11:18.3|0:49:17|4|65θ|3.23|-0.07|B9.5III|",
            "21:28:39.6|70:33:39|19|8β|3.23|-0.22|B1IV|",
            "2:58:15.7|-40:18:17|35|θ1|3.24|0.14|A4III|",
            "3:47:14.3|-74:14:20|42|γ|3.24|1.62|M2III|",
            "16:18:19.3|-4:41:33|58|2ε|3.24|0.96|G9.5IIIbFe-0.5|",
            "18:58:56.6|32:41:22|51|14γ|3.24|-0.05|B9III|",
            "7:29:13.8|-43:18:5|67|σ|3.25|1.51|K5III|",
            "18:21:18.6|-2:53:56|75|58η|3.26|0.94|K0III-IV|",
            "0:39:19.7|30:51:39|0|31δ|3.27|1.28|K3III|",
            "4:33:59.8|-55:2:42|32|α|3.27|-0.1|A0IIISi|",
            "6:48:11.4|-61:56:29|64|α|3.27|0.21|A7IV|",
            "14:6:22.3|-26:40:57|41|49π|3.27|1.12|K2-III-IIIbFe-0.5|",
            "17:22:0.6|-24:59:58|58|42θ|3.27|-0.22|B2IV|",
            "22:54:39.0|-15:49:15|3|76δ|3.27|0.05|A3V|",
            "6:14:52.6|22:30:24|37|7η|3.28|1.6|M3III|",
            "15:4:4.2|-25:16:55|48|20σ|3.29|1.7|M3-III|",
            "15:24:55.8|58:57:58|33|12ι|3.29|1.16|K2III|",
            "1:6:5.0|-46:43:7|63|β|3.31|0.89|G8III|",
            "5:12:55.9|-16:12:20|47|5μ|3.31|-0.11|B9IIIpHgMn|",
            "12:15:25.6|57:1:57|82|69δ|3.31|0.08|A3V|",
            "10:13:44.2|-70:2:17|16|ω|3.32|-0.08|B8III|",
            "10:32:1.4|-61:41:7|-1||3.32|-0.09|B4Vne|",
            "19:6:56.4|-27:40:14|71|40τ|3.32|1.19|K1+IIIb|",
            "17:12:9.2|-43:14:21|72|η|3.33|0.41|F3III-IVp|",
            "7:49:17.7|-24:51:35|67|7ξ|3.34|1.24|G6Iab-Ib|",
            "11:14:14.4|15:25:46|45|70θ|3.34|-0.01|A2V|",
            "17:25:23.6|-56:22:39|5|γ|3.34|-0.13|B1Ib|",
            "17:59:1.6|-9:46:25|58|64ν|3.34|0.99|K0IIIaCN-1|",
            "4:14:25.5|-62:28:26|69|α|3.35|0.91|G8II-III|",
            "22:10:51.3|58:12:4|19|21ζ|3.35|1.57|K1.5Ib|",
            "5:24:28.6|-2:23:49|59|28η|3.36|-0.17|B1V+B2e|",
            "6:45:17.4|12:53:44|37|31ξ|3.36|0.43|F5III|",
            "8:30:15.9|60:43:5|82|1ο|3.36|0.84|G5III|",
            "19:25:29.9|3:6:53|4|30δ|3.36|0.32|F3IV|",
            "13:34:41.6|0:35:45|85|79ζ|3.37|0.11|A3V|",
            "15:22:40.9|-44:41:22|49|ε|3.37|-0.18|B2IV-V|",
            "1:54:23.7|63:40:12|17|45ε|3.38|-0.15|B3III|",
            "8:46:46.6|6:25:8|41|11ε|3.38|0.68|G5III|",
            "12:55:36.2|3:23:51|85|43δ|3.38|1.58|M3+III|",
            "3:5:10.6|38:50:25|62|25ρ|3.39|1.65|M4II|",
            "4:28:39.7|15:52:15|77|78θ2|3.4|0.18|A7III|",
            "10:17:5.0|-61:19:56|-1||3.4|1.54|K3IIa|",
            "22:41:27.7|10:49:53|61|42ζ|3.4|-0.09|B8V|",
            "1:28:21.9|-43:19:6|63|γ|3.41|1.57|M0-IIIa|",
            "1:53:4.9|29:34:44|79|2α|3.41|0.49|F6IV|",
            "13:49:30.3|-41:41:16|18|ν|3.41|-0.22|B2IV|",
            "15:12:17.1|-52:5:57|49|ζ|3.41|0.92|G8III|",
            "16:0:7.3|-38:23:49|49|η|3.41|-0.22|B2.5IV|",
            "17:46:27.5|27:43:14|39|86μ|3.42|0.75|G5IV|",
            "20:44:57.5|-66:12:11|60|β|3.42|0.16|A7III|",
            "20:45:17.4|61:50:20|19|3η|3.43|0.92|K0IV|",
            "0:49:6.0|57:48:57|17|24η|3.44|0.57|F9V+dM0|",
            "9:10:58.0|-58:58:1|-1||3.44|-0.19|B2IV-V|",
            "10:16:41.4|23:25:2|45|36ζ|3.44|0.31|F0III|",
            "19:6:14.9|-4:52:57|4|16λ|3.44|-0.09|B9Vn|",
            "1:8:35.4|-10:10:56|20|31η|3.45|1.16|K1.5IIICN1Fe0.5|",
            "10:17:5.8|42:54:52|82|33λ|3.45|0.03|A2IV|",
            "18:50:4.8|33:21:46|51|10β|3.45|0.0|B8IIpe|",
            "2:43:18.0|3:14:9|20|86γ|3.47|0.09|A3V|",
            "4:0:40.8|12:29:25|77|35λ|3.47|-0.12|B3V+A4IV|",
            "7:1:43.1|-27:56:5|13|22σ|3.47|1.73|K7Ib|",
            "7:56:46.7|-52:58:56|16|χ|3.47|-0.18|B3IVp|",
            "15:15:30.2|33:18:53|8|49δ|3.47|0.95|G8IIIFe-1|",
            "19:58:45.4|19:29:32|70|12γ|3.47|1.57|M0-III|",
            "11:18:28.7|33:5:39|82|54ν|3.48|1.4|K3-IIIBa0.3|",
            "17:14:38.9|14:23:25|39|64α1|3.48|1.44|M5Ib-II|",
            "22:50:0.2|24:36:6|61|48μ|3.48|0.93|G8+III|",
            "22:48:33.3|-51:19:1|38|ε|3.49|0.08|A3V|",
            "1:44:4.1|-15:56:15|20|52τ|3.5|0.72|G8V|",
            "15:1:56.8|40:23:26|8|42β|3.5|0.97|G8IIIaBa0.3Fe-0.5|",
            "18:26:58.4|-45:58:6|78|α|3.51|-0.17|B3IV|",
            "18:57:43.8|-21:6:24|71|37ξ2|3.51|1.18|K1III|",
            "8:16:30.9|9:11:8|11|17β|3.52|1.48|K4IIIBa0.5|",
            "9:41:9.0|9:53:32|45|14ο|3.52|0.49|F6II+A1-5V|",
            "10:7:20.0|16:45:46|45|30η|3.52|-0.03|A0Ib|",
            "22:49:40.8|66:12:2|19|32ι|3.52|1.05|K0-III|",
            "4:28:37.0|19:10:49|77|74ε|3.53|1.01|G9.5IIICN0.5|",
            "7:20:7.4|21:58:56|37|55δ|3.53|0.34|F2IV|",
            "15:49:37.2|-3:25:49|75|32μ|3.53|-0.04|A0V|",
            "16:42:53.8|38:55:20|39|44η|3.53|0.92|G7.5IIIbFe-1|",
            "22:10:12.0|6:11:52|61|26θ|3.53|0.08|A2Vp|",
            "3:43:14.9|-9:45:48|35|23δ|3.54|0.92|K0+IV|",
            "5:35:8.3|9:56:3|59|39λ|3.54|-0.18|O8III((f))|",
            "9:56:51.8|-54:34:4|84|φ|3.54|-0.08|B5Ib|",
            "11:33:0.1|-31:51:28|41|ξ|3.54|0.94|G7III|",
            "17:37:35.2|-15:23:55|75|55ξ|3.54|0.26|F0IVDelSct|",
            "5:46:57.3|-14:49:19|47|14ζ|3.55|0.1|A3Vn|",
            "14:19:24.2|-46:3:28|49|ι|3.55|-0.18|B2.5IV|",
            "0:19:25.7|-8:49:26|20|8ι|3.56|1.22|K1.5III|",
            "2:16:30.6|-51:30:44|35|φ|3.56|-0.12|B8V-IV|",
            "4:17:53.7|-33:47:54|35|41υ4|3.56|-0.12|B9V|",
            "11:19:20.5|-14:46:43|28|12δ|3.56|1.12|G8III-IV|",
            "15:21:48.4|-36:15:41|49|φ1|3.56|1.54|K5III|",
            "20:8:43.6|-66:10:55|60|δ|3.56|0.76|G6-8IV|",
            "1:37:59.6|48:37:42|0|51|3.57|1.28|K3-III|",
            "7:44:26.8|24:23:53|37|77κ|3.57|0.93|G8IIIa|",
            "16:52:20.1|-38:1:3|72|μ2|3.57|-0.21|B2IV|",
            "18:21:3.4|72:43:58|33|44χ|3.57|0.49|F7V|",
            "20:18:3.3|-12:32:41|15|6α2|3.57|0.94|G8IIIb|",
            "7:18:5.6|16:32:25|37|54λ|3.58|0.11|A3V|",
            "14:31:49.8|30:22:17|8|25ρ|3.58|1.3|K3-III|",
            "15:37:1.5|-28:8:6|48|39υ|3.58|1.38|K3III|",
            "12:21:21.6|-60:24:4|29|ε|3.59|1.42|K3-4III|",
            "1:24:1.4|-8:11:0|20|45θ|3.6|1.06|K0III-IIIb|",
            "3:24:48.8|9:1:44|77|1ο|3.6|0.89|G6IIIFe-1|",
            "5:17:36.4|-6:50:40|59|20τ|3.6|-0.11|B5III|",
            "5:44:27.8|-22:26:54|47|13γ|3.6|0.47|F6V|",
            "6:52:47.3|33:57:40|37|34θ|3.6|0.1|A3III|",
            "9:3:37.5|47:9:24|82|12κ|3.6|0.0|A1Vn|",
            "9:30:42.0|-40:28:0|84|ψ|3.6|0.36|F3IV+F0IV|",
            "7:45:15.3|-37:58:7|-1||3.61|1.73|K2.5Ib-II|",
            "10:10:35.3|-12:21:15|41|41λ|3.61|1.01|K0IIICN1|",
            "11:50:41.7|1:45:53|85|5β|3.61|0.55|F9V|",
            "1:31:29.0|15:20:45|65|99η|3.62|0.97|G7IIIa|",
            "8:40:17.6|-52:55:19|-1||3.62|-0.18|B3IV|",
            "13:2:16.2|-71:32:56|55|δ|3.62|1.18|K2III|",
            "16:54:35.0|-42:21:41|72|ζ2|3.62|1.37|K4III|",
            "17:31:5.9|-60:41:2|5|δ|3.62|-0.1|B8Vn|",
            "17:45:44.0|-64:43:26|60|η|3.62|1.19|K2II|",
            "23:1:55.3|42:19:34|0|1ο|3.62|-0.09|B6IIIpe+A2p|",
            "2:49:59.0|27:15:38|6|41|3.63|-0.1|B8Vn|",
            "3:49:9.7|24:3:12|77|27|3.63|-0.09|B8III|",
            "20:37:33.0|14:35:43|31|6β|3.63|0.44|F5IV|",
            "11:45:36.4|-66:43:43|55|λ|3.64|0.16|A7III|",
            "4:19:47.6|15:37:39|77|54γ|3.65|0.99|K0-IIIabCN1|",
            "12:41:39.6|-1:26:58|85|29γ|3.65|0.36|F0V|",
            "14:4:23.3|64:22:33|33|11α|3.65|-0.05|A0III|",
            "20:54:48.6|-58:27:15|43|β|3.65|1.25|K1II|",
            "0:36:58.3|53:53:49|17|17ζ|3.66|-0.2|B2IV|",
            "15:38:39.4|-29:46:40|48|40τ|3.66|-0.17|B2.5V|",
            "18:6:37.9|-50:5:30|5|θ|3.66|-0.08|B2Ib|",
            "23:9:26.8|-21:10:21|3|88|3.66|1.22|K1III|",
            "9:31:31.7|63:3:43|82|23|3.67|0.33|F0IV|",
            "15:46:11.3|15:25:19|75|28β|3.67|0.06|A2IV|",
            "8:43:35.5|-33:11:11|68|α|3.68|-0.18|B1.5III|",
            "12:41:39.6|-1:26:58|85|29γ|3.68|0.0|F0V|",
            "15:27:49.7|29:6:21|26|3β|3.68|0.28|F0p|",
            "21:40:5.5|-16:39:44|15|40γ|3.68|0.32|F0p|",
            "3:19:31.0|-21:45:28|35|16τ4|3.69|1.62|M3.5IIIaCa-1|",
            "4:51:12.4|5:36:18|59|3π4|3.69|-0.17|B2III+B2IV|",
            "9:45:14.8|-62:30:28|-1||3.69|1.22|G5Iab-Ib|",
            "23:17:9.9|3:16:56|65|6γ|3.69|0.92|G9-III:Fe-2|",
            "1:55:57.5|-51:36:32|35|χ|3.7|0.85|G8IIIbCNIV|",
            "3:44:52.5|24:6:48|77|17|3.7|-0.11|B6III|",
            "17:57:45.9|29:14:52|39|92ξ|3.7|0.94|G8+III|",
            "5:56:24.3|-14:10:4|47|16η|3.71|0.33|F1III|",
            "11:46:3.0|47:46:46|82|63χ|3.71|1.18|K0.5IIIb|",
            "15:50:49.0|4:28:40|75|37ε|3.71|0.15|A2Vm|",
            "19:55:18.8|6:24:24|4|60β|3.71|0.86|G8IV|",
            "4:54:15.1|2:26:26|59|8π5|3.72|-0.18|B3III+B0V|",
            "5:59:31.6|54:17:5|7|33δ|3.72|1.0|K0-III|",
            "14:46:14.9|1:53:34|85|109|3.72|-0.01|A0V|",
            "21:4:55.9|43:55:40|30|62ξ|3.72|1.65|K4.5Ib-II|",
            "21:14:47.5|38:2:44|30|65τ|3.72|0.39|F2IV|",
            "1:51:27.6|-10:20:6|20|55ζ|3.73|1.14|K0IIIBa0.1|",
            "3:32:55.8|-9:27:30|35|18ε|3.73|0.88|K2V|",
            "7:52:13.0|-40:34:33|-1||3.73|1.04|K1-2II+A0|",
            "18:7:21.0|9:33:50|58|72|3.73|0.12|A4IVs|",
            "3:27:10.2|9:43:58|77|2ξ|3.74|-0.09|B9Vn|",
            "21:26:40.0|-22:24:41|15|34ζ|3.74|1.0|G4Ib|",
            "22:52:36.9|-7:34:47|3|73λ|3.74|1.64|M2.5IIIaFe-1|",
            "2:50:41.8|55:53:44|62|15η|3.76|1.68|K3-Ib-IIa|",
            "4:22:56.1|17:32:33|77|61δ1|3.76|0.98|K0-IIICN0.5|",
            "5:2:28.7|41:4:33|7|8ζ|3.75|1.22|K4II+B8V|",
            "5:33:37.5|-62:29:23|32|β|3.76|0.82|F6Ia|",
            "9:4:9.3|-47:5:52|-1||3.75|1.2|K2III|",
            "16:21:55.2|19:9:11|39|20γ|3.75|0.27|A9III|",
            "16:49:47.1|-59:2:29|5|η|3.76|1.57|K5III|",
            "17:47:53.6|2:42:26|58|62γ|3.75|0.04|A0Vnp|",
            "17:53:31.7|56:52:22|33|32ξ|3.75|1.18|K2-III|",
            "21:41:28.5|-77:23:24|57|ν|3.76|1.0|K0III|",
            "22:7:0.7|25:20:42|61|24ι|3.76|0.44|F5V|",
            "22:29:10.3|58:24:55|19|27δ|3.75|0.6|F5Ib-G2Ib|",
            "3:45:11.6|42:34:43|62|41ν|3.77|0.42|F5II|",
            "8:25:44.2|-66:8:13|86|β|3.77|1.13|K1III|",
            "19:4:41.0|-21:44:30|71|39ο|3.77|1.01|G9IIIb|",
            "19:17:6.2|53:22:7|30|1κ|3.77|0.96|G9III|",
            "20:39:38.3|15:54:43|31|9α|3.77|-0.06|B9IV|",
            "20:47:40.6|-9:29:45|3|2ε|3.77|0.0|A1V|",
            "22:31:17.5|50:16:57|44|7α|3.77|0.01|A1V|",
            "7:8:44.9|-70:29:56|86|γ2|3.78|1.04|K0III|",
            "10:53:29.6|-58:51:12|-1||3.78|0.95|K1III|",
            "7:4:6.5|20:34:13|37|43ζ|3.79|0.79|F7-G3Ib|",
            "7:25:43.6|27:47:53|37|60ι|3.79|1.03|G9IIIbHdel-1|",
            "19:29:42.3|51:43:47|30|10ι2|3.79|0.14|A5Vn|",
            "20:13:37.9|46:44:29|30|31|3.79|1.28|K2II+B3V|",
            "3:9:29.8|44:51:26|62|27κ|3.8|0.98|K0III|",
            "9:50:59.4|59:2:19|82|29υ|3.8|0.29|F2IV|",
            "10:19:58.6|19:50:26|45|41γ2|3.8|0.0|G7IIIFe-1|",
            "15:34:48.1|10:32:15|75|13δ|3.8|0.26|F0IV|",
            "15:34:48.1|10:32:21|75|13δ|3.8|0.26|F0IV|",
            "17:39:27.9|46:0:23|39|85ι|3.8|-0.18|B3IV|",
            "5:38:44.8|-2:36:0|59|48σ|3.81|-0.24|O9.5V|",
            "5:51:19.3|-20:52:45|47|15δ|3.81|0.99|K0IIIFe-1.5CH0.5|",
            "10:26:5.4|-16:50:11|41|42μ|3.81|1.48|K4.5III|",
            "4:35:33.0|-30:33:44|35|52υ2|3.82|0.98|G8IIIa|",
            "9:18:50.7|36:48:9|50|38|3.82|0.06|A3V|",
            "10:27:52.7|-58:44:22|-1||3.82|0.31|F2II|",
            "16:30:54.8|1:59:2|58|10λ|3.82|0.01|A0V+A4V|",
            "19:47:23.3|18:32:3|70|7δ|3.82|1.41|M2II+A0V|",
            "23:37:33.9|46:27:29|0|16λ|3.82|1.01|G8III-IV|",
            "3:44:19.1|32:17:18|62|38ο|3.83|0.05|B1III|",
            "10:53:18.7|34:12:54|46|46|3.83|1.04|K0+III-IV|",
            "13:58:16.3|-42:6:3|18|φ|3.83|-0.21|B2IV|",
            "14:47:51.6|-79:2:41|2|α|3.83|1.43|K3IIIa|",
            "18:7:32.6|28:45:45|39|103ο|3.83|-0.03|B9.5V|",
            "19:48:10.4|70:16:4|33|63ε|3.83|0.89|G7IIIbCN-2|",
            "4:28:34.5|15:57:44|77|77θ1|3.84|0.95|K0IIIbFe-0.5|",
            "8:40:37.6|-46:38:56|-1||3.84|0.71|F3Ia|",
            "8:55:2.8|-60:38:41|-1||3.84|-0.1|B8-9II|",
            "10:37:18.1|-48:13:33|-1||3.84|0.3|F4IV+F3|",
            "11:31:24.2|69:19:52|33|1λ|3.84|1.62|M0IIICa-1|",
            "15:42:44.6|26:17:44|26|8γ|3.84|0.0|B9IV+A3V|",
            "18:23:41.9|21:46:11|39|109|3.84|1.18|K2.5IIIab|",
            "22:21:39.4|-1:23:14|3|48γ|3.84|-0.05|A0V|",
            "3:44:12.0|-64:48:25|69|β|3.85|1.13|K2+III|",
            "5:47:17.1|-51:3:59|64|β|3.85|0.17|A5V|",
            "6:22:6.8|-33:26:11|23|δ|3.85|0.88|G7II|",
            "7:14:48.7|-26:46:22|13|28ω|3.85|-0.17|B2IV-Ve|",
            "10:14:44.2|-42:7:19|-1||3.85|0.05|A2V|",
            "10:32:48.7|9:18:24|45|47ρ|3.85|-0.14|B1Ib|",
            "15:56:27.2|15:39:42|75|41γ|3.85|0.48|F6V|",
            "16:15:26.3|-63:41:8|80|δ|3.85|1.11|G2Ib-IIa|",
            "18:35:12.4|-8:14:39|74|α|3.85|1.33|K3-III-IIIb|",
            "4:14:0.1|-42:17:40|40|α|3.86|1.1|K1III|",
            "12:37:42.2|-48:32:28|18|τ|3.86|0.05|A2V|",
            "17:56:15.2|37:15:2|39|91θ|3.86|1.35|K1IIaCN+2|",
            "18:13:45.8|-21:3:32|71|13μ|3.86|0.23|B8Iap|",
            "0:56:45.2|38:29:58|0|37μ|3.87|0.13|A5V|",
            "3:12:4.3|-28:59:13|36|α|3.87|0.52|F8V|",
            "3:45:49.6|24:22:4|77|20|3.87|-0.07|B8III|",
            "4:38:10.8|-14:18:14|35|53|3.87|1.09|K2IIIb|",
            "5:31:12.7|-35:28:14|23|ε|3.87|1.14|K1IIIa|",
            "6:54:7.9|-24:11:2|13|16ο1|3.87|1.73|K2+Iab|",
            "12:32:28.0|-72:7:59|55|γ|3.87|-0.15|B5V|",
            "12:33:29.0|69:47:18|33|5κ|3.87|-0.13|B6IIIpe|",
            "13:58:40.8|-44:48:13|18|υ1|3.87|-0.2|B2IV-V|",
            "15:11:56.1|-48:44:16|49|κ1|3.87|-0.05|B9.5Vne|",
            "0:9:24.7|-45:44:51|63|ε|3.88|1.03|K0III|",
            "9:14:21.9|2:18:51|41|22θ|3.88|-0.06|B9.5V|",
            "9:52:45.8|26:0:25|45|24μ|3.88|1.22|K2IIICN1Ca1|",
            "13:31:2.7|-39:24:27|-1||3.88|1.17|G9Ib*|",
            "14:43:3.6|-5:39:30|85|107μ|3.88|0.38|F2III|",
            "15:56:53.1|-29:12:51|72|5ρ|3.88|-0.2|B2IV-V|",
            "2:56:25.7|-8:53:53|35|3η|3.89|1.11|K1-IIIbBa0.2:|",
            "11:21:0.4|-54:29:28|18|π|3.89|-0.15|B5Vn|",
            "12:19:54.4|0:40:1|85|15η|3.89|0.02|A2IV|",
            "16:19:44.4|46:18:48|39|22τ|3.89|-0.15|B5IV|",
            "16:33:27.0|-78:53:50|2|γ|3.89|0.91|G8-K0III|",
            "19:56:18.4|35:5:0|30|21η|3.89|1.02|K0III|",
            "8:25:39.6|-3:54:23|-1||3.9|-0.02|A0V|",
            "19:52:28.4|1:0:20|4|55η|3.9|0.89|F6Ib|",
            "23:10:21.6|-45:14:48|38|ι|3.9|1.02|K1III|",
            "4:3:9.4|5:59:21|77|38ν|3.91|0.03|A1V|",
            "8:46:1.7|-46:2:30|-1||3.91|0.0|A1III|",
            "9:39:51.4|-1:8:34|41|35ι|3.91|1.32|K2.5III-IIIbBa0.3|",
            "11:8:35.4|-58:58:30|-1||3.91|1.23|G40-Ia|",
            "12:28:2.4|-50:13:50|18|σ|3.91|-0.19|B2V|",
            "15:35:31.6|-14:47:22|48|38γ|3.91|1.01|G8.5III|",
            "1:8:23.1|-55:14:45|63|ζ|3.92|-0.08|B6V+B9V|",
            "17:0:17.4|30:55:35|39|58ε|3.92|-0.01|A0V|",
            "21:15:49.4|5:14:52|34|8α|3.92|0.53|G0III+A5V|",
            "4:36:19.1|-3:21:9|35|48ν|3.93|-0.21|B2III|",
            "7:41:14.8|-9:33:4|54|26α|3.93|1.02|K0III|",
            "19:21:40.4|-17:50:50|71|44ρ1|3.93|0.22|F0IV-V|",
            "0:26:12.2|-43:40:48|63|κ|3.94|0.17|A7V|",
            "8:44:41.1|18:9:15|11|47δ|3.94|1.08|K0III-IIIb|",
            "11:23:55.5|10:31:45|45|78ι|3.94|0.41|F4IV|",
            "20:57:10.4|41:10:2|30|58ν|3.94|0.02|A1Vn|",
            "1:31:15.1|-49:4:22|63|δ|3.95|0.99|K0III|",
            "2:54:15.5|52:45:45|62|18τ|3.95|0.74|G4III+A4V|",
            "6:36:41.0|-19:15:21|13|7ν2|3.95|1.06|K1III|",
            "7:41:49.2|-72:36:22|86|ζ|3.95|1.04|K0III|",
            "13:23:56.4|54:55:18|82|79ζ|3.95|0.13|A1m|",
            "15:50:57.5|-33:37:38|49|5χ|3.95|-0.04|B9IV|",
            "22:46:31.9|23:33:56|61|47λ|3.95|1.07|G8IIIa*|",
            "4:24:2.2|-34:1:1|35|43|3.96|1.49|K4III|",
            "5:59:8.8|-42:48:55|23|η|3.96|1.14|K0III|",
            "6:49:50.5|-32:30:31|13|13κ|3.96|-0.23|B1.5IVne|",
            "7:43:48.5|-28:57:17|67|3|3.96|0.18|A2Iabe|",
            "12:11:39.1|-52:22:7|18|ρ|3.96|-0.15|B3V|",
            "16:6:48.4|-20:40:9|72|9ω1|3.96|-0.04|B1V|",
            "20:0:35.5|-72:54:38|60|ε|3.96|-0.03|A0V|",
            "5:51:29.4|39:8:55|7|32ν|3.97|1.13|G9.5III*|",
            "8:40:6.2|-35:18:30|68|β|3.97|0.94|G7Ib-II|",
            "9:0:38.4|41:46:58|-1||3.97|0.44|F5V|",
            "9:11:16.6|-62:19:2|-1||3.97|-0.18|B3III|",
            "18:0:38.7|2:55:54|58|67|3.97|0.02|B5Ib|",
            "19:23:53.2|-40:36:58|71|α|3.97|-0.1|B8V|",
            "22:29:16.2|-43:29:44|38|δ1|3.97|1.03|G6-8III|",
            "23:22:58.2|-20:6:2|3|98|3.97|1.1|K0III|",
            "2:3:26.1|72:25:17|17|50|3.98|-0.01|A2V|",
            "6:14:51.3|-6:16:29|54|5γ|3.98|1.32|K1.5IIIBa0.3|",
            "7:16:49.8|-67:57:26|86|δ|3.98|0.79|F6II|",
            "20:15:28.3|47:42:52|30|32|3.98|1.52|K3Ib+B3V|",
            "23:17:25.8|-58:14:9|81|γ|3.99|0.4|F1III|",
            "2:0:0.3|-21:4:40|20|59υ|4.0|1.57|M0III|",
            "2:53:52.9|-49:53:25|-1||4.0|2.11|M7IIIe|",
            "9:2:26.8|-66:23:46|86|α|4.0|0.14|A2-3IVm|",
            "10:24:23.7|-74:1:54|-1||4.0|0.35|F2IV|",
            "14:41:57.6|-37:47:37|-1||4.0|-0.17|B3V|",
            "2:17:18.9|33:50:50|79|9γ|4.01|0.02|A1Vnn|",
            "4:45:30.1|-3:15:17|35|57μ|4.02|-0.15|B5IV|",
            "8:46:41.8|28:45:36|11|48ι|4.02|1.01|G7.5IIIaBa0.1|",
            "8:50:31.9|-27:42:36|68|γ|4.01|1.27|K3-III|",
            "12:8:24.8|-24:43:44|27|1α|4.02|0.32|F2III-IV|",
            "13:25:13.5|54:59:17|82|80|4.01|0.16|A5V|",
            "16:1:53.3|58:33:55|33|13θ|4.01|0.52|F8IV|",
            "16:11:59.7|-19:27:38|72|14ν|4.01|0.04|B3V|",
            "16:19:50.4|-50:9:20|56|γ2|4.02|1.08|G8III|",
            "18:43:2.1|-71:25:41|60|ζ|4.01|1.14|K0III|",
            "18:59:37.4|15:4:6|4|13ε|4.02|1.08|K1-IIICN0.5Ba0.2|",
            "19:1:40.8|-5:44:20|4|12|4.02|1.09|K1III|",
            "19:22:38.3|-44:27:32|71|β1|4.01|-0.1|B9V|",
            "20:29:23.7|30:22:7|30|41|4.01|0.4|F5II|",
            "21:33:58.9|45:35:31|30|73ρ|4.02|0.89|G8IIIFe-0.5|",
            "22:35:21.4|0:7:3|3|62η|4.02|-0.09|B9IV-Vn|",
            "22:49:35.5|-13:35:33|3|71τ2|4.01|1.57|M0III|",
            "23:59:18.7|6:51:48|65|28ω|4.01|0.42|F4IV|",
            "3:58:57.9|35:47:28|62|46ξ|4.04|0.01|O7.5III(n)((f))|",
            "4:8:39.7|47:42:45|62|48|4.04|-0.03|B3Ve|",
            "4:11:51.9|-6:50:15|35|38ο1|4.04|0.33|F2II-III|",
            "5:3:25.1|60:26:32|10|10β|4.03|0.92|G1Ib-IIa|",
            "11:45:51.6|6:31:46|85|3ν|4.03|1.51|M1IIIab|",
            "12:18:26.1|-64:0:11|29|ζ|4.04|-0.17|B2.5V|",
            "12:54:35.6|-57:10:40|29|μ1|4.03|-0.17|B2IV-V|",
            "18:5:27.3|2:29:58|58|70|4.03|0.86|K0V|",
            "18:55:20.1|43:56:46|51|13|4.04|1.59|M5III|",
            "20:33:12.8|11:18:12|31|2ε|4.03|-0.13|B6III|",
            "0:47:20.3|24:16:2|0|34ζ|4.06|1.12|K1IIe|",
            "3:9:4.0|49:36:48|62|ι|4.05|0.59|G0V|",
            "7:35:55.3|26:53:45|37|69υ|4.06|1.54|M0III-IIIb|",
            "11:21:8.2|6:1:46|45|77σ|4.05|-0.06|B9.5Vs|",
            "14:20:33.4|-37:53:7|18|ψ|4.05|-0.03|A0IV|",
            "14:25:11.8|51:51:3|8|23θ|4.05|0.5|F7V|",
            "14:37:53.2|-49:25:33|49|ρ|4.05|-0.15|B5V|",
            "14:43:39.4|-35:10:25|-1||4.05|1.35|K3IIIb|",
            "15:8:50.6|-45:16:47|49|λ|4.05|-0.18|B3V|",
            "16:59:35.1|-53:9:38|5|ε1|4.06|1.45|K4IIIab|",
            "1:43:39.6|50:41:19|62|φ|4.07|-0.04|B2Vep|",
            "2:39:29.0|0:19:43|20|82δ|4.07|-0.22|B2IV|",
            "4:56:22.3|13:30:52|59|9ο2|4.07|1.15|K2-IIIFe-1|",
            "6:54:11.4|-12:2:19|13|14θ|4.07|1.43|K4III|",
            "8:18:31.6|-76:55:11|21|α|4.07|0.39|F5III|",
            "8:44:24.0|-42:38:57|-1||4.07|0.87|G5III|",
            "9:34:26.7|-59:13:46|-1||4.08|0.01|B5II|",
            "10:59:46.5|-18:17:56|28|7α|4.08|1.09|K0+III|",
            "11:24:52.9|-17:41:2|28|15γ|4.08|0.21|A5V|",
            "13:49:28.6|15:47:52|8|5υ|4.07|1.52|K5.5III|",
            "14:16:0.9|-6:0:2|85|99ι|4.08|0.52|F6III|",
            "15:17:30.8|-58:48:4|22|β|4.07|0.09|A3V|",
            "21:5:56.8|-17:13:58|15|23θ|4.07|-0.01|A1V|",
            "21:22:5.2|19:48:16|61|1|4.08|1.11|K1III|",
            "21:43:30.4|58:46:48|19|μ|4.08|2.35|M2-Ia|",
            "1:36:47.8|41:24:20|0|50υ|4.09|0.54|F8V|",
            "2:21:44.9|-68:39:34|42|δ|4.09|0.03|A3V|",
            "3:2:23.5|-23:37:28|35|11τ3|4.09|0.16|A4IV|",
            "5:36:54.3|9:17:26|59|40φ2|4.09|0.95|K0IIIbFe-2|",
            "15:48:44.4|18:8:30|75|35κ|4.09|1.62|M0.5IIIab|",
            "2:40:40.0|-39:51:20|35|ι|4.11|1.02|K0III|",
            "2:44:12.0|49:13:42|62|13θ|4.12|0.49|F8V|",
            "2:39:35.4|-68:16:1|42|ε|4.11|-0.06|B9V|",
            "3:30:52.4|12:56:12|77|5|4.11|1.12|K0II-IIIFe-0.5|",
            "6:2:23.0|9:38:51|59|61μ|4.12|0.16|A2V|",
            "7:3:45.5|-15:38:0|13|23γ|4.12|-0.12|B8II|",
            "7:49:14.3|-46:22:24|-1||4.11|-0.18|B0III|",
            "9:51:28.7|-14:50:48|41|39υ1|4.12|0.92|G7-III|",
            "10:35:28.1|-78:36:28|21|γ|4.11|1.58|M0III|",
            "11:46:30.8|-61:10:42|-1||4.11|0.9|G5Ib-II|",
            "12:5:12.5|8:43:59|85|9ο|4.12|0.98|G8IIIaCN-1Ba1CH1|",
            "12:17:34.1|-67:57:39|55|ε|4.11|1.58|M5III|",
            "15:36:43.2|-66:19:1|80|ε|4.11|1.17|K1-2III|",
            "19:9:28.3|-37:54:16|25|α|4.11|0.04|A2V|",
            "19:10:1.7|-39:20:27|25|β|4.11|1.2|K0II|",
            "20:51:49.3|-26:55:9|15|18ω|4.11|1.64|M0-III-IIIbBa0.2|",
            "22:29:45.5|-43:44:58|38|δ2|4.11|1.57|M4.5IIIa|",
            "23:0:52.8|-52:45:15|38|ζ|4.12|0.98|G8-K0III|",
            "4:14:53.9|48:24:34|62|51μ|4.14|0.95|G0Ib|",
            "5:23:56.8|-7:48:29|59|29|4.14|0.96|G8IIIFe-0.5|",
            "8:37:38.7|-42:59:21|-1||4.14|0.11|A6II|",
            "15:32:55.8|31:21:33|26|4θ|4.14|-0.13|B6Vnne|",
            "18:28:49.9|-49:4:15|78|ζ|4.13|1.02|G8-K0III|",
            "19:55:15.7|-41:52:6|71|ι|4.13|1.08|K0II-III|",
            "20:46:5.7|-25:16:15|15|16ψ|4.14|0.43|F4V|",
            "21:44:38.7|25:38:42|61|10κ|4.13|0.43|F5IV|",
            "22:15:58.2|37:44:56|44|1|4.13|1.46|K3-II-III|",
            "23:39:57.0|5:37:35|65|17ι|4.13|0.51|F7V|",
            "23:40:24.5|44:20:2|0|19κ|4.14|-0.08|B9IVn|",
            "0:33:0.0|62:55:54|17|15κ|4.16|0.14|B1Ia|",
            "6:4:7.2|23:15:48|37|1|4.16|0.82|G7III|",
            "6:28:57.8|20:12:44|37|18ν|4.15|-0.13|B6IIIe|",
            "7:11:51.9|0:29:34|54|22δ|4.15|-0.01|A2V|",
            "8:37:39.4|5:42:13|41|4δ|4.16|0.0|A1Vnn|",
            "12:6:52.9|-64:36:49|29|η|4.15|0.34|F2III|",
            "15:53:49.5|-16:43:46|48|46θ|4.15|1.02|G8.5IIIb|",
            "15:57:35.3|26:52:40|26|13ε|4.15|1.23|K2IIIab|",
            "16:36:22.5|-35:15:20|-1||4.16|1.57|K6III|",
            "22:16:50.0|-7:47:0|3|43θ|4.16|0.98|G8III-IV|",
            "22:46:3.3|-81:22:54|57|β|4.15|0.2|A9IV-V|",
            "3:46:19.6|23:56:54|77|23|4.18|-0.06|B6IVe|",
            "3:49:27.3|-36:12:1|-1||4.17|0.95|G9II-III|",
            "7:29:6.7|31:47:4|37|62ρ|4.18|0.32|F0V|",
            "14:16:23.0|46:5:18|8|19λ|4.18|0.08|A0p|",
            "17:26:22.2|-24:10:31|58|44|4.17|0.28|A3m|",
            "22:40:39.4|-27:2:37|66|18ε|4.17|-0.11|B8V|",
            "5:30:47.1|5:56:53|59|32|4.2|-0.14|B5V|",
            "7:56:51.5|-22:52:48|67|11|4.2|0.72|F7II|",
            "13:49:26.7|-34:27:3|18|2|4.19|1.5|M4.5III|",
            "14:12:53.8|-10:16:25|85|98κ|4.19|1.33|K2.5IIIFe-0.5|",
            "16:34:6.2|42:26:13|39|35σ|4.2|-0.01|B9V|",
            "18:45:39.7|20:32:47|39|110|4.19|0.46|F6V|",
            "22:15:2.0|57:2:37|19|23ε|4.19|0.28|F0IV|",
            "22:46:41.6|12:10:22|61|46ξ|4.19|0.5|F6III-IV|",
            "3:29:4.1|59:56:25|-1||4.21|0.41|B9Ia|",
            "4:25:22.1|22:17:38|77|65κ1|4.22|0.13|A7IV-V|",
            "5:40:45.6|-1:56:34|59|50ζ|4.21|0.0|B0III|",
            "10:27:53.0|36:42:26|46|31β|4.21|0.9|G9IIIab|",
            "18:20:45.5|71:20:16|33|43φ|4.22|-0.1|A0pSi:|",
            "18:47:10.5|-4:44:52|74|β|4.22|1.1|G4IIa|",
            "18:52:13.0|-62:11:15|60|λ|4.22|-0.14|B2II-IIIe|",
            "20:29:34.9|62:59:39|19|2θ|4.22|0.2|A7III|",
            "20:45:39.7|30:43:11|30|52|4.22|1.05|G9.5III|",
            "21:26:26.6|-65:21:58|60|γ|4.22|0.49|F6V|",
            "22:55:56.9|-32:32:23|66|23δ|4.21|0.97|G8III|",
            "23:14:19.4|-6:2:56|3|90φ|4.22|1.56|M1.5III|",
            "23:15:53.5|-9:5:16|3|91ψ1|4.21|1.11|K0III|",
            "0:20:4.3|-64:52:29|81|ζ|4.23|0.58|F9V|",
            "2:50:35.1|38:19:7|62|16|4.23|0.34|F2III|",
            "3:36:29.4|48:11:34|62|37Psi|4.23|-0.06|B5Ve|",
            "3:46:50.9|-23:14:59|35|27τ6|4.23|0.42|F3III|",
            "7:53:18.2|-48:6:11|-1||4.24|-0.14|B0.5Ib|",
            "13:45:41.2|-33:2:38|18|1|4.23|0.38|F3IV|",
            "16:6:35.5|-36:48:8|49|θ|4.23|-0.17|B2.5Vn|",
            "16:31:22.9|-34:42:16|-1||4.23|-0.16|B2III-IV|",
            "16:43:4.6|-77:31:3|2|β|4.24|1.06|K0III|",
            "16:45:58.1|82:2:14|83|22ε|4.23|0.89|G5III|",
            "19:50:33.9|32:54:51|30|χ|4.23|1.82|S6+/1e|",
            "20:17:38.9|-12:30:30|15|5α1|4.24|1.07|G3Ib|",
            "21:17:25.0|39:23:41|30|67σ|4.23|0.12|B9Iab|",
            "21:46:47.6|49:18:34|30|81π2|4.23|-0.12|B3III|",
            "1:8:44.7|86:15:25|-1||4.25|1.21|K2II-III|",
            "1:9:30.2|47:14:31|0|42φ|4.25|-0.07|B7Ve|",
            "2:26:59.1|-47:42:14|35|κ|4.25|-0.14|B5IV|",
            "2:44:7.4|-13:51:31|20|89π|4.25|-0.14|B7V|",
            "4:16:1.6|-51:29:12|32|γ|4.25|0.3|F4III|",
            "4:36:41.4|41:15:53|62|58|4.25|1.22|K4III+A3V|",
            "4:35:39.3|10:9:39|77|88|4.25|0.18|A5m|",
            "8:22:50.1|43:11:17|50|31|4.25|1.55|K4.5III-IIIb|",
            "8:58:29.2|11:51:28|11|65α|4.25|0.14|A5m|",
            "10:27:9.1|-31:4:4|1|α|4.25|1.45|K4III|",
            "14:27:31.5|75:41:46|83|5|4.25|1.44|K4-IIIBa0.3|",
            "1:45:23.6|9:9:28|65|110ο|4.26|0.96|G8III|",
            "2:44:56.5|10:6:51|20|87μ|4.27|0.31|F0IV|",
            "3:19:55.7|-43:4:11|-1||4.27|0.71|G8V|",
            "3:33:47.3|-21:37:58|35|19τ5|4.27|-0.11|B8V+B8V|",
            "4:38:9.5|12:30:39|77|90|4.27|0.12|A6V|",
            "5:9:8.8|-8:45:15|35|69λ|4.27|-0.19|B2IVne|",
            "5:59:56.1|45:56:13|7|35π|4.26|1.72|M3II|",
            "8:9:29.3|-47:20:45|84|γ1|4.27|-0.23|B1IV|",
            "12:18:20.7|-79:18:44|21|β|4.26|-0.12|B5Vn|",
            "12:33:44.5|41:21:27|12|8β|4.26|0.59|G0V|",
            "12:53:26.2|-40:10:44|-1||4.27|0.21|A7III|",
            "13:6:54.6|-49:54:22|18|ξ2|4.27|-0.19|B1.5V|",
            "13:11:52.4|27:52:41|24|43β|4.26|0.57|F9.5V|",
            "14:1:38.8|1:32:40|85|93τ|4.26|0.1|A3V|",
            "15:18:32.0|-47:52:30|49|μ|4.27|-0.08|B8Ve|",
            "16:8:46.2|44:56:6|39|11φ|4.26|-0.07|B9p:Mn:|",
            "17:41:24.9|-12:52:31|75|56ο|4.26|0.08|A2V|",
            "20:46:39.5|16:7:27|31|12γ2|4.27|1.04|K1IV|",
            "22:6:26.2|-13:52:11|3|33ι|4.27|-0.07|B9IV-V|",
            "1:2:56.6|7:53:24|65|71ε|4.28|0.96|K0III|",
            "2:28:9.5|8:27:36|20|73ξ2|4.28|-0.06|B9III|",
            "3:36:52.4|0:24:6|77|10|4.28|0.58|F9IV-V|",
            "4:6:35.0|50:21:5|62|47λ|4.29|0.02|A0IVn|",
            "4:15:32.1|8:53:32|77|49μ|4.29|-0.06|B3IV|",
            "4:25:29.4|17:55:41|77|68δ3|4.29|0.05|A2IV|",
            "4:26:18.5|22:48:49|77|69υ|4.28|0.26|A8Vn|",
            "4:42:14.7|22:57:25|77|94τ|4.28|-0.13|B3V|",
            "4:54:3.0|66:20:34|10|9α|4.29|0.03|O9.5Ia|",
            "5:19:34.5|-13:10:36|47|6λ|4.29|-0.26|B0.5IV|",
            "7:43:18.7|28:53:1|37|75σ|4.28|1.12|K1III|",
            "9:37:5.2|81:19:35|-1||4.29|1.48|K3IIIa|",
            "10:39:18.4|-55:36:12|-1||4.28|1.04|G2-3Ib|",
            "11:52:54.6|-33:54:29|41|β|4.28|-0.1|B9IIIpSi|",
            "16:31:8.3|-16:36:46|58|8φ|4.28|0.92|G8+IIIa|",
            "17:27:21.3|-29:52:1|58|45|4.29|0.4|F5IVDelSct*|",
            "17:36:32.8|-38:38:7|-1||4.29|1.09|K0IIIb|",
            "19:23:13.2|-44:47:59|71|β2|4.29|0.34|F2III|",
            "21:22:14.8|-16:50:4|15|32ι|4.28|0.9|G7IIIFe-1.5|",
            "21:45:26.9|61:7:15|19|10ν|4.29|0.52|A2Ia|",
            "22:3:47.4|64:37:40|19|17ξ|4.29|0.34|A3/6Vm|",
            "22:9:59.2|33:10:42|61|29π2|4.29|0.46|F5III|",
            "22:31:30.3|-32:20:46|66|17β|4.29|0.01|A0V|",
            "23:6:52.8|-43:31:14|38|θ|4.28|0.42|F5mDelDel|",
            "23:27:58.1|6:22:44|65|10θ|4.28|1.07|K1III|",
            "23:38:8.2|43:16:5|0|17ι|4.29|-0.1|B8V|",
            "0:58:36.4|-29:21:27|73|α|4.31|-0.16|B7IIIp|",
            "3:45:12.5|24:28:2|77|19|4.3|-0.11|B6IV|",
            "8:43:13.5|3:23:55|41|7η|4.3|-0.2|B3V|",
            "9:31:43.2|22:58:5|45|4λ|4.31|1.54|K5III|",
            "11:36:56.9|0:49:26|45|91υ|4.3|1.0|G8.5IIICN-0.5|",
            "12:32:4.2|-16:11:46|27|8η|4.31|0.38|F2III-IV|",
            "15:24:29.4|37:22:38|8|51μ1|4.31|0.31|F2IVa|",
            "18:54:30.2|36:53:56|51|12δ2|4.3|1.68|M4II|",
            "20:13:23.9|56:34:4|30|33|4.3|0.11|A3IV-Vn|",
            "1:11:6.2|55:8:59|17|33θ|4.33|0.17|A7V|",
            "2:2:2.8|2:45:49|65|113α|4.33|0.03|A0pSiSr|",
            "4:40:26.5|-19:40:18|35|54|4.32|1.61|M4III|",
            "6:31:51.3|-23:25:6|13|4ξ1|4.33|-0.24|B0.5IV|",
            "7:28:9.8|8:55:32|14|4γ|4.32|1.43|K3-IIIFe-0.5|",
            "8:40:37.0|-59:45:40|-1||4.33|-0.11|B1.5III|",
            "8:46:22.5|-13:32:52|41|12|4.32|0.9|G8-IIIFe-1|",
            "11:49:41.1|-63:47:18|-1||4.32|-0.15|B3Vne|",
            "12:3:1.5|-63:18:46|29|θ1|4.33|0.27|Am|",
            "12:53:6.9|-48:56:36|-1||4.33|1.37|K3-4III|",
            "14:26:54.9|-83:40:4|57|δ|4.32|1.31|K2III|",
            "14:20:19.5|-56:23:12|-1||4.33|0.12|B6Ib|",
            "14:51:38.4|-43:34:32|49|ο|4.32|-0.15|B5IV|",
            "15:38:3.2|-42:34:3|49|ω|4.33|1.42|K4.5III|",
            "15:44:3.5|77:47:40|83|16ζ|4.32|0.04|A3Vn|",
            "16:7:24.3|-20:52:7|72|10ω2|4.32|0.84|G3II-III|",
            "17:20:49.7|-12:50:49|75|53ν|4.33|0.03|A2V|",
            "18:19:51.7|36:3:52|51|1κ|4.33|1.17|K2IIIabCN0.5|",
            "20:38:20.3|-1:6:19|4|71|4.32|0.95|G7.5IIIa|",
            "2:58:16.3|-40:18:16|35|θ2|4.35|0.08|A1V|",
            "3:11:37.8|19:43:36|6|57δ|4.35|1.03|K2III|",
            "5:44:46.4|-65:44:8|32|δ|4.35|0.21|A7V|",
            "6:15:22.7|29:29:53|7|44κ|4.35|1.02|G8.5IIIb|",
            "6:57:16.5|58:25:21|50|15|4.35|0.85|G5III-IV|",
            "8:8:35.6|-2:59:2|54|29ζ|4.34|0.97|G2Ib|",
            "8:7:55.8|-68:37:2|86|ε|4.35|-0.11|B6IV|",
            "8:20:38.5|-77:29:4|21|θ|4.35|1.16|K2IIICN0.5|",
            "9:16:12.2|-57:32:29|-1||4.34|1.63|M1III|",
            "9:36:49.6|-49:21:19|-1||4.35|0.17|A5IV-V|",
            "14:1:43.4|-45:36:13|18|υ2|4.34|0.6|F6II|",
            "14:26:10.8|-45:22:46|49|τ2|4.35|0.43|F4IV+A7:|",
            "15:17:49.9|-30:8:56|49|2|4.34|1.1|G9IIIaFe1|",
            "17:26:30.9|4:8:25|58|49σ|4.34|1.5|K2II|",
            "18:8:34.8|-63:40:6|60|π|4.35|0.22|A7pSr|",
            "21:44:56.8|-33:1:33|66|9ι|4.34|-0.05|A0V|",
            "21:44:30.7|17:21:0|61|9|4.34|1.17|G5Ib|",
            "0:31:32.7|-62:57:29|81|β1|4.37|-0.07|B9V|",
            "0:36:52.9|33:43:10|0|29π|4.36|-0.14|B5V|",
            "0:38:33.3|29:18:42|0|30ε|4.37|0.87|G6IIIFe-3CH1|",
            "0:43:21.2|-57:27:47|63|η|4.36|0.0|A0IV|",
            "2:13:0.0|8:50:48|20|65ξ1|4.37|0.89|G6II-IIICN-2|",
            "3:30:34.5|47:59:43|62|35σ|4.36|1.35|K3III|",
            "4:4:41.7|22:4:55|77|37|4.36|1.07|K0+III-IIIaFe-0.2|",
            "4:50:36.7|8:54:1|59|2π2|4.36|0.01|A1Vn|",
            "5:13:13.9|-12:56:29|47|4κ|4.36|-0.1|B9V|",
            "5:57:32.2|-35:17:0|23|γ|4.36|-0.18|B2.5IV|",
            "6:16:33.1|-35:8:26|23|κ|4.37|1.0|K0.5IIIa|",
            "6:56:8.2|-17:3:15|13|20ι|4.37|-0.07|B3II|",
            "8:48:26.0|5:50:16|41|13ρ|4.36|-0.04|A0Vn|",
            "10:7:54.3|9:59:51|45|31|4.37|1.45|K3.5IIIbFe-1|",
            "12:26:56.3|28:16:6|24|15γ|4.36|1.13|K1IIIFe0.5|",
            "14:6:2.8|-41:10:47|18|χ|4.36|-0.19|B2V|",
            "18:8:45.5|20:48:52|39|102|4.36|-0.16|B2IV|",
            "17:32:12.9|86:35:11|83|23δ|4.36|0.02|A1Vn|",
            "18:23:13.6|-61:29:38|60|ξ|4.36|1.48|K4III|",
            "18:44:46.4|37:36:18|51|6ζ1|4.36|0.19|A4m|",
            "18:47:1.3|18:10:53|39|111|4.36|0.13|A5III|",
            "19:16:22.1|38:8:1|51|21θ|4.36|1.26|K0+II|",
            "19:36:43.3|-1:17:11|4|41ι|4.36|-0.08|B5III|",
            "19:40:5.8|18:0:50|70|5α|4.37|0.78|G1II|",
            "19:41:2.9|17:28:34|70|6β|4.37|1.05|G8IIIaCN0.5|",
            "19:59:44.2|-35:16:35|71|θ1|4.37|-0.15|B3IV|",
            "22:29:31.8|47:42:25|44|5|4.36|1.68|M0II+B8V|",
            "23:32:58.3|-37:49:6|73|β|4.37|-0.09|B9.5IVpHgMnEu|",
            "4:52:53.7|-5:27:10|35|61ω|4.39|0.25|F4III+A6III|",
            "5:32:12.8|18:35:40|77|119|4.38|2.07|M2Iab-Ib|",
            "6:34:58.6|-52:58:32|-1||4.39|-0.02|A0II|",
            "8:2:15.9|2:20:4|-1||4.39|1.25|K2III|",
            "11:0:9.3|-42:13:33|-1||4.39|0.11|A3IV|",
            "13:9:57.0|-5:32:20|85|51θ|4.38|-0.01|A1IVs+Am|",
            "16:54:0.5|10:9:55|58|25ι|4.38|-0.08|B8V|",
            "17:21:0.2|-21:6:46|58|40ξ|4.39|0.39|F1III-IV|",
            "19:13:45.5|39:8:46|51|20η|4.39|-0.15|B2.5IV|",
            "20:8:53.3|77:42:41|19|1κ|4.39|-0.05|B9III|",
            "21:19:52.0|-53:26:59|43|θ|4.39|0.19|A5V|",
            "23:17:54.2|-9:10:57|3|93ψ2|4.39|-0.15|B5V|",
            "23:26:2.8|-20:38:31|3|99|4.39|1.47|K5III|",
            "1:53:38.8|-46:18:9|63|ψ|4.41|1.59|M4III|",
            "5:34:49.2|9:29:22|59|37φ1|4.41|-0.16|B0III|",
            "5:54:22.9|20:16:34|59|54χ1|4.41|0.59|G0V|",
            "6:49:51.3|-53:37:20|-1||4.4|0.92|G6II|",
            "7:11:8.4|30:14:43|37|46τ|4.41|1.26|K2-III|",
            "7:18:42.4|-24:57:15|13|30τ|4.4|-0.15|O9Ib|",
            "7:58:14.4|-49:14:42|-1||4.41|-0.17|B1Vp+B3IV:|",
            "8:9:1.6|-19:14:42|67|16|4.4|-0.15|B5IV|",
            "11:18:11.0|31:31:45|82|53ξ|4.41|0.59|G0V|",
            "14:50:17.3|-27:57:37|41|58|4.41|1.4|K4III|",
            "15:2:54.0|2:5:29|85|110|4.4|1.04|K0.5IIIbFe-0.5|",
            "17:30:44.3|26:6:38|39|76λ|4.41|1.44|K3.5III|",
            "17:58:30.2|30:11:22|39|94ν|4.41|0.39|F2II|",
            "21:57:55.1|-54:59:33|43|δ|4.4|0.28|F0IV|",
            "23:7:53.9|75:23:15|19|33π|4.41|0.8|G2III|",
            "23:18:49.4|-32:31:55|73|γ|4.41|1.13|K1III|",
            "23:25:22.8|23:24:15|61|68υ|4.4|0.61|F8III|",
            "0:1:57.6|-6:0:51|65|30|4.41|1.63|M3III|",
            "0:48:41.0|7:35:6|65|63δ|4.43|1.5|K4IIIb|",
            "0:57:12.4|23:25:3|0|38η|4.42|0.94|G8IIIb|",
            "3:46:8.5|-12:6:6|35|26π|4.42|1.63|M2III|",
            "4:15:16.3|-7:39:10|35|40ο2|4.43|0.82|K1-V|",
            "6:7:34.3|14:46:6|59|67ν|4.42|-0.17|B3V|",
            "6:37:53.4|-18:14:15|13|8ν3|4.43|1.15|K1-II-III|",
            "11:2:19.8|20:10:47|45|60|4.42|0.05|A1m|",
            "14:23:2.2|-39:30:44|-1||4.42|-0.18|B7IIIp|",
            "14:32:36.9|-50:27:25|49|σ|4.42|-0.19|B2III|",
            "14:41:8.9|13:43:42|8|30ζ|4.43|0.05|A2III|",
            "15:46:26.6|7:21:11|75|27λ|4.43|0.6|G0-V|",
            "16:27:1.4|-18:27:23|58|7χ|4.42|0.28|B2IV:pe|",
            "20:23:51.7|32:11:24|30|39|4.43|1.33|K2.5IIIFe-0.5|",
            "20:43:27.5|15:4:28|31|11δ|4.43|0.32|A7IIIpDelDel|",
            "20:47:44.2|-5:1:40|3|3|4.42|1.65|M3III|",
            "21:17:55.1|34:53:49|30|66υ|4.43|-0.11|B2Vne|",
            "22:23:33.6|52:13:45|44|3β|4.43|1.02|G8.5IIIbCa1|",
            "22:28:50.1|0:1:12|3|55ζ2|4.42|0.38|F3V|",
            "0:14:38.4|-18:55:58|20|7|4.44|1.66|M3III|",
            "1:41:25.9|5:29:15|65|106ν|4.44|1.36|K3IIIbBa0.1|",
            "4:16:28.9|-59:18:7|69|ε|4.44|1.08|K2IVa|",
            "4:40:33.7|-41:51:50|9|α|4.45|0.34|F2V|",
            "5:12:17.9|-11:52:9|47|3ι|4.45|-0.1|B8V|",
            "6:23:46.1|4:35:34|54|8ε|4.44|0.18|A5IV|",
            "7:34:3.2|-22:17:46|-1||4.45|0.51|F6IV|",
            "8:11:21.5|-39:37:7|-1||4.45|1.62|K3Ib|",
            "8:14:2.9|-40:20:53|-1||4.44|1.17|K1II-III|",
            "8:18:33.3|-36:39:34|-1||4.45|0.22|A7III|",
            "8:38:45.4|3:20:29|41|5σ|4.44|1.21|K1+III|",
            "9:0:5.4|-41:15:14|-1||4.45|0.65|G8-K1III+A|",
            "10:35:35.3|-57:33:28|-1||4.45|1.62|K3-4II|",
            "10:45:46.8|-80:32:25|21|δ2|4.45|-0.19|B2.5IV|",
            "16:32:8.2|-21:27:59|58|9ω|4.45|0.13|A7p|",
            "18:1:45.2|1:18:19|58|68|4.45|0.02|A2Vn|",
            "18:56:57.0|-67:14:1|60|κ|4.44|0.71|F5I-II|",
            "19:15:33.0|73:21:20|33|60τ|4.45|1.25|K2+IIIbCN1Fe1|",
            "19:28:42.3|24:39:54|87|6α|4.44|1.5|M0III|",
            "19:34:5.4|7:22:44|4|38μ|4.45|1.17|K3-IIIbCN0.5|",
            "2:45:6.2|-18:34:21|35|1τ1|4.47|0.48|F6V|",
            "2:49:5.4|-32:24:21|36|β|4.46|0.99|K0-IIIFe-0.5|",
            "3:20:20.4|29:2:54|-1||4.47|1.55|K2II-III|",
            "3:49:31.2|65:31:34|-1||4.47|1.88|M2+IIab|",
            "4:57:17.2|53:45:8|10|7|4.47|-0.02|A1V|",
            "4:58:32.9|1:42:51|59|10π6|4.47|1.4|K2-II|",
            "5:13:17.5|2:51:40|59|17ρ|4.46|1.19|K0.5III|",
            "6:47:51.6|2:24:44|54|18|4.47|1.11|K0+IIIaBa0.2|",
            "9:24:39.3|26:10:56|45|1κ|4.46|1.23|K2III|",
            "11:16:39.7|-3:39:6|45|74φ|4.47|0.21|A7IVn|",
            "11:51:8.7|-45:10:25|-1||4.46|1.3|K3III|",
            "12:8:5.2|-50:39:41|-1||4.47|-0.15|B6IIIe|",
            "14:34:40.8|29:44:42|8|28σ|4.46|0.36|F2V|",
            "16:27:11.1|-47:33:18|56|ε|4.47|-0.07|B4V|",
            "22:6:6.9|-39:32:36|38|λ|4.46|1.37|K3III|",
            "22:40:30.9|44:16:35|44|11|4.46|1.33|K2+III-IIIb|",
            "22:52:31.6|-32:52:32|66|22γ|4.46|-0.04|A0III*|",
            "23:6:40.9|-23:44:35|3|86|4.47|0.9|G9III|",
            "4:26:20.8|15:37:6|77|71|4.49|0.25|F0V|",
            "6:11:56.4|14:12:32|59|70ξ|4.48|-0.18|B3IV|",
            "6:19:37.4|59:0:39|50|2|4.48|0.01|A2Vs|",
            "6:28:10.1|-32:34:48|13|λ|4.48|-0.17|B4V|",
            "6:43:59.3|13:13:40|37|30|4.49|1.16|K0IIICN1Ca1|",
            "7:12:33.6|-46:45:34|-1||4.49|0.32|F0IV|",
            "7:52:38.7|-38:51:47|-1||4.49|-0.19|B2.5V|",
            "8:46:42.5|-56:46:11|-1||4.49|-0.17|B3Vne|",
            "9:8:52.3|51:36:17|82|15|4.48|0.27|F0IVmvs|",
            "9:5:8.8|-72:36:10|-1||4.48|0.61|F9II|",
            "10:7:25.8|35:14:41|46|21|4.48|0.18|A7V|",
            "10:7:56.3|0:22:18|76|15α|4.49|-0.04|A0III|",
            "11:11:39.5|-22:49:33|28|11β|4.48|0.03|A2III|",
            "14:57:11.0|-4:20:47|48|16|4.49|0.32|F0V|",
            "19:36:26.5|50:13:16|30|13θ|4.48|0.38|F4V|",
            "21:14:28.9|10:0:25|34|7δ|4.49|0.5|F5V+G0V|",
            "22:13:52.7|39:42:54|-1||4.49|1.39|K3III|",
            "22:27:20.0|-64:57:59|81|δ|4.48|-0.03|B9.5V|",
            "23:42:43.3|-14:32:42|3|105ω2|4.49|-0.04|B9.5V|",
            "6:32:54.2|7:19:59|54|13|4.5|0.0|A0Ib|",
            "7:38:49.3|-26:48:6|-1||4.5|-0.17|B6V|",
            "7:48:5.2|-25:56:14|67|ο|4.5|-0.05|B0V:pe:|",
            "9:34:49.5|52:3:5|82|26|4.5|0.01|A2V|",
            "10:20:54.8|-56:2:35|-1||4.5|-0.12|B3IIIe|",
            "10:55:36.8|24:44:59|45|54|4.5|0.01|A1V|",
            "13:47:15.7|17:27:24|8|4τ|4.5|0.48|F6IV|",
            "16:24:6.2|-20:2:15|58|4ψ|4.5|1.01|K0II-III|",
            "21:7:7.7|-25:0:21|15|24|4.5|1.61|M0.5III|",
            "22:8:23.0|-32:59:19|66|14μ|4.5|0.05|A2V|",
            "23:42:2.8|1:46:48|65|18λ|4.5|0.2|A7V|",
            "23:59:55.0|-65:34:38|81|ε|4.5|-0.08|B9IV|",
            "0:18:19.7|36:47:7|0|25σ|4.52|0.05|A2V|",
            "1:11:39.6|30:5:23|65|83τ|4.51|1.09|K0.5IIIb|",
            "2:29:4.0|67:24:9|17|ι|4.52|0.12|A5pSr|",
            "2:47:54.5|29:14:50|6|39|4.51|1.11|K1.5III|",
            "4:0:53.8|-62:9:34|69|γ|4.51|1.65|M4III|",
            "4:33:30.6|-29:46:0|35|50υ1|4.51|0.98|K0IIICN-1|",
            "5:49:10.5|39:10:52|7|29τ|4.52|0.94|G8IIIFe-1|",
            "5:49:49.7|-56:10:0|64|γ|4.51|1.1|K1III|",
            "9:29:14.7|-35:57:5|1|ε|4.51|1.44|K3IIIa|",
            "9:39:21.0|-61:19:41|-1||4.52|-0.07|B9IV-V|",
            "14:19:6.6|-13:22:16|85|100λ|4.52|0.13|A2m|",
            "15:23:22.7|-59:19:15|22|γ|4.51|0.19|B5IV+F8|",
            "15:41:33.1|19:40:13|75|21ι|4.52|0.04|A1V|",
            "17:23:41.0|37:8:45|39|75ρ|4.52|-0.03|B9.5III|",
            "19:56:56.8|-27:10:12|71|59|4.52|1.46|K2.5IIb|",
            "20:2:49.1|67:52:25|33|67ρ|4.51|1.32|K3III|",
            "20:15:46.1|27:48:51|87|23|4.52|1.26|K3-IIIFe-1|",
            "20:44:2.3|-51:55:16|43|η|4.51|0.27|A7III-IV-A9|",
            "20:45:21.1|57:34:47|-1||4.51|0.54|F8IV-V|",
            "21:9:35.7|-11:22:18|3|13ν|4.51|0.94|G8III|",
            "21:28:43.4|-21:48:26|15|36|4.51|0.91|G5III|",
            "22:30:29.3|43:7:24|44|6|4.51|-0.09|B2IV|",
            "23:7:0.3|9:24:34|61|55|4.52|1.57|M1IIIab|",
            "23:12:33.0|49:24:23|0|7|4.52|0.29|F0V|",
            "0:31:33.6|-62:57:57|81|β2|4.54|0.15|A2V+A7V|",
            "0:44:43.5|48:17:4|17|22ο|4.54|-0.07|B5IIIe|",
            "0:49:48.8|41:4:44|0|35ν|4.53|-0.15|B5V+F8V|",
            "2:1:57.4|70:54:25|17|48|4.54|0.16|A3IV|",
            "2:51:30.8|35:3:35|62|17|4.53|1.56|K5+III|",
            "3:29:54.9|58:52:43|-1||4.54|0.56|A0Ia|",
            "5:18:10.7|33:22:18|7|16|4.54|1.27|K2.5IIIbFe-1|",
            "6:0:3.4|-3:4:27|-1||4.53|1.22|K1.5IIIFe-1.5|",
            "6:35:3.4|-22:57:53|13|5ξ2|4.54|-0.05|A0V|",
            "7:29:47.8|12:0:24|14|6|4.54|1.28|K1+IIIBa0.4|",
            "7:37:22.1|-34:58:7|-1||4.53|-0.09|B8IV|",
            "11:47:59.1|20:13:8|45|93|4.53|0.55|G5III-IVe+A7V|",
            "13:22:37.9|-60:59:18|-1||4.53|-0.13|B3V|",
            "13:24:0.5|-64:32:9|-1||4.53|0.85|G6II|",
            "14:13:29.0|51:47:25|8|17κ2|4.54|0.2|A8IV|",
            "15:4:26.7|26:56:51|8|43ψ|4.54|1.24|K2III|",
            "15:12:13.3|-19:47:30|48|24ι1|4.54|-0.08|A0pSi|",
            "15:23:9.4|-36:51:31|49|φ2|4.54|-0.15|B4V|",
            "15:35:53.2|-44:57:31|-1||4.54|-0.18|B3IVp|",
            "17:26:37.9|-5:5:12|-1||4.54|0.39|F3V|",
            "17:47:33.6|-27:49:51|71|3|4.54|0.8|F7II|",
            "18:11:13.8|-45:57:16|78|ε|4.53|1.01|K0III|",
            "20:47:24.5|36:29:27|30|54λ|4.53|-0.11|B5Ve|",
            "23:3:52.6|3:49:12|65|4β|4.53|-0.12|B6Ve|",
            "23:54:23.0|57:29:58|17|7ρ|4.54|1.22|G20e|",
            "3:58:44.7|-61:24:1|69|δ|4.56|1.62|M2IIIab|",
            "5:4:24.4|-35:29:0|9|γ1|4.55|1.2|K3III|",
            "7:0:4.0|76:58:39|-1||4.55|1.36|K4III|",
            "9:6:31.8|38:27:8|-1||4.56|1.04|G7Ib-II|",
            "9:34:28.9|69:49:49|82|24|4.56|0.77|G4III-IV|",
            "9:34:13.4|36:23:51|46|10|4.55|0.92|G8.5III|",
            "13:51:49.6|-32:59:40|18|3|4.56|-0.13|B5IIIp|",
            "14:26:8.2|-45:13:17|49|τ1|4.56|-0.15|B2IV|",
            "14:51:23.3|19:6:4|8|37ξ|4.55|0.76|G8Ve+K4Ve|",
            "16:20:38.2|-24:10:10|72|19ο|4.55|0.84|A5II|",
            "21:6:36.1|47:38:54|30|63|4.55|1.57|K4Ib-IIa|",
            "21:41:55.3|71:18:41|19|11|4.56|1.1|K1III|",
            "23:29:9.3|12:45:38|61|70|4.55|0.94|G7+III|",
            "0:3:44.4|-17:20:10|20|2|4.55|-0.05|B9.5Vn|",
            "3:37:5.7|-40:16:29|-1||4.58|1.04|K1III|",
            "5:39:11.1|4:7:17|59|47ω|4.57|-0.11|B3IIIe|",
            "5:53:19.6|27:36:44|77|136|4.58|-0.02|A0V|",
            "9:8:2.9|-25:51:30|68|κ|4.58|1.59|K4III|",
            "9:31:58.9|-1:11:6|41|32τ2|4.57|0.1|A3V|",
            "9:51:40.8|-46:32:52|-1||4.58|1.2|G5Ib|",
            "10:19:36.8|-55:1:46|-1||4.57|1.62|K3II|",
            "10:43:32.1|-60:34:0|-1||4.57|1.71|K4III|",
            "16:25:25.0|14:2:0|39|24ω|4.57|0.0|B9pCr|",
            "17:41:56.3|72:8:56|33|31ψ1|4.58|0.42|F5IV-V|",
            "18:8:5.0|-28:27:26|-1||4.57|0.94|G7:IIIb*|",
            "19:53:27.7|24:4:47|87|13|4.58|-0.06|B9.5III|",
            "20:2:39.5|-27:42:35|71|62|4.58|1.65|M4III|",
            "21:29:56.9|23:38:20|61|2|4.57|1.62|M1+III|",
            "22:21:1.6|46:32:12|44|2|4.57|-0.1|B6V|",
            "22:24:31.0|49:28:35|44|4|4.57|0.09|B9Iab|",
            "23:48:55.6|-28:7:49|73|δ|4.57|0.01|A0V|",
            "0:41:19.6|-46:5:6|63|μ|4.59|0.97|G8III|",
            "3:42:50.1|-37:18:49|-1||4.59|1.2|K2.5III|",
            "5:26:50.2|3:5:44|59|30ψ2|4.59|-0.21|B2IV|",
            "5:35:23.2|-4:50:18|59|42|4.59|-0.19|B1V|",
            "6:28:49.0|-7:1:58|54|11β|4.6|-0.1|B3Ve|",
            "7:43:32.4|-28:24:40|67|1|4.59|1.63|K3Ib|",
            "8:40:12.8|64:19:40|82|4π2|4.6|1.17|K1+IIIb|",
            "9:29:8.9|-2:46:8|41|31τ1|4.6|0.46|F6V|",
            "9:52:6.4|54:3:52|82|30φ|4.59|0.03|A3IV|",
            "10:5:7.5|-13:3:53|41|40υ2|4.6|-0.09|B9III-IV|",
            "10:56:43.1|-37:8:16|1|ι|4.6|1.03|K1III|",
            "11:12:36.0|-60:19:3|-1||4.6|0.55|A6Iae|",
            "13:12:17.4|-59:55:15|-1||4.6|-0.08|B8V|",
            "14:45:14.5|16:57:52|8|35ο|4.6|0.98|G8.5III|",
            "14:57:35.0|65:55:57|-1||4.6|1.59|M4.5III|",
            "15:25:20.2|-38:44:1|-1||4.6|0.0|A0IV|",
            "15:53:36.7|-25:19:38|72|2|4.59|-0.07|B2.5Vn|",
            "16:12:18.2|-27:55:35|72|13|4.59|-0.16|B2V|",
            "17:35:39.6|-46:30:20|5|1σ|4.59|-0.03|A0V|",
            "18:54:44.9|22:38:42|39|113|4.59|0.78|G4III+A6V|",
            "19:8:20.9|-40:29:48|25|δ|4.59|1.09|K1III|",
            "19:20:40.1|65:42:53|33|58π|4.59|0.02|A2IIIs|",
            "19:36:42.4|-24:53:1|71|52|4.6|-0.07|B9|",
            "20:52:7.7|27:5:49|87|31|4.59|0.83|G7IIIFe-1|",
            "22:28:49.7|0:1:13|3|55ζ1|4.59|0.0|F6IV|",
            "23:20:38.2|23:44:25|61|62τ|4.6|0.17|A5Vp|",
            "0:5:20.1|-5:42:27|65|33|4.61|1.04|K0IIIbCN-0.5|",
            "0:17:5.5|38:40:54|0|24θ|4.61|0.06|A2V|",
            "1:53:33.3|3:11:15|65|111ξ|4.62|0.94|K0III|",
            "4:18:14.6|50:17:44|-1||4.61|0.04|A2V|",
            "5:31:55.8|-7:18:5|59|36υ|4.62|-0.26|B0V|",
            "7:38:49.8|-26:48:13|-1||4.62|0.0|B5IVn|",
            "7:59:52.0|-18:23:57|-1||4.61|0.08|A2Vn|",
            "8:43:40.4|-7:14:1|-1||4.62|0.84|G1Ib|",
            "9:15:45.1|-37:24:48|-1||4.62|0.45|F5III|",
            "11:6:32.4|-62:25:27|-1||4.61|1.03|G8III|",
            "11:34:45.7|-54:15:51|-1||4.62|-0.08|B9Ve|",
            "12:54:39.2|-59:8:48|29|λ|4.62|-0.15|B4Vne|",
            "15:34:10.7|-10:3:52|48|37|4.62|1.01|K1III-IV|",
            "15:52:40.5|42:27:6|39|1χ|4.62|0.56|F8VFe-2Hdel-1|",
            "17:37:50.7|-8:7:8|58|57μ|4.62|0.11|B8II-IIIp:Mn|",
            "18:0:29.0|-3:41:25|75|57ζ|4.62|0.38|F2IV|",
            "18:56:13.2|4:12:13|75|63θ1|4.62|0.17|A5V|",
            "19:21:43.6|-15:57:18|71|46υ|4.61|0.1|B2Vpe+A2IaShell|",
            "20:33:54.2|35:15:3|30|47|4.61|1.6|K2Ib+B3V|",
            "0:56:39.8|59:10:52|17|28υ2|4.63|0.96|G8IIIbFe-0.5|",
            "2:59:12.7|21:20:25|6|48ε|4.63|0.04|A2Vs|",
            "2:59:12.7|21:20:25|6|48ε|4.63|0.04|A2Vs|",
            "3:11:17.4|39:36:42|62|28ω|4.63|1.11|K1III|",
            "3:50:21.5|71:19:56|10|γ|4.63|0.03|A2IVn|",
            "5:3:5.7|21:35:24|77|102ι|4.64|0.16|A7V|",
            "6:3:55.2|20:8:18|59|62χ2|4.63|0.28|B2Ia|",
            "7:16:35.0|-27:52:52|-1||4.64|1.6|M3III|",
            "7:26:42.8|49:12:41|50|21|4.64|-0.02|A1V|",
            "7:35:22.8|-28:22:10|-1||4.64|-0.11|B8V|",
            "7:53:3.7|-49:36:47|-1||4.63|-0.23|B1.5Vp|",
            "11:5:1.0|7:20:10|45|63χ|4.63|0.33|F2III-IV|",
            "11:15:12.2|23:5:44|45|72|4.63|1.66|M3IIb|",
            "12:39:52.5|-39:59:15|-1||4.64|-0.08|B8II/III|",
            "15:41:11.3|-44:39:40|-1||4.64|0.4|F5IV-V|",
            "15:50:58.7|-25:45:5|72|1|4.64|-0.05|B3V|",
            "15:49:35.7|26:4:6|26|10δ|4.63|0.8|G3.5III-IVFe-1|",
            "16:3:31.9|-57:46:31|56|ι1|4.63|0.24|A7IV|",
            "16:27:48.1|-8:22:18|58|3υ|4.63|0.17|A3m|",
            "18:0:15.8|4:22:7|58|66|4.64|-0.03|B2Ve|",
            "18:7:18.4|8:44:2|58|71|4.64|0.96|G8III|",
            "18:31:22.4|-62:16:42|60|ν|4.64|-0.11|B7-8III|",
            "18:33:30.2|-42:18:45|25|θ|4.64|1.01|G8III|",
            "20:1:6.1|27:45:13|87|15|4.64|0.18|A4III|",
            "22:37:22.4|51:32:43|44|9|4.63|0.24|A8IV|",
            "1:11:27.2|21:2:5|65|84χ|4.66|1.03|G8.5III-IIIa|",
            "1:13:44.9|24:35:1|65|85φ|4.65|1.04|K0III|",
            "2:43:27.1|27:42:26|6|35|4.66|-0.13|B3V|",
            "3:53:42.6|-24:36:45|35|33τ8|4.65|-0.13|B6V|",
            "3:59:55.5|-24:0:59|35|36τ9|4.66|-0.13|B6V+B9.5V|",
            "4:33:50.9|14:50:40|77|86ρ|4.65|0.25|A8V|",
            "4:54:53.8|10:9:3|59|7π1|4.65|0.09|A0Vp|",
            "5:54:6.1|-63:5:24|-1||4.65|1.05|K1III-IV|",
            "6:40:58.7|9:53:44|54|15|4.66|-0.25|O7V((f))|",
            "6:54:38.7|13:10:40|37|38|4.65|0.3|F0Vp|",
            "7:14:15.2|-26:21:9|13|27|4.66|-0.19|B3IIIe|",
            "7:18:18.4|-36:44:3|-1||4.66|-0.1|B2V+B3IVne|",
            "7:30:42.5|-30:57:44|-1||4.65|0.93|G3Ib|",
            "8:43:17.1|21:28:7|11|43γ|4.66|0.02|A1IV|",
            "10:27:24.4|-57:38:20|-1||4.66|0.51|A9Ia|",
            "10:38:45.1|-59:10:59|-1||4.66|1.48|K4-5III:|",
            "12:0:52.4|6:36:51|85|8π|4.66|0.13|A5V|",
            "12:39:14.8|-7:59:44|85|26χ|4.66|1.23|K2III-IIIbCN1|",
            "12:42:35.4|-48:48:47|-1||4.66|1.09|K0III|",
            "12:46:22.7|-56:29:20|-1||4.65|-0.16|B3V|",
            "13:40:44.3|54:40:54|82|83|4.66|1.64|M2IIIabBa0.5|",
            "13:46:39.3|-51:25:58|-1||4.65|0.96|G8-K0III|",
            "13:51:25.9|64:43:24|33|10|4.65|1.58|M3.5III|",
            "16:3:12.9|-49:13:47|56|η|4.65|0.92|G8III|",
            "16:49:50.0|-10:46:59|58|20|4.65|0.47|F7IV|",
            "17:17:40.3|37:17:30|39|69|4.65|0.05|A2V|",
            "18:18:3.2|-27:2:33|-1||4.65|1.66|K3II|",
            "18:51:12.1|59:23:18|33|47ο|4.66|1.19|G9IIIFe-0.5|",
            "19:26:31.1|0:20:19|4|32ν|4.66|0.6|F2Ib|",
            "22:25:16.6|1:22:39|3|52π|4.66|-0.03|B1Ve|",
            "23:4:11.0|50:3:8|0|3|4.65|1.06|K0IIIbFe-0.5|",
            "23:57:45.5|25:8:29|61|84ψ|4.66|1.59|M3III|",
            "1:49:35.1|-10:41:11|20|53χ|4.67|0.33|F3III|",
            "3:29:22.1|49:30:32|62|34|4.67|-0.09|B3V|",
            "5:4:34.1|15:24:15|59|11|4.68|-0.06|A0pSi|",
            "6:6:9.3|-14:56:7|47|18θ|4.67|0.05|A1Vn|",
            "6:55:37.4|-20:8:11|13|19π|4.68|0.37|gF2|",
            "8:1:13.3|-1:23:33|54|28|4.68|1.49|K4III|",
            "9:10:55.1|63:30:49|82|14τ|4.67|0.35|F3-4IIImvs|",
            "9:38:27.3|4:38:57|-1||4.68|1.32|K3III|",
            "15:39:46.0|-34:24:43|49|3ψ1|4.67|0.99|G8III|",
            "16:20:20.8|-78:41:45|2|δ1|4.68|1.69|M5IIIb|",
            "18:0:3.4|16:45:3|39|93|4.67|1.26|K0.5IIb|",
            "18:23:39.5|-8:56:3|74|ζ|4.68|0.95|G9-IIIbFe-0.5|",
            "19:32:21.6|69:39:40|33|61σ|4.68|0.79|K0V|",
            "20:35:18.5|14:40:27|31|4ζ|4.68|0.11|A3V|",
            "21:1:17.5|-32:15:28|53|γ|4.67|0.89|G6III|",
            "21:37:4.8|-19:27:58|15|39ε|4.68|-0.17|B2.5Vpe|",
            "21:42:5.7|51:11:23|30|80π1|4.67|-0.12|B3IV|",
            "1:54:56.1|-67:38:50|42|η2|4.69|0.95|G8.5III|",
            "2:4:29.4|-29:17:49|36|ν|4.69|-0.17|B9.5pSi|",
            "2:58:45.7|39:39:46|62|22π|4.7|0.06|A2Vn|",
            "2:59:42.9|8:54:27|20|91λ|4.7|-0.12|B6III|",
            "4:26:36.4|14:42:49|77|73π|4.69|0.98|G7IIIaFe-1|",
            "4:39:16.5|15:55:5|77|92σ2|4.69|0.15|A5Vn|",
            "7:38:18.0|-25:21:53|-1||4.7|-0.11|B8IV|",
            "8:56:19.4|-52:43:25|-1||4.69|-0.12|B5V|",
            "9:23:12.3|-28:50:2|68|λ|4.69|0.92|G8.5IIICN-1.5*|",
            "9:27:18.4|-22:20:38|-1||4.69|1.14|K2.5III|",
            "10:0:12.8|8:2:39|45|29π|4.7|1.6|M2-IIIab|",
            "11:36:40.9|-9:48:8|28|21θ|4.7|-0.08|B9.5Vn|",
            "11:40:12.8|-34:44:41|41|ο|4.7|-0.07|B9V|",
            "12:45:37.9|-60:58:52|29|ι|4.69|1.05|K0III|",
            "13:31:57.9|-6:15:21|85|74|4.69|1.62|M2III|",
            "13:34:27.3|49:0:58|12|24|4.7|0.12|A5V|",
            "18:5:1.3|-29:34:48|71|γ1|4.69|0.78|F4-G1Ib|",
            "18:29:11.9|-14:33:57|74|γ|4.7|0.06|A3Vn|",
            "19:39:22.6|30:9:12|30|12φ|4.69|0.97|G8III-IV|",
            "19:55:50.4|-26:17:58|71|58ω|4.7|0.75|G5V|",
            "21:10:20.5|10:7:54|34|5γ|4.69|0.26|F0IIIp|",
            "21:37:45.1|-7:51:15|3|23ξ|4.69|0.17|A7V|",
            "22:3:21.6|-56:47:10|43|ε|4.69|1.06|K4-5V|",
            "22:3:18.9|-2:9:19|3|31ο|4.69|-0.06|B7IVe|",
            "22:43:35.3|-18:49:49|3|66|4.69|1.37|K4III|",
            "23:9:54.8|-22:27:27|3|89|4.69|0.65|G2IV+A2V|",
            "1:33:55.9|59:13:55|17|39χ|4.71|1.0|G9IIIb|",
            "2:25:37.4|50:16:43|0|65|4.71|1.53|K4+III|",
            "3:29:22.7|-62:56:15|69|κ|4.72|0.4|F5IV-V|",
            "4:14:53.3|40:29:1|62|52|4.71|1.01|G5Ib+A2V|",
            "5:5:30.6|-57:28:22|32|ζ|4.72|0.52|F7V|",
            "5:19:8.5|40:5:57|7|15λ|4.71|0.63|G1.5IV-VFe-1|",
            "5:20:26.9|-21:14:22|-1||4.71|-0.05|A0V|",
            "5:29:44.0|-1:5:32|59|31|4.71|1.57|K5III|",
            "7:48:20.3|-47:4:40|-1||4.71|1.06|K0III|",
            "8:11:16.3|-12:55:37|67|19|4.72|0.95|G9III-IIIb|",
            "9:5:38.3|-70:32:20|-1||4.71|-0.15|B2IVe|",
            "9:21:29.6|-25:57:56|68|θ|4.72|1.63|M1III|",
            "10:38:43.2|31:58:34|46|37|4.71|0.81|G2.5IIa|",
            "10:53:58.7|43:11:24|82|45ω|4.71|-0.05|A1Vs|",
            "11:48:14.3|-66:48:53|55|μ|4.72|1.54|K4III|",
            "12:4:19.2|-63:9:56|29|θ2|4.72|-0.08|B2IV|",
            "13:6:16.7|-48:27:49|-1||4.71|-0.14|B5V|",
            "13:57:38.9|-63:41:12|-1||4.71|1.11|K1.5III|",
            "15:5:7.2|-47:3:4|49|π|4.72|-0.14|B5V|",
            "16:6:29.4|-45:10:24|56|δ|4.72|0.23|Am|",
            "18:42:16.4|-9:3:9|74|δ|4.72|0.35|F2IIIpDelDel|",
            "19:54:14.9|8:27:41|4|59ξ|4.71|1.05|G9+IIIb|",
            "21:17:56.3|-32:10:21|53|ε|4.71|0.06|A1V|",
            "22:54:24.8|84:20:46|-1||4.71|1.43|K4III|",
            "23:33:16.6|-20:54:52|3|101|4.71|0.02|A1n|",
            "23:35:4.6|-42:36:54|63|ι|4.71|0.08|A2VpSrCrEu|",
            "0:31:46.4|54:31:20|17|14λ|4.73|-0.1|B8Vn|",
            "1:25:56.0|68:7:48|17|36ψ|4.74|1.05|K0III|",
            "3:30:37.1|-5:4:31|35|17|4.73|-0.09|B9Vs|",
            "3:48:35.9|-37:37:14|-1||4.73|-0.03|B9V|",
            "4:52:32.0|14:15:2|59|4ο1|4.74|1.84|S3.5/1-|",
            "5:21:45.7|0:22:57|59|22|4.73|-0.17|B2IV-V|",
            "5:51:2.4|37:18:20|7|31υ|4.74|1.62|M0+III-IIIbFe-0.5|",
            "10:25:54.9|33:47:46|46|30|4.74|0.25|F0V|",
            "10:30:20.1|-71:59:35|-1||4.74|0.04|A1V|",
            "11:1:49.7|-2:29:5|45|61|4.74|1.62|M0IIIBa0.2|",
            "11:44:45.8|-18:21:3|28|27ζ|4.73|0.97|G8IIIa|",
            "12:20:43.0|17:47:34|24|11|4.74|1.01|G8+III|",
            "13:17:32.5|40:34:21|12|20|4.73|0.3|F3III|",
            "13:18:24.3|-18:18:41|85|61|4.74|0.71|G6V|",
            "13:51:47.5|34:26:39|-1||4.74|1.66|K5III|",
            "13:53:12.5|-31:55:40|18|4|4.73|-0.14|B4IV|",
            "15:41:56.8|-19:40:44|48|43κ|4.74|1.57|M0-IIIb|",
            "16:53:59.7|-42:21:44|72|ζ1|4.73|0.49|B1Iape|",
            "17:16:36.7|0:26:43|58|41|4.73|1.14|K2III|",
            "19:31:46.3|34:27:11|30|8|4.74|-0.14|B3IV|",
            "20:52:39.2|-8:59:0|3|6μ|4.73|0.32|A3m|",
            "20:59:49.6|47:31:16|30|59|4.74|-0.05|B1ne|",
            "21:37:55.2|62:4:55|19|9|4.73|0.3|B2Ib|",
            "21:42:39.5|-18:51:59|15|43κ|4.73|0.88|G8III|",
            "21:44:8.6|28:44:34|30|78μ1|4.73|0.48|F6V|",
            "22:47:29.0|83:9:14|-1||4.74|1.26|K3III|",
            "23:37:51.0|-45:29:33|-1||4.74|0.08|A2V|",
            "1:53:31.8|19:17:37|6|5γ2|4.75|-0.04|A1pSi|",
            "2:32:5.2|-15:14:41|20|76σ|4.75|0.45|F4IV|",
            "2:39:48.0|-42:53:30|-1||4.75|0.06|A2V|",
            "2:51:2.3|-21:0:15|35|2τ2|4.75|0.91|K0III|",
            "2:50:28.5|-75:4:1|42|ν|4.75|1.33|K3III|",
            "8:11:25.9|-42:59:14|-1||4.75|0.18|A5Ib|",
            "10:33:13.9|40:25:32|-1||4.75|0.23|A7IV|",
            "14:9:54.8|-53:26:21|-1||4.75|0.94|G9-III|",
            "14:16:9.9|51:22:2|8|21ι|4.75|0.2|A9V|",
            "15:42:41.0|-34:42:38|49|4ψ2|4.75|-0.14|B5V|",
            "19:3:6.9|-42:5:43|25|ζ|4.75|-0.02|B9.5V|",
            "23:18:37.5|68:6:42|19|34ο|4.75|0.84|K0III|",
            "0:31:25.0|-48:48:13|63|λ1|4.77|0.02|A0V|",
            "0:44:11.4|-10:36:34|20|17φ1|4.76|1.01|K0III|",
            "0:53:0.5|-1:8:39|20|20|4.77|1.57|M0III|",
            "1:19:28.0|27:15:51|65|90υ|4.76|0.03|A3V|",
            "3:5:32.4|56:42:21|-1||4.76|1.02|G9.5III|",
            "5:32:43.7|32:11:31|7|25χ|4.76|0.34|B5Iab|",
            "6:47:19.8|8:2:14|54|17|4.77|1.4|K4III|",
            "7:14:38.2|-48:16:18|-1||4.76|-0.1|B8-9V|",
            "8:9:0.7|-61:18:9|-1||4.76|0.43|F5V|",
            "8:41:13.1|-47:19:1|-1||4.77|0.12|A5II|",
            "9:2:32.7|67:37:47|82|8ρ|4.76|1.53|M3III-IIIbCa1|",
            "9:41:17.0|-23:35:30|-1||4.77|-0.12|B6Ve|",
            "11:30:18.9|-3:0:13|45|87|4.77|1.54|K3.5IIIFe-1|",
            "13:27:27.2|-15:58:25|85|69|4.76|1.09|K0-III-IVCN2Fe0.5|",
            "14:20:42.5|-45:11:14|-1||4.77|0.31|F0IV|",
            "14:23:5.8|-27:45:14|41|51|4.77|1.31|K4III|",
            "15:3:47.4|47:39:16|8|44|4.76|0.65|F9-G1Vn|",
            "15:51:15.9|20:58:40|75|38ρ|4.76|1.54|K5-III|",
            "16:4:22.1|-11:22:23|72|ξ|4.77|0.47|F5IV|",
            "16:2:47.9|46:2:12|39|6υ|4.76|-0.11|B9III|",
            "16:8:58.3|36:29:27|26|16τ|4.76|1.01|K1-III-IV|",
            "17:40:23.6|-49:24:56|5|λ|4.77|0.4|F3IV|",
            "17:59:47.6|-23:48:58|71|4|4.76|-0.04|B9V|",
            "18:32:34.5|57:2:44|33|45|4.77|0.61|F7Ib|",
            "19:16:13.0|21:23:25|87|1|4.77|-0.05|B4IV|",
            "20:3:33.5|-37:56:27|-1||4.77|1.41|K5III|",
            "20:20:39.8|-12:45:33|15|8ν|4.76|-0.05|B9.5V|",
            "20:35:34.8|-60:34:54|60|φ1|4.76|0.28|F1III|",
            "23:7:6.8|25:28:6|61|56|4.76|1.34|G8Ib|",
            "1:57:55.7|23:35:46|6|9λ|4.79|0.28|F0V|",
            "3:54:17.5|-2:57:17|35|32|4.79|0.94|G8III|",
            "4:30:33.7|16:11:38|-1||4.78|0.17|A6IV|",
            "4:52:38.0|36:42:11|7|2|4.78|1.41|K2.5IIIbBa0.4|",
            "4:59:55.8|-12:32:15|35|64|4.79|0.26|F0IV|",
            "5:35:2.7|-6:0:7|-1||4.78|-0.25|B0.5V|",
            "5:52:26.4|1:51:18|59|56|4.78|1.38|K1.5IIb|",
            "6:39:19.9|42:29:20|7|50ψ2|4.79|1.23|K3III|",
            "7:16:36.8|-23:18:56|-1||4.79|1.71|K3Ib-II|",
            "7:57:40.1|-30:20:5|-1||4.79|0.15|A2V|",
            "8:13:29.6|-35:53:59|-1||4.78|-0.11|B1.5IIIe|",
            "9:19:46.4|-11:58:30|41|26|4.79|0.93|G8III|",
            "9:44:12.1|-27:46:10|1|θ|4.79|0.51|A8V+F7II-III|",
            "10:19:44.1|19:28:15|45|40|4.79|0.45|F6IV|",
            "11:19:7.9|38:11:8|82|55|4.78|0.12|A1Vp:|",
            "12:54:21.2|-9:32:20|85|40ψ|4.79|1.6|M3-IIICa-1|",
            "12:58:55.4|17:24:34|24|36|4.78|1.56|M1-IIIb|",
            "16:18:17.9|-28:36:50|-1||4.78|0.02|A0V|",
            "16:30:12.4|-25:6:54|72|22|4.79|-0.11|B2V|",
            "17:21:59.4|-67:46:14|2|ζ|4.78|1.21|K2-III|",
            "18:45:26.9|-64:52:17|-1||4.79|0.2|A5IV-V|",
            "20:15:15.9|25:35:31|-1||4.78|-0.18|B3Ve|",
            "20:28:51.6|-17:48:49|15|11ρ|4.78|0.38|F2IV|",
            "20:53:14.8|44:23:14|30|57|4.78|-0.14|B5V|",
            "22:9:48.4|72:20:28|19|24|4.79|0.92|G7II-III|",
            "22:15:36.9|-41:20:48|38|μ1|4.79|0.8|G8III+G|",
            "22:27:51.5|4:41:44|61|35|4.79|1.05|K0III|",
            "22:41:45.4|29:18:27|61|43ο|4.79|-0.01|A1IV|",
            "0:1:35.7|-77:3:57|57|θ|4.78|1.27|K3III|",
            "0:14:36.2|20:12:24|61|89χ|4.8|1.57|M2+III|",
            "0:27:55.7|-33:0:26|73|η|4.81|1.64|M4III|",
            "0:42:3.9|50:30:45|17|19ξ|4.8|-0.11|B2V|",
            "3:15:50.0|-8:49:11|35|13ζ|4.8|0.23|A5m|",
            "3:46:2.3|63:20:42|-1||4.8|0.8|G0III+A3V|",
            "4:24:5.8|17:26:38|77|64δ2|4.8|0.15|A7V|",
            "5:1:26.3|-7:10:26|35|65ψ|4.81|-0.19|B3V|",
            "5:38:53.1|-7:12:47|59|49|4.8|0.13|A4V|",
            "6:18:50.8|69:19:11|-1||4.8|0.03|A0Vn|",
            "6:10:17.9|-54:58:7|64|δ|4.81|-0.23|B3III+O9V|",
            "9:10:23.2|67:8:5|82|13σ2|4.8|0.49|F6IV|",
            "9:20:29.0|-9:33:21|41|27|4.8|0.93|G8III-IV+F5V|",
            "9:20:56.8|-62:24:17|-1||4.81|0.94|G6III|",
            "9:35:3.8|39:37:17|-1||4.81|0.99|G9.5IIIFe-1|",
            "12:22:30.3|25:50:46|24|12|4.81|0.49|G0III-IV+A3V|",
            "12:24:1.5|51:33:44|12|5|4.8|0.87|G6IIIBa0.2|",
            "12:34:51.1|22:37:45|24|23|4.81|0.0|A0IV|",
            "13:7:10.7|27:37:29|24|41|4.8|1.48|K5III|",
            "13:15:14.9|-67:53:40|55|η|4.8|-0.08|B8V|",
            "13:17:36.3|5:28:11|85|60σ|4.8|1.67|M1III|",
            "14:17:59.8|35:30:34|-1||4.81|1.06|K0III|",
            "14:28:12.1|-2:13:41|85|105φ|4.81|0.7|G2IV|",
            "14:43:25.4|26:31:40|8|34|4.81|1.66|M3-III|",
            "15:2:6.5|25:0:29|8|41ω|4.81|1.5|K4-IIIabCa0.5|",
            "17:31:25.0|-23:57:46|58|51|4.81|0.0|B9.5Ve|",
            "17:36:57.1|68:45:29|33|28ω|4.8|0.43|F5V|",
            "17:50:11.2|-40:5:26|72|ι2|4.81|0.26|A2Ib|",
            "18:25:21.0|-20:32:30|71|21|4.81|1.31|K2II|",
            "20:17:47.2|38:1:59|30|34|4.81|0.42|B2pe|",
            "22:21:19.3|28:19:50|61|32|4.81|0.0|B9III|",
            "22:33:0.1|-61:58:56|81|ν|4.81|1.61|M4III|",
            "23:58:24.8|51:23:19|-1||4.8|1.83|M7IIIe|",
            "0:53:4.1|61:7:27|-1||4.82|0.53|F8V|",
            "0:55:0.1|58:58:22|17|26υ1|4.83|1.21|K2III|",
            "1:27:39.4|45:24:24|0|48ω|4.83|0.42|F5IV|",
            "1:53:31.8|19:17:45|6|5γ1|4.83|0.0|B9V|",
            "1:57:10.0|-47:23:6|-1||4.83|0.88|G8III|",
            "2:8:29.3|37:51:33|0|58|4.82|0.12|A5IV-V|",
            "2:13:13.3|44:13:54|0|60|4.83|1.48|K3.5IIIBa0.5:|",
            "3:18:43.8|34:13:22|-1||4.82|1.49|K2IICN1|",
            "3:19:21.7|3:22:13|20|96κ1|4.83|0.68|G5V|",
            "5:9:42.0|15:35:50|59|15|4.82|0.32|F2IV|",
            "5:17:29.1|-34:53:43|23|ο|4.83|1.0|K0IV|",
            "5:13:45.4|-67:11:7|32|θ|4.83|1.28|K2.5IIIa|",
            "5:57:59.7|25:57:14|77|139|4.82|-0.06|B0.5II|",
            "6:39:16.7|-14:8:45|-1||4.82|1.5|K2II|",
            "6:53:32.9|-20:13:27|13|15|4.83|-0.21|B1IV|",
            "7:8:51.1|-39:39:21|-1||4.83|-0.18|B2IV-V|",
            "8:0:20.0|-63:34:3|-1||4.82|-0.17|B3V|",
            "8:21:23.0|-33:3:16|-1||4.83|1.45|K2.5II-III|",
            "8:22:31.6|-48:29:25|-1||4.82|-0.15|B1V|",
            "9:16:11.3|54:1:19|82|18|4.83|0.19|A5V|",
            "10:22:19.6|-41:39:0|-1||4.83|1.12|K1III|",
            "10:37:33.2|-13:23:4|-1||4.82|2.68|C5II|",
            "10:42:14.0|-64:27:59|-1||4.82|-0.14|B4V|",
            "10:44:6.9|-63:57:40|-1||4.82|-0.13|B5Vn|",
            "11:24:36.6|-10:51:34|28|14ε|4.83|1.56|K5III|",
            "12:26:31.6|-51:27:3|-1||4.82|-0.14|B3Vn|",
            "13:37:27.6|36:17:42|12|25|4.82|0.23|A7III|",
            "14:10:23.9|25:5:30|8|12|4.83|0.54|F9IVw|",
            "14:8:50.9|77:32:51|83|4|4.82|1.36|K3III|",
            "14:41:8.9|13:43:42|8|30ζ|4.83|0.0|A2III|",
            "15:5:7.2|-47:3:4|49|π|4.82|0.0|B5IV|",
            "15:12:49.5|-44:30:2|-1||4.82|-0.17|B3IV|",
            "15:51:13.9|35:39:27|26|11κ|4.82|1.0|K1IVa|",
            "16:2:17.7|22:48:16|75|44π|4.83|0.07|A3V|",
            "16:22:4.4|1:1:45|75|50σ|4.82|0.34|F0V|",
            "16:40:55.1|64:35:21|33|18|4.83|1.22|K0III*|",
            "16:49:14.2|45:59:0|39|52|4.82|0.09|A2VpSrCrEu|",
            "17:1:3.6|-4:13:21|58|30|4.82|1.48|K4III|",
            "17:17:19.5|33:6:0|39|68|4.82|-0.17|B1.5Vp+B5III|",
            "17:49:10.5|-31:42:12|-1||4.83|-0.04|B8V|",
            "18:25:59.1|65:33:49|33|42|4.82|1.19|K1.5IIIFe-0.5|",
            "18:46:4.5|26:39:44|-1||4.83|1.2|K3III|",
            "18:54:10.2|-22:44:42|71|32ν1|4.83|1.41|K2I+B9V:|",
            "18:57:3.7|-5:50:46|74|η|4.83|1.08|K2III|",
            "18:54:23.9|71:17:50|33|52υ|4.82|1.15|K0IIIBa0.2|",
            "19:58:57.2|-26:11:44|71|60|4.83|0.9|G6IIIBa0.2|",
            "20:13:18.0|46:48:57|30|30|4.83|0.09|A5IIIn|",
            "20:38:31.3|21:12:4|87|29|4.82|-0.02|A0V|",
            "21:20:45.6|-40:48:35|53|θ1|4.82|0.02|ApCrEuSr|",
            "22:30:38.8|-10:40:41|3|57σ|4.82|-0.06|A0IVs|",
            "23:41:45.8|-17:48:59|3|104|4.82|0.82|G0Ib-II|",
            "1:30:11.1|6:8:38|65|98μ|4.84|1.37|K4III|",
            "1:56:40.2|-22:31:37|20|56|4.85|1.42|K4III|",
            "2:3:54.7|42:19:51|0|57γ2|4.84|0.03|B8V+A0V|",
            "2:39:33.8|-11:52:20|20|83ε|4.84|0.45|F5V+F6V|",
            "2:45:32.6|-67:37:0|42|ζ|4.84|0.06|A2IV-V|",
            "3:19:59.4|65:39:8|-1||4.84|-0.15|B2.5Ven|",
            "4:13:56.4|9:15:49|77|47|4.84|0.8|G5III+A7V?|",
            "4:21:33.2|46:29:56|62|53|4.85|-0.03|B4IV|",
            "7:29:51.4|-23:1:28|-1||4.85|0.23|A5Ib|",
            "7:39:27.4|-38:18:30|-1||4.84|-0.19|B2.5V|",
            "8:8:27.4|51:30:24|50|27|4.84|0.05|A2V|",
            "10:30:37.6|55:58:50|82|36|4.84|0.52|F8V|",
            "10:35:5.5|75:42:47|-1||4.84|0.96|G8.5III|",
            "10:46:51.2|-64:23:0|-1||4.85|-0.15|B3IV|",
            "11:0:33.6|3:37:3|45|58|4.84|1.16|K1IIICN-0.5|",
            "11:45:17.1|8:15:30|85|2ξ|4.85|0.18|A4V|",
            "13:3:33.2|-49:31:38|18|ξ1|4.85|0.02|A0V|",
            "13:12:3.2|-37:48:11|-1||4.85|0.7|G3V|",
            "16:22:5.8|30:53:31|26|19ξ|4.85|0.97|K0III|",
            "16:32:36.3|11:29:17|39|29|4.84|1.49|K7III|",
            "16:45:17.8|56:46:55|-1||4.85|0.38|F2V|",
            "19:15:32.4|-25:15:24|71|42ψ|4.85|0.56|G8:III+A8V|",
            "20:48:56.3|46:6:51|30|55|4.84|0.41|B3Ia|",
            "21:4:24.3|-19:51:18|15|22η|4.84|0.17|A5V|",
            "22:5:40.8|5:3:31|61|22ν|4.84|1.44|K4III|",
            "22:43:30.0|-41:24:52|38|ρ|4.85|1.03|K0III|",
            "22:45:37.9|-53:30:1|38|η|4.85|1.18|K2IIICNIV|",
            "23:6:36.9|59:25:11|17|1|4.85|-0.03|B0.5IV|",
            "23:17:44.7|49:0:55|0|8|4.85|1.67|M2+IIIBa0.3|",
            "1:15:46.1|-68:52:34|81|κ|4.86|0.47|F6IV|",
            "2:17:3.2|34:13:27|79|8δ|4.87|0.61|G0.5V|",
            "2:35:52.5|5:35:36|20|78ν|4.86|0.87|G8III|",
            "3:11:56.3|74:23:37|-1||4.87|0.02|A2Vnn|",
            "4:14:23.7|-10:15:23|35|39|4.87|1.17|K3III|",
            "5:13:25.7|38:29:4|7|11μ|4.86|0.18|A4Vm|",
            "5:41:17.7|16:32:2|77|126|4.86|-0.13|B3IV|",
            "5:49:1.0|24:34:3|77|132|4.86|1.01|G8III|",
            "5:53:6.9|-33:48:5|23|λ|4.87|-0.15|B5V|",
            "6:46:14.1|59:26:30|50|12|4.87|0.08|A3V|",
            "8:35:19.6|-58:0:33|-1||4.86|1.0|K0III|",
            "8:42:25.5|-53:6:50|-1||4.86|-0.17|B3IV|",
            "10:8:56.3|-51:48:40|-1||4.86|-0.12|B3IV|",
            "11:18:10.9|31:31:45|82|53ξ|4.87|0.0|G0V|",
            "12:26:30.9|-63:7:21|-1||4.86|-0.12|B4IV|",
            "13:17:13.0|-66:47:1|-1||4.87|1.5|K2Ib-II|",
            "14:19:45.2|16:18:25|8|20|4.86|1.23|K3III|",
            "14:41:38.8|8:9:42|8|31|4.86|1.0|G7+IIIHdel-0.5|",
            "15:17:38.9|-63:36:38|22|ε|4.86|1.25|K2.5III|",
            "17:4:49.4|-34:7:22|-1||4.87|0.26|B1Ia|",
            "17:32:16.0|55:10:23|33|25ν2|4.87|0.28|A4m|",
            "17:43:25.8|-21:41:0|58|58|4.87|0.47|F6V|",
            "17:56:47.4|-44:20:32|-1||4.86|1.21|K2III|",
            "18:20:52.1|3:22:38|58|74|4.86|0.91|G8III|",
            "18:44:19.4|-35:38:31|-1||4.87|-0.18|B2.5V|",
            "18:58:27.7|-52:56:19|78|λ|4.87|-0.05|A0V|",
            "18:58:43.4|-37:6:27|25|ε|4.87|0.41|F2V|",
            "19:46:21.7|-19:45:40|71|56|4.86|0.93|K1III|",
            "23:47:3.5|58:39:7|17|5τ|4.87|1.11|K1IIIa|",
            "23:58:40.4|-3:33:22|65|27|4.86|0.93|G9III|",
            "0:11:15.9|-15:28:5|20|6|4.89|0.49|F7V|",
            "0:48:50.1|50:58:6|17|25ν|4.89|-0.11|B9III|",
            "1:22:20.4|45:31:44|0|46ξ|4.88|1.08|K0-IIIb|",
            "2:25:57.0|-12:17:26|20|72ρ|4.89|-0.03|B9.5Vn|",
            "3:14:54.1|21:2:40|6|58ζ|4.89|-0.01|A1V|",
            "3:18:22.1|-22:30:41|35|15|4.88|0.9|G6III|",
            "4:49:54.6|37:29:18|-1||4.88|1.44|K3.5IIIBa0.2:|",
            "5:27:38.1|21:56:13|77|114|4.88|-0.15|B2.5IV|",
            "7:13:13.4|-45:10:59|-1||4.89|-0.02|A0pSi|",
            "7:46:7.4|18:30:36|37|81|4.88|1.45|K4III-IIIb|",
            "8:39:42.5|-29:33:40|68|ζ|4.89|0.9|G4III|",
            "8:41:43.3|-15:56:36|41|9|4.88|1.06|G9.5III|",
            "8:55:31.5|-27:40:55|68|δ|4.89|0.11|A3IV|",
            "9:54:12.3|-25:55:57|-1||4.88|1.23|K2+III-IIIb|",
            "10:31:21.8|-53:42:56|-1||4.89|0.5|F6V|",
            "10:37:13.7|-27:24:45|-1||4.89|1.62|M2III|",
            "12:41:53.1|10:14:8|85|30ρ|4.88|0.09|A0V|",
            "15:58:11.4|-14:16:46|48|48|4.88|-0.1|B5IIIp|",
            "16:3:24.2|-38:36:9|-1||4.89|-0.14|B6IV|",
            "16:56:1.7|65:8:5|33|19|4.89|0.48|F6V|",
            "17:32:10.6|55:11:3|33|24ν1|4.88|0.26|A6V|",
            "17:57:47.7|-41:42:58|-1||4.88|1.65|M0III|",
            "19:44:16.6|37:21:16|30|15|4.89|0.95|G7+III|",
            "20:37:35.3|-61:31:48|60|ρ|4.88|0.43|F5DelDel|",
            "20:36:43.6|-2:33:0|4|70|4.89|1.6|K5II|",
            "20:49:29.0|-46:13:37|43|ζ|4.89|1.52|K5III|",
            "22:39:15.7|39:3:1|44|10|4.88|-0.2|O9V|",
            "23:59:0.5|55:45:18|17|8σ|4.88|-0.07|B1V|",
            "1:25:37.2|-14:35:56|20|46|4.9|1.23|K2.5IIIb|",
            "2:33:50.7|-28:13:57|36|ω|4.9|-0.05|B9.5V|",
            "2:42:14.9|40:11:38|62|12|4.91|0.59|F9V|",
            "4:31:52.7|0:2:38|35|45|4.91|1.32|K3II-III|",
            "5:1:25.6|-20:3:7|-1||4.91|-0.05|B9.5Vn|",
            "5:42:28.6|1:28:29|59|51|4.91|1.17|K1III|",
            "5:49:32.9|12:39:4|77|134|4.91|-0.07|B9IV|",
            "6:19:59.6|-2:56:40|-1||4.9|1.6|M1III|",
            "6:24:53.9|49:17:17|7|46ψ1|4.91|1.97|K5-M0Iab-Ib|",
            "6:57:37.1|45:5:39|50|16|4.9|0.03|A2Vn|",
            "7:11:39.3|39:19:14|7|63|4.9|1.45|K4III-IIIa|",
            "7:39:9.9|34:35:3|37|71ο|4.9|0.4|F3III|",
            "10:38:35.0|-16:52:36|41|φ3|4.91|0.92|G8IIIFe-0.5|",
            "11:46:31.1|-40:30:2|-1||4.91|0.66|G3V|",
            "11:51:51.2|-65:12:22|-1||4.9|-0.11|B4V|",
            "11:59:37.3|-78:13:19|21|ε|4.91|-0.06|B9Vn|",
            "12:50:41.2|-33:59:58|-1||4.91|-0.04|A0IV|",
            "12:53:17.8|21:14:42|24|35|4.9|0.9|G8III+F6V|",
            "13:0:16.5|30:47:6|24|37|4.9|1.17|G9IIICH-2Fe1Ca1|",
            "13:49:42.8|21:15:51|8|6|4.91|1.43|K4III|",
            "14:10:50.5|-16:18:7|-1||4.91|1.72|M2IIIa|",
            "14:18:13.8|-81:0:28|2|η|4.91|0.25|A2m|",
            "15:14:37.3|-31:31:9|49|1|4.91|0.37|F1II|",
            "16:28:28.1|-70:5:4|80|ζ|4.91|0.55|F9V|",
            "16:38:44.9|48:55:42|39|42|4.9|1.55|M2.5IIIab|",
            "17:5:22.7|12:44:27|39|60|4.91|0.12|A4IV|",
            "18:43:31.3|-8:16:31|74|ε|4.9|1.12|G8IIb|",
            "19:35:13.0|-48:5:57|78|ι|4.9|1.09|K0III|",
            "20:29:39.0|-2:53:8|4|69|4.91|1.15|K2III|",
            "20:44:52.5|25:16:14|87|30|4.91|1.18|K2III|",
            "20:49:58.1|-33:46:47|53|α|4.9|1.0|G7III|",
            "21:34:46.6|38:32:3|30|72|4.9|1.08|K0.5III|",
            "21:56:39.1|63:37:32|-1||4.91|1.77|M2Iaep+B8Ve|",
            "22:55:13.7|8:48:57|61|50ρ|4.9|0.0|A1V|",
            "23:30:2.0|58:32:56|-1||4.91|-0.12|B3IV|",
            "2:59:3.7|35:10:59|62|24|4.93|1.23|K2III|",
            "4:10:50.6|-41:59:37|40|δ|4.93|0.33|A9V|",
            "4:20:24.6|34:34:0|62|54|4.93|0.94|G8III|",
            "6:4:59.1|-16:29:4|47|17|4.93|0.24|A2eShell|",
            "6:38:37.6|-48:13:13|-1||4.93|0.87|G8III|",
            "7:3:53.7|-49:35:2|-1||4.93|0.13|A4IV|",
            "7:10:13.7|-4:14:14|54|20|4.92|1.03|K0III|",
            "7:59:44.1|-3:40:47|54|27|4.93|1.21|K2III|",
            "8:49:47.7|-45:18:29|-1||4.93|0.05|A2III|",
            "8:56:58.4|-59:13:46|-1||4.92|-0.19|B2IV-V|",
            "10:31:2.0|-73:13:18|-1||4.93|1.68|K4-5III|",
            "12:41:56.6|-59:41:9|-1||4.93|-0.04|B6IVe|",
            "13:0:43.8|56:21:59|82|78|4.93|0.36|F2V|",
            "13:14:14.8|-59:6:12|-1||4.92|0.48|F7IV|",
            "13:13:43.0|40:9:10|-1||4.92|1.06|G8IIIaCN0.5|",
            "14:22:37.0|-58:27:34|-1||4.92|0.86|G8III+F5V|",
            "14:44:59.2|-35:11:31|-1||4.92|0.01|A0V|",
            "15:0:58.4|-8:31:8|48|19δ|4.92|0.0|B9.5V|",
            "15:7:18.1|24:52:9|8|45|4.93|0.43|F5V|",
            "16:5:26.5|-19:48:7|72|8β2|4.92|-0.02|B2V|",
            "18:53:13.6|50:42:30|-1||4.92|0.9|G7IIIaFe-1|",
            "19:0:0.9|32:8:44|51|15λ|4.93|1.47|K2.5IIIBa0.5|",
            "19:6:25.1|-37:3:48|25|γ|4.93|0.52|F8V|",
            "19:55:37.8|52:26:20|30|24ψ|4.92|0.12|A4Vn|",
            "20:9:25.6|36:50:23|30|28|4.93|-0.13|B2.5Ve|",
            "20:47:10.8|34:22:27|-1||4.92|1.32|K3III|",
            "22:10:8.8|-32:32:54|66|15τ|4.92|0.48|F6V|",
            "23:43:59.5|29:21:42|61|78|4.93|0.95|K0III|",
            "0:43:28.1|47:1:29|17|20π|4.94|0.18|A5V|",
            "1:40:34.8|40:34:37|0|53τ|4.94|-0.09|B8III|",
            "1:41:47.2|42:36:49|-1||4.95|0.62|G1.5V|",
            "2:12:22.3|30:18:11|79|6|4.94|0.78|G5III+F5V|",
            "3:21:26.5|43:19:46|62|32|4.95|0.04|A3V|",
            "4:17:15.6|20:34:43|77|50ω2|4.94|0.26|A3m|",
            "4:20:21.3|27:21:3|77|52φ|4.95|1.15|K1III|",
            "4:59:15.4|37:53:25|7|4ω|4.94|0.04|A1V|",
            "5:19:16.6|22:5:47|77|109|4.94|0.93|G8III|",
            "5:24:44.8|1:50:47|59|25ψ1|4.95|-0.2|B1Vpe|",
            "5:40:50.6|-1:7:44|-1||4.95|-0.21|B2IV-V|",
            "6:1:50.4|-10:35:53|54|3|4.95|-0.12|B5III|",
            "6:12:3.3|16:7:50|59|69|4.95|-0.14|B5Vn|",
            "6:56:16.0|-48:43:16|-1||4.95|1.69|M1III|",
            "7:35:39.7|-52:32:2|-1||4.94|1.4|K3III|",
            "7:40:23.2|-15:15:49|-1||4.94|1.56|K3II|",
            "8:3:31.1|27:47:39|37|χ|4.94|1.12|K1.5III|",
            "9:15:36.7|-38:34:12|-1||4.94|1.11|K0III|",
            "9:42:14.4|-23:54:56|-1||4.94|0.53|F9IV|",
            "9:54:52.2|-19:0:34|-1||4.94|1.57|M1III|",
            "11:5:19.9|-27:17:37|41|χ1|4.94|0.36|F3IV|",
            "11:27:56.2|2:51:22|45|84τ|4.95|1.0|G7.5IIIa|",
            "11:40:53.6|-62:5:24|-1||4.94|1.15|G3Ib|",
            "12:16:20.5|23:56:43|24|7|4.95|0.97|G8IIIFe-0.5|",
            "12:26:24.1|27:16:6|24|14|4.95|0.27|F0p|",
            "12:30:6.7|69:12:4|33|4|4.95|1.62|M3IIIa|",
            "12:34:44.0|70:1:19|33|6|4.94|1.31|K3III*|",
            "12:51:41.9|27:32:26|24|31|4.94|0.67|G0III|",
            "13:9:3.3|-23:7:5|41|45ψ|4.95|1.05|K1III|",
            "13:34:7.9|3:39:32|85|78|4.94|0.03|A1pSrCrEu|",
            "14:40:43.6|16:25:6|8|29π1|4.94|-0.03|B9pMnHgSi|",
            "14:46:0.1|-25:26:35|41|54|4.94|0.35|F2III-IV|",
            "14:51:1.0|-2:17:57|48|11|4.94|0.98|G8III-IV|",
            "15:24:11.9|-10:19:20|48|31ε|4.94|0.44|F5IV|",
            "15:57:47.4|54:44:59|-1||4.95|0.26|F0IV|",
            "16:13:28.7|-54:37:50|56|κ|4.94|1.04|G8III|",
            "16:12:0.0|-10:3:51|72|15ψ|4.94|0.09|A3IV|",
            "16:17:30.3|75:45:19|83|21η|4.95|0.37|F5V|",
            "16:34:5.0|-44:2:43|56|μ|4.94|0.05|B0Ia|",
            "18:20:17.9|21:57:41|39|106|4.95|1.59|M1III|",
            "19:36:53.5|-7:1:39|4|39κ|4.95|0.0|B0.5III|",
            "19:51:4.1|22:36:36|87|12|4.95|-0.14|B2.5Ve|",
            "19:55:51.7|38:29:12|30|22|4.94|-0.08|B5IV|",
            "20:7:23.2|-52:52:51|78|ξ|4.94|1.62|M1IIab|",
            "20:14:16.6|15:11:51|4|67ρ|4.95|0.08|A2V|",
            "20:30:3.5|48:57:6|30|45ω1|4.95|-0.09|B2.5IV|",
            "22:52:2.0|43:18:45|44|15|4.94|1.56|M0III|",
            "22:56:26.0|49:44:1|-1||4.95|1.78|K5Ib|",
            "23:26:56.0|1:15:20|65|8κ|4.94|0.03|A0pCrSi:Sr:|",
            "23:46:2.1|46:25:13|0|20ψ|4.95|1.11|G5Ib+A0V|",
            "0:4:30.1|-10:30:34|20|3|4.94|1.63|K3Ib|",
            "1:15:11.1|-45:31:53|63|ν|4.96|0.58|F8V|",
            "3:42:22.5|33:57:54|62|40|4.97|-0.01|B0.5V|",
            "4:1:18.2|-61:4:44|69|ι|4.97|1.42|K4III|",
            "4:28:26.4|16:21:35|77|75|4.97|1.13|K2III|",
            "5:55:29.9|-37:7:15|23|ξ|4.97|1.11|K1III|",
            "7:31:4.4|82:24:41|-1||4.96|1.66|M4IIIa|",
            "7:22:13.5|-19:1:0|-1||4.96|-0.04|B7IV|",
            "7:33:47.9|-14:31:26|-1||4.97|1.41|M2Iabpe+B2V|",
            "7:53:29.8|26:45:57|37|83φ|4.97|0.09|A3V|",
            "9:5:58.4|5:5:32|41|18ω|4.97|1.22|K2II-III|",
            "9:31:56.7|11:17:59|45|5ξ|4.97|1.05|K0-III-IIIb|",
            "10:24:7.9|65:33:59|-1||4.97|-0.06|A0pSiSr:Hg:|",
            "11:49:56.6|-70:13:33|-1||4.97|1.4|G6Ib|",
            "12:20:21.0|3:18:45|85|16|4.96|1.16|K0-IIIbFe-1|",
            "13:29:42.8|-23:16:53|-1||4.97|1.6|M7IIIe|",
            "13:49:52.3|-18:8:3|85|89|4.97|1.06|K0.5III-IIIb|",
            "14:28:10.4|-29:29:30|41|52|4.97|-0.07|B8V|",
            "15:40:16.9|-23:49:5|48|42|4.96|1.33|K3IIICN1|",
            "15:31:24.9|77:20:58|83|15θ|4.96|1.58|K5III|",
            "16:41:34.4|-17:44:32|-1||4.96|1.11|G7.5IICN1Ba0.4|",
            "18:1:30.4|21:35:44|39|95|4.96|0.12|A5IIIn|",
            "18:11:54.2|31:24:19|39|104|4.97|1.65|M3III|",
            "18:31:45.4|-45:54:54|78|δ1|4.96|-0.11|B6IV|",
            "19:17:38.1|-18:57:11|71|43|4.96|1.02|G8II-III|",
            "19:24:7.6|29:37:17|30|2|4.97|-0.1|B3IV|",
            "19:55:55.4|58:50:46|-1||4.96|1.59|K5II-III|",
            "20:14:32.0|36:48:23|30|29|4.97|0.14|A2V|",
            "1:20:4.9|58:13:54|17|34φ|4.98|0.68|F0Ia|",
            "1:39:21.0|44:23:10|0|52χ|4.98|0.89|G8III|",
            "1:42:43.5|-3:41:25|-1||4.99|1.38|K3II-III|",
            "1:56:0.0|68:41:7|17|46ω|4.99|-0.1|B8III|",
            "2:9:25.3|25:56:23|6|14|4.98|0.33|F2III|",
            "2:58:47.8|-64:4:17|40|β|4.99|0.13|A3-5IIIm:|",
            "3:28:3.1|49:3:46|-1||4.98|-0.09|B5V|",
            "5:24:39.2|37:23:8|7|21σ|4.99|1.42|K4III|",
            "5:24:25.4|17:23:0|77|111|4.99|0.53|F8V|",
            "5:54:50.8|55:42:25|7|30ξ|4.99|0.05|A2V|",
            "6:17:54.8|61:30:55|50|1|4.98|1.83|M3IIIab|",
            "6:50:52.4|-34:22:2|-1||4.99|1.38|K5III|",
            "7:2:54.8|-4:14:21|54|19|4.99|-0.2|B1V|",
            "7:18:40.3|-24:33:32|13|29|4.98|-0.15|O7Ia:fp|",
            "7:25:38.9|9:16:34|14|2ε|4.99|1.01|G6.5IIb|",
            "7:43:0.4|58:42:37|50|24|4.99|0.08|A3IVn|",
            "8:13:20.0|-15:47:18|67|20|4.99|1.07|G5II|",
            "8:29:27.6|-44:43:30|-1||4.99|-0.16|B2IV|",
            "8:40:1.5|-12:28:31|41|6|4.98|1.42|K4III|",
            "10:22:58.1|-66:54:6|-1||4.99|-0.13|B8V|",
            "11:0:44.8|6:6:5|45|59|4.99|0.16|A5III|",
            "11:22:49.6|43:28:58|82|56|4.99|0.99|G7.5IIIa:Ba0.3|",
            "12:45:7.8|45:26:25|-1||4.99|2.54|C7I|",
            "13:28:25.8|13:46:44|85|70|4.98|0.71|G4V|",
            "13:34:47.8|37:10:57|-1||4.98|0.4|F2IV|",
            "15:59:30.3|-41:44:40|-1||4.99|1.0|K0II-III|",
            "16:1:26.6|29:51:4|26|14ι|4.99|-0.07|A0p:Hg:|",
            "16:17:0.9|-50:4:6|56|γ1|4.99|0.8|F9Ia|",
            "17:3:7.8|14:5:31|-1||4.98|1.6|M3III|",
            "18:11:43.4|-23:42:4|71|11|4.98|1.05|K0III|",
            "18:23:54.5|58:48:2|33|39|4.98|0.08|A1V|",
            "18:55:7.1|-22:40:17|71|35ν2|4.99|1.33|K3II-IIIBa0.8CN2|",
            "18:56:14.6|4:12:7|75|63θ2|4.98|0.2|A5Vn|",
            "19:6:25.1|-37:3:48|25|γ|4.99|0.52|F8V|",
            "19:13:55.2|57:42:18|33|54|4.99|1.16|K2III|",
            "19:46:25.6|33:43:40|30|17|4.99|0.47|F7V|",
            "20:4:19.6|-32:3:23|-1||4.99|1.21|K1III|",
            "22:8:26.0|-34:2:38|66|υ|4.99|1.48|M1III|",
            "23:18:57.7|-9:36:39|3|95ψ3|4.98|-0.02|A0V|",
            "23:24:50.3|62:16:58|17|4|4.98|1.68|M1III|",
            "23:33:57.2|31:19:31|61|72|4.98|1.38|K4IIIb|",
            "3:42:14.9|-31:56:18|36|δ|5.0|-0.16|B5IV|",
            "3:57:8.3|61:6:32|-1||5.0|1.45|K3I-II+A3V:|",
            "5:6:40.6|51:35:52|7|9|5.0|0.33|F0V|",
            "5:7:27.0|18:38:42|77|104|5.0|0.65|G4V|",
            "5:22:50.0|3:32:40|59|23|5.0|-0.15|B1V|",
            "6:56:6.6|-14:2:37|13|18μ|5.0|1.18|G5III+A2|",
            "7:13:22.3|16:9:32|37|51|5.0|1.66|M4IIIab|",
            "9:11:4.4|-44:52:5|-1||5.0|0.23|B5Ia|",
            "9:37:12.7|6:50:9|45|10|5.0|1.05|K1III|",
            "10:43:4.1|69:4:34|-1||5.0|1.38|K3III-IIIb|",
            "11:23:12.7|-36:9:53|-1||5.0|1.46|K6III|",
            "12:16:30.1|33:3:41|-1||5.0|1.14|K0.5IIIb|",
            "12:18:59.7|-55:8:35|-1||5.0|1.59|M1III|",
            "12:26:59.3|26:49:32|24|16|5.0|0.08|A4V|",
            "15:22:8.3|-47:55:40|49|ν1|5.0|0.5|F8V|",
            "16:3:20.6|-25:51:55|-1||5.0|1.22|K5III|",
            "16:8:4.5|17:2:49|39|7κ|5.0|0.95|G8III|",
            "16:27:59.0|68:46:5|33|15|5.0|-0.06|A0III|",
            "17:20:18.9|18:3:26|-1||5.0|1.62|M2IIIab|",
            "18:7:28.8|43:27:42|-1||5.0|0.91|G8IIICN-1CH-3|",
            "19:34:34.9|19:46:24|87|9|5.0|-0.09|B8IIIn|",
            "19:48:58.7|19:8:32|70|8ζ|5.0|0.1|A3V|",
            "21:18:27.2|43:56:45|30|68|5.0|-0.01|O7.5III:n((f))|",
            "23:0:5.1|56:56:43|-1||5.0|1.42|G40|",
            "23:39:47.1|-14:13:18|3|102ω1|5.0|0.24|F0IV|",
            "23:57:35.2|-64:17:54|81|η|5.0|0.06|A1V|",
            "2:22:52.3|-73:38:45|42|κ|5.01|1.09|K1III|",
            "4:38:53.6|-12:7:23|-1||5.01|0.07|A2IV|",
            "5:2:9.8|-26:16:30|-1||5.02|1.07|K1III|",
            "5:15:24.4|32:41:16|7|14|5.02|0.23|A9IVDelDel|",
            "6:7:31.6|-37:15:11|23|θ|5.02|-0.11|B9IV|",
            "6:15:44.9|-13:43:6|-1||5.01|-0.08|B9Vn|",
            "6:11:15.0|-65:35:22|32|η2|5.01|1.62|M2.5III|",
            "6:43:5.0|44:31:28|7|55ψ4|5.02|1.48|K5III|",
            "6:50:45.9|41:46:53|7|58ψ7|5.02|1.27|K3III|",
            "7:29:48.7|27:54:58|37|65|5.01|1.11|K2III|",
            "7:52:15.7|-34:42:19|-1||5.01|0.44|F5V|",
            "8:34:43.6|-49:56:39|-1||5.01|1.33|K1-2II|",
            "9:33:12.5|-21:6:57|-1||5.01|1.02|K0IV|",
            "9:34:8.8|-51:15:19|-1||5.01|-0.18|B1.5IV|",
            "10:32:56.9|-47:0:12|-1||5.02|1.04|K4III|",
            "12:25:50.9|39:1:7|12|6|5.02|0.96|G9III|",
            "12:35:7.8|18:22:37|24|24|5.02|1.15|K2III|",
            "13:41:44.7|-54:33:36|-1||5.01|-0.05|B8Vn|",
            "13:41:36.8|-8:42:11|85|82|5.01|1.63|M1.5III|",
            "13:56:34.2|27:29:31|8|9|5.01|1.42|K3III|",
            "14:12:15.8|2:24:34|-1||5.01|-0.12|A0VpSi|",
            "15:17:5.9|71:49:26|83|11|5.02|1.37|K4III|",
            "15:30:55.8|40:49:59|8|52ν1|5.02|1.59|K4.5IIIbBa0.4|",
            "15:31:47.0|40:53:58|8|53ν2|5.02|0.07|A5V|",
            "16:25:35.2|-23:26:50|58|5ρ|5.02|0.24|B2IV|",
            "17:49:4.3|50:46:52|33|30|5.02|0.02|A2V|",
            "18:44:49.9|2:3:36|4|4|5.02|-0.06|B9V|",
            "19:1:26.4|46:56:5|51|16|5.01|0.19|A7V|",
            "19:20:32.9|-5:24:57|4|26|5.01|0.92|G8III-IV|",
            "19:57:57.0|-15:29:29|71|61|5.02|0.05|A3IV|",
            "20:54:33.6|28:3:27|87|32|5.01|1.48|K4III|",
            "21:13:20.5|-70:7:35|60|ο|5.02|1.58|M1-2III|",
            "21:36:57.0|40:24:49|30|74|5.01|0.18|A5V|",
            "21:47:44.2|-30:53:54|66|10θ|5.01|0.04|A2V|",
            "22:21:31.1|12:12:19|61|31|5.01|-0.13|B2IV-Ve|",
            "0:2:19.9|-29:43:13|73|ζ|5.01|-0.15|B4III|",
            "0:10:19.3|46:4:20|0|22|5.03|0.4|F2II|",
            "1:8:0.9|43:56:31|0|41|5.03|0.11|A3m|",
            "1:46:6.3|-53:31:19|-1||5.04|0.04|A1V|",
            "2:2:18.1|54:29:15|62|4|5.04|-0.08|B8III|",
            "2:6:33.9|22:38:54|6|12κ|5.03|0.11|A2m|",
            "2:18:57.0|28:38:33|79|10|5.03|0.04|A2V|",
            "3:16:12.2|50:56:16|-1||5.03|1.15|G6Ib-IIa|",
            "3:19:7.6|50:5:42|62|31|5.03|-0.06|B5V|",
            "3:57:25.5|63:4:20|-1||5.03|-0.09|B9.5V|",
            "4:28:50.2|13:2:51|77|79|5.03|0.23|A7V|",
            "4:50:11.6|-16:13:2|35|60|5.03|0.98|K0III|",
            "5:4:58.0|-49:34:40|64|η2|5.03|1.49|K5III|",
            "5:20:0.9|33:57:29|7|19|5.03|0.27|A5II|",
            "5:59:4.3|-9:33:30|54|2|5.03|0.19|A6IIImvs|",
            "6:3:15.5|-26:17:4|-1||5.04|1.34|K3III|",
            "6:16:26.6|12:16:20|59|74|5.04|0.42|F5IV-V|",
            "7:16:49.5|-36:35:34|-1||5.03|-0.17|B2IV-V|",
            "7:23:28.5|25:3:2|37|57|5.03|0.9|G8III|",
            "7:45:56.9|-14:33:50|67|4|5.04|0.33|F0V|",
            "10:55:44.4|33:30:25|82|46|5.03|1.1|K1III|",
            "11:32:54.1|-31:5:14|-1||5.04|1.58|M2IIIb|",
            "11:43:31.2|-62:29:22|-1||5.03|0.8|G00-IaFe1|",
            "12:4:46.5|-76:31:9|21|κ|5.04|1.49|K4III|",
            "13:12:3.5|-16:11:55|85|53|5.04|0.46|F5III-IV|",
            "14:52:51.1|-37:48:12|-1||5.03|-0.16|B7IIIp|",
            "15:53:20.1|-20:10:2|48|45λ|5.03|-0.01|B2.5V|",
            "16:28:38.5|41:52:54|39|30|5.04|1.52|M6-III|",
            "16:51:45.3|24:39:23|39|51|5.04|1.25|K0.5IIIaCa0.5|",
            "17:1:52.7|-32:8:37|-1||5.03|-0.1|B8V|",
            "17:18:37.0|10:51:52|-1||5.03|1.55|K4II-III|",
            "17:49:27.0|76:57:46|33|35|5.04|0.49|F6IV-Vs|",
            "18:7:1.5|30:33:43|39|99|5.04|0.52|F7V|",
            "18:13:53.8|64:23:50|33|36|5.03|0.38|F5V|",
            "18:42:37.9|55:32:22|33|46|5.04|-0.09|B9.5pHg:|",
            "19:25:16.5|-24:30:31|71|47χ1|5.03|0.23|Am|",
            "19:30:39.8|-2:47:20|4|36|5.03|1.75|M1III|",
            "19:50:37.7|52:59:17|30|20|5.03|1.28|K3IIICN1|",
            "20:38:31.9|24:6:58|87|28|5.04|-0.14|B5IV|",
            "20:50:4.9|44:3:34|30|56|5.04|0.2|A4mDelDel|",
            "21:49:50.7|30:10:27|61|14|5.04|-0.03|A1Vs|",
            "21:59:15.0|73:10:48|19|16|5.03|0.44|F5V|",
            "22:11:30.7|59:24:52|19|22λ|5.04|0.25|O6I(n)fp|",
            "22:37:45.4|-4:13:41|3|63κ|5.03|1.14|K2III|",
            "23:46:23.5|3:29:12|65|19|5.04|2.6|C5II|",
            "23:47:54.8|67:48:25|-1||5.04|-0.01|A1Vn|",
            "0:28:2.9|17:53:35|65|47|5.06|1.65|M3III|",
            "3:12:46.4|-1:11:46|20|94|5.06|0.57|F8V|",
            "4:4:27.2|59:9:20|-1||5.06|0.5|F0II|",
            "4:39:54.7|53:4:47|10|3|5.05|1.07|K0III|",
            "4:42:3.5|-37:8:40|9|β|5.05|0.37|F1V|",
            "5:22:33.5|79:13:52|-1||5.05|0.47|F6V|",
            "5:21:46.2|-24:46:23|-1||5.06|0.67|G7II-III+A7IV-V|",
            "6:7:3.4|-62:9:17|-1||5.05|1.25|K2-3III|",
            "6:11:51.8|-6:33:1|-1||5.05|-0.2|B2V|",
            "6:8:44.2|-68:50:36|32|ν|5.06|-0.08|B8V|",
            "6:27:57.6|-4:45:44|54|10|5.06|-0.17|B2V|",
            "6:58:25.1|-34:6:42|-1||5.06|-0.16|B3V|",
            "7:18:31.9|49:27:54|-1||5.05|0.08|A4IIIn|",
            "7:29:20.4|28:7:5|37|64|5.05|0.11|A4V|",
            "7:39:28.6|17:40:29|37|74|5.05|1.56|K5IIIFe-0.5|",
            "7:42:57.2|-45:10:24|-1||5.06|0.78|G6IV|",
            "8:6:40.4|-45:15:59|-1||5.05|1.5|K3III|",
            "8:39:8.0|-22:39:43|-1||5.05|0.73|G6IV|",
            "9:40:18.4|-14:19:56|41|38κ|5.06|-0.15|B5V|",
            "9:52:30.4|-8:6:18|76|8γ|5.05|0.04|A1V|",
            "10:59:28.0|40:25:49|82|47|5.05|0.61|G1-VFe-0.5|",
            "13:25:7.1|-74:53:16|55|ι1|5.05|1.11|K0III|",
            "13:29:25.2|-51:9:55|-1||5.06|0.07|A1V|",
            "14:22:22.7|-80:6:32|2|ε|5.06|-0.1|B4V|",
            "15:19:18.8|1:45:55|75|5|5.06|0.54|F8III-IV|",
            "17:31:57.9|68:8:6|33|27|5.05|1.08|K0III|",
            "18:6:1.9|22:13:8|39|98|5.06|1.58|M3-IIIZrO0+|",
            "18:21:32.7|49:7:18|-1||5.05|1.66|M2IIIab|",
            "18:44:20.4|39:40:12|51|4ε1|5.06|0.16|A4V|",
            "19:22:51.1|-54:25:25|78|η|5.05|0.02|A0Vn|",
            "19:42:31.1|-16:7:26|71|55|5.06|0.33|F1III|",
            "19:40:50.2|45:31:30|-1||5.06|0.4|F5II-III|",
            "20:1:21.6|50:6:17|30|26|5.05|1.11|K1II-III|",
            "20:39:7.8|10:5:10|31|7κ|5.05|0.72|G2IV|",
            "20:51:30.1|-51:36:30|43|ι|5.05|1.13|K1II-III|",
            "23:16:50.9|-7:43:36|3|92χ|5.06|1.6|M3III|",
            "23:20:20.6|5:22:53|65|7|5.05|1.2|K2III|",
            "23:43:22.4|10:19:53|61|77|5.06|1.68|M2III|",
            "0:36:8.3|54:10:7|-1||5.08|-0.11|B7III|",
            "0:48:58.7|16:56:26|65|64|5.07|0.51|F8V|",
            "0:48:35.4|-74:55:24|42|λ|5.07|1.37|K5III|",
            "3:48:16.3|11:8:36|77|30|5.07|-0.13|B3V+F5V|",
            "4:30:50.1|-44:57:14|9|δ|5.07|-0.19|B2IV-V|",
            "4:39:9.2|15:47:59|77|91σ1|5.07|0.15|A4m|",
            "5:0:20.7|81:11:38|-1||5.07|1.28|K3III|",
            "5:6:8.5|58:58:21|10|11|5.08|-0.08|B2.5Ve|",
            "5:15:24.3|-26:56:36|-1||5.07|-0.1|B9V|",
            "5:24:28.9|0:53:29|59|27|5.08|0.96|G9III-IVFe-1|",
            "5:27:38.9|34:28:33|7|24φ|5.07|1.4|K3IIICN+2|",
            "5:35:22.9|-5:24:58|59|43θ2|5.08|-0.09|O9.5Vp|",
            "6:47:37.1|-8:59:54|-1||5.07|1.8|M1+Ib-IIa|",
            "7:40:30.5|87:1:12|-1||5.07|1.63|M2IIIab|",
            "7:47:25.0|-38:30:40|-1||5.08|-0.1|B2.5III|",
            "8:13:58.4|-36:19:21|-1||5.08|-0.19|B1.5IV|",
            "8:18:18.9|-65:36:48|-1||5.07|1.15|K1III|",
            "9:31:57.6|9:42:57|45|6|5.07|1.37|K2.5IIIbFe-0.5|",
            "9:49:57.1|-45:43:58|-1||5.08|-0.1|B7III|",
            "10:6:11.3|-47:22:12|-1||5.08|0.88|K1IV+G5V|",
            "10:34:0.9|-23:44:43|41|44|5.08|1.6|K4III|",
            "10:34:48.0|6:57:13|45|48|5.08|0.94|G8.5IIIFe-1Ca-1|",
            "10:36:20.3|-59:33:53|-1||5.08|1.18|K1III|",
            "10:43:25.0|23:11:18|46|41|5.08|0.04|A3Vn|",
            "11:0:50.4|39:12:44|82|49|5.08|0.24|F0Vs|",
            "11:28:35.1|-42:40:27|-1||5.08|-0.03|B9V|",
            "14:12:46.0|-27:15:40|41|50|5.08|1.16|K3III|",
            "14:14:57.0|-57:5:9|-1||5.07|-0.08|B4Vne|",
            "15:39:22.7|36:38:9|26|7ζ2|5.07|-0.12|B7V|",
            "16:4:22.1|-11:22:23|72|ξ|5.07|0.0|F5IV|",
            "16:36:13.7|52:55:28|33|17|5.08|-0.04|B9V|",
            "17:10:42.3|-44:33:27|-1||5.08|0.86|G8-K0III+G|",
            "17:9:33.3|40:46:38|-1||5.08|1.28|K3III|",
            "17:15:20.8|-26:36:5|58|36|5.07|0.85|K0V|",
            "18:32:2.0|-45:45:26|78|δ2|5.07|-0.14|B3III|",
            "18:57:20.5|-20:39:23|71|36ξ1|5.08|0.13|A0II|",
            "20:6:53.4|23:36:52|87|17|5.07|-0.18|B3V|",
            "21:53:17.8|-13:33:6|15|51μ|5.08|0.37|F1III|",
            "21:53:3.8|25:55:30|61|16|5.08|-0.17|B3Ve|",
            "22:35:46.1|73:38:35|19|31|5.08|0.39|F3III-IV|",
            "22:44:5.5|41:49:9|44|13|5.08|0.96|K0III|",
            "23:19:6.7|-13:27:32|3|94|5.08|0.8|G5IV|",
            "23:23:4.6|12:18:50|61|66|5.08|1.31|K3III|",
            "23:52:29.3|19:7:13|61|81φ|5.08|1.6|M2.5IIIb|",
            "0:32:43.8|-63:1:52|81|β3|5.09|0.04|A0V|",
            "1:57:21.1|17:49:3|6|8ι|5.1|0.92|K1p|",
            "3:22:45.2|20:44:31|6|63τ2|5.09|1.24|K3III|",
            "3:30:0.2|55:27:7|-1||5.09|0.05|A1V|",
            "3:42:9.3|63:13:0|-1||5.1|1.63|S3.5/2|",
            "3:49:11.2|24:8:12|77|28|5.09|-0.08|B8Vpe|",
            "4:10:2.8|80:41:55|-1||5.1|0.56|G8III+A6V|",
            "4:51:22.5|18:50:23|77|97|5.1|0.21|A7IV-V|",
            "6:10:14.4|-74:45:11|52|α|5.09|0.72|G6V|",
            "6:33:37.9|-1:13:13|-1||5.1|-0.14|B5Vn|",
            "7:13:32.4|-44:38:23|-1||5.1|1.56|M5IIIe|",
            "7:21:56.8|20:26:37|37|56|5.1|1.52|M0IIIab|",
            "7:26:21.9|-51:1:6|-1||5.1|1.06|K0III|",
            "7:57:18.4|-44:6:35|-1||5.09|-0.17|B2.5IV|",
            "8:27:36.5|-53:5:19|-1||5.09|0.25|A9-F0III-IV|",
            "8:50:33.5|-46:31:45|-1||5.1|-0.21|B0III|",
            "9:48:35.4|46:1:16|-1||5.09|0.62|G0.5Va|",
            "10:30:17.5|0:38:13|76|30β|5.09|-0.14|B6V|",
            "10:53:34.5|54:35:6|82|44|5.1|1.36|K3III|",
            "11:23:21.9|-18:46:48|28|13λ|5.09|0.42|F5III|",
            "12:16:0.2|14:53:56|24|6|5.1|0.06|A3V|",
            "13:16:53.1|-31:30:22|-1||5.1|0.96|K1III|",
            "13:26:7.8|-39:45:19|-1||5.09|1.2|K0.5III:Ba3|",
            "14:24:11.3|5:49:12|-1||5.1|0.12|A5V|",
            "15:16:56.7|-60:57:27|22|δ|5.09|-0.06|O8.5V|",
            "15:55:29.6|-68:36:11|80|κ|5.09|1.13|G5IIa|",
            "18:8:52.9|20:2:43|39|101|5.1|0.15|A8III|",
            "18:22:18.6|-38:39:25|-1||5.1|1.49|K4-5III|",
            "18:54:43.1|-15:36:11|-1||5.1|0.17|B5II|",
            "19:6:58.6|11:4:17|4|18|5.09|-0.07|B8III|",
            "19:18:32.5|1:5:7|4|23|5.1|1.15|K2II-III|",
            "20:5:9.5|19:59:28|70|16η|5.1|1.06|K2III|",
            "20:40:3.0|-18:8:19|15|15υ|5.1|1.66|M2III|",
            "21:39:33.3|2:14:37|3|25|5.1|1.04|K0III|",
            "21:45:0.3|-9:4:57|15|46|5.09|1.11|G8II-III|",
            "22:20:1.5|-80:26:23|57|ε|5.1|1.47|M5III|",
            "22:16:26.6|-41:37:39|38|μ2|5.1|0.92|G8III|",
            "23:2:36.3|42:45:28|0|2|5.1|0.09|A3Vn|",
            "0:1:49.4|-3:1:39|65|29|5.1|-0.12|B7III-IV|",
            "0:14:27.6|-7:46:50|-1||5.12|1.62|M3+III|",
            "0:21:46.3|-20:3:28|-1||5.12|1.82|M5IIe|",
            "1:29:36.1|-21:37:46|20|48|5.12|0.02|A1V|",
            "1:54:22.0|-42:29:49|63|φ|5.11|-0.06|A3V|",
            "2:57:17.3|31:56:3|62|21|5.11|-0.01|B9pSi|",
            "3:3:36.8|-59:44:16|40|μ|5.11|0.34|F0IV|",
            "3:49:32.6|33:5:29|62|42|5.11|0.07|A3V|",
            "3:53:38.9|-34:43:56|-1||5.11|-0.13|B6V|",
            "4:23:51.9|9:27:39|77|66|5.12|0.07|A3V|",
            "4:34:11.6|-8:13:53|35|47|5.11|1.7|M3III|",
            "5:6:45.7|-4:39:18|35|66|5.12|-0.06|B9V+A1V|",
            "5:8:43.6|-4:27:22|35|68|5.12|0.44|F2V|",
            "5:49:53.6|-66:54:4|32|ε|5.11|-0.14|B6V|",
            "6:53:42.2|68:53:18|10|43|5.12|-0.13|B7III|",
            "7:18:38.2|-36:44:34|-1||5.11|-0.16|B2IVne|",
            "7:59:5.7|-23:18:38|67|12|5.11|1.12|cK2|",
            "8:5:4.5|13:7:5|11|8|5.12|0.01|A1V|",
            "9:16:23.1|-44:15:57|-1||5.12|1.67|K3Ib|",
            "9:26:18.1|-53:22:45|-1||5.11|-0.11|B6V|",
            "9:33:44.5|-49:0:18|-1||5.12|-0.12|B4IV|",
            "9:33:53.2|-80:56:29|21|ζ|5.11|-0.14|B5V|",
            "10:41:56.6|65:42:59|82|38|5.12|1.2|K2III|",
            "11:23:21.8|-64:57:18|-1||5.11|-0.08|B5V|",
            "11:48:45.1|-26:44:59|-1||5.11|1.6|M4+III|",
            "12:46:38.7|16:34:39|24|27|5.12|1.35|K3III|",
            "14:23:22.7|8:26:48|-1||5.12|-0.02|A0V|",
            "14:44:59.2|27:4:30|8|36ε|5.12|0.0|A2V|",
            "14:56:44.0|-62:46:51|22|θ|5.11|0.0|B4Vnpe|",
            "15:35:15.0|39:0:36|26|6μ|5.11|1.64|M1.5III-IIIb|",
            "15:51:15.6|-3:5:26|75|36|5.11|0.12|A3Vnp|",
            "15:56:53.5|-33:57:59|49|ξ1|5.12|0.12|A3V|",
            "16:1:14.3|17:49:6|39|5|5.12|0.99|G8IIIbFe-0.5|",
            "17:15:21.0|-26:36:10|58|36|5.11|0.86|K1V|",
            "17:20:54.2|24:29:58|39|70|5.12|-0.03|A2V|",
            "17:24:13.0|-44:9:45|-1||5.12|-0.06|B7III|",
            "17:48:49.2|25:37:22|39|87|5.12|1.16|K2III|",
            "18:21:1.0|28:52:12|39|107|5.12|0.2|A7V|",
            "18:24:13.8|39:30:26|51|2μ|5.12|0.03|A3IVn|",
            "19:11:40.5|56:51:33|33|53|5.12|1.01|G8III|",
            "19:30:45.3|27:57:55|30|6β2|5.11|-0.1|B8Ve|",
            "19:35:7.3|-10:33:37|4|37|5.12|1.13|G9IIIa|",
            "19:51:1.6|10:24:56|4|54ο|5.11|0.55|F8V|",
            "19:50:34.0|38:43:21|30|19|5.12|1.69|M2IIIa|",
            "20:33:55.1|-44:30:58|53|ν|5.11|1.01|K0III|",
            "20:40:2.6|-60:32:56|60|φ2|5.12|0.53|F8V|",
            "20:48:29.2|-43:59:19|53|ι|5.11|0.35|F1IV|",
            "21:40:11.1|43:16:26|30|75|5.11|1.6|M1IIIab|",
            "22:5:8.9|62:16:48|19|19|5.11|0.08|O9.5Ib|",
            "23:3:29.8|-34:44:58|66|π|5.11|0.29|F0V+F3V|",
            "23:9:31.5|8:40:38|61|57|5.12|1.47|M4IIIS+A2V|",
            "23:52:6.4|-82:1:8|57|γ1|5.11|0.92|G7III|",
            "0:36:46.6|44:29:19|-1||5.13|1.6|K5-M0III|",
            "1:14:24.0|-7:55:23|20|37|5.13|0.46|F5V|",
            "2:1:42.4|-44:42:49|63|χ|5.14|1.49|K5III|",
            "2:28:1.7|-33:48:40|36|φ|5.14|0.1|A2V|",
            "3:30:24.5|11:20:11|77|4|5.14|-0.03|A0Vn|",
            "5:26:19.3|-58:54:45|32|λ|5.14|1.0|G6III|",
            "5:35:16.5|-5:23:23|59|41θ1|5.13|0.02|O6p|",
            "6:3:27.3|19:41:26|59|64|5.14|-0.11|B8III|",
            "6:17:41.7|-16:48:57|-1||5.14|1.3|K3III|",
            "6:50:57.1|67:34:19|10|42|5.14|-0.17|B4IV|",
            "6:49:54.6|-46:36:53|-1||5.14|0.45|F5V|",
            "7:3:38.0|10:57:6|-1||5.13|1.39|K3III|",
            "7:0:51.5|-51:24:9|-1||5.14|1.61|M1III|",
            "7:10:47.5|-48:55:56|-1||5.14|1.24|K2III|",
            "7:22:2.6|36:45:38|7|65|5.13|1.08|K0III|",
            "7:37:16.7|-4:6:40|54|25|5.13|0.44|F6III|",
            "7:47:30.3|33:24:56|37|80π|5.14|1.6|M1IIIa|",
            "7:51:42.0|1:46:1|14|13ζ|5.14|-0.12|B8II|",
            "8:13:36.2|-46:59:31|-1||5.13|-0.14|B2.5IV|",
            "8:20:3.9|27:13:4|11|18χ|5.14|0.47|F6V|",
            "8:25:54.8|7:33:52|-1||5.13|0.94|G7II-IIIFe-1|",
            "9:8:23.6|66:52:24|82|11σ1|5.14|1.51|K5III|",
            "9:9:21.5|22:2:44|11|77ξ|5.14|0.97|G9IIIFe-1CH-0.5|",
            "9:14:20.6|61:25:24|82|16|5.13|0.58|F9V|",
            "9:57:41.1|41:3:20|46|19|5.14|0.46|F6Vs|",
            "11:8:34.0|-61:56:50|-1||5.13|0.22|B9Ia|",
            "11:31:46.1|-59:26:32|18|ο1|5.13|1.08|G30-Ia|",
            "12:12:11.9|77:36:59|-1||5.14|0.33|A5m|",
            "12:20:55.7|-13:33:56|-1||5.14|1.05|K1III|",
            "12:35:45.5|-41:1:19|-1||5.13|0.22|A7III|",
            "14:19:32.5|-2:15:56|85|102υ|5.14|1.02|G9III|",
            "15:14:38.3|67:20:48|-1||5.13|0.53|F9IV|",
            "16:11:2.0|-29:24:59|-1||5.13|1.12|K3III|",
            "16:15:15.3|-47:22:20|56|θ|5.14|-0.13|B8V|",
            "16:46:40.0|-67:6:35|-1||5.13|-0.08|ApSi|",
            "18:31:26.3|-18:24:10|-1||5.14|0.0|A0Vp|",
            "18:35:2.4|-10:58:38|-1||5.14|0.92|G8III|",
            "18:43:46.9|-38:19:25|25|λ|5.13|0.09|A2Vn|",
            "18:44:22.9|39:36:47|51|5ε2|5.14|0.19|A8Vn|",
            "18:58:36.4|-60:12:2|60|ω|5.14|1.37|K2IIICNIV|",
            "19:9:9.8|76:33:38|33|59|5.13|0.31|A9V|",
            "19:53:17.4|57:31:25|30|23|5.14|-0.13|B5V|",
            "20:1:44.7|-59:22:34|-1||5.13|1.53|M6III|",
            "20:46:38.7|16:7:28|31|12γ1|5.14|0.49|F7V|",
            "22:6:2.0|45:0:52|-1||5.14|1.57|K5III|",
            "22:21:35.6|-21:35:54|3|47|5.13|1.07|K2III|",
            "23:58:55.8|-52:44:45|63|π|5.13|1.13|K0III|",
            "1:11:6.8|31:25:29|65|82|5.16|0.23|F0V|",
            "1:17:48.0|3:36:52|65|89|5.16|0.07|A3V|",
            "2:32:6.2|36:8:50|79|14|5.15|1.47|K5III|",
            "2:38:2.0|72:49:6|-1||5.16|0.88|G8III|",
            "3:18:37.8|50:13:20|62|29|5.15|-0.06|B3V|",
            "6:31:23.0|-12:23:30|-1||5.15|1.27|K3III|",
            "8:15:15.9|-62:54:57|-1||5.16|0.09|A2V|",
            "8:43:40.3|-49:49:22|-1||5.16|-0.2|B0IIIn|",
            "8:51:56.8|43:43:36|50|35|5.15|0.98|K0III|",
            "8:59:24.1|-59:5:1|-1||5.16|0.42|F3V|",
            "10:13:30.6|-66:22:23|-1||5.16|0.21|Am|",
            "10:35:9.7|57:4:58|82|37|5.16|0.34|F1V|",
            "11:7:16.6|-42:38:19|-1||5.15|0.03|ApSrCrEu|",
            "11:31:48.8|-59:30:57|18|ο2|5.15|0.49|A2Ia|",
            "11:37:0.6|-61:17:0|-1||5.15|1.12|K0III|",
            "11:38:7.3|-61:49:35|-1||5.15|-0.02|ApHgMn|",
            "12:3:39.6|-42:26:3|-1||5.15|0.41|F6V|",
            "12:22:7.3|-67:31:19|55|ζ2|5.15|0.19|A5V|",
            "12:57:4.4|-51:11:55|-1||5.16|-0.06|B8-9V|",
            "13:18:14.5|49:40:55|12|21|5.15|-0.07|A0V|",
            "13:46:56.4|-36:15:7|-1||5.15|-0.02|A0V|",
            "13:54:42.1|-1:30:11|85|90|5.15|1.08|K2III|",
            "13:58:31.1|-24:58:20|41|47|5.15|-0.1|B8VpShell|",
            "14:50:41.2|-15:59:50|48|8α1|5.15|0.41|F4IV|",
            "15:5:19.1|-41:4:2|-1||5.15|1.01|G8III|",
            "15:16:4.0|-41:29:28|-1||5.16|0.58|G5Ia+B|",
            "15:34:37.3|-28:2:49|48|36|5.15|1.3|K4III|",
            "16:45:49.9|8:34:57|39|43|5.15|1.53|K5III|",
            "17:44:8.7|-51:50:3|5|μ|5.15|0.7|G3IV-V|",
            "17:53:18.1|40:0:29|39|90|5.16|1.18|K1IIIbCN-1|",
            "17:59:5.2|-30:15:11|-1||5.16|1.77|M1Ib|",
            "18:32:21.4|-39:42:14|-1||5.16|0.08|A3Vn|",
            "19:6:19.9|-52:20:27|78|ρ|5.16|0.53|F7V|",
            "19:13:42.7|2:17:37|4|21|5.15|-0.07|B8II-III|",
            "19:24:58.2|11:56:40|4|31|5.16|0.77|G8IVHdel1|",
            "19:25:28.6|19:47:55|87|4|5.16|0.98|K0III|",
            "19:26:9.1|36:19:4|30|4|5.15|-0.12|B9pSi|",
            "20:15:30.2|23:30:31|87|22|5.15|1.04|G3Ib-II|",
            "20:41:57.1|-66:45:39|60|υ|5.15|-0.06|B9III|",
            "20:39:24.9|0:29:11|3|1|5.16|1.06|K1III|",
            "21:4:43.0|-77:1:26|57|α|5.15|0.49|A7III+G2III|",
            "21:5:14.2|-54:43:38|43|μ|5.16|1.21|K2III|",
            "21:22:53.6|6:48:40|34|10β|5.16|0.05|A3V|",
            "22:52:24.1|9:50:8|61|49σ|5.16|0.48|F7IV|",
            "23:11:44.2|8:43:12|61|59|5.16|0.13|A5Vn|",
            "0:21:7.3|37:58:7|0|27ρ|5.18|0.42|F5III|",
            "0:21:31.2|-28:58:54|73|ι|5.18|1.0|G5III|",
            "0:28:13.7|44:23:40|-1||5.17|0.03|A2Vs|",
            "1:8:16.4|54:55:13|17|30μ|5.17|0.69|G5Vb|",
            "1:42:55.9|70:37:21|17|42|5.18|-0.04|B9V|",
            "2:22:21.4|55:50:44|62|9|5.17|0.37|A2Ia|",
            "2:44:57.6|12:26:45|6|38|5.18|0.24|A7III-IV|",
            "2:56:37.4|-3:42:44|-1||5.17|0.08|A1Vn|",
            "4:23:40.8|-3:44:44|35|42ξ|5.17|0.08|A2V|",
            "5:11:41.6|16:2:44|-1||5.18|1.49|K5III|",
            "5:39:44.2|25:53:49|77|125|5.18|-0.15|B3IV|",
            "5:45:59.9|-32:18:23|23|μ|5.17|-0.28|O9.5V|",
            "5:50:53.2|-52:6:32|-1||5.17|0.99|G8III|",
            "7:2:24.8|24:12:55|37|42ω|5.18|0.94|G5IIa-Ib|",
            "6:59:50.5|-67:54:58|-1||5.17|1.4|K3III|",
            "7:4:18.3|-56:44:59|-1||5.17|-0.04|A0pSi|",
            "7:46:39.3|37:31:3|-1||5.18|1.58|M2IIIb|",
            "7:43:41.9|-40:56:2|-1||5.17|1.1|K1III|",
            "7:49:41.2|-17:13:42|67|6|5.18|1.28|K3III|",
            "7:51:46.3|-13:53:53|67|9|5.17|0.6|G0V:|",
            "7:57:51.8|-45:34:40|-1||5.17|1.27|K2III|",
            "7:59:37.6|-60:35:13|-1||5.17|1.74|M1.5IIa|",
            "8:25:31.0|-51:43:41|-1||5.17|-0.16|B2Ve|",
            "8:58:52.3|-47:14:5|-1||5.18|0.25|Am|",
            "9:42:57.2|72:15:9|82|27|5.17|1.04|K0III|",
            "10:43:32.9|46:12:14|-1||5.18|0.33|F5III|",
            "11:17:17.4|2:0:38|45|75|5.18|1.52|M0III-IIIb|",
            "11:25:43.2|-63:58:22|-1||5.17|0.5|F7V|",
            "11:39:29.4|-65:23:52|-1||5.17|0.8|G2III+A0V|",
            "11:56:0.9|-17:9:3|28|30η|5.18|-0.02|A0V|",
            "12:7:49.8|-75:22:1|-1||5.18|1.3|K2II-III|",
            "12:24:18.5|26:5:55|24|13|5.18|0.08|A3V|",
            "12:54:36.8|-57:10:6|29|μ2|5.17|-0.12|B5Vne|",
            "15:4:48.2|-64:1:54|22|η|5.17|0.93|G8III|",
            "15:25:47.4|15:25:41|75|9τ1|5.17|1.66|M1III|",
            "15:28:38.2|1:50:32|75|10|5.17|0.23|A8IV|",
            "15:34:26.6|-9:11:0|-1||5.17|-0.09|B6IV|",
            "18:1:29.9|21:35:43|39|95|5.18|0.95|G8III|",
            "18:52:39.6|-52:6:27|78|κ|5.17|0.94|G8-K0III|",
            "19:22:50.9|26:15:45|87|3|5.18|-0.12|B6III|",
            "19:36:37.9|44:41:42|-1||5.17|0.93|G9IIIbFe-0.5|",
            "19:39:11.6|5:23:52|4|44σ|5.17|0.03|B3V+B3V|",
            "20:14:14.5|28:41:41|87|21|5.18|0.18|A7IVn|",
            "20:18:39.1|34:58:58|30|35|5.17|0.65|F5Ib|",
            "20:55:36.7|13:43:17|31|17|5.17|1.12|K0III|",
            "21:6:24.7|-32:20:30|-1||5.18|1.1|K2III|",
            "21:19:22.2|64:52:19|19|6|5.18|-0.04|B3IVe|",
            "21:41:32.9|-14:2:51|15|42|5.18|0.65|G1V+G0V|",
            "21:43:4.0|72:19:13|-1||5.17|1.05|K0III|",
            "23:47:16.0|-50:13:36|63|σ|5.18|-0.19|B3V|",
            "23:51:21.3|-18:54:32|3|108|5.18|-0.14|B9pSiSrCr|",
            "0:30:22.7|-23:47:16|-1||5.19|0.12|A5Vn|",
            "0:35:14.9|-3:35:34|20|13|5.2|0.56|F8V|",
            "0:50:7.6|-10:38:40|20|19φ2|5.19|0.5|F7IV-V|",
            "2:24:24.9|50:0:24|0|64|5.19|0.98|G8III|",
            "2:22:32.6|-23:48:59|36|κ|5.2|0.6|G0Va|",
            "4:6:36.4|27:36:0|77|41|5.2|-0.13|B9pSi|",
            "4:16:43.1|53:36:43|-1||5.19|0.05|A2Vn|",
            "4:54:46.9|11:25:34|59|6|5.19|0.12|A3V|",
            "5:7:34.0|-63:23:59|-1||5.2|1.65|M3III|",
            "5:31:52.9|-76:20:28|52|γ|5.19|1.13|K2III|",
            "5:54:57.8|59:53:18|10|31|5.2|0.02|A2V|",
            "6:14:50.9|19:9:23|59|71|5.2|0.44|F6V|",
            "6:27:13.8|0:17:57|-1||5.2|1.18|K1II|",
            "6:38:49.2|39:54:9|7|52ψ3|5.2|-0.07|B8III|",
            "6:41:56.4|-9:10:2|-1||5.19|1.53|M0III|",
            "6:44:28.4|-31:4:14|13|10|5.2|-0.12|B2IIIe|",
            "7:1:56.4|-5:43:20|-1||5.2|1.68|M2III|",
            "7:4:2.8|-42:20:14|-1||5.2|0.2|Am|",
            "7:15:54.9|59:38:15|50|18|5.2|1.07|K2III|",
            "7:24:8.5|40:40:20|7|66|5.19|1.23|K1+IIIaCN1|",
            "8:21:21.0|-36:29:4|-1||5.2|-0.19|B2IV-V|",
            "8:40:19.3|-40:15:51|-1||5.2|-0.01|B9V|",
            "8:39:57.6|-53:3:18|-1||5.19|-0.14|B4IV|",
            "8:39:5.2|-70:23:13|86|θ|5.2|0.01|A0V|",
            "8:57:14.9|15:19:22|11|62ο1|5.2|0.15|A5III|",
            "8:59:32.6|32:25:7|11|64σ3|5.2|0.93|G8III|",
            "9:46:31.7|57:7:41|-1||5.2|1.62|M3IIIab|",
            "11:36:2.8|69:19:22|33|2|5.2|1.01|K0III|",
            "13:7:53.8|-10:44:25|85|49|5.19|1.14|K2III|",
            "14:55:34.6|-60:6:51|-1||5.2|1.16|K2III|",
            "15:6:37.6|-16:15:25|48|21ν|5.2|1.58|K5-III|",
            "15:46:40.0|62:35:58|-1||5.19|0.04|A2IV|",
            "15:50:41.7|15:8:1|-1||5.2|0.0|M7IIIe|",
            "16:22:21.4|33:47:57|26|20ν1|5.2|1.6|M2IIIab|",
            "16:30:49.4|-61:38:1|-1||5.2|1.23|K0II-IIICNIb-II|",
            "17:18:0.7|-24:17:13|58|39ο|5.2|1.1|K0II-III|",
            "18:47:29.0|-5:42:18|-1||5.2|1.47|K0Ibp|",
            "19:59:55.2|37:2:34|30|25|5.19|-0.17|B3IVe|",
            "20:31:30.4|74:57:17|33|73|5.2|0.07|A0pSrCrEu|",
            "22:34:41.6|-20:42:30|3|59υ|5.2|0.44|F4IV|",
            "22:38:39.0|63:35:4|19|30|5.19|0.06|A3IV|",
            "23:22:39.2|-15:2:21|3|97|5.2|0.2|A3Vp|",
            "0:50:41.2|-50:59:13|63|ρ|5.22|0.36|F2III|",
            "1:7:47.9|-41:29:13|63|υ|5.21|0.16|A3IV|",
            "2:5:31.2|76:6:54|17|49|5.22|0.95|G8III|",
            "2:40:39.6|-54:33:0|40|ζ|5.21|0.4|F4IV|",
            "2:49:17.5|17:27:51|6|42π|5.22|-0.06|B6V|",
            "4:14:36.3|10:0:40|-1||5.22|-0.1|B9Vn|",
            "5:58:49.6|0:33:11|59|60|5.22|0.01|A1Vs|",
            "6:4:13.5|-6:42:33|-1||5.21|-0.06|B2Ven|",
            "6:26:48.9|58:25:2|50|5|5.21|1.53|K4III|",
            "6:24:10.3|-11:31:49|-1||5.22|1.24|K3III|",
            "6:29:28.5|-56:51:10|-1||5.22|1.09|K0III|",
            "6:42:24.3|17:38:43|37|26|5.21|0.06|A2V|",
            "6:47:39.6|48:47:22|7|57ψ6|5.22|1.12|K0III|",
            "7:27:44.4|21:26:42|37|63|5.22|0.39|F5V+F5V|",
            "8:9:35.9|-44:7:22|-1||5.21|-0.19|B2IV-V|",
            "8:49:51.5|-32:46:50|-1||5.21|0.87|G5III|",
            "8:55:39.7|27:55:39|11|58ρ2|5.22|1.0|G8II-III|",
            "10:29:28.7|-2:44:21|76|29δ|5.21|-0.06|B9.5V|",
            "11:25:29.4|-36:3:47|-1||5.22|0.99|K0III|",
            "11:41:44.0|-32:29:59|-1||5.22|1.48|K5III+F7V|",
            "12:2:6.8|43:2:44|82|67|5.21|0.26|F0Vam|",
            "12:20:33.7|-22:12:57|27|5ζ|5.21|-0.1|B8Vne|",
            "12:45:37.1|7:40:24|85|32|5.22|0.33|F0IIIm|",
            "13:9:59.3|17:31:46|24|42α|5.22|0.45|F5V|",
            "13:9:59.3|17:31:46|24|42α|5.22|0.0|F5V|",
            "13:15:58.8|-19:56:35|85|57|5.22|1.03|K1III-IV|",
            "13:16:46.5|9:25:27|85|59|5.22|0.59|G0Vs|",
            "13:32:58.1|-10:9:54|85|76|5.21|0.96|K0III|",
            "14:47:1.3|-52:23:1|-1||5.21|0.98|G8III|",
            "16:13:50.9|-11:50:15|72|17χ|5.22|1.42|K3III|",
            "16:51:33.7|-41:13:50|-1||5.22|0.07|O8Iaf|",
            "18:27:12.5|0:11:46|75|59|5.21|0.5|G0III+A6V|",
            "18:57:1.6|32:54:5|-1||5.22|0.59|F9V|",
            "19:8:59.9|6:4:24|4|19|5.22|0.35|F0III-IV|",
            "20:2:1.4|24:56:17|87|16|5.22|0.36|F2III|",
            "20:39:16.4|-14:57:17|15|14τ|5.22|-0.12|B6III|",
            "21:6:54.6|38:44:45|30|61|5.21|1.18|K5V|",
            "22:38:37.9|56:47:45|-1||5.21|1.58|M4+III|",
            "23:31:17.4|39:14:11|0|14|5.22|1.02|K0III|",
            "0:30:7.3|29:45:6|0|28|5.23|0.24|A7III|",
            "0:44:44.4|-22:0:22|-1||5.24|0.33|F1III-IV|",
            "1:13:43.9|7:34:31|65|86ζ|5.24|0.32|A7IV|",
            "1:21:7.4|28:44:17|65|91|5.23|1.39|gK5|",
            "1:42:29.8|20:16:7|65|107|5.24|0.84|K1V|",
            "2:2:2.8|2:45:49|65|113α|5.23|0.0|A3m|",
            "2:58:42.0|-2:46:57|-1||5.23|0.0|A2IV|",
            "3:24:40.5|64:35:10|-1||5.23|2.08|M0II|",
            "3:18:12.9|-62:30:23|69|ζ2|5.24|0.6|G1V|",
            "3:36:17.4|-17:28:1|35|20|5.23|-0.13|B9.5p|",
            "3:47:39.6|-23:52:29|35|28τ7|5.24|0.07|A2|",
            "4:7:0.5|29:0:5|77|42ψ|5.23|0.34|F1V|",
            "4:21:53.3|-63:23:11|69|η|5.24|0.96|G8III|",
            "4:37:36.1|-2:28:24|35|51|5.23|0.28|F0V|",
            "5:21:48.4|41:48:16|7|20ρ|5.23|-0.15|B3V|",
            "6:31:48.3|11:32:40|-1||5.23|0.15|A3V|",
            "6:32:21.3|-37:41:48|-1||5.24|1.0|G8III|",
            "7:47:31.5|-46:36:31|-1||5.23|-0.14|B1.5IV|",
            "7:59:28.4|-39:17:50|-1||5.24|0.39|F5III|",
            "8:9:43.2|-47:56:15|-1||5.23|-0.21|B1IVe|",
            "8:41:56.9|-45:24:39|-1||5.23|0.21|B6Iae|",
            "9:1:44.6|-52:11:18|-1||5.23|-0.12|B9Si|",
            "9:7:44.8|10:40:5|11|76κ|5.24|-0.11|B8IIIpMn|",
            "9:16:41.7|-6:21:11|41|23|5.24|1.17|K2III|",
            "9:58:52.3|-35:53:28|1|η|5.23|0.31|F1III-IV|",
            "10:17:37.8|-8:4:8|76|22ε|5.24|0.31|F2III|",
            "10:45:51.9|30:40:56|46|42|5.24|-0.06|A1Vn|",
            "10:46:29.7|-64:15:48|-1||5.23|-0.07|B7IV|",
            "10:46:57.5|-56:45:26|-1||5.23|-0.08|B8-9IIIe|",
            "10:53:29.5|-20:8:20|-1||5.24|0.47|F6V|",
            "11:12:45.2|-64:10:11|-1||5.23|-0.06|B8V|",
            "12:55:28.5|65:26:19|33|8|5.24|0.28|F0V|",
            "14:12:4.0|69:25:57|-1||5.24|1.58|M2IIIab|",
            "14:19:51.5|-61:16:23|-1||5.23|0.29|Am|",
            "14:47:44.8|-26:5:15|41|56|5.24|0.94|G5III|",
            "15:29:24.3|-46:43:58|-1||5.24|1.74|K4III|",
            "15:37:49.6|40:21:12|8|54φ|5.24|0.88|G7III-IVFe-2|",
            "15:42:38.3|-37:25:30|-1||5.24|0.98|G8-K0III|",
            "15:50:17.5|2:11:47|75|34ω|5.23|1.02|G8III|",
            "16:27:43.5|-7:35:53|-1||5.23|1.72|M3-III|",
            "16:47:46.4|5:14:48|39|45|5.24|-0.02|B9pCr:|",
            "17:26:0.0|-50:38:1|5|κ|5.23|1.06|G8III|",
            "17:34:59.5|61:52:30|33|26|5.23|0.61|G0Va|",
            "18:3:4.9|-8:10:50|58|69τ|5.24|0.38|F2V|",
            "18:47:44.6|-40:24:22|25|μ|5.24|0.78|G5-6III|",
            "18:49:40.1|-20:19:29|71|29|5.24|1.41|K4III|",
            "18:59:5.7|13:37:21|4|11|5.23|0.53|F8V|",
            "19:7:25.6|32:30:6|51|17|5.23|0.34|F0V|",
            "20:16:55.3|40:21:54|-1||5.24|1.65|K3.5IIab-IIb|",
            "20:59:4.4|4:17:37|34|1ε|5.23|0.46|F6IV|",
            "21:15:37.9|-20:39:6|15|28φ|5.24|1.17|gG9|",
            "21:29:27.0|46:32:26|30|71|5.24|0.97|K0-III|",
            "21:42:0.8|-23:15:46|15|41|5.24|0.95|G9III|",
            "22:11:48.8|56:50:22|-1||5.24|0.51|F8V|",
            "23:3:32.9|67:12:33|-1||5.24|1.26|K3III|",
            "23:44:12.1|-18:16:37|3|106|5.24|-0.08|B9Vn|",
            "0:11:44.0|-35:7:59|73|θ|5.25|0.44|F4V|",
            "0:12:10.0|-17:56:18|-1||5.25|1.48|K5III|",
            "1:42:8.6|-32:19:37|73|π|5.25|1.05|K0III|",
            "2:31:30.1|2:16:2|-1||5.25|1.27|K3III|",
            "3:44:30.5|-1:9:47|35|24|5.25|-0.1|B7V|",
            "5:23:30.2|-13:55:38|47|8|5.25|-0.21|B2IV|",
            "6:46:44.3|43:34:39|7|56ψ5|5.25|0.56|G0V|",
            "7:18:33.6|-39:12:37|-1||5.25|0.01|A1V|",
            "7:28:2.1|6:56:31|14|5η|5.25|0.22|F0III|",
            "7:32:5.9|1:54:52|14|7δ1|5.25|0.22|F0III|",
            "7:33:36.5|15:49:36|37|68|5.25|0.05|A1Vn|",
            "9:14:24.5|-43:13:39|-1||5.25|-0.14|B4V|",
            "9:38:21.7|40:14:23|50|42|5.25|0.22|F0V|",
            "10:52:30.9|-57:14:26|-1||5.25|0.16|B9Ia|",
            "11:35:55.6|-47:38:30|-1||5.25|0.25|A7m|",
            "13:5:44.5|35:47:56|12|14|5.25|-0.08|B9V|",
            "13:11:23.2|-43:22:8|-1||5.25|1.05|K1-2III|",
            "13:26:43.2|-12:42:28|85|68|5.25|1.52|M0III|",
            "13:52:4.8|-52:48:42|-1||5.25|-0.09|B9V|",
            "14:8:17.3|49:27:29|8|13|5.25|1.65|M1.5III|",
            "15:6:16.7|54:33:23|-1||5.25|0.96|G7.5IIIFe-1|",
            "16:21:48.7|69:6:34|-1||5.25|1.12|K2III|",
            "16:30:33.6|20:28:45|-1||5.25|1.29|G8IIICN-2CH-1|",
            "16:54:35.7|-6:9:14|58|23|5.25|1.08|K2III|",
            "17:1:36.4|33:34:6|39|59|5.25|0.02|A3IV|",
            "17:23:16.1|-47:28:6|5|ι|5.25|-0.11|B2IIIne|",
            "17:38:5.6|-54:30:1|5|π|5.25|0.2|A5IV-V|",
            "18:24:18.2|-44:6:37|-1||5.25|-0.19|B2.5Vn|",
            "18:22:49.0|17:49:36|-1||5.25|1.27|K3III|",
            "18:49:52.9|32:33:3|51|9ν2|5.25|0.08|A3V|",
            "20:27:19.2|-18:12:42|15|10π|5.25|-0.07|B8II-III|",
            "22:41:28.6|40:13:32|44|12|5.25|-0.14|B2III|",
            "1:30:6.2|47:0:26|0|49|5.27|1.0|K0III|",
            "1:59:38.0|64:37:17|-1||5.26|0.01|A0Vn|",
            "2:12:48.1|21:12:39|6|17η|5.27|0.43|F5V|",
            "2:49:1.5|-62:48:24|40|ν|5.26|0.1|A2V|",
            "3:4:16.4|-7:36:3|35|10ρ3|5.26|0.2|A8V|",
            "3:6:33.5|-6:5:19|-1||5.27|1.6|M3III|",
            "3:50:18.9|25:34:46|-1||5.26|0.21|A2V+A5V|",
            "4:20:40.3|65:8:26|-1||5.27|0.81|G5IIb|",
            "4:20:36.3|15:5:43|77|58|5.26|0.22|F0V|",
            "4:34:11.7|-8:58:13|-1||5.26|1.47|K4III|",
            "4:44:21.1|-59:43:58|32|κ|5.27|0.2|A8-9III-IV|",
            "5:35:39.5|-4:51:21|59|45|5.26|0.24|F0III|",
            "5:48:0.2|6:27:15|59|52|5.27|0.23|A5V|",
            "6:19:42.8|-7:49:23|54|7|5.27|-0.19|B2.5V|",
            "6:29:49.1|-50:14:21|-1||5.27|0.41|F2V|",
            "6:35:12.1|28:1:20|7|49|5.27|-0.03|A0Vnn|",
            "6:37:47.6|-32:20:23|-1||5.27|1.18|K2III|",
            "6:47:21.4|-37:55:47|-1||5.26|-0.08|B9IV|",
            "6:51:33.0|21:45:40|37|36|5.27|-0.02|A2V|",
            "7:44:4.2|50:26:2|-1||5.27|0.0|A0IIIn|",
            "8:35:15.4|-58:13:30|-1||5.26|-0.14|B3V+B3Vn|",
            "8:37:52.2|-26:15:18|68|η|5.27|-0.04|A0V|",
            "9:15:49.9|56:44:29|82|17|5.27|1.56|K5III|",
            "9:14:18.0|-55:34:11|-1||5.27|0.99|G8II-III|",
            "9:18:5.8|-51:3:4|-1||5.26|-0.07|B7-8III|",
            "9:55:43.0|49:49:12|82|31|5.27|0.07|A3III|",
            "9:58:13.4|12:26:41|45|27ν|5.26|-0.04|B9IV|",
            "10:31:4.6|82:33:31|-1||5.26|0.37|F2V|",
            "11:40:47.1|21:21:10|45|92|5.26|0.98|K1III|",
            "11:46:55.6|55:37:42|-1||5.27|1.27|K2.5IIIbCN1Ca1|",
            "12:0:51.2|-19:39:32|-1||5.26|-0.2|B1.5V|",
            "14:7:55.8|43:51:16|-1||5.27|1.59|M4.5:III|",
            "15:14:29.2|29:9:51|8|48χ|5.26|0.03|A2V|",
            "15:36:29.6|10:0:36|75|16|5.26|0.95|K0III:CN1Ba0.7Sr2|",
            "16:20:26.8|-78:40:2|2|δ2|5.27|1.41|K3III|",
            "16:27:57.3|-64:3:29|80|ι|5.27|0.36|F4IV|",
            "18:19:10.7|24:26:46|39|105|5.27|1.53|K3III:Ba0.4|",
            "18:45:46.7|74:5:8|-1||5.27|0.92|K0II-III|",
            "18:59:45.5|26:13:50|-1||5.27|1.24|K2III|",
            "19:42:34.0|11:49:36|4|47χ|5.27|0.57|G0:III+A3V|",
            "19:57:6.2|-58:54:5|-1||5.26|-0.01|B9.5IV|",
            "20:1:28.5|64:49:16|33|64|5.27|1.56|M1III-IIIb|",
            "21:13:3.1|-39:25:31|-1||5.26|0.44|F5IV+F6V|",
            "22:5:0.5|62:47:8|19|20|5.27|1.41|K4III|",
            "22:13:10.6|86:6:29|-1||5.27|-0.03|B9.5Vn|",
            "22:47:33.1|-19:36:48|3|68|5.26|0.94|G7III|",
            "0:10:2.1|-82:13:26|57|γ3|5.28|1.05|G8III|",
            "1:10:39.3|68:46:43|17|31|5.29|-0.02|A0Vnn|",
            "1:38:30.9|73:2:24|17|40|5.28|0.96|G8III|",
            "2:12:54.5|-30:43:26|36|μ|5.28|-0.02|B9V|",
            "2:15:56.2|33:21:32|79|7|5.28|-0.01|A0V|",
            "2:21:56.6|0:23:45|20|69|5.28|1.65|M2III|",
            "2:28:10.0|29:40:10|79|12|5.29|0.0|F0III|",
            "2:31:40.5|-79:6:34|42|μ|5.28|0.98|G8III|",
            "3:0:52.2|52:21:6|-1||5.28|-0.05|B7V|",
            "3:21:13.6|21:8:49|6|61τ1|5.28|-0.07|B5IV|",
            "3:23:13.2|49:12:48|-1||5.29|-0.07|B5V|",
            "3:56:36.5|50:41:43|62|43|5.28|0.41|F5IV|",
            "4:1:32.0|-1:32:59|35|35|5.28|-0.15|B5V|",
            "4:13:33.1|7:42:58|77|46|5.29|0.36|F2V+F5V|",
            "4:25:25.0|22:11:59|77|67κ2|5.28|0.25|A7V|",
            "4:26:6.3|31:26:20|-1||5.28|0.97|K1III|",
            "4:42:54.3|43:21:54|62|59|5.29|0.0|A1Vn|",
            "5:23:27.8|57:32:40|10|16|5.28|-0.03|A0Vn|",
            "5:42:15.1|-34:40:4|-1||5.29|-0.05|B9.5V|",
            "5:47:42.9|13:53:59|77|133|5.29|-0.17|B2IV-V|",
            "5:54:50.2|-52:38:7|-1||5.29|0.31|F0VDelDel|",
            "6:36:32.9|38:26:43|-1||5.29|2.61|C5II|",
            "6:46:51.1|-14:25:33|13|11|5.29|-0.04|B9III|",
            "7:18:51.2|-26:35:9|-1||5.28|0.96|G2Ib|",
            "7:58:20.6|2:13:29|14|14|5.29|0.92|K0III|",
            "8:25:3.7|-24:2:46|-1||5.28|1.48|K5III+K1III|",
            "8:22:4.4|-73:24:0|86|η|5.29|0.01|A0-1IV-V|",
            "8:47:15.0|-1:53:50|-1||5.29|0.04|A3V|",
            "9:17:25.4|-74:53:40|-1||5.29|0.02|A1V|",
            "10:8:42.6|-65:48:55|-1||5.28|0.98|K0III|",
            "10:13:22.8|-51:14:0|-1||5.28|0.25|A7V|",
            "10:28:52.6|-64:10:20|-1||5.29|1.86|M0III|",
            "11:45:43.9|-45:41:24|-1||5.29|-0.12|B6III|",
            "12:19:48.7|48:59:3|12|3|5.29|1.66|M0III|",
            "12:28:54.7|25:54:46|24|17|5.29|-0.05|A1IVp|",
            "12:49:13.6|83:24:46|-1||5.28|-0.03|A1IIIShell|",
            "14:14:50.8|10:6:2|8|15|5.29|1.0|K1III|",
            "16:38:0.4|56:0:56|-1||5.29|1.08|K1III|",
            "17:3:8.8|-53:14:13|5|ε2|5.29|0.48|F6V|",
            "17:26:51.5|-45:50:37|-1||5.29|-0.07|B7V+B9.5V|",
            "18:54:46.9|-87:36:21|57|χ|5.28|1.28|K3III|",
            "18:2:23.1|20:50:1|39|96|5.28|-0.09|B3IV|",
            "18:33:57.8|-33:1:0|-1||5.28|-0.11|B2IV-V|",
            "19:7:18.1|36:6:1|51|18ι|5.28|-0.11|B6IV|",
            "19:17:49.0|11:35:43|4|25ω1|5.28|0.2|F0IV|",
            "19:56:14.3|11:25:26|4|61φ|5.28|-0.01|A1IV|",
            "20:19:23.6|-19:7:7|15|7σ|5.28|1.4|K3II|",
            "21:15:44.9|-15:10:17|15|29|5.28|1.64|M3III|",
            "21:32:5.9|-41:10:45|38|ξ|5.29|1.1|K0III|",
            "21:50:54.3|-82:43:9|57|λ|5.29|0.75|G8-K0III|",
            "21:46:4.4|22:56:56|61|12|5.29|1.41|K0IbHdel0.5|",
            "21:50:8.7|17:17:8|61|13|5.29|0.37|F2III-IV|",
            "22:3:52.9|63:7:11|19|18|5.29|1.58|M5IIIab|",
            "22:24:36.8|-72:15:20|43|ν|5.29|0.65|A3V:+F9V|",
            "23:42:27.9|-15:26:52|-1||5.28|1.37|K4III|",
            "23:46:0.9|-18:40:41|3|107|5.29|0.28|F2III+F2V|",
            "0:56:1.5|-11:16:0|20|22φ3|5.31|1.52|K4III|",
            "1:45:38.8|-25:3:9|73|ε|5.31|0.39|F1V|",
            "2:13:36.3|51:3:57|-1||5.31|0.93|G8III:|",
            "2:19:16.8|47:22:48|0|62|5.3|-0.01|A1V|",
            "2:37:2.5|34:15:50|-1||5.3|1.55|M4IIIe|",
            "2:37:24.4|-52:32:35|40|η|5.31|0.27|A6V|",
            "2:40:41.1|27:3:39|6|33|5.3|0.09|A3V|",
            "3:32:26.3|46:3:25|62|36|5.31|0.4|F4III|",
            "4:37:13.7|0:59:54|-1||5.31|-0.12|B7V|",
            "4:48:0.3|56:45:26|10|4|5.3|0.25|A3m|",
            "4:42:46.4|-50:28:53|64|λ|5.31|0.98|K0-1III|",
            "5:7:48.4|20:25:6|77|106|5.3|0.09|A5V|",
            "5:2:43.0|-71:18:52|52|β|5.31|1.0|G8III|",
            "5:19:59.1|-12:18:56|47|7ν|5.3|-0.12|B7IVnn|",
            "5:37:44.6|-28:41:22|23|ν2|5.31|0.46|F4V|",
            "5:46:27.4|-46:35:50|-1||5.31|1.04|K0-1II|",
            "6:7:41.6|-19:9:57|47|19|5.31|1.68|M2III|",
            "6:15:25.1|16:8:35|59|72|5.3|-0.14|B7V|",
            "6:55:46.8|-22:56:29|-1||5.3|-0.18|B3II-III|",
            "7:12:15.8|-40:29:56|-1||5.31|0.06|A3pSrEuCr|",
            "7:24:58.2|11:40:11|14|1|5.3|0.1|A5IV|",
            "7:44:6.9|25:47:3|37|76|5.31|1.54|K4-5III|",
            "7:46:16.2|10:46:6|14|11|5.3|0.01|A1Vnn|",
            "8:4:16.2|-32:40:30|-1||5.31|1.91|M1Ib|",
            "8:7:45.8|21:34:54|11|10μ2|5.3|0.63|G1IVb|",
            "8:49:21.7|-3:26:35|41|14|5.31|-0.09|B9pHgMn|",
            "10:10:5.9|-12:48:58|-1||5.31|0.36|F5V|",
            "11:26:35.3|-61:6:55|-1||5.3|-0.08|B3IV|",
            "11:29:4.2|39:20:13|82|57|5.31|0.01|A2V|",
            "11:42:28.4|66:44:42|33|3|5.3|1.28|K3III|",
            "11:54:42.5|-25:42:50|-1||5.3|0.88|G4III|",
            "12:14:2.6|-45:43:26|-1||5.31|1.43|K3III|",
            "12:42:50.3|-63:3:31|-1||5.31|0.27|B1IIIe|",
            "13:25:13.9|-64:29:7|-1||5.31|0.4|F2III|",
            "14:49:19.1|-14:8:56|48|7μ|5.31|0.07|A1pSrCrEu|",
            "14:54:20.1|-24:38:32|48|12|5.3|1.32|K2III|",
            "17:30:23.8|-1:3:45|-1||5.31|0.72|G9IV-VHdel1|",
            "20:1:52.4|-66:56:39|60|μ2|5.31|1.22|K2IVCNII|",
            "19:59:51.3|-34:41:52|71|θ2|5.3|0.17|A4/5IV|",
            "20:23:10.7|5:20:35|-1||5.31|0.97|G8III-IV|",
            "20:58:16.4|22:19:33|87|33|5.31|1.4|K3.5III|",
            "21:2:58.0|-38:37:54|53|ζ|5.3|0.41|F3V|",
            "21:8:33.6|-21:11:37|15|25χ|5.3|0.01|A0V|",
            "21:27:21.4|37:7:0|30|70|5.31|-0.14|B3V|",
            "21:26:51.6|48:50:6|-1||5.31|0.07|A6pCrEu:|",
            "21:42:15.5|5:40:48|61|7|5.3|1.64|M2IIIab|",
            "22:4:47.4|0:54:24|3|32|5.3|0.23|A5m|",
            "23:39:8.3|50:28:18|0|18|5.3|-0.06|B9V|",
            "23:40:38.2|-32:4:23|73|μ|5.31|0.97|K1III|",
            "23:52:37.1|10:56:51|61|82|5.3|0.18|A4Vn|",
            "0:41:7.2|39:27:31|0|32|5.33|0.89|G8III|",
            "2:53:42.6|38:20:15|62|20|5.33|0.41|F4IV|",
            "3:2:42.3|-7:41:7|35|9ρ2|5.32|0.94|K0II-III|",
            "4:3:44.6|5:26:8|77|40|5.33|-0.08|B3V|",
            "4:53:22.8|2:30:29|59|5|5.33|1.64|M1III|",
            "4:54:47.8|7:46:45|-1||5.33|1.22|gK1|",
            "6:12:51.1|65:43:6|10|36|5.32|1.34|K1.5IIIbCN-0.5|",
            "6:15:45.0|12:33:4|59|73|5.33|-0.02|B9II-III|",
            "6:45:59.3|-14:47:46|-1||5.32|0.07|A2V|",
            "6:53:5.1|59:26:55|50|14|5.33|0.65|G4III+A2V|",
            "7:24:40.1|-16:12:4|-1||5.33|-0.05|B2.5IVe|",
            "7:35:8.7|30:57:40|-1||5.33|1.01|K0III|",
            "7:49:1.7|-24:54:44|-1||5.33|0.76|G0III|",
            "8:12:48.8|68:28:27|-1||5.32|1.04|G7+II|",
            "8:29:4.7|-47:55:45|-1||5.33|-0.14|B2IV|",
            "8:32:42.5|20:26:28|11|33η|5.33|1.25|K3III|",
            "8:53:50.7|-47:31:15|-1||5.33|0.26|A9IV-V|",
            "9:13:48.2|43:13:4|50|36|5.32|-0.14|B8IIIpMn|",
            "9:16:57.2|-39:24:5|-1||5.33|1.17|K5III-IV|",
            "9:40:42.5|-57:59:1|-1||5.32|0.2|A3IV|",
            "9:51:53.0|24:23:43|45|22|5.32|0.23|A5IV|",
            "10:23:29.3|-38:0:36|-1||5.33|0.25|A8V|",
            "11:15:51.9|13:18:27|45|73|5.32|1.2|K3III|",
            "11:41:3.0|34:12:6|82|61|5.33|0.72|G8V|",
            "11:47:54.9|8:14:45|85|4|5.32|0.02|A1|",
            "12:23:35.4|-35:24:46|-1||5.32|-0.08|B9III|",
            "12:55:57.0|-56:50:10|-1||5.32|0.01|O9Ib|",
            "12:59:55.1|66:35:50|33|9|5.32|1.29|K2III|",
            "13:14:10.9|-19:55:51|85|55|5.33|0.87|G6V|",
            "13:17:15.6|13:40:32|-1||5.33|1.31|K3III|",
            "14:24:48.6|-24:48:23|-1||5.32|0.96|G8III|",
            "14:55:44.7|-33:51:21|-1||5.32|0.04|A0V|",
            "15:15:11.4|4:56:22|75|3|5.33|1.09|K0III|",
            "15:41:47.4|12:50:51|75|20χ|5.33|0.04|A0pSr|",
            "16:22:28.0|-49:34:20|-1||5.33|-0.04|B6IV|",
            "16:31:41.7|-41:49:1|-1||5.33|0.33|B1Iae|",
            "16:52:58.1|31:42:6|39|53|5.32|0.29|F0-2V|",
            "17:12:27.8|10:35:7|58|37|5.33|1.59|M2IIIa|",
            "18:17:7.5|-56:1:24|-1||5.33|-0.05|B3IIIep|",
            "19:9:52.7|-68:25:29|-1||5.33|0.91|G8-K0III-IV|",
            "19:51:50.6|-39:52:28|-1||5.33|-0.06|A0pCrSr:|",
            "20:11:11.9|-36:6:4|-1||5.32|0.87|K3V|",
            "20:16:47.1|24:40:16|87|24|5.32|0.95|G8III|",
            "22:12:47.8|34:36:17|-1||5.33|1.13|K2-III-IIIb|",
            "22:14:18.0|-21:4:27|3|41|5.32|0.8|K0III+F2V|",
            "22:24:56.4|-57:47:50|-1||5.32|0.67|G3IV|",
            "23:7:39.3|46:23:14|0|4|5.33|1.41|K5III|",
            "23:21:54.9|31:48:45|61|64|5.32|-0.11|B6III|",
            "23:33:28.1|22:29:56|61|71|5.32|1.6|M5IIIa|",
            "1:5:40.9|21:28:24|65|74ψ1|5.34|-0.03|A1Vn|",
            "1:45:59.3|-5:44:0|-1||5.34|1.52|K4III|",
            "2:1:14.7|-30:0:6|36|π|5.35|0.88|G5III|",
            "2:24:53.9|-60:18:43|40|λ|5.35|0.39|F2III|",
            "2:32:9.4|-1:2:6|20|75|5.35|1.02|gG3|",
            "2:35:46.8|34:41:15|79|15|5.35|1.66|M3IIIa|",
            "3:45:40.4|6:3:0|77|29|5.35|-0.12|B3V|",
            "4:19:26.1|21:8:32|77|53|5.35|-0.08|B9IV|",
            "4:19:16.6|-44:16:5|-1||5.34|1.08|K2III|",
            "4:39:58.1|53:28:23|10|2|5.35|0.32|A8V|",
            "5:7:52.9|8:29:54|59|14|5.34|0.33|Am|",
            "5:19:11.2|2:35:45|59|21|5.34|0.41|F5II|",
            "5:32:41.3|-1:35:31|-1||5.35|-0.19|B1IV|",
            "5:33:31.4|-1:9:22|-1||5.34|-0.18|B1V|",
            "5:32:59.6|-64:13:39|-1||5.34|1.04|G8-K0III|",
            "5:51:22.0|-7:31:5|59|55|5.35|-0.2|B2IV-V|",
            "6:15:40.6|59:59:57|10|40|5.35|1.34|K3III|",
            "6:46:49.5|57:10:9|50|13|5.35|0.96|K0III|",
            "7:14:20.0|3:6:41|-1||5.35|1.19|K2II|",
            "7:24:43.8|-31:48:32|-1||5.35|1.07|G8II|",
            "7:55:39.9|19:53:2|37|85|5.35|-0.04|A0Vs|",
            "7:56:57.9|-43:30:1|-1||5.35|-0.18|B2.5V|",
            "8:31:35.7|18:5:40|11|31θ|5.35|1.56|K5III|",
            "8:50:34.8|-66:47:35|-1||5.35|0.42|F5IV|",
            "9:15:13.8|14:56:29|11|82π2|5.34|1.32|K1III|",
            "9:32:19.3|-40:38:58|-1||5.35|0.9|G8III|",
            "9:43:43.9|14:1:18|45|16ψ|5.35|1.63|M2IIIab|",
            "10:16:14.4|29:18:38|46|23|5.35|0.01|A0Vn|",
            "10:18:7.6|-28:59:31|-1||5.34|0.24|A0Ib-IIp|",
            "10:46:16.5|-64:30:54|-1||5.34|-0.1|B6V|",
            "10:49:15.4|10:32:43|45|53|5.34|0.03|A2V|",
            "12:4:38.7|-68:19:45|-1||5.35|-0.01|A0IV|",
            "12:8:14.7|-48:41:34|-1||5.34|-0.01|B9V|",
            "12:29:57.3|58:24:21|82|74|5.35|0.2|A5DelDel|",
            "14:57:52.9|-76:39:46|-1||5.34|1.45|K4III:|",
            "15:21:2.0|0:42:55|75|6|5.35|1.19|K3III|",
            "16:29:42.3|-46:14:36|-1||5.35|0.56|B1.5Iape|",
            "16:55:22.2|18:26:0|39|54|5.35|1.41|K4III|",
            "17:23:21.6|-28:8:35|58|43|5.35|1.55|K5III|",
            "18:2:51.1|-24:16:56|71|7|5.34|0.52|F3III|",
            "18:22:53.1|-36:40:10|-1||5.34|-0.14|Ap|",
            "18:31:4.8|-32:59:21|-1||5.34|0.16|A3m|",
            "18:46:22.2|75:26:2|33|50|5.35|0.05|A1Vn|",
            "19:12:40.7|-7:56:22|4|20|5.34|0.13|B3V|",
            "19:34:41.2|42:24:46|-1||5.35|0.05|A2V|",
            "19:48:1.2|-56:21:45|78|ν|5.35|0.2|A7III-IV|",
            "20:53:40.2|-39:48:36|-1||5.35|1.32|K2III|",
            "21:28:44.9|-69:30:19|-1||5.34|1.55|M5III|",
            "22:12:1.9|60:45:34|-1||5.35|1.17|K1III|",
            "22:16:48.1|-12:49:53|3|42|5.34|1.14|gK0|",
            "22:50:22.9|-80:7:27|57|ξ|5.35|-0.15|B6IV|",
            "23:41:34.5|-18:1:38|3|103|5.34|1.57|K5III|",
            "0:20:35.9|8:11:25|65|41|5.37|1.34|gK3|",
            "0:39:55.6|21:26:18|65|55|5.36|1.16|K0III+F3V|",
            "1:2:49.2|-46:23:51|-1||5.36|0.9|G8III|",
            "1:7:18.7|-61:46:31|81|ι|5.37|0.88|G5III|",
            "3:55:58.2|47:52:17|-1||5.37|-0.08|B6V|",
            "4:4:9.9|2:49:37|-1||5.36|0.5|F6IV|",
            "4:9:17.8|-16:23:9|-1||5.37|-0.15|B4V|",
            "4:22:34.9|25:37:45|77|59χ|5.37|-0.05|B9V|",
            "4:46:1.7|11:42:20|-1||5.37|0.19|A2m|",
            "5:34:16.7|3:46:1|59|38|5.36|0.05|A2V|",
            "6:6:35.1|38:28:58|7|40|5.36|0.25|A4m|",
            "6:9:59.1|58:56:9|10|37|5.36|1.09|G8III|",
            "6:21:46.1|53:27:8|7|45|5.36|0.43|F5III|",
            "6:18:50.6|-9:23:25|-1||5.36|1.24|K1.5III|",
            "7:15:21.0|-30:41:11|-1||5.36|-0.17|B3V|",
            "7:29:56.0|49:40:21|50|22|5.36|0.45|F6V|",
            "7:45:35.0|-34:10:23|-1||5.37|0.6|G0V|",
            "8:11:33.0|-7:46:21|-1||5.36|0.89|G6III|",
            "8:19:49.0|-71:30:54|86|κ1|5.37|-0.06|B9III-IV|",
            "8:41:1.1|45:50:2|50|34|5.37|0.99|G8IV|",
            "9:31:32.4|35:6:11|46|8|5.37|1.53|M1IIIab|",
            "9:24:9.1|-80:47:13|21|ι|5.36|0.45|F3-5IV|",
            "10:1:0.7|31:55:25|46|20|5.36|0.66|G3VaHdel1|",
            "11:12:33.1|-49:6:4|-1||5.36|0.18|A3IV-V|",
            "11:38:27.6|8:8:3|85|1ω|5.36|1.57|M4III|",
            "11:59:56.9|3:39:19|85|7|5.37|0.0|A1V|",
            "13:23:1.1|-17:44:7|85|63|5.37|0.99|KIII|",
            "13:43:3.7|3:32:17|85|84|5.36|1.11|K2III|",
            "14:30:20.9|-49:31:9|-1||5.37|0.05|A1V+B|",
            "14:45:17.3|-62:52:33|-1||5.36|0.29|A9V|",
            "15:21:48.6|32:56:2|8|50|5.37|-0.07|B9Vn|",
            "15:24:44.9|-39:42:37|49|υ|5.37|-0.11|A0pSi|",
            "15:54:37.9|43:8:19|39|2|5.37|1.65|M3IIIBa0.3|",
            "16:9:50.5|-3:28:1|-1||5.37|1.45|K4III|",
            "17:36:37.6|48:35:8|39|82|5.37|1.15|gK1|",
            "18:33:56.7|52:21:13|-1||5.36|1.09|K0III|",
            "18:39:35.0|-43:11:10|-1||5.37|1.68|M2III|",
            "18:46:20.6|-22:23:32|71|28|5.37|1.64|K4III|",
            "18:44:22.9|39:36:46|51|5ε2|5.37|0.0|F0Vn|",
            "18:56:16.9|-42:42:38|-1||5.36|1.0|K0III|",
            "19:56:1.3|16:38:5|70|10|5.36|0.67|G5Ib|",
            "20:0:3.3|17:31:0|70|13|5.37|1.67|M4IIIa|",
            "20:6:21.8|35:58:21|30|27|5.36|0.85|K0IV|",
            "21:1:10.9|46:9:21|30|60|5.37|-0.21|B1Ve|",
            "22:9:55.7|-34:0:53|-1||5.37|0.24|A5V|",
            "22:18:15.6|-53:37:40|-1||5.37|0.6|G3V|",
            "22:20:11.9|-7:49:16|3|46ρ|5.37|-0.06|B8IIIpMn:Hg:|",
            "22:20:27.6|5:47:22|61|30|5.37|-0.02|B5IV|",
            "23:4:39.6|-53:57:54|38|κ|5.37|1.45|K5III|",
            "0:32:35.5|20:17:40|65|52|5.38|1.08|K0III|",
            "0:42:28.4|-65:28:5|81|ρ|5.39|0.5|F6V|",
            "0:46:33.0|15:28:32|65|57|5.38|1.65|M4IIIa|",
            "0:50:43.6|64:14:51|-1||5.39|0.49|G0III-IV+B9.5V|",
            "1:26:15.3|19:10:20|65|93ρ|5.38|0.39|F2V:|",
            "2:5:7.4|77:16:53|17|47|5.38|0.31|F0Vn|",
            "2:49:54.2|-27:56:30|36|γ2|5.39|0.02|A0V|",
            "3:18:22.4|0:55:49|20|95|5.38|1.04|G9IV|",
            "4:2:36.7|0:16:8|-1||5.38|0.5|F5V|",
            "4:21:47.6|60:44:8|-1||5.39|1.49|M0III|",
            "4:19:36.7|21:46:25|77|56|5.38|-0.14|A0pSi|",
            "4:20:39.0|-20:38:23|-1||5.38|-0.02|A2V|",
            "4:39:6.2|7:52:15|-1||5.39|0.26|A5m|",
            "4:59:50.4|-10:15:48|35|63|5.38|0.8|G4V|",
            "5:2:48.6|-49:9:5|64|η1|5.38|0.42|F2V|",
            "5:35:27.1|24:2:22|77|121|5.38|-0.09|B2.5IV|",
            "6:6:38.7|-4:11:38|-1||5.38|-0.13|B5IV|",
            "6:17:6.6|9:56:33|59|75|5.39|0.1|A2V|",
            "6:25:28.6|-69:41:25|32|π2|5.38|0.97|G8III|",
            "6:48:57.8|-15:8:41|-1||5.39|-0.1|B6V|",
            "7:6:40.7|-11:17:39|-1||5.39|0.05|B0.5IV|",
            "7:20:38.7|-52:5:10|-1||5.39|-0.07|B9II-III|",
            "7:23:29.1|-27:50:3|-1||5.38|1.53|K2III|",
            "7:23:31.9|-32:12:8|-1||5.39|-0.18|B3III-IV|",
            "8:7:18.0|-20:33:17|-1||5.38|0.1|A5II|",
            "8:54:14.7|30:34:46|11|57|5.39|1.05|G7III|",
            "9:17:17.2|-68:41:22|-1||5.39|0.42|F4V|",
            "9:27:46.8|-6:4:16|-1||5.38|0.64|G2V|",
            "10:35:12.9|-39:33:46|-1||5.38|2.88|N0:|",
            "10:42:40.6|-59:12:57|-1||5.38|0.26|B2.5Iae|",
            "11:24:2.3|1:24:28|45|79|5.39|0.94|G8IIICN-0.5|",
            "11:33:37.3|-40:35:13|-1||5.39|0.12|A2IV-V|",
            "12:18:49.9|75:9:38|-1||5.38|-0.02|A1V|",
            "12:22:49.3|-57:40:34|-1||5.39|-0.1|B9V|",
            "13:42:1.1|-58:47:14|-1||5.38|-0.03|B9III|",
            "14:26:27.4|19:13:37|8|22|5.39|0.23|F0m|",
            "14:38:50.2|44:24:16|8|33|5.39|0.0|A1V|",
            "14:56:17.3|-52:48:35|-1||5.38|0.13|A2III|",
            "15:38:54.5|-19:18:7|48|41|5.38|0.86|G8III|",
            "15:53:53.8|-24:31:59|-1||5.39|-0.02|B6IVn|",
            "16:8:7.6|-26:19:36|-1||5.38|1.65|M2III|",
            "16:22:29.2|33:42:13|26|21ν2|5.39|1.53|K5III|",
            "16:28:34.0|0:39:54|-1||5.39|1.46|K4IIIp|",
            "17:8:2.0|35:56:7|-1||5.39|0.31|A5-F1III/IVms|",
            "17:14:39.2|14:23:24|39|64α2|5.39|0.0|G5III+F2V|",
            "17:20:9.8|25:32:15|-1||5.38|0.03|A3III|",
            "17:20:39.6|32:28:4|39|72|5.39|0.62|G0V|",
            "18:15:12.9|-20:43:42|71|15|5.38|0.07|B0Ia|",
            "18:19:9.5|7:15:35|-1||5.39|1.07|K2III-IV|",
            "18:20:8.8|-15:49:54|-1||5.39|1.47|K4III|",
            "18:29:41.0|-1:59:7|75|60|5.39|0.96|K0III|",
            "18:36:27.8|9:7:21|-1||5.39|0.37|F5III|",
            "18:56:40.5|-37:20:36|-1||5.38|-0.14|B8IVSi|",
            "18:58:14.7|17:21:39|-1||5.38|0.8|F8Ib|",
            "19:0:13.7|50:32:1|-1||5.38|-0.18|B2.5IV|",
            "19:4:55.2|53:23:48|33|51|5.38|-0.01|A0Vn|",
            "19:34:50.9|29:27:47|30|9|5.38|0.55|F8III+A0V|",
            "19:50:46.8|-10:45:49|4|51|5.39|0.38|F0V|",
            "20:5:32.8|61:59:44|33|66|5.39|1.18|K3III|",
            "20:33:57.0|13:1:38|31|3η|5.38|0.07|A3IVs|",
            "20:42:12.6|50:20:24|30|51|5.39|-0.1|B2V|",
            "20:47:33.4|80:33:8|-1||5.39|1.12|K1III|",
            "23:10:1.5|9:49:19|61|58|5.39|-0.08|B9III|",
            "0:11:34.4|-27:47:59|73|κ2|5.41|1.34|K5III|",
            "0:24:47.5|61:49:52|17|12|5.4|0.0|B9III|",
            "0:47:46.1|74:50:51|17|23|5.41|-0.08|B8III|",
            "1:16:36.3|-2:30:1|20|39|5.41|0.9|G5IIIe+dA|",
            "1:53:17.3|40:43:47|0|55|5.4|1.32|gK1|",
            "1:59:46.1|-20:49:28|20|57|5.41|1.65|M1III|",
            "2:42:33.5|-50:48:1|40|ι|5.41|0.56|G0V|",
            "3:48:35.4|-37:37:20|-1||5.4|0.01|A1V|",
            "4:10:49.9|26:28:51|77|44|5.41|0.34|F2IV-V|",
            "4:30:37.3|13:43:28|77|83|5.4|0.26|F0V|",
            "4:36:45.6|-62:4:39|-1||5.4|1.58|M8eIII:|",
            "4:44:25.8|11:8:46|-1||5.4|0.25|F0V|",
            "5:19:0.0|33:44:54|-1||5.41|-0.19|A0pSi|",
            "5:38:38.1|30:29:33|7|26|5.4|0.45|F9III+B9.5V|",
            "5:55:49.3|20:10:30|-1||5.4|0.99|M6.5IIIe|",
            "6:28:49.5|-7:2:4|54|11β|5.4|-0.07|B3ne|",
            "6:46:52.8|-51:15:57|-1||5.4|1.34|K1II-III+G:p|",
            "6:51:27.0|-70:57:48|86|ι|5.4|-0.11|B7IV|",
            "8:0:11.7|73:55:5|-1||5.41|1.42|K3III|",
            "8:55:55.6|11:37:34|11|60|5.41|1.46|gK5|",
            "9:28:40.0|45:36:5|-1||5.41|0.98|K0III-IV|",
            "9:28:27.5|9:3:24|45|2ω|5.41|0.6|F9V|",
            "9:35:39.6|35:48:37|46|11|5.41|0.77|G8V|",
            "10:16:40.7|13:43:42|45|37|5.41|1.61|M1.5IIIab|",
            "11:47:19.1|-57:41:47|-1||5.41|1.67|K5III|",
            "13:28:27.1|59:56:45|-1||5.4|-0.01|A1Vn|",
            "14:19:16.3|13:0:15|8|18|5.41|0.38|F5IV|",
            "14:37:20.1|-46:8:2|-1||5.41|1.01|G8III|",
            "15:44:4.4|-15:40:22|48|44η|5.41|0.23|F0IV|",
            "15:46:5.6|-1:48:16|75|25|5.4|-0.03|B8III|",
            "16:1:2.7|33:18:13|26|15ρ|5.41|0.6|G0+VaFe-1|",
            "16:17:15.3|59:45:18|-1||5.4|1.63|M4IIIa|",
            "16:24:1.3|-39:11:35|-1||5.4|0.62|G5V|",
            "16:54:55.2|20:57:31|-1||5.41|0.97|G8III|",
            "17:22:5.9|-70:7:24|2|ι|5.41|-0.04|B9V+B9.5V|",
            "18:22:8.7|23:17:7|-1||5.41|1.6|M0IIIab|",
            "19:16:21.7|-45:27:59|-1||5.4|1.35|K3III|",
            "19:39:26.5|42:49:6|30|14|5.4|-0.08|B9III|",
            "19:49:25.3|-72:30:12|-1||5.41|0.22|A4III|",
            "20:49:18.1|-68:46:35|60|σ|5.41|1.12|K0III|",
            "21:24:9.6|-20:51:7|15|33|5.41|1.16|K0III|",
            "21:27:40.1|27:36:31|87|35|5.41|0.04|A1V|",
            "22:11:9.9|50:49:24|-1||5.4|0.15|A5V|",
            "23:8:40.9|2:7:40|65|5|5.4|0.91|G8III-IV|",
            "0:9:21.0|-27:59:16|73|κ1|5.42|0.42|F2V|",
            "0:28:26.4|-39:54:54|-1||5.43|1.56|M0III|",
            "0:39:9.9|49:21:16|-1||5.43|1.64|K7III|",
            "0:45:17.2|55:13:18|-1||5.42|0.04|A2Vs|",
            "0:57:50.2|28:59:32|65|68|5.42|1.08|gG6|",
            "1:3:2.6|-4:50:12|20|25|5.43|1.11|K0III-IV|",
            "1:24:40.8|-41:29:33|-1||5.42|1.04|K0III|",
            "1:35:59.0|-15:24:1|20|50|5.42|1.21|K2IIIaBa0.2CN1|",
            "2:3:11.7|0:7:42|20|60|5.43|0.15|A5III|",
            "2:22:12.4|0:53:6|20|70|5.42|0.31|F0Vn|",
            "2:38:49.0|21:57:41|6|32ν|5.43|0.16|A7V|",
            "2:44:5.2|44:17:49|62|14|5.43|0.9|G0Ib-IICa1CH-1|",
            "4:27:2.8|80:49:27|-1||5.43|1.17|gG6|",
            "5:12:22.4|73:56:48|-1||5.43|-0.12|B9pSi|",
            "5:9:19.6|9:49:46|59|16|5.43|0.24|A2m|",
            "5:30:10.2|63:4:2|10|17|5.42|1.71|M1IIIa|",
            "5:27:10.1|17:57:44|77|115|5.42|-0.1|B5V|",
            "6:31:50.1|-8:9:29|-1||5.43|1.38|gK2|",
            "6:33:49.5|-36:13:56|-1||5.42|1.44|K3III|",
            "7:23:0.6|-31:55:26|-1||5.43|-0.15|B5IIIn|",
            "7:29:5.7|-38:48:44|-1||5.43|-0.16|B5Vp|",
            "7:31:48.4|17:5:10|-1||5.42|1.13|gK2|",
            "7:41:15.8|-38:32:1|-1||5.42|-0.15|B5V|",
            "8:4:47.1|79:28:47|-1||5.42|-0.06|A0pSi|",
            "7:53:3.5|-36:21:50|-1||5.43|1.16|K0III|",
            "8:31:30.9|-19:34:39|-1||5.42|-0.06|A0V|",
            "9:8:0.1|29:39:15|11|72τ|5.43|0.89|G8III|",
            "8:56:41.1|-85:39:47|57|ζ|5.42|0.31|A8-9IV|",
            "10:46:52.0|-17:17:48|-1||5.42|0.11|A3V|",
            "11:4:54.2|-35:48:17|-1||5.43|0.03|A2V|",
            "11:13:45.6|0:4:11|45|69|5.42|-0.03|A0V|",
            "12:33:38.9|33:14:51|-1||5.42|1.0|K0IIICN-1|",
            "12:47:34.4|66:47:25|33|7|5.43|1.56|gK5|",
            "13:47:25.4|-17:51:36|85|87|5.43|1.62|M2IIIab|",
            "14:15:24.1|-18:12:3|-1||5.43|-0.03|A1V|",
            "14:28:41.7|-6:54:2|85|106|5.42|1.49|K5III|",
            "15:36:12.1|-44:23:49|-1||5.43|1.5|K4-5III|",
            "15:53:55.8|-23:58:41|-1||5.42|-0.04|B2.5Vne|",
            "15:58:34.8|-24:49:53|-1||5.43|-0.09|B5IV|",
            "16:12:7.3|-8:32:51|72|16|5.43|0.12|A4V|",
            "16:24:31.7|-37:33:57|-1||5.42|-0.11|B8IV|",
            "18:36:37.2|33:28:8|-1||5.42|-0.1|B8II-IIIpHg|",
            "18:44:57.2|-39:41:11|-1||5.43|0.87|K3II+B7|",
            "19:2:54.5|-3:41:56|4|14|5.42|0.0|A1V|",
            "19:4:57.6|-4:1:53|4|15|5.42|1.12|K1III|",
            "19:17:43.6|23:1:32|87|2|5.43|0.02|B0.5IV|",
            "19:25:29.7|-23:57:44|71|49χ3|5.43|1.43|K4III|",
            "19:50:44.8|-59:11:35|-1||5.42|0.08|A0IV|",
            "20:37:49.1|11:22:40|31|5ι|5.43|0.06|A2V|",
            "21:13:17.3|-27:37:10|-1||5.42|1.42|K5III|",
            "21:17:57.3|-17:59:7|15|30|5.43|-0.12|B8III|",
            "22:0:50.2|-28:27:13|66|12η|5.42|-0.09|B8V|",
            "22:14:18.8|-27:46:1|66|16λ|5.43|-0.16|B8III|",
            "22:51:2.2|-39:9:25|-1||5.42|1.43|M0III|",
            "22:49:46.2|55:54:10|-1||5.43|1.17|K1III|",
            "22:57:4.5|48:41:3|-1||5.43|-0.09|B4IIIep|",
            "22:59:27.4|0:57:46|65|2|5.43|0.98|gK1|",
            "23:5:9.8|-7:41:37|3|83|5.43|0.3|F2IV+F0V|",
            "23:48:50.2|62:12:52|17|6|5.43|0.67|A3Ia|",
            "0:55:0.3|-69:31:37|81|λ2|5.45|1.09|K2III|",
            "2:57:23.7|-23:51:43|35|4|5.45|0.23|A5V|",
            "3:20:19.7|77:44:5|-1||5.45|0.19|A6V|",
            "3:49:13.8|70:52:16|-1||5.44|0.09|A2m|",
            "3:48:20.9|23:25:16|-1||5.45|-0.07|B8V|",
            "4:10:22.5|-6:55:26|35|37|5.44|0.94|G8III|",
            "4:19:13.3|50:2:56|-1||5.45|0.22|A7V|",
            "4:14:48.7|-62:11:31|-1||5.45|1.1|K0III|",
            "4:39:19.7|-14:21:33|-1||5.45|1.06|K1IVa|",
            "4:52:5.2|63:30:19|-1||5.44|1.57|M3IIIab|",
            "5:19:22.1|-50:36:22|64|ζ|5.45|0.51|F7III-IV|",
            "5:39:49.8|-32:37:45|-1||5.45|0.92|G6-8III|",
            "6:46:14.1|79:33:53|-1||5.45|0.5|F8V|",
            "6:44:45.5|28:58:15|37|28|5.44|1.45|K4III|",
            "6:54:24.6|-1:7:37|-1||5.45|0.18|A4IV|",
            "7:8:22.0|15:55:51|37|45|5.44|1.03|G8III|",
            "6:56:34.4|-79:25:13|52|θ|5.45|0.05|B9.5V|",
            "7:11:23.6|0:18:7|54|21|5.45|0.29|A8Vn-F3Vn|",
            "7:22:52.1|55:16:53|50|19|5.45|0.0|B8V|",
            "7:20:58.2|-14:21:36|-1||5.45|0.98|gG5|",
            "7:54:42.7|47:33:53|50|26|5.45|1.46|gK4|",
            "8:56:56.6|32:54:37|11|59σ2|5.45|0.12|A7IV|",
            "9:2:44.3|24:27:10|11|69ν|5.45|-0.04|A0pSi|",
            "9:30:5.2|-51:31:2|-1||5.45|-0.1|B8V|",
            "9:37:12.3|-53:40:7|-1||5.45|0.15|A2-3V|",
            "9:46:20.6|-76:46:34|21|ν|5.45|0.89|G8III|",
            "10:37:26.8|-58:44:0|-1||5.45|0.5|A0Iae|",
            "10:53:43.7|-2:7:45|-1||5.45|0.96|G8III|",
            "11:8:43.9|-28:4:50|-1||5.44|0.07|A1V|",
            "11:37:33.9|-47:44:50|-1||5.44|1.24|K2III|",
            "11:58:15.2|-56:19:2|-1||5.44|-0.08|B8III|",
            "12:28:22.5|-39:2:29|-1||5.44|-0.08|B8V|",
            "12:37:42.2|-27:8:20|-1||5.45|0.32|F1IV|",
            "13:47:38.4|-50:19:16|-1||5.45|1.36|K2III|",
            "15:2:59.3|-32:38:36|-1||5.44|-0.12|B3V|",
            "15:27:18.2|-36:46:4|-1||5.45|-0.15|B4Vp|",
            "15:38:49.5|-52:22:22|-1||5.44|0.0|A0V|",
            "15:54:34.6|20:18:39|-1||5.44|1.59|M0III|",
            "15:55:47.6|37:56:49|26|12λ|5.45|0.33|F0IV|",
            "16:6:19.7|67:48:37|-1||5.44|-0.02|A0Vn|",
            "16:16:43.1|-53:48:40|-1||5.44|1.73|M2III|",
            "16:19:17.7|-42:40:26|56|λ|5.45|0.1|A3Vn|",
            "16:54:1.8|-41:48:23|-1||5.45|0.19|B0.5Ia|",
            "17:28:49.7|0:19:50|-1||5.44|0.22|A8V|",
            "17:55:11.2|72:0:18|33|34ψ2|5.45|0.3|F2-3II-III|",
            "18:14:15.9|-21:42:47|71|14|5.44|1.52|K3III|",
            "18:36:39.1|6:40:19|-1||5.45|0.37|F3V|",
            "18:54:52.2|41:36:10|-1||5.44|1.03|K0III|",
            "19:57:13.9|40:22:5|-1||5.45|-0.1|B5V|",
            "20:31:18.8|49:13:13|30|46ω2|5.44|1.55|M2IIIab|",
            "20:53:18.6|45:10:55|-1||5.45|1.1|K0II|",
            "21:27:46.1|66:48:33|19|7|5.44|-0.11|B7V|",
            "21:37:45.4|19:19:7|61|5|5.45|0.3|F1IV|",
            "23:19:29.8|48:37:31|0|11|5.44|1.03|K0III|",
            "0:52:40.6|-24:0:21|-1||5.46|1.24|K2III|",
            "0:54:58.0|23:37:42|0|36|5.47|1.0|K1IV|",
            "2:22:1.4|-10:46:40|-1||5.46|0.35|F0V|",
            "2:24:49.0|10:36:38|6|24ξ|5.47|-0.1|B7IV|",
            "2:50:40.4|-35:40:34|36|η3|5.47|1.25|K5III|",
            "2:59:49.9|47:13:15|-1||5.47|0.89|G5:III*|",
            "3:17:47.4|44:1:30|62|30|5.47|-0.06|B8V|",
            "3:32:8.6|48:1:25|-1||5.47|-0.1|B8IIIpMn|",
            "3:44:48.2|24:17:22|77|16|5.46|-0.04|B7IV|",
            "4:4:21.7|24:6:21|77|36|5.47|0.86|G0III+A4V|",
            "4:3:56.6|8:11:50|-1||5.46|0.37|F2V|",
            "4:30:0.1|83:20:26|-1||5.46|0.87|G8III|",
            "4:40:3.4|12:11:52|77|93|5.46|-0.12|B8IV|",
            "4:55:11.2|-74:56:13|52|η|5.47|1.52|K4III|",
            "5:29:16.5|25:9:2|77|118|5.47|-0.04|B8.5V|",
            "5:31:14.5|3:17:32|59|33|5.46|-0.18|B1IV+B1.5V|",
            "5:32:14.2|17:3:29|-1||5.46|-0.04|B7IIIe|",
            "5:30:9.5|-47:4:40|-1||5.46|0.62|G3IV|",
            "5:45:54.0|49:49:35|7|27ο|5.47|0.03|A2VpCr|",
            "5:50:16.7|-79:21:41|52|κ|5.47|-0.08|B9V|",
            "6:6:32.0|-23:6:38|-1||5.47|0.08|Am|",
            "6:57:33.9|-24:37:50|-1||5.46|0.36|dF0|",
            "7:13:23.4|51:25:44|-1||5.47|1.67|M3-III|",
            "7:10:19.4|-27:29:29|-1||5.46|1.0|G8III|",
            "7:16:14.5|-15:35:9|-1||5.46|0.08|A2Vnp|",
            "8:25:51.9|-42:9:12|-1||5.47|-0.15|B3V|",
            "8:34:36.2|65:8:42|82|2|5.47|0.18|A2m|",
            "8:37:18.8|-62:51:13|-1||5.47|1.02|K0III|",
            "8:46:30.6|-45:54:46|-1||5.46|0.27|B3Ia|",
            "8:41:19.5|-78:57:48|21|η|5.47|-0.1|B8V|",
            "9:9:35.5|-8:47:16|41|20|5.46|1.01|G8II|",
            "9:16:41.3|-8:44:41|41|24|5.47|-0.09|B9III|",
            "9:21:43.3|56:41:57|-1||5.47|1.61|M4IIIa|",
            "9:27:6.4|-71:36:8|-1||5.47|1.08|K2III|",
            "9:31:36.3|-73:4:51|-1||5.47|1.56|K4III|",
            "10:32:11.8|14:8:14|45|46|5.46|1.68|M1.5IIIbCa-1|",
            "10:45:15.7|-80:28:11|21|δ1|5.47|0.95|K0III|",
            "11:0:14.7|45:31:34|-1||5.47|1.47|K5III|",
            "12:11:3.9|-23:36:9|27|3|5.46|0.06|A2V|",
            "12:31:0.6|24:34:2|24|21|5.46|0.05|A2p|",
            "12:39:7.3|21:3:45|24|26|5.46|0.96|G9III|",
            "12:54:58.6|-85:7:24|57|ι|5.46|1.02|K0III|",
            "12:55:19.4|-42:54:57|-1||5.47|1.68|M0III|",
            "13:39:30.4|52:55:17|82|82|5.46|0.1|A3Vn|",
            "14:6:42.8|-9:18:48|85|95|5.46|0.34|F2IV|",
            "14:51:26.4|59:17:38|-1||5.46|1.36|K4III|",
            "14:56:46.1|-11:24:35|48|15ξ2|5.46|1.49|K4III|",
            "15:18:48.9|-60:29:47|-1||5.46|-0.1|O7.5III((f))|",
            "15:26:17.4|34:20:9|-1||5.46|1.4|K4III|",
            "16:0:19.6|-16:32:0|48|49|5.47|0.52|F8V|",
            "16:19:55.1|39:42:31|-1||5.46|0.4|F3IV-V|",
            "16:36:22.5|-42:51:32|-1||5.47|0.4|O9Ia|",
            "17:23:40.7|37:8:48|39|75ρ|5.47|0.0|A0Vn|",
            "17:55:25.2|26:3:0|39|89|5.46|0.34|F2Ib|",
            "17:56:47.7|-4:4:55|-1||5.47|1.16|gG9|",
            "18:13:12.6|-41:20:10|-1||5.47|-0.17|B2.5III|",
            "18:15:52.7|-44:12:24|-1||5.46|0.96|G8-K0III|",
            "18:23:36.1|-75:2:39|57|φ|5.47|0.02|A0V|",
            "18:26:53.9|-48:7:1|-1||5.46|0.84|K0-1III+F-G|",
            "21:8:46.2|-88:57:23|57|σ|5.47|0.27|F0III|",
            "19:37:34.4|-14:18:6|-1||5.47|0.5|F5V|",
            "19:37:47.3|-4:38:51|4|42|5.46|0.43|F3IV|",
            "20:13:13.9|-1:0:34|4|66|5.47|1.43|K5III|",
            "20:40:19.8|-33:25:55|-1||5.47|1.12|K1III|",
            "20:28:14.6|81:25:22|33|75|5.46|1.02|G9III|",
            "20:53:53.9|33:26:16|-1||5.47|1.52|gK5|",
            "21:56:22.8|-37:15:13|-1||5.46|0.08|A2Vn|",
            "22:10:37.5|-11:33:54|3|38|5.46|-0.12|B7III|",
            "22:28:39.2|-39:7:55|38|ν|5.47|0.95|G9III|",
            "22:26:0.8|70:46:15|-1||5.47|1.2|gK2|",
            "22:27:5.3|65:7:56|19|26|5.46|0.37|B0.5Ibe:|",
            "0:37:21.1|35:23:58|-1||5.48|0.88|G2.5IIa|",
            "1:46:5.8|-50:48:59|-1||5.49|1.6|M3III|",
            "2:51:29.6|15:4:55|6|43σ|5.49|-0.09|B7V|",
            "3:6:7.8|79:25:7|-1||5.49|1.57|M1III+F7IV|",
            "3:52:41.6|-5:21:41|35|30|5.48|-0.1|B8V|",
            "3:56:28.7|35:4:52|-1||5.49|-0.03|B1.5V|",
            "4:30:38.9|15:41:31|77|81|5.48|0.26|A5m|",
            "4:57:22.3|17:9:13|-1||5.48|1.31|gK1|",
            "5:18:15.9|42:47:32|-1||5.48|1.65|M4III|",
            "5:32:51.3|-38:30:47|-1||5.48|1.22|K2III|",
            "5:47:26.2|17:43:45|77|130|5.49|0.3|F0III|",
            "5:49:36.5|-14:29:1|-1||5.49|0.88|gG6|",
            "7:46:2.2|-6:46:21|-1||5.49|1.38|K5III|",
            "7:47:56.7|-12:11:35|67|5|5.48|0.48|dF5|",
            "7:54:11.0|-35:52:39|-1||5.49|-0.19|B2V|",
            "8:39:23.8|-53:26:23|-1||5.48|-0.16|B5V|",
            "8:49:39.2|-40:19:14|-1||5.48|0.06|A2/3IV|",
            "9:29:54.5|-26:35:23|-1||5.48|1.36|K3III|",
            "9:59:51.7|56:48:43|-1||5.48|1.46|K5III|",
            "10:46:24.5|18:53:29|45|51|5.49|1.12|gK3|",
            "10:46:25.3|14:11:41|45|52|5.48|0.91|gG4|",
            "11:32:20.8|61:4:57|-1||5.48|0.5|F8V|",
            "11:38:40.1|-13:12:7|28|24ι|5.48|0.52|F7V|",
            "12:8:54.5|-41:13:53|-1||5.48|-0.07|B3IV|",
            "12:29:26.9|24:6:32|24|18|5.48|0.43|F5III|",
            "12:31:40.3|-59:25:26|-1||5.48|0.63|F7Ib-II|",
            "12:33:46.8|-9:27:7|85|21|5.48|-0.03|A0V|",
            "12:44:0.5|-28:19:26|-1||5.48|1.34|K4III|",
            "13:20:37.8|-52:44:53|-1||5.48|-0.13|B6V|",
            "14:2:22.8|-27:25:48|-1||5.48|1.34|K3III|",
            "14:50:29.6|37:16:19|-1||5.48|1.02|K0III-IV|",
            "15:31:30.8|-73:23:22|2|κ1|5.49|-0.12|B3IVe|",
            "16:13:15.4|5:1:16|39|9|5.48|1.47|gK5|",
            "16:19:32.7|-30:54:24|-1||5.49|0.47|F6III|",
            "16:10:49.5|75:52:39|83|19|5.48|-0.11|B8V|",
            "16:46:47.8|-39:22:38|-1||5.48|0.98|K0III|",
            "16:50:19.4|7:14:52|39|47|5.49|0.1|A3m|",
            "16:57:11.1|-33:15:34|72|27|5.48|1.59|K5III|",
            "17:19:3.2|-46:38:2|-1||5.48|0.8|G8-K0V|",
            "18:10:26.1|-62:0:8|60|ι|5.49|0.58|G0V|",
            "18:8:2.2|36:24:5|-1||5.48|1.17|K2.5III|",
            "18:33:53.5|-24:1:57|71|24|5.49|1.79|K4Ib|",
            "18:32:49.9|30:33:15|-1||5.48|-0.1|B8IV|",
            "18:48:50.5|-43:40:48|25|η1|5.49|0.13|A3V|",
            "18:52:16.4|21:25:31|39|112|5.48|-0.07|B9II-IIIpHg|",
            "19:0:43.4|55:39:30|33|49|5.48|0.86|G5.5IIbFe-0.5|",
            "19:20:35.7|0:53:32|4|27|5.49|-0.04|B9III|",
            "19:43:33.5|-15:28:12|-1||5.49|0.46|F5IV|",
            "19:43:42.9|25:46:19|87|10|5.49|0.93|G8III|",
            "19:58:38.0|30:59:1|-1||5.49|-0.06|B9Vn|",
            "20:11:48.0|26:48:32|87|19|5.49|1.41|K3II-III|",
            "20:58:25.9|10:50:21|31|18|5.48|0.93|gG6|",
            "21:24:11.5|-12:52:41|3|18|5.49|0.29|F1V|",
            "21:25:17.0|-3:33:24|3|21|5.49|1.46|K4III|",
            "21:43:6.4|41:9:18|-1||5.49|1.59|M2IIIab|",
            "22:29:58.0|4:25:54|61|37|5.48|0.38|F2V+F2V|",
            "22:57:27.9|20:46:8|61|51|5.49|0.67|G2.5IVa|",
            "23:28:3.7|-87:28:56|57|τ|5.49|1.27|K2III|"
        )
/*"23:47:56.5|-2:45:42|65|20|5.49|0.94|G8III|",
"0:46:11.8|-22:31:19|-1||5.5|0.98|G3V|",
"0:47:1.5|11:58:26|65|58|5.5|0.97|G8II|",
"1:2:49.1|31:48:16|65|69σ|5.5|-0.05|B9.5V|",
"1:2:26.4|-31:33:7|73|σ|5.5|0.08|A2V|",
"1:26:41.7|19:14:25|65|94|5.5|1.11|K1III|",
"2:2:58.0|33:17:2|79|3ε|5.5|0.03|A2V|",
"3:24:18.5|24:43:27|6|64|5.5|1.19|gK4|",
"4:9:10.0|19:36:33|77|43ω1|5.5|1.07|K2III|",
"5:8:6.6|24:15:55|77|103|5.5|0.06|B2V|",
"5:14:44.1|5:9:22|-1||5.5|1.37|gK4|",
"5:17:40.2|-13:31:11|-1||5.5|0.93|sgG9|",
"5:27:45.6|15:52:27|77|116|5.5|0.01|B9.5Vn|",
"5:56:20.9|-31:22:57|23|σ|5.5|0.0|F2III|",
"6:8:57.9|-22:25:39|-1||5.5|-0.01|A0IV|",
"6:7:52.9|-42:9:14|23|π2|5.5|0.0|A0V|",
"7:3:15.6|-59:10:41|-1||5.5|-0.11|B9IV|",
"8:26:43.9|12:39:16|11|27|5.5|1.6|M3III|",
"9:38:1.5|-43:11:28|-1||5.5|1.0|G8II|",
"10:29:41.5|84:15:8|-1||5.5|0.0|F0IV|",
"10:24:8.6|33:43:7|46|28|5.5|1.18|gK1|",
"11:3:14.9|-11:18:13|-1||5.5|0.94|G7-III|",
"11:34:56.8|-49:8:12|-1||5.5|1.04|K1III-IV|",
"12:27:28.7|-58:59:31|-1||5.5|1.45|M4-5III|",
"12:36:23.3|59:29:13|-1||5.5|0.0|M4IIIe|",
"13:37:11.0|71:14:32|-1||5.5|1.2|gK2|",
"13:46:59.8|38:32:34|-1||5.5|1.03|K0III+F8V|",
"14:5:19.8|-76:47:48|2|θ|5.5|1.55|M6.5III:|",
"14:30:8.6|-45:19:18|-1||5.5|-0.08|B8Vn|",
"15:16:23.0|-22:23:58|-1||5.5|1.38|K5III|",
"15:22:37.4|39:34:53|-1||5.5|1.59|gK4|",
"15:32:55.2|-16:51:10|48|35ζ4|5.5|-0.14|B2Vn|",
"16:15:37.3|-8:22:10|72|18|5.5|0.65|G2Va|",
"16:34:19.3|-70:59:17|-1||5.5|1.22|K1IIICNIa-Ib|",
"17:50:22.9|29:19:20|-1||5.5|1.05|K1III|",
"18:32:43.3|-14:51:56|-1||5.5|1.97|K3Ib-IICN1|",
"19:4:25.1|-31:2:49|-1||5.5|0.03|A0IV|",
"20:46:20.1|-39:11:57|-1||5.5|-0.1|B8/9V|",
"21:59:17.9|-38:23:43|-1||5.5|1.0|K0III|",
"22:10:38.9|70:7:58|-1||5.5|0.38|F2V|",
"22:29:52.9|78:49:27|19|29ρ2|5.5|0.06|A3V|",
"0:5:42.0|13:23:46|61|86|5.51|0.9|G5III|",
"0:10:2.3|11:8:44|65|34|5.51|-0.07|B9Vn|",
"0:20:39.0|-69:37:30|81|π|5.51|-0.05|B9V|",
"0:35:41.1|-48:0:3|63|λ2|5.51|0.44|F6V|",
"1:8:22.2|5:38:59|65|80|5.52|0.34|F0III-IV|",
"1:32:56.0|-36:51:55|-1||5.51|1.02|K0III|",
"1:42:29.3|-53:44:26|-1||5.52|0.53|F9V|",
"1:51:59.3|55:8:51|62|1|5.52|-0.18|B1.5V|",
"2:0:26.9|-8:31:25|-1||5.51|1.52|M3III|",
"2:16:59.0|-6:25:20|20|67|5.51|0.96|G8.5III|",
"3:15:20.5|30:33:24|-1||5.52|0.01|A1Vs|",
"3:22:11.9|27:36:27|6|62|5.52|1.1|G5III|",
"3:21:24.0|-23:38:7|-1||5.52|0.88|G6.5IIbCN-1Hdel-1|",
"3:15:57.6|-77:23:18|42|ι|5.52|0.44|F4III|",
"4:8:36.6|38:2:23|62|50|5.51|0.46|F7V|",
"4:47:36.3|-16:56:4|35|58|5.51|0.63|G2.5V|",
"4:55:3.1|55:15:33|10|5|5.52|0.04|B9.5V|",
"4:56:24.2|-5:10:17|35|62|5.51|-0.13|B6V|",
"5:20:14.8|41:5:10|-1||5.52|0.11|A3V|",
"5:50:28.9|14:18:20|77|135|5.52|1.01|gG9|",
"6:18:13.7|-19:58:1|-1||5.52|-0.18|B2V|",
"6:36:35.3|-5:12:40|-1||5.52|-0.08|B8V|",
"8:2:44.8|-41:18:36|-1||5.52|-0.15|B9pSi|",
"8:13:34.1|-50:11:46|-1||5.51|1.61|M1III|",
"8:23:48.5|53:13:11|-1||5.51|0.11|A3V|",
"8:42:16.0|-48:5:57|-1||5.51|-0.18|B1.5Vn|",
"8:42:18.9|-53:6:0|-1||5.52|-0.15|B8Si|",
"10:0:43.7|-82:12:53|21|μ1|5.52|0.03|A0IV|",
"10:39:5.7|53:40:6|-1||5.52|1.27|K3III|",
"10:40:11.3|-65:6:2|-1||5.52|-0.16|B9pSi|",
"10:43:1.8|26:19:32|46|40|5.51|0.17|A4Vn|",
"11:6:54.2|1:57:20|45|65|5.52|0.97|G9IIICN-1|",
"11:30:29.0|18:24:35|45|86|5.52|1.05|K0III|",
"13:8:7.0|-65:18:23|55|θ|5.51|-0.02|B0Ia+WC5:|",
"13:45:56.3|-12:25:36|85|86|5.51|0.9|G8III|",
"15:1:19.8|-2:45:18|-1||5.52|1.68|M0III|",
"15:3:6.1|35:12:21|-1||5.51|1.02|gG8|",
"15:20:8.5|29:36:58|26|1ο|5.51|1.02|K0III|",
"15:32:36.7|-19:40:14|-1||5.52|0.18|A2m|",
"15:32:57.9|-1:11:11|75|11|5.51|1.09|K0III|",
"15:42:50.7|52:21:39|-1||5.51|-0.07|B9pSiCr|",
"16:35:44.8|-65:29:43|80|θ|5.52|0.93|G8-K0III|",
"16:51:24.9|1:12:58|58|21|5.51|0.05|A2Vs|",
"17:21:43.6|39:58:28|-1||5.51|0.68|F9Vn:|",
"17:41:58.7|15:57:7|-1||5.52|0.38|F4Vw|",
"17:42:28.4|24:33:51|39|83|5.52|1.46|K4III|",
"18:7:48.4|-17:9:15|-1||5.52|1.11|K1III|",
"18:10:40.3|3:19:27|-1||5.51|1.19|K2III|",
"18:51:35.0|52:58:30|-1||5.51|0.84|G9IVa|",
"19:13:15.5|-12:16:57|-1||5.51|1.44|gK4|",
"19:29:52.2|-26:59:8|-1||5.52|1.12|K3III|",
"19:46:1.2|-31:54:31|-1||5.52|0.02|B8V|",
"19:54:31.1|24:19:10|-1||5.52|-0.02|A0III|",
"20:4:8.3|7:16:41|4|63τ|5.52|1.06|gK0|",
"20:10:33.5|26:54:15|87|18|5.52|0.08|A3III|",
"20:41:2.6|32:18:26|30|49|5.51|0.88|G8IIb|",
"20:51:0.7|-37:54:48|-1||5.52|1.38|K3II|",
"20:56:54.0|-9:41:51|3|7|5.51|1.47|gK5|",
"20:59:25.4|59:26:19|-1||5.51|1.4|gK4|",
"21:27:1.6|-42:32:52|-1||5.51|0.39|Am|",
"21:47:25.3|60:41:34|19|12|5.52|1.52|M1IIIb|",
"22:17:50.5|-77:30:42|57|ψ|5.51|0.31|F3III|",
"22:45:40.7|-46:32:51|-1||5.51|1.32|K2III|",
"22:59:35.8|-29:27:44|-1||5.51|0.25|A5n|",
"23:4:52.2|-68:49:13|-1||5.52|0.36|F4III|",
"23:26:36.6|-52:43:18|38|ο|5.52|0.4|F4V|",
"23:47:1.9|57:27:5|-1||5.51|1.65|K3IIb|",
"0:9:2.4|18:12:43|61|87|5.53|1.04|G9III|",
"2:12:47.5|-2:23:37|20|66|5.54|0.57|F8V|",
"2:27:27.7|31:48:5|79|11|5.54|1.12|gK1|",
"2:36:0.0|-7:49:54|20|80|5.53|1.59|M0III|",
"3:2:15.4|-71:54:9|42|θ|5.53|-0.14|B3V+A0IV|",
"3:17:46.2|-62:34:31|69|ζ1|5.54|0.64|G2.5VFe1Hdel1|",
"3:40:38.3|-5:12:38|35|22|5.53|-0.15|B9IIIpSi4200|",
"3:47:56.0|-30:10:4|36|ρ|5.54|0.98|G6III|",
"4:27:17.5|22:59:47|77|72|5.53|-0.1|B7V|",
"4:44:8.0|-18:40:0|-1||5.53|0.02|A3V|",
"4:43:3.9|-70:55:52|52|μ|5.54|-0.12|B8II-IIISi:|",
"5:22:50.3|41:1:46|-1||5.54|0.12|A3V|",
"5:37:3.8|17:2:25|77|122|5.54|0.22|F0V|",
"6:17:1.2|-37:44:15|-1||5.53|1.14|K1III|",
"6:20:36.3|-34:8:38|-1||5.53|-0.19|B1.5Ve|",
"6:33:36.1|14:9:19|-1||5.53|1.11|gK2|",
"7:3:57.3|-43:36:29|-1||5.54|0.64|G3V|",
"7:27:59.2|-29:9:21|-1||5.54|-0.08|B9VpSi:|",
"7:33:51.0|-36:20:18|-1||5.54|-0.06|B3Vne|",
"7:25:38.0|-79:5:39|52|ε|5.53|1.28|K2-3III|",
"8:5:4.0|-53:6:29|-1||5.53|1.34|K3-4III|",
"8:10:39.8|-13:47:57|67|18|5.54|0.49|F6V|",
"8:19:32.2|75:45:25|-1||5.54|0.9|G8III|",
"8:26:41.9|-12:32:4|-1||5.54|1.19|K2III|",
"8:27:16.9|-70:5:36|-1||5.53|-0.03|A0V|",
"8:51:34.5|-7:10:38|41|15|5.54|0.15|A4m|",
"9:12:55.6|-59:24:52|-1||5.54|0.85|G6II|",
"11:55:40.5|15:38:48|45|95|5.53|0.11|A3V|",
"12:20:19.7|26:37:10|-1||5.54|1.09|K2III-IV|",
"13:53:32.8|-35:39:51|-1||5.54|0.44|F4V|",
"14:14:5.2|12:57:34|8|14|5.54|0.54|F6IV|",
"14:57:33.3|0:10:3|-1||5.53|1.13|K1III|",
"15:11:16.0|-55:20:46|-1||5.54|1.14|G2Ib-II|",
"15:21:7.6|-5:49:29|-1||5.54|1.04|K1III|",
"15:48:56.8|-3:49:7|-1||5.53|0.12|A5IV|",
"15:57:14.6|14:24:52|75|φ|5.54|1.14|K1IV|",
"16:9:52.6|-33:32:45|-1||5.54|-0.1|B8V|",
"16:25:24.2|37:23:38|39|25|5.54|0.17|A5V|",
"16:36:11.5|52:54:1|33|16|5.53|-0.07|B9.5Vn|",
"17:15:19.3|-33:32:54|-1||5.53|-0.01|O7.5V[nee|",
"17:26:49.1|20:4:51|-1||5.54|-0.13|B5V|",
"17:42:51.0|-36:56:45|-1||5.54|1.55|K5III|",
"18:10:5.7|-30:43:43|-1||5.53|0.97|K1II|",
"18:52:27.1|-46:35:43|-1||5.54|1.63|M0III|",
"18:59:23.8|-12:50:26|-1||5.53|-0.04|B5IV|",
"19:8:16.7|-19:17:24|-1||5.54|-0.11|B2Ve|",
"19:17:12.0|-66:39:41|-1||5.53|0.18|A5V+A8V|",
"19:19:39.3|12:22:29|4|28|5.53|0.26|F0III|",
"19:31:19.3|50:18:24|-1||5.53|1.25|gK1|",
"19:57:45.4|16:47:21|70|11|5.53|-0.05|B9III|",
"20:22:3.4|24:26:46|87|25|5.54|-0.06|B8IIIne|",
"21:6:25.5|-41:23:10|53|η|5.53|1.35|K3III|",
"21:30:59.3|60:27:34|-1||5.53|0.12|B1II|",
"21:36:2.4|45:22:29|-1||5.53|1.58|M5IIIae|",
"21:50:47.1|-69:37:46|43|ο|5.53|1.37|K2-3III|",
"21:52:29.9|28:47:36|61|15|5.53|0.42|F6IV-Vvw|",
"21:56:56.4|12:4:35|61|17|5.54|0.05|A2Vnn|",
"22:3:16.4|-6:31:21|3|30|5.54|0.96|K0III|",
"22:13:49.3|45:26:27|-1||5.53|0.04|A0III|",
"22:23:30.9|-24:45:45|3|49|5.53|0.99|gG9|",
"23:16:42.3|53:12:49|-1||5.54|0.52|F7V|",
"23:18:9.9|-40:49:28|38|φ|5.53|0.44|F5V|",
"23:37:56.8|18:24:2|61|75|5.53|0.0|A1Vn|",
"0:1:20.0|-50:20:14|-1||5.53|1.6|M2III|",
"0:33:41.1|-29:33:30|-1||5.55|1.27|K2III|",
"0:56:47.1|60:21:46|-1||5.55|-0.07|B9IVn|",
"1:5:41.7|21:27:55|65|74ψ1|5.56|-0.07|A0Vn|",
"1:7:57.2|20:44:21|65|79ψ2|5.55|0.13|A3V|",
"1:9:49.2|19:39:31|65|81ψ3|5.55|0.69|G0III|",
"1:11:25.6|64:12:10|-1||5.55|-0.07|B9.5V|",
"1:38:7.6|57:58:39|-1||5.56|1.38|G5II|",
"2:14:14.7|-67:50:30|42|π1|5.55|1.55|M1III|",
"2:59:41.2|-2:27:54|35|5|5.56|-0.08|B9.5V|",
"3:12:26.4|6:39:39|-1||5.56|1.08|K1IIIep+A6V|",
"3:44:56.5|0:17:48|35|25|5.55|1.42|K4III|",
"4:20:11.5|50:55:15|-1||5.55|-0.01|B1.5IV|",
"4:28:32.1|1:22:51|-1||5.55|-0.1|B3V|",
"5:16:4.1|11:20:29|59|18|5.56|-0.04|A0V|",
"5:31:7.6|-20:51:49|47|10|5.55|0.0|A0V|",
"5:50:58.1|27:58:4|-1||5.56|0.97|gG7|",
"6:1:16.4|-33:54:42|-1||5.55|1.58|K5III|",
"6:9:34.3|-14:35:3|-1||5.56|1.16|K2III|",
"6:28:34.1|30:29:35|7|48|5.55|0.68|F8Ib|",
"6:27:20.4|2:54:29|-1||5.55|1.04|G9III|",
"6:27:15.6|0:16:34|-1||5.55|1.38|K5III|",
"6:22:38.2|-69:59:3|32|π1|5.56|1.51|K5III|",
"7:6:11.6|34:28:26|-1||5.55|0.91|G8IV|",
"7:38:32.8|35:2:55|37|70|5.56|0.93|K0III|",
"7:41:12.4|48:7:54|-1||5.56|1.01|K0III|",
"7:42:3.2|14:12:30|-1||5.56|1.64|M3II-III|",
"8:0:47.3|17:18:31|11|3|5.55|1.32|gK3|",
"9:1:20.8|-41:51:52|-1||5.55|-0.14|B5V|",
"9:34:32.7|-5:54:54|41|33|5.56|1.16|K1III|",
"9:36:42.9|31:9:42|-1||5.56|1.59|M2IIIa|",
"9:43:42.2|-53:53:30|-1||5.56|-0.04|A0IV|",
"9:46:30.4|-44:45:18|-1||5.55|-0.18|B2.5IV|",
"10:29:35.4|-30:36:26|1|δ|5.56|-0.04|B9.5V|",
"11:41:19.8|-43:5:45|-1||5.55|0.0|A0V|",
"12:0:44.5|-10:26:46|-1||5.55|0.77|G8-K0IV|",
"12:20:50.8|57:51:50|82|70|5.55|1.43|K5III|",
"12:26:51.7|-32:49:48|-1||5.55|0.01|B9V|",
"12:49:44.9|-71:59:11|-1||5.55|1.17|G8Ib-II|",
"13:8:32.5|-8:59:4|-1||5.55|1.18|K3III|",
"13:32:51.7|-15:21:47|85|75|5.55|1.23|K1.5IIIb|",
"14:13:16.4|-53:39:57|-1||5.56|1.44|K5III+B-A|",
"14:20:9.7|-43:3:32|-1||5.56|0.92|G8III|",
"14:22:19.7|-34:47:13|-1||5.56|-0.09|B8V|",
"14:36:19.0|-46:14:43|-1||5.55|1.48|K3III|",
"14:41:43.5|11:39:38|8|32|5.56|0.94|G8III|",
"15:43:59.3|32:30:57|26|9π|5.56|1.06|gG9|",
"16:0:47.6|-8:24:41|48|50|5.55|0.05|A0Vs|",
"16:3:31.3|76:47:37|-1||5.56|0.0|A3V|",
"16:25:43.1|78:57:50|-1||5.56|0.26|F0V|",
"16:45:22.5|15:44:43|-1||5.56|1.66|M3IIIab|",
"16:58:18.0|-50:38:28|-1||5.55|0.02|B9IV|",
"17:6:18.1|22:5:3|-1||5.56|1.3|K3III|",
"17:9:48.0|-10:31:24|-1||5.56|0.52|F5IV|",
"17:17:3.7|-32:39:46|-1||5.55|0.5|F6IV|",
"17:12:32.6|62:52:28|-1||5.56|0.21|F0IV|",
"17:34:46.4|-11:14:31|-1||5.55|0.02|B8Vn|",
"18:23:28.9|-36:14:18|-1||5.55|1.02|K0III|",
"19:4:57.9|31:44:40|-1||5.56|1.54|M0III|",
"19:6:37.7|28:37:43|-1||5.55|0.29|F0III|",
"19:29:22.1|14:35:45|-1||5.56|1.05|K0III|",
"20:20:6.0|68:52:49|-1||5.55|1.59|M4.5-5III|",
"20:52:8.7|-5:30:25|3|5|5.55|-0.08|B9III|",
"20:58:19.5|44:28:18|-1||5.55|0.97|K0IIIbFe-0.5|",
"22:2:4.6|58:0:2|19|14|5.56|0.06|O9Vn|",
"22:28:37.7|-67:29:21|-1||5.55|0.2|A4V|",
"22:54:45.5|-16:16:19|3|77|5.56|1.14|K2.5IIIb|",
"23:1:19.4|-28:51:13|-1||5.55|1.35|K3III|",
"23:13:17.0|57:10:6|-1||5.56|1.01|K3V|",
"23:15:34.3|-3:29:47|-1||5.55|0.06|A3V|",
"23:15:37.8|70:53:17|-1||5.56|0.24|F0IV|",
"23:19:24.0|-5:7:28|3|96|5.55|0.39|F3IV-V|",
"23:22:32.5|60:8:1|-1||5.56|1.68|K3II|",
"23:51:57.9|2:55:49|65|22|5.55|1.53|K4IIIaBa0.3|",
"23:57:8.5|55:42:21|-1||5.55|0.49|F1/6V+F3|",
"0:1:36.9|61:13:23|-1||5.55|0.41|F0III|",
"0:24:15.6|52:1:12|-1||5.57|-0.12|B5IV|",
"0:34:27.8|-52:22:23|-1||5.57|0.47|F3IV-V|",
"0:37:20.7|-24:46:2|-1||5.57|0.72|G8V|",
"0:48:1.1|-21:43:21|-1||5.57|-0.06|B9V|",
"1:6:5.1|-9:50:22|20|28|5.58|0.01|A1V|",
"1:11:41.4|65:1:8|17|32|5.57|-0.09|B9IV|",
"1:23:40.6|37:42:54|0|47|5.58|0.26|A2Vm|",
"1:37:5.9|12:8:30|65|102π|5.57|0.35|F0V|",
"1:38:51.8|-21:16:31|-1||5.58|0.34|A4n|",
"1:59:38.8|-42:1:50|-1||5.57|1.06|K1III|",
"2:3:0.3|64:23:24|17|53|5.58|0.38|B8Ib|",
"2:15:42.8|25:2:35|6|21|5.58|0.49|F6V|",
"2:18:1.4|1:45:28|-1||5.58|0.6|G0.5IVb|",
"3:7:32.0|-78:59:22|-1||5.57|0.3|F2II-III|",
"3:28:52.4|49:50:54|-1||5.58|-0.04|B6Vn|",
"3:35:57.7|-11:11:37|-1||5.57|0.91|gG7|",
"3:41:7.9|37:34:48|-1||5.57|-0.07|B7Vne|",
"3:39:51.1|3:3:25|77|12|5.57|0.94|gG6|",
"4:28:13.0|83:48:28|-1||5.57|-0.13|B5V|",
"4:30:8.6|15:38:17|77|80|5.58|0.32|F0V|",
"4:40:6.8|-24:28:57|-1||5.58|0.92|G6III|",
"4:49:12.8|31:26:14|-1||5.58|1.12|K2III|",
"5:28:15.3|-37:13:50|-1||5.57|0.02|A1V|",
"5:54:52.5|-39:57:29|-1||5.57|1.51|M0III|",
"6:10:10.3|-40:21:13|-1||5.58|1.68|M2II-III|",
"7:15:50.1|47:14:24|-1||5.58|0.58|G0V|",
"7:14:51.1|-27:2:17|-1||5.58|1.22|K4III|",
"8:18:17.4|-35:27:6|-1||5.58|1.24|K2III|",
"8:21:21.2|-20:4:45|-1||5.58|0.77|G2III+A3|",
"8:26:27.7|27:53:37|11|22φ1|5.57|1.4|K5III|",
"8:56:37.5|64:36:14|82|6|5.58|0.86|G7IIIFe-0.5|",
"9:12:30.6|-43:36:49|-1||5.57|-0.11|B8Vp:Si:|",
"9:21:50.9|-42:11:42|-1||5.58|1.63|M1III|",
"9:50:55.7|-62:44:43|-1||5.57|1.32|K1IIICNII|",
"10:25:44.3|-7:3:35|-1||5.57|1.52|K5:IIIbFe-0.5|",
"10:26:49.0|-54:52:39|-1||5.58|1.56|K3II-III|",
"10:29:29.0|-29:39:49|-1||5.58|1.42|K5III|",
"10:30:59.8|-13:35:18|-1||5.58|-0.04|B9Vn|",
"10:33:30.9|34:59:19|46|34|5.58|0.02|A2Vn|",
"10:51:23.7|59:19:12|82|42|5.58|1.14|K2III|",
"11:6:49.9|-70:52:41|-1||5.57|-0.05|B2V|",
"11:25:36.4|16:27:23|45|81|5.57|0.36|F2V|",
"11:52:10.1|-56:59:16|-1||5.57|0.07|A2V|",
"11:55:3.1|8:26:38|85|6|5.58|0.94|gK0|",
"11:57:40.1|-62:26:56|-1||5.57|-0.15|B3V|",
"12:12:9.3|20:32:31|24|5|5.57|0.95|K0II-III|",
"12:33:34.3|-12:49:49|-1||5.58|0.86|G8III|",
"13:3:46.1|-20:34:59|-1||5.58|0.56|F7V|",
"13:40:55.5|-85:47:10|57|κ|5.58|0.18|Am|",
"13:39:34.6|10:44:46|-1||5.57|0.33|F0V|",
"15:5:25.8|48:9:4|8|47|5.57|0.0|A1V|",
"15:23:12.3|30:17:16|26|2η|5.58|0.58|G0V|",
"15:43:16.8|-84:27:55|57|ρ|5.57|0.11|A2V|",
"15:45:23.5|5:26:49|-1||5.58|0.04|A0V|",
"16:9:18.6|-57:56:4|56|ι2|5.57|-0.04|B9.5V|",
"16:41:53.7|-19:55:28|-1||5.57|0.43|F4IV-III|",
"16:47:19.5|-58:20:29|-1||5.58|-0.08|B0.5Ia|",
"16:56:48.0|-23:9:0|58|24|5.58|-0.02|A0V|",
"17:55:50.8|22:27:51|-1||5.58|1.24|gK3|",
"18:9:59.0|36:27:59|-1||5.58|0.91|G8III|",
"18:53:43.6|36:58:18|51|11δ1|5.58|-0.15|B2.5V|",
"18:55:27.5|6:36:55|-1||5.57|1.04|K0III|",
"18:57:16.6|2:32:7|75|64|5.57|0.0|B9IIIep:Hg:|",
"19:15:20.1|15:5:1|-1||5.57|1.07|G8II-III|",
"19:20:38.1|-22:24:9|-1||5.58|0.27|F0III:|",
"19:52:1.6|24:59:32|-1||5.57|0.71|A1Ia|",
"20:18:28.6|37:0:0|30|36|5.58|0.06|A2V|",
"20:22:5.4|45:47:42|-1||5.58|1.08|K0III|",
"20:43:11.0|66:39:27|19|4|5.58|0.22|A8V|",
"20:47:48.3|6:0:30|31|13|5.58|-0.02|A0V|",
"20:47:49.3|47:49:55|-1||5.57|1.46|K5III|",
"20:55:38.6|12:34:7|31|16|5.58|0.12|A4V|",
"21:21:4.4|23:51:21|-1||5.57|1.05|K1III|",
"21:33:23.5|-44:50:55|-1||5.57|1.04|K1III|",
"21:46:32.1|-11:21:57|15|48λ|5.58|-0.01|A1V|",
"21:48:15.8|-47:18:13|-1||5.58|0.6|G0V|",
"22:1:5.0|0:36:18|3|28|5.58|1.28|gK4|",
"22:9:13.6|33:10:20|61|27π1|5.58|1.0|G8IIIb|",
"22:13:44.4|-25:10:51|-1||5.58|0.49|F6III-II|",
"22:29:8.0|9:7:44|61|36|5.58|1.55|K5IIIa|",
"23:24:50.8|32:23:6|61|67|5.57|-0.11|B9III|",
"23:27:0.8|87:18:27|-1||5.58|0.23|A7IV|",
"0:6:26.5|64:11:46|17|10|5.59|-0.03|B9III|",
"0:31:41.2|52:50:22|-1||5.6|1.15|K2III|",
"0:49:25.6|-13:33:41|-1||5.59|1.3|K5III|",
"1:1:18.3|-38:55:0|73|ξ|5.59|1.18|K0III|",
"1:42:20.5|68:2:35|17|43|5.59|-0.07|A0pSiSr|",
"2:20:58.2|50:9:5|0|63|5.59|-0.13|B9pSi|",
"2:55:56.9|61:31:16|-1||5.59|0.45|F4V|",
"3:29:36.0|-12:40:29|-1||5.59|0.17|A5IV|",
"3:44:31.4|36:27:36|-1||5.59|0.06|A2m|",
"3:43:33.8|-10:29:8|-1||5.6|0.22|A5m|",
"3:59:30.1|-12:34:27|-1||5.6|1.48|K5III|",
"4:5:37.4|-27:39:6|-1||5.59|0.31|F1IV|",
"4:19:57.7|14:2:7|77|57|5.59|0.28|F0IV|",
"4:29:6.9|-13:2:54|-1||5.6|-0.23|B1Vne|",
"5:35:13.4|10:14:24|-1||5.6|0.12|B9IIIpHg:Mn:|",
"5:42:26.4|65:41:52|-1||5.6|1.24|gK5|",
"5:52:22.3|14:10:18|77|137|5.59|-0.05|B9pSiCrEu|",
"6:28:49.5|-7:2:4|54|11|β|5.6|0.0|B3e|",
"6:32:23.1|-5:52:8|-1||5.6|0.25|F0Vnn|",
"6:31:18.3|-51:49:34|-1||5.6|0.54|F8V|",
"6:35:24.1|-36:46:48|-1||5.59|-0.14|A0V|",
"6:58:35.9|-25:24:50|-1||5.59|-0.16|B3V|",
"7:29:18.7|-1:54:19|-1||5.59|1.5|K5III|",
"7:33:11.6|3:17:25|14|8δ2|5.59|0.31|F2V|",
"7:43:12.0|-36:3:1|-1||5.6|-0.13|B5V|",
"7:49:35.4|-33:17:20|-1||5.6|1.61|K5III|",
"7:49:6.7|-56:24:38|-1||5.59|1.13|G5II|",
"7:57:46.9|-60:18:12|-1||5.6|0.57|G0V|",
"8:26:27.2|-3:59:15|41|2|5.59|0.22|A5III-IV|",
"8:51:36.6|-57:38:1|-1||5.59|-0.11|B8III|",
"9:8:42.2|-8:35:22|41|19|5.6|-0.06|B9.5III|",
"9:9:56.4|-30:21:55|68|ε|5.59|0.19|A4IV-V|",
"9:25:24.0|-5:7:3|41|28|5.59|1.52|K5III|",
"10:7:9.5|-17:8:30|-1||5.6|1.5|K7III|",
"10:9:21.9|-61:32:57|-1||5.6|1.6|M2-3IIIe|",
"10:15:31.5|-43:6:45|-1||5.6|1.52|K4III|",
"11:24:11.1|-72:15:24|-1||5.59|0.06|B2IV-V|",
"11:38:20.6|43:37:32|82|59|5.59|0.33|F2II-III|",
"12:1:39.5|36:2:31|-1||5.59|1.01|K0III|",
"12:41:57.1|6:48:24|85|31|5.59|0.0|A2V|",
"12:56:0.4|38:18:53|12|12|α1|5.6|0.34|F0V|",
"13:6:35.1|-41:35:19|-1||5.59|1.05|K0II-III|",
"13:6:22.6|22:36:58|24|40|5.6|1.59|M5III|",
"13:20:19.0|40:9:2|12|23|5.6|1.2|K1III|",
"13:34:7.3|55:20:55|82|81|5.6|-0.03|A0V|",
"13:39:48.6|-40:3:7|-1||5.6|1.3|K2/3III|",
"13:44:29.8|-16:10:45|85|83|5.6|0.81|G0Ib-IIa|",
"14:28:37.8|49:50:41|8|24|5.59|0.85|G3IV|",
"14:53:13.7|-73:11:24|-1||5.6|0.82|G7IIIa+F9IV|",
"15:18:56.4|-40:47:18|-1||5.59|-0.1|B7V|",
"17:20:21.1|46:14:27|39|74|5.59|1.57|M0III|",
"17:31:21.3|2:43:28|-1||5.59|0.84|G8III+A7|",
"17:53:23.3|-34:53:43|-1||5.6|1.14|K3III|",
"18:15:40.9|-63:3:20|-1||5.6|0.92|K0III-IV|",
"18:15:38.8|42:9:34|-1||5.59|-0.1|B7IV|",
"18:25:1.5|-30:45:24|71|18|5.6|1.14|K0III-IV|",
"19:16:31.0|4:50:5|4|22|5.59|0.08|A3IV|",
"19:19:40.0|-35:25:17|-1||5.59|-0.13|B3V|",
"19:26:19.2|-21:46:36|71|50|5.59|1.22|K3III|",
"20:22:27.5|-42:2:59|71|κ1|5.59|0.0|A0V|",
"20:37:4.7|26:27:43|87|27|5.59|-0.07|B9V|",
"21:8:38.9|30:12:21|-1||5.59|-0.1|B9VpSi|",
"21:23:0.5|-22:40:8|-1||5.6|1.63|M1III|",
"21:25:19.6|46:42:52|-1||5.6|0.32|F0V|",
"22:1:5.4|13:7:11|61|20|5.6|0.34|F4III|",
"22:2:56.7|44:39:0|-1||5.6|-0.03|A0IV|",
"22:51:22.8|61:41:49|-1||5.6|0.78|G8III-IV+G2IV|",
"22:56:23.6|41:36:14|44|16|5.59|-0.14|B2IV|",
"23:8:21.0|-28:49:24|-1||5.6|0.88|G9III|",
"23:20:49.6|30:24:54|61|63|5.59|1.5|M0III|",
"23:25:19.4|-56:50:57|-1||5.59|1.07|K0III|",
"23:27:16.6|70:21:35|-1||5.6|0.19|A6IV|",
"23:34:37.5|40:14:11|0|15|5.59|0.1|A1Vp|",
"0:4:41.3|-71:26:13|-1||5.59|-0.12|B8IV-V|",
"0:54:53.1|83:42:26|-1||5.62|0.09|A4V|",
"0:58:43.9|-11:22:48|20|23φ4|5.61|0.97|G7III|",
"1:40:39.8|43:17:52|-1||5.61|0.21|sgA9|",
"2:3:40.5|-4:6:13|-1||5.62|1.59|K5I:|",
"2:18:7.5|19:54:4|6|22θ|5.62|0.01|A1Vn|",
"3:2:22.5|4:21:10|20|93|5.61|-0.1|B7V|",
"3:6:23.7|13:11:14|-1||5.62|1.08|K3III|",
"3:32:20.1|84:54:40|-1||5.61|0.92|G3IIp:+F0:V|",
"3:19:34.8|-24:7:23|-1||5.61|1.66|M2III|",
"3:24:29.7|33:32:9|-1||5.61|-0.03|A0V|",
"3:28:20.8|33:48:27|-1||5.61|0.02|A2V|",
"4:4:22.7|-12:47:33|-1||5.61|1.08|gK0|",
"4:50:55.2|-53:27:41|64|ι|5.61|0.33|F0IV|",
"5:3:53.3|-24:23:16|-1||5.61|0.1|A3m|",
"5:20:22.6|62:39:13|-1||5.61|1.75|K4I:|",
"5:25:1.6|-10:19:45|-1||5.61|1.56|K5III|",
"5:35:8.5|9:56:6|59|39λ|5.61|0.04|B0.5V|",
"6:24:1.0|-36:42:28|-1||5.62|1.04|G6III|",
"6:22:55.8|-56:22:12|64|ν|5.61|0.24|Am|",
"6:34:35.3|-32:42:59|-1||5.62|-0.08|B8V|",
"6:47:18.7|-55:32:24|-1||5.61|1.52|K5III|",
"7:4:5.2|-5:19:25|-1||5.62|1.29|K3III|",
"7:14:32.6|12:6:57|-1||5.62|1.01|G6III|",
"7:26:59.4|-23:5:10|-1||5.61|-0.13|B0IV:pe|",
"7:44:34.0|-24:40:26|-1||5.62|-0.19|B1.5III|",
"7:50:10.6|-9:11:0|-1||5.61|1.44|K3III|",
"8:24:35.0|-3:45:4|41|1|5.61|0.46|F3V|",
"8:40:17.4|-53:0:55|-1||5.61|-0.14|B7Vn|",
"9:42:0.3|39:45:28|50|43|5.62|0.95|G8III|",
"9:51:19.8|-46:11:38|-1||5.62|1.17|K2III|",
"10:25:15.2|8:47:5|45|44|5.61|1.62|M3IIIabs|",
"10:49:57.0|-34:3:29|-1||5.61|0.04|A1V|",
"11:58:47.7|-64:20:21|-1||5.61|0.18|A3Ib|",
"13:41:2.3|22:29:45|8|2|5.62|1.01|G9III|",
"13:48:38.7|31:11:25|-1||5.62|1.01|K0III|",
"14:14:42.6|-41:50:15|-1||5.61|0.93|G8III|",
"14:25:6.3|-68:11:43|-1||5.61|0.49|A3Ib|",
"15:37:39.1|69:17:0|-1||5.62|1.35|K5IIIb|",
"15:46:44.2|-34:40:57|-1||5.61|-0.11|B7Vn|",
"15:55:30.1|-26:15:57|72|4|5.62|0.15|A3V|",
"15:56:54.2|-33:57:51|49|ξ2|5.62|0.05|B9V|",
"15:58:57.7|36:38:38|-1||5.62|1.49|gK5|",
"17:30:55.4|31:9:30|-1||5.61|0.95|G8III|",
"17:31:49.6|28:24:27|39|78|5.62|0.0|A1V|",
"17:33:29.9|-5:44:41|-1||5.62|0.18|A5V|",
"18:35:30.4|23:36:20|-1||5.61|1.0|G9III+G7III|",
"18:49:35.0|-43:26:2|25|η2|5.61|-0.08|B9IV|",
"18:54:13.2|27:54:34|-1||5.62|1.35|K4III|",
"19:33:21.6|-45:16:19|-1||5.61|-0.04|ApCrEuSr|",
"19:51:59.1|47:1:39|-1||5.62|-0.07|O9.5Ia|",
"19:54:44.8|0:16:25|4|58|5.61|0.1|A0III|",
"20:27:34.3|38:26:25|30|40|5.62|0.06|A3V|",
"20:58:30.1|50:27:44|-1||5.61|-0.15|B5Vn|",
"21:4:34.7|5:30:10|34|3|5.61|1.65|K5III|",
"21:38:57.6|57:29:21|-1||5.62|0.21|O6.5V((f))|",
"21:50:0.1|-64:42:45|-1||5.62|1.02|K0III|",
"22:5:50.9|-59:38:10|43|κ2|5.62|1.46|K4III|",
"22:23:8.0|-45:55:43|38|π2|5.62|0.36|F3III-IV|",
"23:6:53.6|-38:53:32|38|υ|5.61|0.01|A1V|",
"23:54:46.6|0:6:33|-1||5.61|1.59|M5III|",
"23:59:27.9|-29:29:6|-1||5.62|1.6|K5III|",
"1:12:16.7|79:40:26|-1||5.64|0.01|A3V|",
"1:34:37.8|-15:40:34|20|49|5.63|0.07|A3V|",
"1:42:3.5|35:14:44|-1||5.64|-0.07|B9IV-V|",
"1:47:44.8|63:51:8|-1||5.63|0.81|K0V|",
"2:3:39.3|25:56:8|6|10|5.63|0.54|F8IV|",
"2:10:52.8|39:2:22|0|59|5.63|-0.02|B9V|",
"2:11:21.1|8:34:11|20|64|5.63|0.56|G0IV|",
"2:56:26.1|18:1:23|6|46ρ3|5.63|0.43|F6V|",
"3:45:9.7|24:50:21|77|18|5.64|-0.07|B8V|",
"3:56:52.1|22:28:41|77|32|5.63|0.3|F2IV|",
"4:23:25.0|16:46:38|77|63|5.64|0.3|A1m|",
"5:33:54.3|14:18:20|59|35|5.64|-0.14|B3V|",
"5:52:33.2|-37:37:52|-1||5.63|1.04|K1III|",
"6:4:58.4|4:9:31|59|66|5.63|1.04|G4III|",
"6:21:24.7|-11:46:24|-1||5.64|-0.02|B1Vpe|",
"6:26:25.8|56:17:6|-1||5.64|0.24|A3Vm|",
"6:23:55.9|-25:34:40|-1||5.63|1.56|K5III|",
"6:40:2.7|-80:48:49|52|ζ|5.64|0.2|A5III|",
"6:53:18.8|-19:1:58|-1||5.64|0.28|F1V|",
"7:1:5.9|-25:12:55|-1||5.63|-0.17|B2V|",
"7:30:52.7|68:27:56|-1||5.64|1.11|gK2|",
"7:27:8.0|-17:51:52|-1||5.63|0.32|A5n|",
"7:42:48.1|-26:21:4|-1||5.64|0.99|K1III|",
"7:51:42.9|-21:10:26|-1||5.63|0.96|G8III|",
"7:54:53.2|-57:18:11|-1||5.63|1.3|K3-4III|",
"8:12:12.7|17:38:52|11|16ζ1|5.63|0.54|F8V|",
"8:13:8.9|29:39:24|11|15|5.64|-0.07|B9pSiCr|",
"8:17:50.4|59:34:16|50|29|5.64|0.16|A7IV|",
"8:39:11.7|65:1:15|82|3π1|5.64|0.62|G1.5Vb|",
"8:43:12.3|12:40:51|11|45|5.64|0.39|A3V+G0III|",
"9:21:50.0|-55:30:54|-1||5.63|0.19|A3IVs:|",
"9:37:9.9|-32:10:43|-1||5.63|1.02|K0III|",
"9:43:33.3|29:58:28|45|15|5.64|0.12|A2IV|",
"9:46:23.3|11:48:36|45|18|5.63|1.49|gK4|",
"10:42:43.2|-32:42:57|-1||5.64|0.0|A0V|",
"11:32:16.3|-29:15:40|-1||5.64|0.53|F8V|",
"11:32:48.1|-40:26:11|-1||5.64|1.58|K6III|",
"11:35:4.9|54:47:7|-1||5.63|1.02|K0III|",
"11:51:2.2|-5:20:0|-1||5.64|1.06|K0III|",
"12:30:17.5|-23:41:48|-1||5.63|1.67|M0III|",
"13:5:52.3|45:16:7|-1||5.63|1.13|K1III|",
"13:37:12.2|-61:41:31|-1||5.63|0.5|F6V|",
"14:46:6.0|15:7:55|-1||5.63|1.57|M5IIIab|",
"14:47:22.5|-25:37:28|41|55|5.63|0.0|A0IIIp|",
"14:56:32.0|-47:52:45|-1||5.64|-0.04|B9V|",
"14:56:23.0|49:37:43|-1||5.63|0.5|F7V|",
"14:59:36.9|39:15:55|8|40|5.64|0.31|F0-2IV-III|",
"14:50:20.4|82:30:43|-1||5.64|0.68|F9V|",
"15:15:49.1|0:22:20|75|4|5.63|0.18|A4V|",
"15:28:15.4|-16:42:59|48|32ζ1|5.64|1.55|K5III|",
"16:7:37.5|9:53:30|75|45|5.63|0.2|A7V|",
"16:15:49.7|-57:54:44|-1||5.63|0.14|A3III|",
"16:11:48.0|36:25:30|-1||5.63|1.34|K3III|",
"16:14:40.8|33:51:31|26|17σ|5.64|0.51|G0VCaIIe|",
"16:32:35.7|5:31:16|39|28|5.63|-0.06|B9.5III|",
"17:5:32.3|0:53:31|-1||5.64|0.16|B1V|",
"17:33:22.8|19:15:24|-1||5.64|0.48|F6V|",
"18:20:57.1|29:51:32|39|108|5.63|0.21|A5m|",
"18:28:27.1|-38:59:44|-1||5.64|0.13|A2mA2-F0|",
"18:29:44.9|77:32:49|-1||5.64|1.18|gK4|",
"18:56:25.6|65:15:29|-1||5.63|0.95|G8III|",
"19:15:17.4|21:13:56|70|1|5.64|0.11|A4V|",
"19:16:26.8|14:32:41|-1||5.63|-0.02|B9.5V|",
"19:26:13.2|20:5:52|87|5|5.63|-0.01|A0V|",
"19:37:3.3|-18:13:52|-1||5.64|1.26|K3III|",
"20:4:36.1|32:13:7|-1||5.64|0.54|B1.5Ia|",
"20:23:53.2|-42:25:22|71|κ2|5.64|0.2|A5V|",
"21:11:48.2|59:59:11|-1||5.64|0.11|B0II|",
"21:26:22.9|-37:49:46|-1||5.63|1.19|K2III|",
"21:47:14.0|2:41:10|61|11|5.64|0.0|A1V|",
"22:53:2.3|16:50:28|-1||5.64|1.12|K1-2II-III|",
"23:21:15.5|-26:59:12|-1||5.64|0.82|G4V|",
"23:27:15.0|-58:28:34|-1||5.63|0.98|G8III|",
"23:34:38.2|33:29:50|61|73|5.63|1.03|gK0|",
"0:2:29.7|8:29:8|65|32|5.63|0.29|F0V|",
"0:45:39.0|74:59:17|17|21|5.66|0.05|A2IV|",
"1:10:18.8|42:4:53|0|44|5.65|0.6|F8V|",
"1:26:51.6|-13:3:24|20|47|5.66|0.35|F0IIIDelDel|",
"2:37:41.8|-3:23:46|20|81|5.65|1.02|gG5|",
"3:45:59.3|45:40:55|-1||5.66|-0.07|B6V|",
"3:50:4.5|44:58:4|-1||5.66|0.76|G2III+F2:V|",
"4:18:23.2|21:34:45|77|51|5.65|0.28|F0V|",
"4:51:9.3|48:44:27|-1||5.66|0.99|G9III|",
"4:59:1.3|-16:22:33|-1||5.66|0.43|F3V+F9V|",
"5:24:28.4|-16:58:34|-1||5.65|0.0|A1V|",
"5:37:9.8|-80:28:9|52|π|5.65|0.6|G1V|",
"5:54:43.6|-11:46:26|-1||5.66|1.53|K5III|",
"6:4:20.3|-32:10:21|-1||5.65|-0.19|B2.5V|",
"6:15:34.3|0:30:44|-1||5.65|0.5|F6V|",
"6:46:39.0|-10:6:26|-1||5.66|-0.05|B9.5V|",
"6:50:25.5|13:24:48|37|35|5.65|1.34|gK3|",
"6:52:0.0|23:36:6|-1||5.65|1.45|K5III|",
"7:16:15.5|-46:46:28|-1||5.66|1.44|K4III|",
"7:33:19.5|-19:24:45|-1||5.66|1.12|K3III|",
"7:36:31.6|46:10:49|-1||5.65|1.56|M0III|",
"8:1:13.8|4:52:47|-1||5.65|0.0|A1V|",
"8:9:33.6|-56:5:8|-1||5.66|0.21|A3m|",
"8:20:0.7|-71:30:19|86|κ2|5.65|-0.1|A0IVMn|",
"8:30:28.6|-32:9:34|-1||5.65|1.49|K2III|",
"8:38:22.2|53:24:5|-1||5.66|0.96|G8IV|",
"8:44:45.0|10:4:54|11|49|5.66|-0.11|A1pEuCr|",
"8:52:34.6|32:28:27|11|51σ1|5.66|0.22|A8Vmas|",
"9:29:12.6|-20:44:55|-1||5.66|1.6|M1III|",
"9:46:23.6|1:47:8|-1||5.65|0.34|F4IV|",
"10:2:48.9|21:56:57|-1||5.66|-0.19|B2.5IV|",
"10:10:55.8|-8:25:6|76|18|5.65|1.3|K2III|",
"10:20:16.7|-47:41:57|-1||5.65|1.67|K5-M0III|",
"10:54:17.8|-13:45:29|-1||5.66|0.83|G4III|",
"11:37:15.6|-75:53:48|21|π|5.65|0.35|F1III|",
"12:11:51.2|25:52:13|24|4|5.66|1.41|K4III|",
"12:16:7.6|40:39:37|12|2|5.66|1.55|M1III+F7V|",
"12:48:26.4|-27:35:51|-1||5.66|0.95|G5III-IV|",
"13:29:13.0|10:49:6|85|71|5.65|1.05|K0III|",
"15:1:50.8|-83:13:40|57|π1|5.65|0.95|G8-K0III|",
"15:4:46.7|-83:2:18|57|π2|5.65|1.3|G8Ib|",
"14:58:39.2|-27:39:26|41|59|5.65|0.24|A4V+A6V|",
"15:21:48.2|-48:19:4|49|ν2|5.65|0.65|G3-5V|",
"15:20:5.2|51:57:31|-1||5.66|0.11|A4V|",
"15:40:21.2|-73:26:48|2|κ2|5.65|-0.04|B7III-IV|",
"16:31:47.3|45:35:54|-1||5.65|0.12|A4Vn|",
"16:41:20.3|-48:45:47|-1||5.65|0.13|O5III(f)|",
"16:41:40.2|-49:39:6|-1||5.65|-0.03|B1Iab-Ib|",
"17:0:6.2|-54:35:49|-1||5.65|0.19|A5IV-V|",
"17:0:58.1|22:37:56|-1||5.65|1.33|gK3|",
"17:18:48.5|28:49:23|-1||5.65|0.98|K0III|",
"17:25:41.3|60:2:54|-1||5.65|0.03|A1Vn|",
"18:25:38.8|8:1:55|-1||5.65|0.92|G8III-IV+A0V|",
"18:30:11.9|-18:43:44|-1||5.66|1.06|gK0|",
"18:33:23.1|-38:43:34|25|κ2|5.65|-0.06|B9V|",
"18:56:45.0|57:48:54|33|48|5.66|1.15|K1III|",
"19:2:27.7|-24:50:49|-1||5.65|1.23|K3III|",
"19:36:1.7|-24:43:9|71|51|5.65|0.19|A7m|",
"19:37:17.4|16:27:46|70|4ε|5.66|1.02|G8III|",
"19:53:18.7|-3:6:52|-1||5.65|0.2|A5p|",
"20:0:20.3|-33:42:14|-1||5.66|0.49|F7V|",
"20:14:19.0|-52:26:44|-1||5.65|1.5|K4III|",
"20:15:23.7|33:43:46|-1||5.66|0.91|K0III|",
"20:25:40.5|21:24:35|-1||5.66|0.93|G6III|",
"20:32:23.7|-9:51:12|-1||5.65|0.69|G2.5IV|",
"21:0:27.7|19:19:46|-1||5.65|1.61|M3IIIab|",
"21:19:15.8|58:37:25|-1||5.66|1.38|M1Ibep+B2pe+B3V|",
"21:43:25.7|38:17:2|30|79|5.65|0.0|A0V|",
"22:1:9.2|8:15:26|61|19|5.65|1.44|gK5|",
"22:30:1.8|32:34:21|61|38|5.65|-0.04|B9.5V|",
"22:38:51.5|-33:4:53|-1||5.66|0.05|A2Vp|",
"22:47:42.8|-14:3:23|3|69τ1|5.66|-0.05|A0V|",
"23:0:5.8|-25:9:51|-1||5.65|1.25|gK0|",
"23:16:57.7|-62:0:4|-1||5.66|0.51|F7V|",
"23:37:39.6|-13:3:37|-1||5.65|1.03|G9IIIFe-0.5|",
"0:8:3.5|-33:31:46|-1||5.68|1.12|K1III|",
"0:16:8.9|-31:26:47|-1||5.67|1.35|K5III|",
"0:32:23.8|6:57:20|65|51|5.67|0.0|B9.5V|",
"0:44:26.4|47:51:51|-1||5.67|-0.12|B5V|",
"1:5:5.4|14:56:46|65|72|5.68|0.41|F4II-III|",
"1:56:9.3|37:15:6|0|56|5.67|1.06|K0III|",
"2:8:40.5|58:25:25|-1||5.67|0.61|A1Ia|",
"2:36:37.9|12:26:51|6|31|5.68|0.49|F7V|",
"3:32:34.8|-50:22:43|-1||5.68|1.1|K2III|",
"3:52:0.2|6:32:5|77|31|5.67|0.06|B5V|",
"4:1:46.1|9:59:52|-1||5.67|0.02|B5V|",
"4:34:8.3|5:34:7|-1||5.68|0.05|A2Vs|",
"4:41:24.1|48:18:3|-1||5.67|-0.02|A0V|",
"4:43:9.3|-30:45:56|-1||5.68|1.41|K2III|",
"5:10:42.9|46:57:44|-1||5.68|0.42|F5V|",
"5:11:22.8|-11:50:57|-1||5.68|1.46|M6III|",
"5:21:31.8|0:24:59|-1||5.68|-0.12|B3V|",
"5:35:0.9|-6:0:33|-1||5.67|-0.23|B1V|",
"6:0:49.2|-51:12:59|-1||5.67|0.2|Am|",
"6:4:58.2|5:25:12|59|63|5.67|1.04|gG7|",
"7:1:21.5|70:48:29|-1||5.68|1.33|gK4|",
"7:0:15.8|16:4:44|37|41|5.68|1.66|K3Ib|",
"7:38:18.2|-48:36:4|-1||5.68|0.65|F4Iab|",
"8:9:28.5|-16:14:56|-1||5.68|-0.17|B2.5V|",
"8:24:55.1|-23:9:13|-1||5.68|0.06|A2|",
"8:57:35.2|15:34:53|11|63ο2|5.67|0.2|F0IV|",
"9:1:58.0|0:28:58|-1||5.67|1.15|K0III|",
"10:19:4.8|-64:40:35|-1||5.67|0.05|A1V|",
"10:35:2.2|8:39:1|45|49|5.67|0.05|A2V|",
"10:51:11.1|56:34:56|82|43|5.67|1.12|K2III|",
"11:4:31.2|-47:40:45|-1||5.67|0.24|A8III-IV|",
"11:8:49.1|24:39:30|45|67|5.68|0.06|A3IV|",
"12:23:21.6|-24:50:26|27|6|5.68|1.16|gK1|",
"12:36:58.3|17:5:22|24|25|5.68|1.41|K5III|",
"12:46:22.5|9:32:24|85|33|5.67|0.99|K1III-IV|",
"13:14:31.3|11:19:54|-1||5.67|1.5|M0III|",
"13:25:50.1|-70:37:39|-1||5.67|-0.03|ApHgMn:|",
"14:41:1.4|-36:8:6|-1||5.67|-0.08|A0p:|",
"14:49:18.7|-24:15:6|-1||5.68|1.3|gK1|",
"15:8:23.8|26:18:4|8|46|5.67|1.24|gK2|",
"15:23:10.4|-60:39:25|-1||5.67|0.48|F7V|",
"16:12:15.9|-28:25:3|72|12|5.67|0.01|B9V|",
"16:23:47.0|61:41:48|-1||5.67|0.96|G8III|",
"16:29:46.9|-14:33:3|-1||5.68|0.82|G2-6III|",
"17:12:16.2|-39:30:25|-1||5.67|0.04|A1V|",
"17:21:45.4|53:25:14|-1||5.67|1.47|K4III|",
"17:59:56.2|45:30:5|-1||5.67|1.57|M0IIIab|",
"18:0:9.2|80:0:15|33|41|5.68|0.5|F7|",
"19:26:56.5|-29:44:36|-1||5.67|0.0|B9V|",
"19:40:43.3|0:37:16|4|45|5.67|0.11|A3IV|",
"19:59:10.5|23:6:5|87|14|5.67|0.0|F0|",
"20:3:30.0|16:1:53|-1||5.67|-0.1|B9pHgMn|",
"20:4:23.2|0:42:34|4|62|5.68|1.3|K4III|",
"20:38:59.5|30:20:4|-1||5.68|1.09|K2III|",
"20:41:56.5|41:43:1|-1||5.67|-0.12|B8II-III|",
"20:55:49.8|47:25:4|-1||5.67|0.47|B8Ia|",
"21:9:22.3|-73:10:23|-1||5.68|0.59|F8-G0V|",
"21:6:1.2|-30:7:30|53|δ|5.68|1.03|K0/1III|",
"21:20:50.1|32:27:10|-1||5.68|1.08|G8IV|",
"21:24:34.0|26:10:28|-1||5.68|0.31|A8III|",
"21:38:31.9|5:46:18|61|4|5.67|0.25|A9IV-Vn|",
"21:42:10.1|1:17:7|3|26|5.67|1.44|K2III|",
"21:53:37.4|19:40:6|-1||5.68|0.01|A0Vs|",
"22:32:16.2|76:13:35|-1||5.68|0.05|A2V|",
"23:1:7.5|-50:57:0|-1||5.68|1.42|K3III|",
"23:29:1.0|-63:6:39|-1||5.68|-0.17|ApSi|",
"23:36:23.3|2:6:8|65|16|5.68|0.44|F6Vbvw|",
"0:4:42.0|67:10:0|-1||5.67|1.07|K1III|",
"0:6:19.0|-49:4:30|-1||5.7|0.52|G1IV|",
"0:30:26.1|-48:12:54|-1||5.69|0.35|F2V|",
"0:41:46.4|-56:30:6|63|ξ|5.7|0.2|ApSrEuCr|",
"0:47:43.3|-18:3:41|-1||5.7|1.3|K3III|",
"0:53:37.9|-62:52:17|-1||5.7|1.56|M4III|",
"1:14:49.2|0:58:26|20|38|5.7|0.42|F5V|",
"1:33:25.8|58:19:39|-1||5.7|1.52|K0Ib+B9V|",
"1:36:8.4|-29:54:27|73|τ|5.69|0.33|F2V|",
"1:37:28.0|-84:46:11|-1||5.69|0.94|G8III|",
"1:58:33.6|49:12:15|62|3|5.69|1.01|K0IV|",
"2:10:37.6|19:30:1|6|15|5.7|1.65|M3IIIab|",
"2:15:28.5|-67:44:47|42|π2|5.69|1.3|K2III|",
"2:42:22.0|20:0:42|6|34μ|5.69|-0.02|A0Vnp:|",
"3:21:6.8|3:40:32|20|97κ2|5.69|0.97|G8.5III|",
"3:29:58.8|-78:21:7|-1||5.7|0.93|G8III|",
"3:42:18.9|19:42:1|77|13|5.69|-0.01|B9Vne|",
"4:10:47.7|-8:49:11|-1||5.7|1.06|gG9|",
"4:16:53.6|61:51:1|-1||5.7|-0.14|B5Vn|",
"4:17:59.1|-80:12:50|52|δ|5.69|0.84|K2-3III+A|",
"4:55:6.8|-16:44:26|-1||5.7|0.96|gG9|",
"5:23:42.3|0:9:35|-1||5.7|-0.21|B1.5V|",
"5:33:31.6|18:32:25|77|120|5.69|0.01|B2IV-Ve|",
"5:58:53.2|12:48:31|-1||5.7|0.89|K2III+A5V|",
"6:20:4.2|14:39:4|-1||5.69|1.61|K3Ib|",
"6:32:39.0|-32:1:50|-1||5.69|-0.17|B2IVe|",
"6:31:58.4|-58:45:15|64|μ|5.7|-0.06|B9Ve|",
"6:38:39.5|39:23:27|7|51|5.69|1.35|K5III|",
"6:36:22.8|-18:39:36|13|6ν1|5.7|0.85|G8III+F3IV-V|",
"6:50:23.3|-31:42:22|-1||5.7|0.14|B6Vnpe|",
"7:9:42.9|-25:13:52|-1||5.69|-0.16|B2.5IV|",
"7:8:42.2|-70:29:50|86|γ1|5.69|0.4|F2V|",
"7:19:28.1|-16:23:42|-1||5.7|0.35|F1V|",
"7:36:3.9|-14:29:34|-1||5.7|-0.12|B2Ve|",
"7:52:18.9|-14:50:47|67|10|5.69|0.37|F1Ia|",
"7:52:29.7|-54:22:2|-1||5.7|-0.15|B1.5IV|",
"8:9:9.6|-48:41:4|-1||5.7|-0.12|B8Ib-II|",
"8:32:4.8|-53:12:44|-1||5.69|0.58|K0III+A3|",
"8:24:19.8|-80:54:51|-1||5.69|1.02|G8III|",
"8:46:2.5|-2:2:56|-1||5.7|1.1|gK0|",
"9:37:2.6|16:26:16|45|8|5.69|1.25|gK1|",
"9:37:0.2|-25:17:48|-1||5.7|1.12|gK1|",
"9:42:14.8|69:14:15|-1||5.69|1.14|gG9|",
"10:4:21.0|-24:17:8|-1||5.7|0.3|A8V|",
"10:36:32.4|-12:13:49|-1||5.7|0.52|F7V|",
"11:49:41.7|34:55:54|-1||5.7|0.46|F5IV|",
"11:50:27.2|-62:38:58|-1||5.7|0.26|A2Iab|",
"12:17:30.5|28:56:14|-1||5.7|0.16|A4m:|",
"12:27:35.1|55:42:46|82|73|5.7|1.55|M2IIIb|",
"12:29:43.2|20:53:46|24|20|5.69|0.07|A3V|",
"12:48:54.2|14:7:21|24|29|5.7|0.02|A1V|",
"13:21:41.6|2:5:14|-1||5.69|0.06|A2V|",
"13:26:56.1|-41:29:53|-1||5.69|1.47|K3III|",
"13:32:35.9|-28:41:34|-1||5.69|0.04|A1Vn|",
"13:46:35.7|54:25:58|82|84|5.7|-0.08|B9pEuCr|",
"13:53:12.9|17:55:58|8|7|5.7|0.84|G5III|",
"13:53:51.0|53:43:43|82|86|5.7|-0.05|A0V|",
"14:38:12.5|43:38:31|-1||5.7|1.48|K2III|",
"14:45:30.2|0:43:2|85|108|5.69|-0.03|B9.5V|",
"14:49:41.3|48:43:14|8|39|5.69|0.47|F6V+F5V|",
"15:11:57.6|-48:44:37|49|κ2|5.69|0.14|A3IV|",
"15:18:24.5|20:34:22|-1||5.7|0.97|G8IIIaBa0.3|",
"16:5:55.8|-72:24:3|-1||5.7|1.17|K1IIICNII|",
"16:11:38.0|23:29:41|39|10|5.7|1.56|M4.5IIIa|",
"16:15:28.7|18:48:30|39|16|5.69|1.12|K3III|",
"16:28:15.2|-58:35:59|-1||5.69|0.0|B9II-III|",
"17:24:1.1|-62:51:51|-1||5.7|-0.14|B2IV|",
"17:34:42.5|-32:34:54|-1||5.7|0.04|O7V+O7V|",
"17:33:39.4|16:19:3|-1||5.69|1.01|gK0|",
"17:48:24.8|20:33:56|-1||5.69|0.94|G5IV|",
"18:9:54.0|3:7:11|-1||5.69|0.47|F5V|",
"18:29:55.8|-47:13:13|-1||5.7|1.26|K2III|",
"18:43:51.6|31:55:36|-1||5.7|0.34|F1III-IV|",
"18:54:0.1|-21:21:35|71|33|5.69|1.23|K1Ib|",
"18:56:6.2|18:6:19|-1||5.69|1.09|K1III|",
"19:1:17.4|26:17:29|-1||5.69|-0.08|B5V|",
"19:25:21.6|-13:53:49|-1||5.69|1.43|K3III|",
"19:27:48.1|-54:19:31|-1||5.69|1.4|K4III|",
"19:50:37.3|40:35:59|-1||5.69|-0.04|B1III+B3V|",
"20:21:11.4|63:58:49|-1||5.69|1.56|K5III|",
"20:27:2.3|49:23:0|30|43|5.69|0.26|dF0|",
"20:56:47.3|-26:17:47|-1||5.7|0.5|F7V|",
"21:22:0.4|49:23:20|-1||5.69|1.1|K0III|",
"21:25:13.1|-9:44:55|3|19|5.7|0.2|F0IV|",
"21:34:51.0|-20:5:4|15|37|5.69|0.4|F1V|",
"21:42:22.9|41:4:38|30|77|5.69|0.01|A0V|",
"22:5:34.7|28:57:50|61|23|5.7|-0.06|B9Vn|",
"22:56:47.8|-47:58:9|38|τ3|5.7|0.22|Am|",
"23:7:45.4|49:17:45|0|5|5.7|0.44|F5V|",
"23:9:44.1|59:19:59|17|2|5.7|0.33|A5III|",
"0:13:30.8|41:2:7|0|23|5.72|0.31|F0IV|",
"0:30:2.4|-3:57:26|20|12|5.72|1.56|M0III|",
"1:42:3.0|-36:49:57|-1||5.72|-0.01|A1V|",
"1:41:48.0|-60:47:22|-1||5.71|1.27|K2-3III|",
"2:13:3.3|15:16:47|6|19|5.71|1.55|M0III|",
"2:35:38.8|37:18:44|-1||5.71|1.39|K3III|",
"2:41:13.9|0:41:45|20|84|5.71|0.52|F7IV|",
"2:59:36.1|-25:16:27|36|ζ|5.71|0.4|F2V|",
"3:9:36.7|29:4:37|6|55|5.72|0.12|B8III|",
"3:18:41.2|-18:33:35|-1||5.71|0.37|F0IV|",
"3:27:33.4|-35:40:53|36|χ2|5.71|1.29|K2III|",
"3:36:47.3|0:35:16|-1||5.71|0.92|G9V|",
"3:54:23.2|-40:21:26|-1||5.71|0.6|K0III+A3V|",
"4:10:59.0|33:35:12|-1||5.72|1.44|K1II-III|",
"4:11:20.3|5:31:23|77|45|5.72|0.36|F4V|",
"4:17:8.2|57:51:38|-1||5.71|1.09|K1III|",
"4:22:3.5|14:4:38|77|60|5.72|0.32|A3m|",
"4:28:0.8|21:37:12|-1||5.72|0.27|Am|",
"4:33:54.8|-6:44:20|35|46|5.72|-0.13|B9pSi|",
"4:45:4.2|-21:17:1|-1||5.72|1.47|gK2|",
"4:52:47.8|42:35:12|-1||5.71|0.11|A3III|",
"4:55:18.6|-16:25:4|-1||5.72|0.88|gG4|",
"5:23:24.0|-39:40:43|-1||5.71|1.62|M1III|",
"5:36:35.7|-6:3:54|-1||5.72|-0.22|B1V|",
"5:47:13.2|14:29:18|77|131|5.72|0.04|A3Vn|",
"6:9:47.9|-22:46:27|-1||5.71|0.44|F6V|",
"6:6:9.4|-66:2:23|32|η1|5.71|-0.03|A0V|",
"6:10:34.6|-27:9:15|-1||5.72|1.07|K1III|",
"6:17:16.1|5:6:1|-1||5.71|0.61|F9V|",
"6:37:13.8|-36:59:26|-1||5.71|-0.12|B7IV|",
"6:39:42.7|-30:28:13|-1||5.71|1.14|K0III|",
"6:49:41.3|32:36:24|-1||5.71|1.29|K3II|",
"7:7:22.6|-23:50:25|-1||5.71|-0.1|B2IVe|",
"7:15:57.1|27:53:51|37|53|5.71|1.63|M1IIIa|",
"7:14:45.9|-46:50:59|-1||5.72|-0.11|A0pSi|",
"7:28:51.6|48:11:2|-1||5.72|-0.1|B9pHgMn|",
"7:36:43.9|-48:49:49|-1||5.72|-0.06|B9.5V|",
"8:19:17.3|62:30:26|-1||5.71|0.89|G8III|",
"8:35:28.2|-7:58:56|41|3|5.72|-0.03|A1pSrCrEu|",
"8:40:35.3|-45:11:29|-1||5.71|1.65|M0III|",
"8:55:11.9|-54:57:56|-1||5.71|0.48|F6V|",
"9:28:29.2|8:11:18|45|3|5.71|1.04|K0III|",
"9:34:53.6|72:12:20|82|22|5.72|0.48|F7V|",
"9:54:17.6|-45:17:2|-1||5.71|-0.11|B3V|",
"9:54:51.3|-50:14:38|-1||5.72|-0.01|A0V|",
"10:11:46.5|-58:3:38|-1||5.72|-0.08|B2IVpne|",
"10:54:58.2|34:2:5|-1||5.72|1.01|gG7|",
"10:59:13.9|-33:44:14|-1||5.71|0.37|F2V|",
"11:5:57.6|-27:17:16|41|χ2|5.71|-0.06|A0IV|",
"11:35:13.2|-47:22:21|-1||5.71|1.66|M3III|",
"12:10:3.4|5:48:25|85|11|5.72|0.35|F2-6IIImvs|",
"12:15:8.5|70:12:0|-1||5.71|1.19|gK2|",
"12:38:22.4|1:51:17|-1||5.71|1.6|M3+IIIbCa0.5|",
"12:51:17.8|-60:19:47|-1||5.72|0.38|A2Iabe|",
"13:7:38.3|-53:27:35|-1||5.71|-0.07|B8V|",
"13:54:48.9|-67:39:9|-1||5.71|1.49|K2III|",
"13:55:12.2|-52:9:40|-1||5.71|-0.08|B9V|",
"14:57:11.7|16:23:18|-1||5.71|0.94|gG5|",
"15:1:48.9|0:8:26|-1||5.71|1.52|M0.5IIb|",
"15:23:52.2|-12:22:10|-1||5.72|1.04|gG6|",
"15:27:33.1|-64:31:53|-1||5.71|1.64|K5-M0III|",
"15:47:17.3|14:6:55|75|31υ|5.71|0.09|A3V|",
"16:44:42.6|-40:50:23|-1||5.71|-0.12|B3V|",
"16:50:39.0|29:48:24|39|50|5.72|1.6|M1IIIa|",
"17:24:31.5|16:18:4|-1||5.71|0.07|A3V|",
"17:19:37.0|80:8:11|-1||5.72|1.5|K5III|",
"17:43:21.6|24:19:40|39|84|5.71|0.65|G2IIIb|",
"17:47:8.0|17:41:50|-1||5.72|0.01|A1V|",
"18:5:49.6|32:13:50|-1||5.71|1.16|K0III|",
"18:31:56.2|-43:30:28|-1||5.72|1.34|K2III|",
"18:31:25.7|-10:47:45|-1||5.72|0.24|B2V|",
"18:46:43.3|-10:7:30|-1||5.71|0.59|F2Ib-II|",
"19:26:11.1|-15:3:11|-1||5.72|0.02|B8Vn|",
"19:29:23.9|-43:26:45|-1||5.71|0.22|Am|",
"19:48:42.1|11:48:57|4|52π|5.72|0.0|G2III:+A1V:|",
"19:54:37.6|-8:13:38|4|57|5.71|-0.08|B7Vn|",
"20:1:58.6|-13:38:13|71|63|5.71|0.08|A3V|",
"20:3:37.4|29:53:48|-1||5.71|0.73|G6IV+M6V|",
"20:19:36.7|62:15:27|33|71|5.72|-0.05|B9V|",
"20:38:43.9|13:18:54|31|8θ|5.72|1.53|K3Ib|",
"21:23:58.8|24:16:27|-1||5.71|0.32|F1IV|",
"21:52:1.0|55:47:49|-1||5.71|-0.13|B6IV-V|",
"21:54:10.4|-4:16:34|-1||5.71|1.18|K2III|",
"22:14:44.4|42:57:14|-1||5.71|0.0|A2Vnn|",
"22:33:40.6|56:37:30|-1||5.71|0.96|G8III-IV|",
"22:40:52.7|14:32:58|-1||5.71|0.72|G4V|",
"22:55:11.0|-4:59:16|-1||5.72|0.88|K0III-IV|",
"23:10:42.6|17:35:40|-1||5.71|1.34|K4III|",
"23:44:12.0|-64:24:16|-1||5.72|1.4|K2II-III|",
"23:50:33.3|-14:24:7|-1||5.72|1.51|K4.5IIIb|",
"0:1:4.5|-48:48:36|63|τ|5.71|0.91|G8III|",
"0:16:57.1|61:32:0|-1||5.74|0.88|G8III|",
"0:25:6.4|53:2:49|-1||5.74|-0.06|B9IV|",
"0:54:35.2|19:11:18|65|66|5.74|-0.01|A1VN|",
"1:55:51.0|23:34:38|6|7|5.74|1.19|K1III|",
"2:45:27.5|-63:42:16|40|γ|5.74|0.93|G8III-IV|",
"3:12:33.2|-57:19:18|-1||5.74|2.28|C5II|",
"3:28:1.0|-11:17:12|-1||5.73|1.1|K2III|",
"3:45:15.8|-47:21:35|-1||5.73|0.96|K1III|",
"4:24:29.2|34:7:50|62|55|5.73|-0.06|B8V|",
"5:5:16.2|-26:9:9|-1||5.73|1.17|K2III|",
"5:18:13.3|73:16:5|-1||5.74|0.0|A0V|",
"5:27:8.3|30:12:31|-1||5.74|0.16|B9Ib|",
"5:36:35.2|54:25:44|-1||5.73|1.63|M0III|",
"5:43:21.6|-18:33:27|-1||5.73|-0.01|A0Vs|",
"6:0:58.6|47:54:7|7|36|5.73|-0.01|B9.5pSiFe|",
"6:8:57.9|2:29:58|-1||5.73|0.07|A3Vn|",
"6:40:28.8|77:59:45|-1||5.73|1.47|gK5|",
"6:28:39.2|-32:22:16|-1||5.74|-0.17|B4Vnpe|",
"6:49:16.4|-2:16:19|-1||5.74|-0.1|B8IIIn|",
"6:55:18.6|25:22:32|37|37|5.73|0.57|G0V|",
"6:55:2.7|-20:24:17|13|17|5.74|0.08|A3IV|",
"7:2:17.4|15:20:10|-1||5.74|0.0|gK1|",
"7:36:41.0|-19:42:8|-1||5.74|-0.19|B2III|",
"7:40:14.6|38:20:40|-1||5.73|1.63|M0III|",
"7:39:43.8|-38:8:22|-1||5.73|-0.12|B5Vn|",
"7:56:18.6|-60:31:35|-1||5.74|1.55|K3III|",
"8:10:27.2|25:30:26|11|14ψ|5.73|0.81|G7V|",
"8:25:35.5|2:6:8|-1||5.73|1.53|K5III|",
"8:53:22.6|61:57:44|82|5|5.73|0.28|F2III|",
"8:56:50.0|45:37:55|-1||5.74|1.09|K1IV|",
"9:9:4.3|-18:19:43|-1||5.73|0.0|A2Vn|",
"9:11:58.7|-19:44:52|-1||5.73|0.98|G9III|",
"9:32:20.4|-19:24:1|-1||5.74|0.14|A5V|",
"9:50:42.0|-46:56:4|-1||5.73|1.08|K0IIICNIb|",
"9:59:36.2|29:38:43|-1||5.73|1.06|gG9|",
"10:4:36.3|53:53:30|-1||5.74|0.48|F5V|",
"10:31:57.5|-45:4:0|-1||5.74|-0.15|B6II|",
"11:9:19.1|36:18:34|-1||5.74|1.51|M3.5IIIab|",
"11:13:30.8|-59:37:10|-1||5.74|-0.1|B1.5V|",
"11:29:41.9|15:24:48|45|85|5.74|1.32|gK4|",
"11:36:35.0|-33:34:12|-1||5.74|1.02|K0III|",
"11:41:34.3|31:44:46|82|62|5.73|0.43|F4V|",
"12:22:11.9|-68:18:27|55|ζ1|5.74|1.04|K0III|",
"12:25:21.8|-35:11:11|-1||5.73|-0.06|B9III|",
"12:32:36.0|-13:51:33|-1||5.74|0.4|F2V|",
"12:50:57.9|-52:47:15|-1||5.73|0.13|A5V|",
"13:35:31.3|-5:23:46|85|80|5.73|0.95|G6III|",
"13:36:59.1|24:36:48|-1||5.74|1.55|M2III|",
"14:36:44.2|-40:12:42|-1||5.74|-0.12|B8n|",
"14:34:39.6|49:22:6|-1||5.74|1.56|M1IIIab|",
"14:43:13.6|-24:59:51|48|4|5.73|-0.01|B9|",
"14:43:44.4|40:27:33|-1||5.73|1.39|K4III|",
"14:46:29.1|-47:26:28|-1||5.74|0.07|A1V|",
"14:49:18.7|46:6:58|8|38|5.74|0.48|F7IVw|",
"14:57:28.0|-21:24:56|-1||5.74|1.11|K4V|",
"15:16:36.4|-60:54:14|-1||5.73|-0.08|B0.5Ve|",
"15:35:57.1|54:37:50|-1||5.74|0.0|A2V|",
"15:51:6.8|-55:3:21|-1||5.73|0.06|B2II|",
"16:7:16.4|-36:45:20|-1||5.73|0.29|F1IV|",
"16:8:28.0|8:32:3|75|47|5.73|1.61|M3.5IIIa|",
"16:24:25.3|55:12:18|-1||5.74|0.0|A2Si3955Sr|",
"16:41:42.5|1:10:52|58|14|5.74|0.32|F2-4III-IV|",
"16:46:21.2|-58:30:13|-1||5.74|-0.09|B2IV-V|",
"17:4:24.7|-57:42:44|-1||5.73|-0.1|B5IV|",
"17:24:6.6|22:57:37|39|73|5.74|0.21|F0IV|",
"17:33:7.3|41:14:37|-1||5.74|1.09|gK1|",
"17:58:55.6|-36:51:30|-1||5.74|0.9|G8III|",
"18:9:33.8|3:59:36|58|73|5.73|0.37|F2V|",
"18:23:12.2|-12:0:53|-1||5.73|0.01|B8IV-Ve|",
"18:27:58.8|6:11:39|-1||5.73|-0.03|B8III-IV|",
"18:37:33.5|62:31:36|-1||5.74|-0.06|A0V|",
"18:48:37.8|-65:4:40|60|θ|5.73|0.24|A8V|",
"18:44:48.2|37:35:40|51|7ζ2|5.73|0.28|F0IV|",
"19:3:17.7|-38:15:12|-1||5.74|0.32|F0IIIn|",
"19:26:24.1|13:1:26|-1||5.74|0.47|F6III|",
"19:34:19.8|51:14:12|-1||5.73|0.48|F7V|",
"19:52:37.6|-54:58:16|-1||5.74|0.92|G8-K0III|",
"20:15:17.4|-27:1:58|-1||5.73|0.88|K0V|",
"21:10:15.6|53:33:48|-1||5.73|-0.12|B9III|",
"21:36:11.0|-26:10:17|66|8|5.73|0.22|A7/8IV|",
"22:35:52.3|39:38:3|44|8|5.73|-0.15|B2Ve|",
"22:55:44.5|36:21:6|-1||5.74|-0.05|B7III|",
"23:47:15.9|-11:54:39|-1||5.73|1.08|gK1|",
"23:57:32.7|-82:10:12|57|γ2|5.73|1.05|K0III|",
"0:14:54.5|-9:34:11|-1||5.75|-0.08|B9V|",
"0:48:23.0|5:16:50|-1||5.75|0.88|K2V|",
"1:41:44.7|-11:19:29|-1||5.75|0.44|F5V+F7V|",
"2:17:59.9|57:53:59|62|8|5.75|1.17|K3III|",
"2:34:42.7|-7:51:34|20|77|5.75|1.4|gK4|",
"2:36:9.3|-30:2:41|36|ι1|5.75|1.02|G8-K0III|",
"3:1:10.0|-7:39:46|35|8ρ1|5.75|1.05|K0II|",
"4:27:45.9|-62:31:15|-1||5.75|1.01|K0III|",
"4:56:7.1|52:52:10|-1||5.75|0.11|A2Vs|",
"5:2:44.9|-22:47:42|47|1|5.75|1.2|K1IV|",
"6:9:44.0|23:6:48|37|3|5.75|0.21|B2.5Ib|",
"6:12:1.3|19:47:26|59|68|5.75|-0.07|B9.5V|",
"6:48:19.0|-1:19:9|-1||5.75|0.28|F1V|",
"7:7:49.5|7:28:16|-1||5.75|1.18|gK0|",
"7:14:11.0|-3:54:5|-1||5.75|1.58|K5III|",
"7:29:22.1|-10:19:36|-1||5.75|1.62|K5III|",
"8:21:54.6|-17:35:11|-1||5.75|1.05|K1III|",
"8:27:59.3|-35:6:50|-1||5.75|-0.15|B3V|",
"8:31:30.5|24:4:52|11|30υ1|5.75|0.28|F0IIIn|",
"8:47:18.9|-46:9:20|-1||5.75|0.56|F2Iab|",
"8:55:12.4|-18:14:29|-1||5.75|1.32|K2-3III|",
"9:4:0.4|54:17:2|-1||5.75|0.02|A2V|",
"9:18:26.0|35:21:51|-1||5.75|0.0|A8V|",
"9:22:24.0|-46:2:51|-1||5.75|0.92|G6-8III|",
"10:41:48.3|68:26:36|-1||5.75|1.3|gK3|",
"11:25:57.1|55:51:2|-1||5.75|0.0|K0III|",
"12:8:53.8|-44:19:34|-1||5.75|0.24|A2mA5-F2|",
"13:24:33.2|-5:9:50|85|66|5.75|0.42|F3-4Vs|",
"13:40:40.5|19:57:20|8|1|5.75|0.01|A1V|",
"13:51:47.4|-69:24:5|-1||5.75|1.73|K5-M0III|",
"14:16:38.6|-66:35:16|-1||5.75|-0.06|B1.5III|",
"15:38:16.2|46:47:52|-1||5.75|0.36|F2V|",
"15:58:58.1|-65:2:16|-1||5.75|-0.06|B7III|",
"15:55:30.6|42:33:58|39|4|5.75|-0.11|B9pe|",
"16:17:5.5|-67:56:29|-1||5.75|0.15|A4V|",
"16:36:21.5|-2:19:29|58|12|5.75|0.82|K2V|",
"17:0:9.5|-24:59:21|58|26|5.75|0.41|F4V|",
"17:2:18.7|25:30:20|-1||5.75|1.02|gG7|",
"17:27:57.6|-52:17:50|-1||5.75|1.17|K2III|",
"17:38:9.5|-10:55:35|-1||5.75|1.23|gK0|",
"17:43:59.3|53:48:6|-1||5.75|0.01|A2V|",
"18:17:11.6|-17:22:26|-1||5.75|1.58|K4II-III|",
"18:21:23.1|-18:51:36|-1||5.75|0.94|F8I|",
"18:37:36.0|0:18:34|-1||5.75|0.07|A1V+A1V|",
"19:27:25.9|52:19:14|30|7ι1|5.75|0.0|A1V|",
"19:32:53.8|-53:11:9|-1||5.75|0.3|FmDelDel|",
"19:58:41.3|-69:9:50|-1||5.75|0.23|Am|",
"20:11:34.9|62:4:43|33|68|5.75|0.47|F5V|",
"20:42:35.2|82:31:52|33|76|5.75|0.0|A0V|",
"21:15:45.9|-53:15:47|-1||5.75|0.19|A6IV|",
"21:32:56.6|49:58:40|-1||5.75|-0.03|A0V|",
"22:7:28.6|19:28:32|-1||5.75|0.0|dF2|",
"22:17:6.5|-5:23:14|3|44|5.75|0.88|G6III|",
"22:18:12.7|62:48:16|19|25|5.75|1.26|K3III|",
"22:26:37.4|4:23:37|61|34|5.75|0.52|F7V|",
"22:59:11.8|11:43:44|61|52|5.75|0.32|A8V+F6V|",
"23:24:13.1|-51:53:29|-1||5.75|1.59|M0III|",
"23:27:7.4|42:54:43|0|13|5.75|0.0|B9III|",
"23:44:40.7|-78:47:29|-1||5.75|1.11|K1III|",
"23:52:50.5|-8:59:48|-1||5.75|1.17|K0III|",
"0:2:10.2|27:4:55|61|85|5.75|0.67|G5VbFe-2|",
"0:13:19.4|-84:59:39|-1||5.77|1.72|M0-1III|",
"0:25:24.2|1:56:23|65|44|5.77|0.86|G5III|",
"1:33:42.9|-7:1:31|-1||5.76|0.64|G2IV|",
"1:39:47.8|-56:11:41|-1||5.76|0.87|K5V|",
"2:43:2.8|55:6:21|62|11|5.77|-0.13|B7IIIpHg|",
"2:44:32.9|15:18:42|6|37ο|5.77|-0.01|B9Vn|",
"3:32:36.0|9:22:25|77|6|5.77|-0.08|B9IV|",
"3:42:42.7|59:58:10|-1||5.76|1.71|K3IIb|",
"3:45:54.4|24:33:17|77|21|5.76|-0.04|B8V|",
"3:51:53.7|34:21:33|-1||5.77|0.0|B1V|",
"3:53:38.7|48:39:2|-1||5.76|1.05|K0III|",
"4:20:41.2|6:7:51|-1||5.77|0.92|G8III-IV|",
"4:24:37.4|33:57:35|62|56|5.76|0.4|F4V|",
"4:32:1.8|53:54:39|10|1|5.77|0.18|B0III|",
"4:48:32.5|-16:19:46|35|59|5.77|0.55|F6V|",
"5:14:28.8|-35:58:38|-1||5.76|1.01|G8III|",
"5:21:12.7|29:34:12|-1||5.76|0.06|A1Vs|",
"5:28:1.6|17:14:20|77|117|5.77|1.63|M1III|",
"6:25:43.6|-48:10:38|-1||5.76|-0.06|B9V|",
"6:28:37.3|-17:27:58|-1||5.77|1.12|G5|",
"6:50:49.9|0:32:27|-1||5.77|0.39|F2V|",
"6:52:49.4|8:22:49|-1||5.77|0.26|F0Vn|",
"7:21:17.5|45:13:41|-1||5.77|0.32|A7s|",
"7:24:33.4|27:38:17|37|59|5.76|0.34|g:F0|",
"7:29:4.9|-31:27:23|-1||5.77|-0.19|B2V|",
"7:34:34.9|-27:0:43|-1||5.77|1.06|K1III|",
"7:39:47.8|-38:15:39|-1||5.76|-0.07|B2.5V|",
"7:41:51.8|13:28:50|-1||5.77|1.67|M2IIIab|",
"7:52:47.9|-5:25:41|-1||5.76|0.41|F5IV|",
"8:1:20.7|59:2:51|-1||5.77|0.39|d:F2|",
"8:12:0.0|-46:38:39|-1||5.76|0.59|F7Ib-II|",
"8:44:51.9|-37:8:50|-1||5.76|-0.15|B2III|",
"9:9:11.5|-12:21:28|-1||5.77|0.94|G6III|",
"9:25:27.1|-61:57:1|-1||5.77|0.15|A4V|",
"10:12:48.3|4:36:53|76|19|5.77|1.18|gK0|",
"10:22:10.5|41:13:46|-1||5.76|0.54|F7V|",
"10:30:6.4|38:55:31|46|32|5.77|0.08|A4V|",
"10:43:51.2|-64:14:56|-1||5.77|0.0|B2.5V|",
"11:13:39.3|-53:13:54|-1||5.76|1.32|K2III|",
"11:29:38.6|-24:27:48|-1||5.76|0.07|A0V|",
"11:34:22.0|3:3:36|45|89|5.77|0.46|F5V|",
"12:13:25.3|-38:55:45|-1||5.76|-0.13|B4IV|",
"12:34:42.3|-44:40:24|-1||5.77|0.7|G1V|",
"12:53:21.8|-60:19:43|-1||5.76|0.33|B9Ia|",
"13:12:32.9|11:33:22|-1||5.77|1.51|M0III|",
"13:20:57.7|-46:52:50|-1||5.77|1.12|K1III|",
"13:26:56.7|78:38:38|-1||5.77|0.77|G2.5IIIbCH1|",
"13:51:47.2|-46:53:57|-1||5.77|-0.16|B2Vp|",
"13:58:38.9|21:41:46|8|10|5.76|-0.03|A0Vs|",
"14:0:0.1|-25:0:37|41|48|5.77|0.48|F7V|",
"14:32:30.9|55:23:52|-1||5.76|1.5|gK5|",
"14:47:57.5|-26:38:47|41|57|5.77|-0.02|B9V|",
"14:56:13.2|14:26:47|-1||5.77|-0.06|A0V|",
"15:7:25.9|-49:5:18|-1||5.77|0.92|G8III|",
"15:9:29.9|-67:5:3|-1||5.76|0.69|F6II|",
"15:10:18.6|-26:19:58|-1||5.76|1.05|K0III|",
"15:50:6.9|-53:12:34|-1||5.77|-0.08|B9Vn:|",
"15:55:32.3|-60:10:40|-1||5.77|0.35|G5II-III+A3|",
"15:56:6.0|-60:28:58|-1||5.76|0.06|A3V|",
"16:20:25.2|-55:8:24|-1||5.77|0.97|K0III|",
"16:31:13.4|22:11:43|-1||5.76|1.61|gK5|",
"16:40:38.7|4:13:11|39|37|5.77|-0.02|A1V|",
"16:54:58.4|-41:9:4|-1||5.77|0.15|O8:Iafpe|",
"17:18:48.0|-44:7:47|-1||5.76|-0.05|B9V|",
"17:24:18.7|-60:40:25|-1||5.77|-0.08|B8Ib-II|",
"17:23:57.6|8:51:10|-1||5.77|1.25|gK1|",
"17:37:31.1|24:18:36|39|79|5.77|0.11|A2Vn|",
"17:53:14.2|6:6:5|-1||5.77|0.42|F3-5IV-V|",
"18:1:54.4|-22:46:50|-1||5.77|0.0|B0Ib|",
"18:6:49.8|-43:25:29|-1||5.77|0.22|A5V|",
"18:6:49.8|-43:25:29|-1||5.77|0.0|A5V|",
"18:6:15.2|-4:45:5|-1||5.77|0.96|K1+IV|",
"18:29:56.7|-57:31:23|-1||5.76|0.98|K0III|",
"18:31:4.4|16:55:43|-1||5.77|0.04|A2V|",
"18:33:39.0|-14:51:13|-1||5.76|0.04|A2V|",
"18:54:47.1|48:51:35|-1||5.77|0.43|F3III|",
"19:6:38.4|24:15:3|-1||5.77|0.09|A4III|",
"19:47:27.8|38:24:27|-1||5.77|-0.06|B8Vn|",
"20:0:23.0|-66:56:58|60|μ1|5.76|1.04|K0III|",
"19:54:48.3|36:59:46|-1||5.76|0.75|G1Ib-IICH1Fe-1Ca-1|",
"20:18:24.8|55:23:50|-1||5.76|0.11|A2Vs|",
"20:33:17.5|-80:57:54|-1||5.77|1.14|G6-8II|",
"20:41:23.7|-31:35:54|-1||5.76|1.53|M0III|",
"20:51:28.2|28:15:2|-1||5.77|0.72|F5Ib|",
"21:0:21.5|-51:15:55|-1||5.76|0.47|F5IV-V|",
"21:8:32.9|-63:55:44|-1||5.76|1.18|K0III|",
"21:19:28.8|49:30:37|-1||5.76|-0.15|B6V|",
"21:24:24.8|-41:0:24|53|θ2|5.77|-0.05|A0IIIpSi|",
"21:35:17.6|-3:58:59|-1||5.77|1.11|gG9|",
"21:51:34.2|19:49:36|-1||5.77|-0.1|B8III|",
"22:31:37.4|-85:58:2|57|υ|5.77|1.02|K0III|",
"22:24:27.1|-13:31:46|3|50|5.76|0.97|G6.5III|",
"22:46:10.2|44:32:46|-1||5.76|0.36|F0III-IV|",
"23:14:58.6|-41:6:20|-1||5.77|1.18|K2III|",
"23:20:53.3|38:10:56|0|12|5.77|0.46|F5V|",
"23:49:27.5|1:4:34|65|21|5.77|0.16|A5Vm|",
"0:14:58.8|8:49:15|65|35|5.79|0.31|F0IV|",
"0:20:45.5|32:54:41|-1||5.79|1.59|K5III|",
"0:36:27.3|60:19:34|-1||5.79|0.29|A4III|",
"1:8:33.3|58:15:49|-1||5.79|-0.01|B8V|",
"1:26:58.1|-32:32:35|-1||5.79|3.86|C6II|",
"1:43:19.7|60:33:4|17|44|5.78|-0.02|B8IIIn|",
"1:48:41.6|32:41:25|-1||5.79|0.55|F8V|",
"1:52:9.4|50:47:34|62|2|5.79|-0.07|B9IIIpHgMn|",
"2:15:46.0|25:46:59|6|20|5.79|0.44|F6IV-V|",
"2:37:36.1|65:44:44|-1||5.78|1.56|K5III|",
"2:36:58.6|-34:34:42|36|λ2|5.79|0.66|G5IV|",
"2:47:47.6|81:26:54|-1||5.78|1.3|G8pBa3|",
"2:40:12.3|-9:27:11|-1||5.78|0.52|F6V|",
"3:12:14.2|27:15:25|6|56|5.79|-0.12|B9pSi|",
"3:15:48.0|57:8:27|-1||5.79|0.73|A0Ia|",
"3:29:55.0|-42:38:3|-1||5.78|0.22|A5V|",
"4:11:36.2|-20:21:22|-1||5.79|0.18|A2m|",
"4:20:57.9|-81:34:48|52|ν|5.79|0.35|F0-2III|",
"4:38:9.4|16:2:0|77|89|5.79|0.31|F0V|",
"4:33:34.0|-62:49:25|-1||5.79|1.04|K1III|",
"4:41:19.8|28:36:54|-1||5.78|-0.03|A2V|",
"4:48:36.3|-5:40:26|-1||5.78|0.62|F8V|",
"4:57:48.7|23:56:55|77|99|5.79|1.11|gG8|",
"5:8:20.2|-8:39:54|-1||5.78|-0.06|B8V|",
"5:29:23.6|-3:26:47|-1||5.79|1.15|K1-III|",
"5:29:54.8|1:47:21|-1||5.78|-0.2|B2V|",
"5:33:7.4|-35:8:23|-1||5.78|1.07|K0III|",
"5:35:15.4|-33:4:48|-1||5.78|1.12|K2IIIa|",
"5:34:44.7|-73:44:29|-1||5.78|1.71|M3III|",
"5:46:52.1|9:31:20|-1||5.79|0.88|G8III|",
"6:6:57.6|-21:48:46|-1||5.78|1.64|M4III|",
"6:12:20.1|32:41:36|-1||5.78|1.66|M2IIIa|",
"6:19:41.0|-34:23:48|-1||5.78|-0.08|B9V|",
"6:38:23.0|28:59:3|7|53|5.79|0.0|B9npEu|",
"6:41:5.4|0:29:43|-1||5.79|-0.1|B8III|",
"6:50:21.9|-17:5:2|-1||5.79|1.44|K0|",
"7:5:39.1|9:11:9|-1||5.78|1.52|M0III|",
"7:7:7.1|-40:53:36|-1||5.79|-0.17|B3V|",
"7:11:23.1|26:51:24|37|47|5.78|0.1|A4IV|",
"7:13:7.2|-11:15:5|-1||5.78|1.51|K0|",
"7:18:2.2|40:53:0|7|64|5.78|0.17|A5Vn|",
"7:25:8.3|-13:45:7|-1||5.78|0.42|F0V|",
"7:25:25.3|-25:13:4|-1||5.78|-0.1|B7III|",
"7:27:51.7|-11:33:25|-1||5.79|0.58|G8Ib-II+B2+B8V|",
"7:49:12.9|-60:17:1|-1||5.78|0.42|F1V|",
"7:49:41.0|-66:11:45|-1||5.79|-0.04|B9V|",
"7:56:59.4|15:47:25|11|1|5.78|1.28|K3+III|",
"8:14:13.2|-35:29:26|-1||5.78|1.02|K1III|",
"8:29:7.6|-44:9:38|-1||5.79|-0.16|B2Vn|",
"8:34:43.8|36:25:10|50|33|5.78|0.04|A2Vnn|",
"8:45:55.2|-79:30:16|-1||5.79|1.6|K5III|",
"8:53:48.7|-60:21:15|-1||5.78|-0.08|B5III|",
"9:0:45.7|-60:57:50|-1||5.79|1.21|G8II|",
"9:11:33.2|-46:35:2|-1||5.79|-0.21|B2III/IV|",
"9:19:33.2|-15:50:4|-1||5.78|1.29|K4III|",
"9:46:10.0|6:42:31|-1||5.79|1.64|M1.5IIIab|",
"9:51:12.1|-59:25:33|-1||5.79|1.36|K2IVCNIV-Vp|",
"10:13:28.0|-51:45:22|-1||5.78|0.14|A3IV-V|",
"10:43:20.9|4:44:52|76|35|5.79|1.17|K3III+K0III|",
"10:50:18.1|-8:53:52|76|41|5.79|0.16|A3m|",
"11:14:1.8|8:3:38|-1||5.79|1.12|K3III|",
"11:23:8.1|-56:46:46|-1||5.79|0.01|A4:pe|",
"12:23:44.9|-38:54:40|-1||5.79|-0.08|B9V|",
"12:49:17.4|27:33:8|24|30|5.78|0.03|A2V|",
"12:59:39.5|-3:48:43|85|44|5.79|0.18|A3V|",
"13:9:12.4|10:1:20|-1||5.78|1.0|K0III|",
"13:11:8.8|-42:13:59|-1||5.79|0.52|F7IV|",
"13:15:32.0|40:51:19|12|19|5.79|0.19|A7V|",
"13:25:6.7|23:51:16|-1||5.78|0.06|A3IV|",
"13:26:8.1|72:23:29|-1||5.79|1.63|M1IIIab|",
"13:36:48.4|-26:29:42|-1||5.78|0.22|A7III|",
"13:40:10.9|-64:34:37|-1||5.79|0.39|F3III-IV|",
"15:8:12.1|-40:35:2|-1||5.79|-0.14|B8IVSi|",
"15:22:38.4|63:20:29|-1||5.79|1.27|gK4|",
"15:30:55.7|64:12:31|-1||5.79|0.96|K0III-IV|",
"15:37:48.1|-23:8:30|-1||5.78|1.1|K0III|",
"16:7:36.4|-12:44:44|72|11|5.78|0.01|B9.5Vnn|",
"16:16:44.8|29:9:1|26|18υ|5.78|0.07|A3V|",
"16:28:14.7|-37:10:46|-1||5.79|1.1|K1IIICNII|",
"16:36:11.2|46:36:48|-1||5.79|1.04|G8II|",
"16:59:33.8|-69:16:6|-1||5.79|-0.1|ApSi|",
"17:41:16.3|-46:55:19|-1||5.79|-0.01|A0V|",
"17:51:35.5|-60:9:52|-1||5.78|1.0|K0III|",
"17:41:58.0|72:9:25|33|31ψ1|5.79|0.53|G0V|",
"17:30:48.0|86:58:5|83|24|5.79|0.25|A2m|",
"18:35:12.6|18:12:12|-1||5.78|0.0|A0Vn|",
"18:43:37.2|-64:33:4|-1||5.78|0.96|K0III|",
"18:55:31.0|-16:22:36|-1||5.79|0.36|F4V|",
"19:54:8.2|-8:34:27|4|56|5.79|1.64|gK5|",
"20:13:27.7|60:38:26|-1||5.79|1.47|gK5|",
"20:33:54.9|46:41:38|-1||5.78|-0.16|B9pSi|",
"20:44:22.0|56:29:17|-1||5.78|1.67|M3III|",
"20:54:47.9|-17:55:23|15|19|5.78|1.12|K0III|",
"21:27:14.8|-21:11:46|15|35|5.78|1.44|K5III|",
"22:1:50.6|52:52:56|-1||5.78|-0.11|B5III|",
"22:5:11.4|26:40:26|-1||5.78|1.25|K2III|",
"22:7:50.3|21:42:10|61|25|5.78|-0.1|B7Vne|",
"22:10:37.4|11:37:28|-1||5.78|1.58|M1III|",
"22:12:22.3|63:17:29|-1||5.79|1.67|M3IIIab|",
"22:16:52.6|-9:2:24|-1||5.79|1.16|gK3|",
"22:25:10.5|-70:25:54|-1||5.78|0.38|F3III|",
"22:24:6.9|-4:50:13|3|51|5.78|-0.04|A0V|",
"22:29:10.2|26:45:47|-1||5.79|1.25|K2II|",
"22:37:13.0|75:22:18|-1||5.79|1.57|M1IIIab|",
"23:3:59.5|-41:28:42|-1||5.79|1.08|K0III|",
"23:19:52.4|42:4:41|0|10|5.79|1.48|M0III|",
"23:51:21.2|9:18:48|61|80|5.79|1.66|M3IIIa|",
"0:4:19.7|-16:31:44|-1||5.78|1.1|K2III|",
"0:45:45.6|-47:33:6|-1||5.8|0.64|G1V|",
"1:10:19.4|25:27:28|-1||5.8|1.47|K7III|",
"1:11:10.3|37:43:27|0|45|5.81|-0.1|B7III-IV|",
"1:31:13.8|70:15:53|17|38|5.81|0.47|F6V|",
"1:35:54.8|17:26:1|-1||5.8|0.0|F0IV|",
"1:52:52.1|-16:55:45|-1||5.8|0.27|F0IIIn|",
"2:19:54.3|-55:56:41|-1||5.81|1.55|K5III|",
"2:36:35.1|7:43:47|-1||5.81|1.04|gK0|",
"2:51:58.7|68:53:19|-1||5.8|0.64|F5:Ib-II|",
"2:58:5.2|20:40:7|6|47|5.8|0.41|F5IV|",
"3:33:35.1|39:53:58|-1||5.81|0.11|A5m|",
"3:46:0.9|67:12:6|-1||5.8|0.35|F0IV|",
"3:48:35.8|-20:54:11|-1||5.81|1.64|K5III|",
"3:53:43.3|57:58:30|-1||5.8|0.18|A5m|",
"4:32:37.4|-3:12:33|-1||5.81|-0.14|B9III|",
"4:55:50.3|15:2:24|-1||5.81|-0.08|B9V|",
"4:58:9.4|25:3:1|77|98|5.81|0.0|A0V|",
"5:21:43.6|8:25:43|-1||5.8|-0.13|B1V|",
"5:50:2.6|9:52:16|-1||5.8|0.87|G8III|",
"5:58:37.6|-44:2:4|-1||5.81|1.07|G8II|",
"6:5:27.1|-35:30:49|-1||5.8|0.02|A1V|",
"6:6:5.5|-29:45:31|-1||5.81|0.05|A1V|",
"6:11:32.3|24:25:13|37|5|5.8|1.11|K0III|",
"6:18:59.0|-20:55:34|-1||5.81|-0.15|B4IV|",
"6:24:13.7|-60:16:52|-1||5.8|0.0|A0V|",
"6:35:15.8|0:53:24|-1||5.8|0.0|B8Ib|",
"6:45:31.3|-30:56:56|-1||5.8|-0.19|B2III|",
"6:45:53.7|-52:24:36|-1||5.8|1.53|K3III|",
"7:16:31.8|-38:19:8|-1||5.8|-0.13|B4V|",
"7:24:57.2|51:53:14|-1||5.8|1.61|K5III|",
"7:34:15.8|3:22:17|14|9δ3|5.81|-0.02|A0Vnn|",
"7:38:43.9|-36:29:49|-1||5.8|-0.16|B2IV-V|",
"7:44:9.6|-36:3:46|-1||5.8|0.31|F2V|",
"7:58:50.5|-60:49:28|-1||5.81|-0.09|B2IVpne|",
"8:34:1.6|-2:9:6|-1||5.81|0.0|A1V|",
"8:35:52.1|-50:58:12|-1||5.8|-0.13|B8Si|",
"9:41:2.2|-57:15:35|-1||5.8|1.09|K0-1III|",
"10:9:30.5|-68:41:0|-1||5.81|0.02|A0IV|",
"10:18:37.6|-56:6:36|-1||5.81|0.48|F6V|",
"10:43:43.3|57:11:57|82|39|5.8|-0.02|A0Vs|",
"10:56:1.5|6:11:7|45|56|5.81|1.45|M5.5III|",
"10:59:59.4|-43:48:26|-1||5.81|-0.08|B8-9V|",
"11:9:53.4|-32:22:3|-1||5.81|0.04|A2V|",
"11:13:14.7|-44:22:20|-1||5.8|1.66|K5-M0III|",
"11:24:58.9|11:25:49|-1||5.8|1.38|K4III|",
"11:26:47.3|-53:9:36|-1||5.81|0.52|K0III+A2-3V|",
"11:32:16.1|-29:15:48|-1||5.81|0.53|F8V|",
"11:36:17.9|27:46:52|-1||5.8|0.23|F0V|",
"12:5:15.1|76:54:21|-1||5.8|1.01|G9III|",
"12:17:29.5|53:11:28|-1||5.81|1.3|K6III|",
"12:25:3.2|56:46:39|82|71|5.81|1.62|M3IIIb|",
"12:29:53.9|-56:31:29|-1||5.8|1.56|M1III|",
"12:36:1.2|-39:52:12|-1||5.8|0.01|A0V|",
"13:45:36.9|-26:6:58|-1||5.81|0.02|A1Vn|",
"14:17:28.4|15:15:48|-1||5.8|1.71|M3IIIa|",
"14:46:6.8|-23:9:11|-1||5.81|0.98|gG5|",
"14:49:58.4|28:36:57|-1||5.8|0.05|A4V|",
"14:54:22.9|-11:53:54|48|13ξ1|5.8|0.97|G7III|",
"15:8:35.5|25:6:31|-1||5.81|1.24|K1III|",
"15:14:19.1|-70:4:46|-1||5.81|3.38|C5,5|",
"15:41:54.7|18:27:50|75|22τ7|5.81|0.2|A2m|",
"15:52:16.6|55:49:36|-1||5.81|0.96|gG8|",
"15:57:21.3|-36:11:6|-1||5.8|1.01|K0-1III|",
"16:13:22.6|-55:32:27|56|ζ|5.81|0.34|F2III|",
"17:5:19.7|54:28:13|33|21μ|5.8|0.48|F7V|",
"17:23:6.9|-56:31:31|-1||5.8|1.0|G8-K0III|",
"17:34:36.7|9:35:12|58|53|5.81|0.02|A2V|",
"17:56:41.9|-28:3:55|-1||5.8|0.21|A7III/V:|",
"18:38:30.7|-23:30:18|-1||5.81|0.02|B8III|",
"18:49:27.4|-45:48:37|-1||5.81|0.9|G8III|",
"19:8:25.8|52:25:32|-1||5.81|1.09|K1IV|",
"19:13:13.7|-25:54:24|-1||5.8|1.38|K1I|",
"19:26:28.7|19:53:29|-1||5.81|1.55|M0III|",
"19:29:1.0|1:57:1|4|35|5.8|0.08|A0IVp|",
"19:28:57.0|24:46:7|87|8|5.81|1.03|K0III|",
"20:0:48.3|-45:6:47|-1||5.81|0.28|A8III|",
"20:4:6.2|17:4:12|70|15|5.8|0.61|G1V|",
"20:20:21.4|17:47:35|-1||5.8|1.49|gK5|",
"20:40:32.5|-16:7:27|-1||5.8|1.0|gG7|",
"20:56:25.5|50:43:43|-1||5.81|0.3|F0III|",
"21:28:8.3|32:13:31|-1||5.8|0.32|F0V|",
"21:54:53.2|56:36:41|19|13|5.8|0.73|B8Ib|",
"22:3:19.0|11:23:11|61|21|5.8|-0.07|B9.5V|",
"22:8:59.0|-18:31:11|3|35|5.81|-0.17|B2.5IV|",
"22:53:28.7|-11:37:0|3|74|5.8|-0.08|B9III|",
"22:53:40.1|44:44:57|-1||5.81|0.26|A3Vm+F6V|",
"22:54:7.0|40:22:37|-1||5.81|1.13|K0III|",
"23:9:57.3|-42:51:38|-1||5.81|0.48|F4IV|",
"23:33:19.5|-77:23:7|-1||5.81|0.68|G2V|",
"23:37:32.0|44:25:45|-1||5.8|-0.06|B8V|",
"0:5:6.2|61:18:51|-1||5.8|-0.09|B8IVpHgMn|",
"0:42:3.4|66:8:51|-1||5.83|1.04|G9III-IV|",
"1:7:46.2|-9:47:8|20|30|5.82|0.43|F7IV|",
"1:31:43.3|-30:17:0|-1||5.82|1.08|K0III|",
"1:49:15.7|47:53:49|-1||5.82|0.29|A3V|",
"1:57:43.8|27:48:16|-1||5.82|1.6|M2III|",
"2:22:50.3|41:23:47|-1||5.82|0.27|F0III-IV|",
"2:26:0.3|-15:20:28|-1||5.83|0.15|A6VpSrCr|",
"2:32:52.5|34:32:33|-1||5.83|1.07|K0III|",
"2:36:4.9|6:53:13|-1||5.82|0.98|K3V|",
"2:38:18.7|-30:11:39|36|ι2|5.83|0.48|F4V|",
"2:48:32.1|18:17:1|6|40|5.82|1.2|K1III|",
"3:1:56.1|-9:57:41|-1||5.83|1.11|gG6|",
"3:2:55.9|-46:58:30|-1||5.82|1.3|K2-3III|",
"3:30:37.0|48:6:13|-1||5.82|-0.04|B8V|",
"3:30:51.6|-66:29:23|-1||5.83|-0.06|B8V|",
"3:58:52.3|-5:28:12|-1||5.83|1.0|G9V|",
"4:23:5.7|-24:53:32|-1||5.83|1.51|K5|",
"5:37:8.8|26:55:27|-1||5.83|-0.07|B9IV-V|",
"5:38:43.6|-40:42:27|-1||5.82|-0.09|B8V|",
"6:7:3.7|-34:18:43|-1||5.83|-0.13|B4IVe|",
"6:13:54.3|-3:44:29|-1||5.83|0.94|G8III|",
"6:14:36.7|-4:34:6|-1||5.83|-0.17|B5V|",
"6:27:4.0|-58:0:8|-1||5.82|1.28|K3III|",
"7:2:33.5|16:40:27|-1||5.82|1.68|M2III|",
"7:14:41.9|24:53:6|37|52|5.82|1.56|M1III|",
"7:15:39.4|7:58:40|-1||5.82|1.6|M4-IIIab|",
"7:22:25.4|-5:58:58|-1||5.82|0.35|F3IV|",
"7:34:18.6|-23:28:25|-1||5.83|0.44|dF4|",
"8:0:55.9|25:23:34|11|2ω1|5.83|1.02|gG8|",
"8:3:4.1|-32:27:50|-1||5.82|1.22|K2-3III|",
"8:11:11.1|-48:27:43|-1||5.82|-0.15|B3V|",
"8:14:23.9|-45:50:4|-1||5.83|-0.2|B2IV-V|",
"8:20:21.0|20:44:52|-1||5.83|1.13|K1III|",
"8:52:48.0|-38:43:27|-1||5.82|1.5|M0III|",
"9:1:24.1|32:15:9|11|66|5.82|0.0|A2V|",
"9:58:22.8|72:52:46|-1||5.83|1.14|gK3|",
"10:18:2.0|65:6:30|82|32|5.82|0.12|A8III|",
"10:17:14.6|23:6:22|45|39|5.82|0.5|F8Vbw|",
"11:29:4.6|61:46:42|-1||5.83|0.36|F5Vavw|",
"11:36:22.3|-61:3:8|-1||5.83|-0.09|B2.5IV|",
"12:14:59.6|-20:50:39|-1||5.83|1.05|gG7|",
"12:56:17.6|54:5:58|-1||5.82|0.19|A5m|",
"13:18:27.8|34:5:53|-1||5.82|1.35|K4.5III|",
"13:22:16.2|-52:10:59|-1||5.83|0.12|B2.5Ib|",
"13:38:42.0|-29:33:39|-1||5.83|0.4|F5V|",
"13:56:19.5|-46:35:33|-1||5.83|1.14|K1III|",
"14:27:12.2|-46:8:4|-1||5.83|0.31|A1mA5/7-F2|",
"14:31:16.5|-67:43:2|-1||5.83|1.0|K1III|",
"14:54:38.0|-33:18:2|-1||5.82|1.42|K2III|",
"15:30:40.4|-16:36:34|48|34ζ3|5.82|1.06|gG6|",
"15:34:1.6|-40:3:58|-1||5.82|1.68|M2III|",
"16:0:51.1|4:25:39|-1||5.83|1.0|gK0|",
"16:3:19.4|36:37:54|-1||5.83|0.56|A2V+F7III|",
"16:13:16.8|-53:40:18|-1||5.83|1.96|M0Ib-II+F-G|",
"16:38:26.2|-43:23:55|-1||5.83|-0.02|B2.5IV|",
"17:5:19.8|54:28:13|33|21μ|5.83|0.0|F7V|",
"17:56:18.4|0:40:13|-1||5.82|0.09|B2IV-V|",
"18:25:58.8|29:49:44|-1||5.83|0.06|A2IV|",
"18:44:49.6|-25:0:40|-1||5.83|0.05|B5:V|",
"18:45:28.4|5:29:59|-1||5.83|0.04|A1V+A1V|",
"18:50:58.5|-9:46:27|-1||5.83|0.61|F2Ib|",
"19:3:32.2|1:49:8|-1||5.83|0.18|A4V|",
"19:22:21.5|0:15:9|-1||5.83|1.09|gG8|",
"19:38:41.2|54:58:26|-1||5.82|0.44|F6Va|",
"21:2:9.1|56:40:11|-1||5.83|-0.07|B8III|",
"21:6:30.3|31:11:5|-1||5.82|0.56|F7.5Ib-II|",
"21:12:13.6|-40:16:10|-1||5.83|0.45|F5IV|",
"21:18:11.1|-4:31:10|3|15|5.82|-0.13|B5V|",
"21:19:22.2|38:14:15|-1||5.83|0.5|F1II|",
"21:21:4.8|7:21:16|34|9|5.82|1.66|M2IIIa|",
"22:26:42.5|78:47:9|19|28ρ1|5.83|0.15|A2Vm|",
"22:36:35.4|-31:39:50|-1||5.82|1.09|K1III|",
"22:38:52.6|19:31:20|61|40|5.82|0.92|G8II|",
"23:0:42.9|3:0:42|-1||5.83|1.34|K4III|",
"23:7:14.7|-50:41:11|-1||5.83|0.48|F6-7IV-V|",
"23:10:9.8|-40:35:30|-1||5.83|1.62|M4III|",
"23:13:26.5|11:3:54|-1||5.82|1.01|G8III|",
"0:10:18.8|-5:14:55|-1||5.84|0.98|K1III|",
"0:10:42.8|-12:34:48|-1||5.85|1.01|K0IV|",
"0:55:42.4|-7:20:50|-1||5.85|1.52|K5III|",
"1:4:19.6|61:34:49|-1||5.84|0.54|F6V|",
"1:23:31.0|-30:56:44|-1||5.84|1.61|K5III|",
"1:48:10.9|16:57:20|6|4|5.84|-0.03|B9.5V|",
"2:9:9.3|-43:31:0|-1||5.85|1.19|K1III|",
"2:42:59.7|53:31:34|-1||5.84|1.12|K0II-III|",
"2:58:5.7|-23:36:22|35|6|5.84|1.33|K2III|",
"3:17:26.6|-47:45:6|-1||5.85|1.24|K2III|",
"3:38:29.2|-7:23:30|-1||5.85|0.98|gG5|",
"3:49:36.7|63:17:50|-1||5.85|0.18|A5Vn|",
"4:20:42.8|-7:35:33|-1||5.85|-0.13|B5III|",
"5:2:45.5|-4:12:35|-1||5.85|1.21|K3|",
"4:58:50.9|-82:28:14|52|ξ|5.85|0.93|G8-K0III|",
"6:32:19.2|4:51:21|54|12|5.84|0.99|K0V|",
"6:31:13.0|-35:15:33|-1||5.84|0.81|G8III|",
"6:37:38.5|56:51:27|50|11|5.85|0.0|A2V|",
"6:49:49.8|16:12:10|37|33|5.85|-0.13|B7III|",
"7:12:26.4|24:7:42|37|48|5.85|0.36|F5III-IV|",
"7:11:41.6|-20:52:59|-1||5.84|-0.04|A0V|",
"7:18:4.2|-43:59:12|-1||5.85|-0.12|B8II-III|",
"7:33:9.7|-24:42:39|-1||5.85|0.17|A7V:|",
"7:49:12.9|-46:51:28|-1||5.84|-0.14|B1.5IV|",
"8:13:50.2|56:27:8|-1||5.85|1.01|G9III|",
"8:22:55.2|-52:7:26|-1||5.85|0.01|A0V|",
"9:2:44.8|7:17:53|-1||5.85|1.11|gK3|",
"9:14:8.2|-44:8:45|-1||5.85|-0.12|B5/6IV/V|",
"9:17:7.5|-14:34:25|-1||5.84|1.06|gK0|",
"9:30:43.2|33:39:20|46|7|5.85|1.05|gG8|",
"9:30:22.6|-15:34:38|-1||5.85|1.2|gK3|",
"9:56:26.0|8:55:59|-1||5.85|1.13|gK2|",
"9:56:35.5|-33:25:7|-1||5.84|1.2|K1III|",
"10:11:12.8|37:24:7|-1||5.85|1.29|gK3|",
"10:16:41.9|25:22:17|-1||5.84|1.2|gK2|",
"10:39:7.6|37:54:36|46|38|5.85|0.57|F9V|",
"11:51:41.6|-30:50:6|-1||5.85|0.56|F7V|",
"11:55:58.4|56:35:55|82|66|5.84|1.1|K1III|",
"12:13:25.9|10:15:44|85|12|5.85|0.27|A2m|",
"12:35:8.1|21:52:53|-1||5.85|1.22|K1III|",
"12:41:23.0|-46:8:44|-1||5.84|1.52|K4III|",
"12:48:39.4|60:19:12|-1||5.85|0.46|F5V|",
"12:49:6.6|83:25:5|-1||5.85|-0.06|A0V+A2V|",
"12:54:56.5|47:11:48|-1||5.84|1.55|M5III|",
"13:14:17.2|-78:26:50|-1||5.85|1.07|F8Ib|",
"13:17:13.9|-43:58:46|-1||5.84|0.2|Am|",
"13:41:29.9|64:49:21|-1||5.85|0.07|A2V|",
"14:27:7.1|-65:49:18|-1||5.85|1.5|K3III|",
"14:38:15.2|54:1:24|-1||5.85|-0.01|A1V|",
"14:50:15.8|23:54:43|-1||5.85|0.56|G0-2V|",
"15:2:6.4|-28:3:38|41|60|5.85|0.16|A4IV|",
"15:8:39.1|-42:52:4|-1||5.85|-0.11|B7V|",
"15:13:53.3|-26:11:37|-1||5.84|1.14|gG5|",
"15:38:16.3|-21:0:58|-1||5.84|1.08|gG9|",
"15:38:34.3|50:25:24|-1||5.84|0.83|G8III|",
"15:49:57.5|-48:54:43|-1||5.84|0.07|A1V|",
"15:48:34.4|28:9:24|-1||5.85|0.77|G0Iep|",
"15:57:40.4|-20:58:59|-1||5.85|0.02|B3V|",
"16:24:39.7|-29:42:17|-1||5.84|0.59|G0IV|",
"16:24:10.8|6:56:53|39|21|5.85|-0.01|A2pSr:|",
"17:11:38.9|-48:52:27|-1||5.84|1.84|M1-2III|",
"17:24:42.0|-21:26:30|-1||5.85|0.93|G8III|",
"17:26:44.2|48:15:36|39|77|5.85|0.12|A4V|",
"17:33:7.4|-41:10:25|-1||5.84|0.06|B9Ib-II|",
"17:52:19.7|-34:25:0|-1||5.84|1.13|G8III|",
"18:12:34.5|-73:40:18|-1||5.85|0.46|F5V|",
"18:6:7.4|-8:19:26|-1||5.85|0.21|B8III-IV|",
"18:32:46.2|23:37:1|-1||5.84|1.46|gK5|",
"18:40:0.5|-7:47:26|-1||5.84|1.55|K4III|",
"19:15:24.8|30:31:35|-1||5.85|1.67|M0III|",
"19:23:56.5|43:23:17|-1||5.84|0.92|G7III-IIIa|",
"19:28:20.8|2:55:49|-1||5.85|0.01|B6III|",
"19:43:45.0|41:46:23|-1||5.84|1.57|M0IIIab|",
"20:6:13.8|53:9:57|-1||5.85|0.39|F5V|",
"20:12:25.9|-12:37:3|15|2ξ2|5.85|0.48|F7V|",
"20:18:7.0|40:43:56|-1||5.84|0.1|O9V|",
"20:25:26.8|-28:39:48|-1||5.85|1.1|G8II/III|",
"21:39:1.1|20:15:55|-1||5.85|0.32|F2V|",
"23:14:37.3|74:13:52|-1||5.84|0.0|A0V|",
"23:34:59.0|71:38:32|-1||5.84|1.8|G9Ib|",
"0:18:38.3|31:31:2|-1||5.87|-0.01|A0IV|",
"0:31:25.6|33:34:54|-1||5.87|1.14|K1III|",
"0:39:21.8|21:15:2|65|54|5.87|0.85|K0+V|",
"0:48:9.1|72:40:30|-1||5.87|1.01|K0IV|",
"1:19:48.3|0:30:32|20|42|5.87|0.64|G8III+A7V|",
"1:39:47.4|-56:11:53|-1||5.87|0.9|K0V|",
"1:37:55.6|-82:58:30|-1||5.87|0.61|G2V|",
"1:50:8.5|22:16:31|6|1|5.86|0.74|K1III+A6V|",
"1:59:35.7|21:3:30|-1||5.87|1.03|K0III-IV|",
"2:2:58.6|-15:18:21|-1||5.86|0.98|G3IV|",
"2:13:0.9|-21:0:1|-1||5.86|1.01|G9III|",
"2:22:5.0|-17:39:44|-1||5.87|1.23|K0III|",
"2:48:45.9|25:11:17|-1||5.86|-0.07|A0V|",
"4:10:1.5|86:37:34|-1||5.86|0.37|F5IV|",
"4:6:3.1|68:40:48|-1||5.87|1.54|K2III|",
"4:21:27.1|0:5:53|-1||5.86|1.32|K3III|",
"4:17:40.2|-63:15:20|69|θ|5.87|-0.07|B9III-IV|",
"4:43:21.6|49:58:26|-1||5.87|0.02|B9III|",
"4:49:19.0|32:35:18|-1||5.86|0.24|A8m|",
"4:51:28.2|-34:54:23|-1||5.86|0.08|A1Vn|",
"5:27:5.3|-40:56:37|-1||5.87|0.23|A7m|",
"5:31:36.1|-45:55:31|-1||5.86|1.35|K3III|",
"5:42:13.9|-22:22:25|47|12|5.87|0.11|A2|",
"5:49:53.5|-22:58:18|-1||5.87|0.06|A2|",
"5:55:30.3|-4:36:59|-1||5.87|1.18|gK2|",
"5:56:49.5|11:31:16|-1||5.87|1.1|K2III|",
"6:5:3.4|42:58:54|7|39|5.87|0.3|F3V|",
"6:5:27.0|-10:14:34|-1||5.87|0.37|dF4|",
"6:17:9.5|-37:15:11|-1||5.87|0.14|A3V|",
"6:25:16.4|0:56:46|-1||5.87|0.56|F8V|",
"6:26:39.6|-1:30:26|-1||5.87|0.08|A3Vn|",
"6:32:27.2|32:27:17|-1||5.87|0.14|A3m+A3m:|",
"6:56:32.3|46:16:27|7|ψ9|5.87|-0.06|B8IIIe|",
"6:56:56.0|46:42:18|-1||5.86|1.08|gK0|",
"7:21:4.3|-25:53:29|-1||5.87|1.64|M4III|",
"7:29:25.7|-7:33:4|-1||5.86|0.48|F8V|",
"7:29:59.6|-52:39:4|-1||5.87|1.01|K0III|",
"7:34:19.1|-23:28:29|-1||5.87|0.0|dF6|",
"7:55:31.4|8:51:46|-1||5.86|0.35|F2IV|",
"8:0:49.9|-54:9:5|-1||5.87|-0.14|B5Vn|",
"8:33:43.5|4:45:24|-1||5.87|1.07|G5III|",
"8:46:56.0|12:6:36|11|50|5.87|0.11|A1V|",
"8:50:2.2|-29:27:47|-1||5.87|0.95|G8III|",
"8:58:43.9|-16:7:58|-1||5.86|0.53|F6V|",
"8:57:55.8|-48:34:24|-1||5.87|1.07|G8-K0II|",
"9:14:57.2|-37:36:9|-1||5.86|0.83|G0V|",
"9:18:42.2|-51:33:38|-1||5.87|0.54|B6Iae|",
"9:17:27.4|-74:44:5|-1||5.86|-0.02|A0V|",
"9:31:32.9|-35:42:54|-1||5.87|1.29|K4III|",
"10:4:2.9|-18:6:6|-1||5.86|-0.06|A0V|",
"10:49:43.5|-9:51:10|-1||5.86|1.07|gG8|",
"12:4:16.6|21:27:33|24|2|5.87|0.22|F0IV-V|",
"12:36:47.4|-5:49:55|85|25|5.87|0.07|A3V|",
"12:46:46.0|-33:18:56|-1||5.86|1.34|K3III|",
"13:22:9.7|5:9:17|85|64|5.87|0.12|A2m|",
"13:46:13.5|41:5:19|-1||5.87|0.21|A5V|",
"13:51:9.2|34:39:52|-1||5.87|1.62|M2III|",
"14:19:0.8|-25:48:56|-1||5.87|0.5|F5V|",
"14:33:32.4|-54:59:54|-1||5.87|0.48|F6IV-V|",
"14:33:29.9|-52:40:48|-1||5.87|1.09|K0III|",
"14:35:31.5|-41:31:2|-1||5.87|-0.08|B7V|",
"14:52:35.0|-63:48:36|-1||5.87|0.72|G3II+B8V|",
"14:58:53.6|-11:8:39|48|18|5.87|1.26|K3-IIICN1|",
"15:37:32.0|54:30:32|-1||5.87|1.07|gK1|",
"15:47:38.0|55:22:36|-1||5.86|0.25|A3m|",
"15:54:39.5|-25:14:37|72|3|5.87|-0.06|B8IIIp|",
"16:11:17.7|-41:7:11|-1||5.86|0.27|F0IV|",
"16:11:47.6|42:22:28|-1||5.87|1.45|K4II+F6-8V|",
"16:41:45.5|-33:8:47|-1||5.87|0.65|G3III|",
"16:47:19.8|42:14:20|-1||5.87|1.61|M4+III-IIIa|",
"16:59:57.6|-25:5:31|-1||5.86|1.62|M3III|",
"17:44:42.0|-42:43:44|-1||5.87|0.16|A1V+F0IV|",
"17:37:8.8|72:27:21|-1||5.86|1.01|G9III|",
"17:59:36.7|-4:49:17|-1||5.87|1.56|K5III|",
"18:11:15.7|-75:53:29|-1||5.86|1.24|K2III|",
"18:7:49.5|26:6:5|39|100|5.86|0.12|A3V|",
"18:11:5.6|-41:21:33|-1||5.86|0.29|F2V|",
"18:39:14.3|-47:54:35|-1||5.86|0.23|A7IV-V|",
"18:38:53.4|-21:3:7|-1||5.86|0.68|G4V|",
"19:21:50.9|-18:18:30|71|45ρ2|5.87|1.06|gG9|",
"19:31:21.8|26:37:2|-1||5.87|0.93|K0III-IV|",
"20:18:1.4|-21:48:36|15|4|5.87|1.0|K0III|",
"20:49:17.6|-25:46:53|-1||5.86|-0.07|B7IIIp|",
"20:57:40.6|-16:1:54|-1||5.87|0.18|A2m|",
"21:6:23.3|71:25:55|-1||5.87|0.4|F3IV|",
"21:21:4.3|-4:33:36|3|16|5.87|0.92|gG7|",
"21:55:31.1|65:19:15|-1||5.86|-0.06|B2.5Ve|",
"22:36:58.8|-40:35:28|38|σ2|5.86|0.06|A1V|",
"22:40:22.3|-30:39:32|-1||5.87|1.3|K3III|",
"23:9:44.6|-28:5:19|-1||5.87|1.31|K2III|",
"23:34:9.0|-1:14:51|65|14|5.87|0.3|A2m|",
"23:52:30.0|-14:15:4|-1||5.87|1.28|K3III|",
"0:2:36.1|66:5:56|-1||5.86|1.09|G8III|",
"0:17:9.1|47:56:51|-1||5.89|-0.09|B7III|",
"0:36:47.3|15:13:54|65|53|5.89|-0.15|B2.5IV|",
"0:40:26.4|-59:27:16|-1||5.89|0.55|G1V|",
"1:34:16.6|37:14:14|-1||5.88|-0.07|B9IV|",
"1:34:49.1|18:27:38|-1||5.89|1.52|M2IIIab|",
"1:55:54.4|37:16:40|-1||5.89|1.63|gM0|",
"2:0:9.2|3:5:50|65|112|5.88|0.62|G2IV|",
"2:26:35.2|-20:2:34|-1||5.88|1.26|K2III|",
"2:28:48.5|29:55:55|79|13|5.89|0.58|G0V|",
"2:51:41.7|46:50:31|-1||5.88|0.89|G8III|",
"2:59:39.9|41:1:59|-1||5.89|1.44|K2|",
"3:1:37.7|-28:5:30|36|ε|5.89|0.79|G5IV|",
"3:7:19.0|64:3:28|-1||5.89|-0.03|B9V|",
"4:0:48.8|18:11:38|-1||5.89|0.32|F4V|",
"4:7:59.4|17:20:23|-1||5.89|1.5|K5IIIb|",
"4:21:51.8|56:30:24|-1||5.88|0.0|A3V|",
"4:27:28.8|11:12:45|-1||5.88|0.05|B8IV|",
"4:34:38.0|28:57:40|-1||5.88|-0.06|B9pHg|",
"5:7:55.5|21:42:17|77|105|5.89|0.19|B2Ve|",
"5:11:45.3|1:2:13|-1||5.89|0.66|G5III|",
"5:25:59.8|-19:41:44|-1||5.89|0.4|F2V|",
"5:38:1.1|7:32:29|-1||5.88|-0.07|B8III|",
"5:59:21.8|49:55:28|-1||5.89|1.23|G5III|",
"6:14:28.6|17:54:23|-1||5.88|0.22|A5Vm|",
"6:30:47.2|58:9:46|50|6|5.88|0.94|K0III-IV|",
"6:35:17.6|9:59:18|-1||5.88|1.51|K4III|",
"6:57:0.5|33:40:52|-1||5.89|0.88|G5III|",
"7:19:22.4|2:44:26|-1||5.89|1.07|G9III|",
"7:40:58.5|23:1:7|-1||5.89|1.58|K5|",
"7:44:34.2|-37:56:35|-1||5.88|-0.11|B7V|",
"7:46:10.4|-37:56:2|-1||5.88|-0.11|B7V|",
"8:20:26.1|57:44:36|50|30|5.89|0.39|F4V|",
"8:29:46.2|67:17:51|-1||5.88|0.97|G8III|",
"8:37:5.8|9:39:20|11|36|5.88|0.09|A3V|",
"8:56:30.5|40:12:6|-1||5.89|0.35|F3III|",
"9:1:8.5|-68:41:2|-1||5.88|1.63|M1III|",
"9:30:23.4|-58:21:42|-1||5.88|1.7|M2III|",
"9:41:35.2|31:16:41|-1||5.89|1.6|K6III|",
"10:48:14.2|-31:41:18|-1||5.88|0.03|A1V|",
"10:59:30.9|-16:21:14|-1||5.89|1.63|M2III|",
"11:0:11.6|-14:5:0|-1||5.88|1.5|K5III|",
"11:9:38.5|43:12:27|-1||5.89|1.57|M2III|",
"11:16:41.9|49:28:35|-1||5.88|1.08|gK0|",
"11:25:33.1|-37:44:52|-1||5.89|1.54|M3III|",
"11:48:38.7|14:17:3|-1||5.88|0.29|F0V|",
"12:2:37.7|-69:11:32|-1||5.89|-0.08|B9V|",
"12:32:10.0|-73:0:6|-1||5.88|1.11|K1III|",
"12:39:3.5|-30:25:20|-1||5.89|1.21|K2-3III|",
"12:47:18.9|62:46:51|-1||5.89|0.0|A9V|",
"12:50:10.7|37:31:1|-1||5.89|0.15|A3V|",
"12:54:58.5|-44:9:7|-1||5.89|0.64|G1V|",
"13:13:23.5|-50:42:0|-1||5.89|-0.02|B9V|",
"13:14:12.1|-58:41:2|-1||5.89|1.08|K0-1III|",
"13:14:43.1|-48:57:24|-1||5.89|1.06|K1III|",
"13:23:18.9|-4:55:28|85|65|5.89|1.43|K3III|",
"13:26:16.6|46:1:41|-1||5.88|0.97|gK0|",
"13:53:43.1|-53:22:25|-1||5.89|0.01|B5III|",
"14:40:43.9|16:25:4|8|29π2|5.88|0.24|A6V|",
"15:1:13.0|-38:3:30|-1||5.89|1.24|K2-3III|",
"15:12:4.3|18:58:33|-1||5.89|1.53|M4IIIab|",
"15:18:26.2|0:27:41|-1||5.89|1.51|K5III|",
"15:26:14.7|-68:18:33|-1||5.89|1.02|G8-K0III|",
"15:44:1.8|2:30:54|75|23ψ|5.88|0.68|G2.5V|",
"16:8:43.7|-23:41:8|-1||5.88|0.02|B9IVp:|",
"16:22:28.9|-43:54:44|-1||5.88|1.16|G3II|",
"16:54:26.9|-42:28:44|-1||5.88|0.64|F5Ib-II|",
"16:53:25.2|-20:24:56|-1||5.88|0.68|G3V|",
"17:13:17.5|-67:11:48|-1||5.89|1.06|K0-1III|",
"17:16:31.7|1:12:38|-1||5.88|0.06|B5Vnn+B5V|",
"17:31:27.3|-80:51:33|-1||5.88|1.67|M3III|",
"17:22:55.0|-58:0:37|-1||5.88|1.07|G8Ib-II|",
"17:56:19.0|-15:48:45|-1||5.89|0.05|A1V|",
"18:11:45.1|33:26:49|-1||5.88|0.01|A3V|",
"18:22:35.3|12:1:44|-1||5.89|0.04|A2V|",
"18:32:55.3|-73:57:56|-1||5.89|0.98|K0III|",
"18:46:43.1|52:59:17|-1||5.88|-0.09|B2.5Ve|",
"18:48:53.4|19:19:43|-1||5.88|0.03|A1V|",
"19:3:29.7|-68:45:19|-1||5.88|0.56|F8V|",
"18:58:46.9|13:54:24|4|10|5.89|0.25|F0pSrEu|",
"18:58:1.9|38:15:58|-1||5.89|-0.17|B7IV|",
"19:9:57.8|-41:53:33|-1||5.88|-0.08|B6V+F1IV|",
"19:34:8.5|-40:2:5|-1||5.89|0.09|A3III|",
"19:59:47.4|-9:57:30|-1||5.88|0.58|F8V|",
"20:1:44.7|24:48:1|-1||5.88|-0.12|B4V|",
"20:29:20.4|36:27:17|30|42|5.88|0.52|A1Ib|",
"20:50:41.8|-12:32:42|-1||5.88|1.07|gK1|",
"21:4:4.7|-5:49:23|3|12|5.89|0.68|G4III|",
"21:43:4.4|-14:23:59|15|44|5.88|0.25|F0IV|",
"22:13:38.6|28:36:30|-1||5.89|1.15|K2III|",
"22:16:26.5|57:13:13|-1||5.88|0.93|G8III|",
"22:32:26.4|39:46:47|-1||5.88|0.16|A6V|",
"22:34:2.9|-1:34:27|3|60|5.89|0.99|G6III|",
"23:41:8.9|-11:40:50|-1||5.89|1.0|G9III|",
"23:41:56.7|7:15:2|-1||5.89|0.1|A3Vn|",
"0:4:13.6|62:17:16|17|9|5.88|0.3|A1III|",
"0:20:24.4|30:56:9|-1||5.9|-0.1|B7V|",
"0:40:42.4|-4:21:7|-1||5.91|1.1|K0III|",
"0:44:12.1|-38:25:18|73|λ2|5.9|1.16|K1III|",
"0:49:13.9|-24:8:11|-1||5.9|0.95|K2III|",
"1:24:20.6|-6:54:53|-1||5.91|0.41|F3V|",
"1:48:26.0|3:41:8|-1||5.91|0.97|G9III|",
"1:50:57.1|51:56:0|-1||5.9|0.43|F5IV|",
"2:14:32.0|-41:10:0|-1||5.91|0.97|G8III|",
"2:33:7.0|-34:39:0|36|λ1|5.9|1.06|K0III|",
"2:36:57.2|38:43:58|-1||5.9|0.48|F5V|",
"2:55:48.5|18:19:54|6|45ρ2|5.91|1.47|M6-III:|",
"3:1:54.1|26:27:44|6|49|5.9|0.14|A3m|",
"3:13:24.0|48:10:37|-1||5.9|0.97|G9III|",
"3:18:2.8|-28:47:49|-1||5.91|0.33|F3V+A8-9|",
"3:19:55.8|27:4:16|6|59|5.9|0.86|G6IV|",
"3:32:40.0|35:27:42|-1||5.9|-0.06|B1V|",
"3:46:9.5|6:48:11|-1||5.91|0.99|G9III|",
"3:46:27.4|-29:20:17|36|σ|5.9|0.12|A3V|",
"3:48:38.9|0:13:40|-1||5.91|1.23|K3III|",
"4:5:20.2|22:0:32|77|39|5.9|0.62|G5V|",
"4:22:22.8|20:49:17|-1||5.91|1.66|M0IIIab+A,F|",
"4:28:23.4|14:44:27|77|76|5.9|0.32|F0IV|",
"4:44:5.3|-8:30:13|35|56|5.9|-0.11|B2Ve|",
"5:11:19.2|-2:29:27|-1||5.9|0.46|F5V|",
"5:12:48.2|-6:3:26|-1||5.91|0.96|G7III|",
"5:23:18.5|-8:24:57|-1||5.9|-0.03|B8III|",
"5:54:59.0|31:42:6|-1||5.9|0.14|A5IV|",
"5:58:24.4|1:50:13|59|59|5.9|0.21|A5mDelDel|",
"6:15:8.5|13:51:4|-1||5.91|-0.23|B1V|",
"6:15:8.4|-20:16:20|-1||5.91|1.32|K0|",
"6:30:3.0|46:41:8|7|47|5.9|1.44|gK4|",
"6:43:38.7|3:55:56|-1||5.9|-0.02|B0III|",
"7:7:22.3|34:0:34|-1||5.91|1.51|gK4|",
"7:14:15.5|-9:56:51|-1||5.9|1.52|K3III|",
"7:19:47.6|7:8:34|-1||5.91|0.53|F8V|",
"7:26:42.3|-34:8:27|-1||5.9|-0.17|B2IV-V|",
"7:32:5.8|-8:52:51|-1||5.9|0.54|F5V|",
"7:36:34.7|5:51:42|-1||5.91|0.6|G0V|",
"7:47:12.5|-22:31:11|-1||5.9|-0.19|B2IV-V|",
"7:50:23.9|-50:30:35|-1||5.91|1.09|K2III|",
"8:22:49.9|-26:20:53|-1||5.9|0.37|F3Ib|",
"8:32:55.0|38:0:59|-1||5.9|1.11|K2III|",
"8:39:17.6|52:42:42|-1||5.91|1.17|gK1|",
"8:41:5.3|-48:55:21|-1||5.9|-0.21|B1.5V|",
"8:52:38.6|-48:21:33|-1||5.91|-0.15|B3Vn|",
"9:28:30.6|-66:42:7|-1||5.91|0.01|A0V|",
"9:33:26.2|-22:51:50|-1||5.91|0.02|A0Vn|",
"10:10:7.5|-8:24:30|76|17|5.91|0.02|A1V|",
"10:13:45.9|-40:20:45|-1||5.9|1.21|K1III|",
"10:23:6.3|33:54:29|46|27|5.9|0.14|A6V|",
"10:31:51.4|32:22:46|46|33|5.9|0.11|A0IV|",
"10:32:33.6|-44:37:8|-1||5.91|0.92|G6-8III|",
"10:38:2.5|-57:15:23|-1||5.91|-0.14|B3IV|",
"10:49:24.1|-59:19:25|-1||5.91|0.0|B9.5IV-V|",
"10:55:42.4|0:44:13|45|55|5.91|0.42|F2/3III/V|",
"10:57:7.9|-50:45:54|-1||5.91|0.18|A4V|",
"11:18:55.0|1:39:2|45|76|5.91|1.04|gK0|",
"11:32:19.9|-66:57:44|-1||5.9|1.13|K1IIICNIb-II|",
"11:54:59.8|-63:16:44|-1||5.91|0.19|A3Ib|",
"12:18:40.3|0:47:14|85|13|5.9|0.17|A5Vn|",
"12:53:49.1|-60:22:37|29|κ|5.9|0.2|B5Ia|",
"13:9:47.8|16:50:55|-1||5.91|1.45|K5III|",
"13:11:51.6|-69:56:31|-1||5.91|0.42|F3IV-V|",
"13:10:3.2|38:29:56|12|17|5.91|0.29|A9III-IV|",
"13:12:48.9|-66:13:37|-1||5.9|0.06|A0Vm:|",
"13:34:40.5|-13:12:52|-1||5.91|0.02|A2pSrEu:Cr:|",
"13:37:23.7|-46:25:42|-1||5.9|-0.12|B8V|",
"13:47:27.6|-50:14:58|-1||5.91|0.29|A3mA5F0|",
"13:42:39.3|78:3:52|-1||5.91|1.01|gG7|",
"13:53:10.3|28:38:53|-1||5.9|0.2|A7V|",
"13:56:27.9|1:3:2|85|92|5.91|0.2|A8V|",
"13:59:17.3|-50:22:12|-1||5.91|0.96|G8-K0III|",
"14:13:40.8|0:50:44|-1||5.91|0.47|F7Vw|",
"14:18:38.3|-18:42:58|-1||5.9|0.0|A0pCrEu|",
"14:38:14.0|18:17:54|-1||5.91|1.1|gK2|",
"14:40:42.4|13:32:3|-1||5.91|0.21|F0V|",
"14:48:44.4|-66:35:38|-1||5.91|-0.07|B2.5Ve|",
"15:11:8.3|-84:47:15|57|ω|5.91|-0.06|B9.5V|",
"15:27:51.4|60:40:13|-1||5.9|1.44|K5III|",
"16:4:36.7|-37:51:47|-1||5.9|0.4|F3IV|",
"16:8:58.9|3:27:16|-1||5.91|1.47|gK5|",
"16:19:11.2|49:2:17|-1||5.91|1.37|gK6|",
"16:41:23.3|-68:17:46|80|η1|5.91|-0.08|B7IVe|",
"16:39:5.2|-37:13:3|-1||5.91|0.0|B9-A0V+B|",
"16:49:34.6|13:15:41|-1||5.91|0.03|A1V|",
"17:3:50.8|-38:9:8|-1||5.91|0.38|F4IV+F2V|",
"17:19:12.4|-59:41:40|-1||5.91|1.37|K2IIICNIb-II|",
"17:18:57.2|-34:59:23|-1||5.91|1.04|K3V+K5V|",
"17:52:13.6|-34:47:57|-1||5.9|-0.1|B6V|",
"18:7:49.5|26:5:51|39|100|5.9|0.14|A3V|",
"18:29:35.7|23:51:58|-1||5.9|-0.1|B6IV|",
"18:46:28.5|0:57:42|4|5|5.9|0.13|A2Vm|",
"18:49:45.9|32:48:46|51|8ν1|5.91|-0.16|B3IV|",
"19:20:16.1|57:38:43|-1||5.91|1.58|M1IIIab|",
"19:45:39.9|7:36:48|4|49υ|5.91|0.18|A3IV|",
"19:52:7.2|47:55:55|-1||5.91|-0.18|B2III|",
"20:0:58.9|8:33:29|-1||5.91|1.52|K5III|",
"20:16:0.6|45:34:46|-1||5.91|0.38|F5V:|",
"20:23:44.4|37:28:35|-1||5.9|-0.2|B2Ven|",
"20:38:18.6|-81:17:20|-1||5.91|1.71|K5III|",
"20:29:27.1|56:4:5|-1||5.91|-0.04|B9Vne|",
"20:38:35.1|23:40:50|-1||5.91|0.98|K0II-III+A3V|",
"20:56:25.9|49:11:45|-1||5.9|1.04|G8II-III|",
"21:3:47.6|53:17:10|-1||5.9|0.99|K0III|",
"21:5:29.3|78:7:35|-1||5.91|-0.07|B8Vn|",
"21:55:11.5|-61:53:11|-1||5.9|0.39|F1III|",
"22:41:57.4|14:30:59|-1||5.9|1.11|gK0|",
"22:48:10.9|37:25:0|-1||5.9|1.03|gG8|",
"22:55:2.6|37:4:37|-1||5.91|0.42|F5II|",
"22:51:2.2|85:22:25|-1||5.9|1.32|K5|",
"23:49:41.0|36:25:31|-1||5.9|0.79|G1III|",
"0:33:10.4|54:53:42|-1||5.93|1.04|K0III|",
"0:35:32.8|0:30:20|20|14|5.93|0.44|F5IV|",
"0:48:17.4|7:18:0|65|62|5.93|1.1|G8III|",
"1:3:37.0|61:4:30|-1||5.92|0.49|F0II|",
"1:12:45.4|-37:51:23|-1||5.92|0.28|F0III|",
"1:25:5.3|-64:22:10|-1||5.93|1.56|K5III|",
"1:30:22.9|-26:12:28|-1||5.93|1.34|K4III|",
"1:36:27.2|48:43:22|-1||5.92|1.21|gK1|",
"2:3:48.2|0:20:25|20|61|5.93|0.88|G5II-III+G5V|",
"2:11:35.8|-1:49:31|20|63|5.93|0.97|gG9|",
"2:22:54.6|-51:5:32|-1||5.92|0.22|A5V|",
"2:30:32.4|25:14:6|-1||5.92|0.41|F6IV|",
"2:50:14.8|-35:50:37|36|η2|5.92|0.9|K0III|",
"2:53:34.4|-38:26:13|36|ψ|5.92|0.44|F6IV|",
"3:12:25.8|-44:25:11|-1||5.93|0.44|F7III+A0V|",
"3:21:52.6|49:4:15|-1||5.93|0.43|F6V|",
"3:26:22.5|-27:19:3|-1||5.93|0.94|G5III|",
"3:34:26.6|24:27:52|77|7|5.92|0.13|A3V+A3V|",
"3:53:33.3|-46:53:37|-1||5.93|1.24|K2III|",
"4:0:40.7|-30:29:27|-1||5.93|0.04|A2V|",
"4:20:14.4|41:48:29|-1||5.92|0.94|K0III|",
"4:38:15.8|20:41:5|-1||5.92|-0.05|B8V|",
"5:1:50.3|0:43:20|-1||5.92|1.27|K0|",
"5:34:4.0|-1:28:14|-1||5.93|1.55|K5III|",
"5:41:5.6|0:20:16|-1||5.93|0.3|F0IV|",
"5:54:56.7|19:44:59|59|57|5.92|-0.17|B2V|",
"6:4:40.2|-45:4:44|-1||5.93|0.49|F4V|",
"6:9:32.4|22:11:24|-1||5.93|1.63|K4I|",
"6:16:7.7|-16:37:4|-1||5.92|-0.17|B2.5Vn|",
"6:30:11.3|-10:4:53|-1||5.93|1.38|K0|",
"6:30:46.3|-27:46:10|-1||5.93|-0.15|B2.5V|",
"6:40:32.2|71:44:56|-1||5.92|1.19|K0III|",
"6:46:32.4|8:35:14|54|16|5.93|-0.17|B2.5V|",
"6:45:22.8|-31:47:37|-1||5.92|0.48|F6V|",
"6:56:25.8|9:57:23|-1||5.92|-0.08|B8Vn|",
"7:3:30.4|29:20:14|-1||5.93|0.6|G4V|",
"7:12:12.2|-25:56:33|13|26|5.92|-0.17|B2V|",
"7:17:33.7|52:7:51|-1||5.92|1.26|gK1|",
"7:26:56.3|20:15:26|37|61|5.93|0.3|F2Vn|",
"7:36:47.0|55:45:19|-1||5.92|1.12|K2III|",
"7:37:53.9|48:46:25|-1||5.92|0.22|A5m|",
"7:40:13.6|-19:39:39|-1||5.93|1.16|K0|",
"7:46:40.1|65:27:21|10|51|5.92|1.18|gK2|",
"7:49:14.7|-35:14:36|-1||5.93|-0.05|B9V|",
"8:10:3.8|58:14:53|-1||5.93|1.39|gK4|",
"9:8:51.1|33:52:56|-1||5.93|0.6|F9V|",
"9:13:34.5|-47:20:19|-1||5.92|-0.05|B9Ve|",
"9:28:47.0|-62:16:23|-1||5.92|1.1|K1III|",
"9:31:32.2|-31:52:19|1|ζ2|5.93|0.26|A9IV|",
"9:57:13.6|57:25:6|-1||5.93|0.89|G5III|",
"9:53:50.2|-51:8:49|-1||5.93|-0.15|B2III|",
"10:38:59.4|-58:49:1|-1||5.92|1.65|M1III|",
"10:48:40.6|-1:57:32|-1||5.93|1.6|M2III|",
"10:53:30.7|69:51:14|-1||5.93|0.99|G9IV|",
"10:54:29.6|-61:49:36|-1||5.93|1.75|K4III|",
"10:55:17.2|-60:31:1|-1||5.92|1.08|K0III|",
"11:55:40.1|-28:28:37|-1||5.93|1.5|K5III|",
"12:12:22.0|-62:57:3|-1||5.92|0.29|B8Ia-Iab|",
"12:21:57.5|-56:22:29|-1||5.92|1.57|K4III+F:|",
"12:43:38.1|-1:34:37|-1||5.93|0.86|G8IIIp|",
"12:53:3.9|-54:57:9|-1||5.93|1.31|K2III|",
"12:56:31.5|-72:11:7|-1||5.93|1.13|G8III|",
"14:3:26.2|-56:12:49|-1||5.92|1.22|K2III|",
"14:32:32.5|22:15:36|8|26|5.92|0.35|F2IV|",
"15:0:11.8|-77:9:37|-1||5.93|1.05|G8II|",
"14:59:23.1|4:34:4|-1||5.93|1.6|M2III|",
"15:1:27.1|60:12:16|-1||5.93|0.09|A4V|",
"15:36:29.3|16:7:8|75|18τ5|5.93|0.29|F3V|",
"15:46:34.8|55:28:29|-1||5.92|1.39|gK3|",
"16:2:5.5|52:54:57|-1||5.93|1.48|gK5|",
"16:6:6.3|-23:36:23|-1||5.92|-0.08|B8p|",
"16:14:22.3|-33:0:41|-1||5.92|1.02|K0III|",
"16:25:35.1|-23:26:46|58|5ρ|5.92|0.0|B2V|",
"16:41:36.7|26:55:1|39|39|5.92|0.4|F2III|",
"17:3:39.3|13:36:19|-1||5.93|0.0|A1V|",
"17:22:54.9|-37:13:14|-1||5.93|1.08|K1III|",
"17:27:12.4|-50:37:49|-1||5.92|0.08|B9II|",
"17:37:27.2|-50:3:36|-1||5.93|1.1|K0III|",
"17:50:28.2|-53:36:44|-1||5.92|-0.08|B2V+B3V|",
"18:27:49.5|-29:48:59|-1||5.92|0.52|F9V|",
"18:56:0.6|-23:10:25|-1||5.93|-0.02|B8|",
"19:3:57.4|-51:1:7|-1||5.93|1.24|K0-1III|",
"19:14:39.7|-45:11:36|-1||5.92|0.9|G8III|",
"19:12:36.7|21:33:16|-1||5.93|0.03|A2Vn|",
"19:25:4.1|-29:18:33|-1||5.93|1.26|K3III|",
"19:44:18.5|69:20:13|-1||5.92|0.05|A2III|",
"19:52:12.0|-19:2:42|71|57|5.92|0.98|G5III|",
"19:59:20.5|45:46:20|-1||5.92|0.16|A5III|",
"20:12:0.7|26:28:44|87|20|5.92|-0.11|B7Ve|",
"20:17:31.3|66:51:14|-1||5.93|0.58|G3V|",
"20:22:45.3|41:1:34|-1||5.93|1.6|K7III|",
"20:46:10.0|-21:30:51|15|17|5.93|0.04|A0|",
"21:28:59.9|22:10:46|-1||5.93|1.53|M4.5III-IIIa|",
"21:58:53.4|62:41:54|-1||5.93|1.67|M3IIIab|",
"22:12:8.0|24:57:0|-1||5.92|1.51|K0|",
"22:23:32.1|-7:11:40|-1||5.93|1.0|G6IIIBaII|",
"22:40:18.4|53:50:46|-1||5.93|0.93|K0III|",
"22:50:21.8|41:57:13|44|14|5.92|0.08|B3IV:|",
"23:16:39.7|-44:29:21|-1||5.92|1.06|K1III|",
"23:19:24.1|-18:4:31|-1||5.93|1.52|gK3|",
"23:52:55.6|-3:9:20|65|24|5.93|1.07|G9III|",
"0:7:46.8|-22:30:32|-1||5.94|0.14|A2Vp:|",
"0:13:42.1|-26:1:19|-1||5.94|1.55|K5III|",
"0:30:19.9|59:58:38|-1||5.94|0.01|B9IIIn|",
"0:44:57.1|-42:40:36|-1||5.94|0.28|F0V|",
"1:10:33.6|2:26:44|20|33|5.95|1.51|K4III|",
"1:11:43.5|-2:15:4|20|34|5.94|1.4|K4III|",
"1:38:27.4|-36:31:42|-1||5.94|1.05|K0IV|",
"1:48:38.9|37:57:10|-1||5.94|0.97|K0III|",
"1:50:52.0|11:2:36|-1||5.94|0.3|F2Vw|",
"1:50:54.5|-50:12:22|-1||5.94|0.14|A1Vp|",
"2:2:35.2|13:28:36|-1||5.94|1.59|M2III|",
"2:44:49.7|67:49:29|-1||5.95|0.1|A5III|",
"2:53:35.3|-22:22:35|-1||5.95|1.04|K0III|",
"3:0:44.1|10:52:13|-1||5.95|1.59|K6|",
"3:11:42.8|81:28:14|-1||5.95|0.15|A7III-IV|",
"3:30:45.4|6:11:19|-1||5.94|0.96|G8III|",
"4:9:1.6|13:23:54|-1||5.95|0.05|B9.5V|",
"4:17:19.2|-6:28:19|-1||5.94|1.08|gG8|",
"4:33:30.7|72:31:43|-1||5.94|0.3|A8m|",
"4:25:5.3|-61:14:18|-1||5.94|1.54|K4-5III|",
"4:36:24.2|64:15:42|-1||5.94|-0.03|A1V|",
"5:0:18.3|39:23:41|7|5|5.95|0.41|F5V|",
"5:2:22.8|-31:46:17|-1||5.94|1.17|G8III|",
"5:24:38.5|31:8:35|-1||5.94|0.04|B9III|",
"5:26:48.9|34:23:30|-1||5.94|0.14|A0III|",
"5:30:26.1|15:21:37|-1||5.94|0.14|A3Vn|",
"5:37:4.4|11:2:6|-1||5.94|1.58|K4III|",
"5:46:30.4|56:6:56|10|26|5.94|0.17|A4Vn|",
"5:46:35.0|1:10:5|-1||5.95|0.78|G4V|",
"5:52:20.3|-57:9:22|-1||5.94|0.66|F7IV|",
"6:22:3.6|59:22:20|50|4|5.94|0.0|A3V|",
"6:37:41.4|61:28:52|50|8|5.94|0.89|G8IV-V|",
"7:2:25.5|17:45:20|-1||5.94|1.63|M1|",
"7:15:43.1|-10:35:2|-1||5.95|1.18|K0|",
"7:14:57.1|-41:25:33|-1||5.94|-0.16|B4III-IV|",
"7:27:42.9|-22:51:35|-1||5.95|-0.09|B5V:|",
"7:41:35.2|3:37:29|-1||5.94|-0.04|A0V|",
"8:1:37.4|-37:17:1|-1||5.95|0.14|A3IV|",
"8:4:42.4|-50:35:26|-1||5.95|1.21|G5II|",
"8:23:21.8|18:19:56|11|20|5.95|0.17|A9V|",
"8:28:37.3|14:12:39|11|29|5.95|0.19|A5V|",
"8:38:19.0|32:48:7|-1||5.94|1.12|gK2|",
"8:52:35.8|28:19:51|11|55ρ1|5.95|0.87|G8V|",
"9:5:24.1|48:31:49|-1||5.95|0.45|F6II-III|",
"9:10:38.7|30:57:47|-1||5.95|1.67|M6IIIase|",
"9:32:55.8|-13:31:1|-1||5.94|1.5|K5III|",
"9:39:27.9|67:16:20|-1||5.94|1.52|K5|",
"9:53:42.9|5:57:30|-1||5.95|1.66|M2III|",
"10:2:0.0|-60:25:15|-1||5.94|0.26|A9IV|",
"10:24:59.4|-58:34:35|-1||5.95|0.32|F2III|",
"10:51:5.4|-3:5:33|-1||5.95|1.48|K2|",
"11:3:36.6|0:0:3|45|62|5.95|1.22|K3III|",
"11:27:9.5|-12:21:24|28|16κ|5.94|0.49|F4III-IV|",
"11:30:31.1|43:10:24|82|58|5.94|0.49|F4V|",
"11:32:47.5|-7:49:39|-1||5.95|1.38|K4III|",
"11:34:42.5|16:47:49|45|90|5.95|-0.16|B4V|",
"12:9:41.3|1:53:52|85|10|5.95|1.12|K3III|",
"12:25:11.7|-11:36:37|-1||5.95|0.03|A1V|",
"12:31:55.8|-63:30:22|-1||5.95|0.27|A8III|",
"12:44:59.5|39:16:44|12|10|5.95|0.55|G0V|",
"13:9:45.3|-10:19:46|85|50|5.94|1.49|K5III|",
"13:46:19.0|38:30:14|-1||5.94|0.94|G9III|",
"13:46:43.3|25:42:8|8|3|5.95|0.49|G5III+A7V:|",
"13:55:38.7|-82:39:58|-1||5.95|1.46|K2.5IIIaCH-3Ba0.5|",
"14:19:23.9|-37:0:13|-1||5.94|0.08|A2Vn|",
"14:24:0.9|8:14:37|-1||5.95|0.06|A3V|",
"14:29:50.5|0:49:44|-1||5.94|0.16|A5IV|",
"14:47:5.1|-38:17:27|-1||5.94|1.33|K3III|",
"15:15:53.8|-48:4:27|-1||5.95|0.21|A3m|",
"15:41:54.6|-76:4:55|-1||5.95|-0.04|B9V|",
"15:39:56.5|-59:54:30|-1||5.95|0.48|F6V|",
"15:44:22.6|-41:49:10|-1||5.94|0.0|A0V+B|",
"15:55:0.3|-19:22:59|48|47|5.94|-0.01|B5V|",
"16:19:0.4|-14:52:21|-1||5.94|1.52|K4III|",
"16:32:25.7|60:49:24|-1||5.94|0.02|A2V|",
"16:54:0.5|-57:54:34|-1||5.94|1.59|M1III|",
"16:56:28.7|-52:17:2|-1||5.94|-0.08|B9V|",
"17:18:23.3|38:48:41|-1||5.94|1.0|gG7|",
"17:28:38.7|-55:10:11|-1||5.94|1.11|G8II-III|",
"17:31:23.0|-56:55:14|-1||5.95|-0.08|B7II-III|",
"17:26:46.2|34:41:45|-1||5.94|-0.01|A0V|",
"17:37:36.2|-15:34:16|-1||5.94|0.37|F0IV|",
"17:41:32.3|6:18:46|-1||5.95|1.26|G7III|",
"17:47:36.8|-14:43:33|-1||5.94|0.05|B9pHgMn|",
"17:52:35.4|1:18:18|-1||5.95|1.58|K5III|",
"18:3:5.0|-8:10:49|58|69τ|5.94|0.0|F5V|",
"18:6:23.7|-36:1:11|-1||5.95|0.62|G5V|",
"18:10:31.6|54:17:12|-1||5.95|0.94|K1III|",
"18:15:12.9|-20:23:17|71|16|5.95|0.02|O9.5II|",
"18:29:19.5|-80:13:58|-1||5.95|1.16|K2III|",
"18:15:17.0|68:45:21|33|37|5.95|1.06|gK1|",
"18:31:57.0|-1:0:11|75|61|5.94|0.16|A4III|",
"18:37:54.4|-21:23:52|-1||5.94|0.19|A8IIIn|",
"19:42:44.6|32:25:36|-1||5.94|0.11|A5III|",
"19:50:13.8|-47:33:26|-1||5.94|1.7|M1III|",
"19:47:48.6|25:23:2|-1||5.95|0.99|K0II-III|",
"20:0:15.9|-37:42:8|-1||5.95|1.0|G8III|",
"20:20:0.2|13:32:53|-1||5.95|0.31|A5-F2m|",
"20:29:53.9|-18:35:0|15|12ο|5.94|0.08|A3Vn|",
"20:40:3.1|43:27:31|-1||5.95|1.19|K2III|",
"21:2:27.2|-38:31:50|-1||5.94|1.11|K0IV|",
"21:5:26.7|5:57:30|34|4|5.94|0.54|F8V|",
"21:15:42.2|77:0:44|-1||5.95|1.5|K5III|",
"21:25:47.0|36:40:3|30|69|5.94|-0.08|B0Ib|",
"21:44:31.3|14:46:19|-1||5.94|0.59|G0V|",
"21:44:53.3|62:27:38|-1||5.95|0.31|O9Ib-II|",
"22:3:3.8|-76:7:7|-1||5.95|0.39|F3III|",
"22:11:51.3|16:2:26|-1||5.95|0.95|K1III|",
"22:19:0.8|-13:18:18|3|45|5.95|1.06|gG7|",
"22:29:46.0|-27:6:26|-1||5.95|0.33|F1V|",
"22:41:36.1|41:32:58|-1||5.94|0.0|G9III|",
"22:44:5.2|39:27:56|-1||5.95|1.48|K5III+K2III|",
"23:1:31.7|-4:42:41|-1||5.94|1.0|K0|",
"23:10:27.2|43:32:39|0|6|5.94|0.44|F5IV|",
"23:39:10.4|75:17:34|-1||5.95|0.13|A3V|",
"23:46:36.7|66:46:56|-1||5.95|-0.04|B2IV|",
"23:50:14.7|-9:58:27|-1||5.94|1.13|K0IV|",
"0:6:16.0|58:26:12|-1||5.96|0.67|G5V|",
"0:21:28.6|-77:25:37|-1||5.97|1.4|K3III|",
"0:58:31.1|66:21:8|-1||5.97|-0.02|A0III|",
"1:23:24.9|20:28:8|-1||5.97|1.71|K5|",
"1:26:18.6|43:27:28|-1||5.96|0.49|F7V|",
"1:39:40.8|16:24:21|65|105|5.97|1.12|K2III|",
"2:12:37.5|24:10:4|-1||5.96|1.37|K0|",
"2:56:13.8|8:22:54|-1||5.97|0.48|F7IV|",
"3:17:45.8|39:17:0|-1||5.96|0.07|A2IV|",
"3:25:36.2|-69:20:11|-1||5.96|0.42|F3-5IV|",
"3:31:20.8|27:34:19|-1||5.96|0.0|A2V|",
"3:39:1.1|-5:37:34|35|21|5.96|0.92|K1V|",
"3:53:10.0|17:19:37|-1||5.97|0.34|F4V|",
"4:28:39.0|-19:27:30|-1||5.96|1.22|K1III|",
"4:30:40.3|-35:39:13|-1||5.96|1.0|K0II|",
"4:46:44.4|40:18:46|-1||5.97|0.93|G9III|",
"4:52:47.1|27:53:51|-1||5.97|0.37|F2IV|",
"5:4:39.8|74:4:1|-1||5.96|0.0|A1V|",
"5:7:25.0|-12:29:26|-1||5.97|0.6|F7V|",
"5:16:18.2|34:18:43|-1||5.96|0.22|O9.5V|",
"5:18:50.4|-18:7:48|-1||5.96|0.58|G0V|",
"5:39:18.4|29:12:55|-1||5.96|0.16|B2IV-V|",
"5:38:37.8|-6:34:26|-1||5.96|-0.23|B1.5IV|",
"5:48:34.9|-4:5:41|-1||5.97|0.64|G4V|",
"5:50:13.1|4:25:24|-1||5.97|1.36|gK2|",
"5:52:7.6|-9:2:29|-1||5.97|0.1|A2Vnp|",
"5:56:14.3|-22:50:25|-1||5.96|1.11|K0V|",
"6:1:43.1|48:57:34|-1||5.96|1.45|K0|",
"6:28:14.6|70:32:8|-1||5.97|0.0|A4V|",
"6:36:46.7|-13:19:15|-1||5.97|1.56|K5|",
"6:39:47.6|12:58:59|-1||5.97|0.06|A2V|",
"6:51:42.3|-36:13:49|-1||5.96|0.18|A3V|",
"6:58:57.0|3:36:8|-1||5.97|1.06|G8III|",
"7:0:23.7|-8:24:25|-1||5.96|-0.08|B9III|",
"7:3:17.9|9:8:18|-1||5.97|0.12|A3Vs|",
"7:7:13.3|-51:58:4|-1||5.96|1.0|K0III|",
"7:12:25.7|-36:32:40|-1||5.96|-0.14|B3V|",
"7:15:21.0|-52:29:59|-1||5.97|1.1|K1III|",
"7:25:51.0|-5:46:30|-1||5.97|0.92|G3Ib|",
"7:30:30.9|-54:23:58|-1||5.96|1.56|M1III|",
"8:22:54.0|-7:32:36|-1||5.96|1.67|M1III|",
"8:21:12.0|-57:58:23|-1||5.97|-0.09|B1.5III|",
"8:25:51.6|-64:36:3|-1||5.97|0.96|G8-K0III|",
"8:33:38.3|-38:50:56|-1||5.96|-0.14|B5III|",
"8:35:28.8|-26:50:37|-1||5.96|0.37|A1V+G-KIII|",
"8:56:34.1|-16:42:34|-1||5.96|1.54|K0|",
"9:15:52.6|72:56:46|-1||5.96|0.18|F0III|",
"9:15:14.3|34:38:1|-1||5.97|0.86|G6III|",
"9:17:31.2|46:49:2|-1||5.97|0.04|A1V|",
"9:49:28.1|-37:11:11|-1||5.97|1.24|K1III|",
"10:16:32.3|23:30:11|45|35|5.97|0.67|G1.5IV-V|",
"10:21:3.4|68:44:51|-1||5.96|0.2|A7Vn|",
"10:18:28.2|-41:40:6|-1||5.96|-0.06|B9V|",
"10:23:26.5|-4:4:27|76|25|5.97|-0.1|B9pSiCr:Sr:|",
"10:41:51.3|-79:47:0|-1||5.97|-0.07|B4IVe|",
"11:37:48.4|-67:37:13|-1||5.96|1.02|K0III|",
"11:40:42.6|-53:58:7|-1||5.96|1.66|M1III|",
"11:59:17.6|33:10:3|-1||5.96|1.15|K1III|",
"12:4:57.1|-60:58:9|-1||5.96|1.67|M2III|",
"12:20:10.7|-22:10:32|-1||5.97|0.82|G3IV|",
"13:1:9.6|17:7:23|24|38|5.96|0.96|K0III|",
"13:26:11.4|-1:11:33|-1||5.97|0.19|A7III|",
"13:49:45.5|61:29:21|-1||5.96|0.96|G3V|",
"14:0:52.2|-66:16:7|-1||5.97|0.35|F2III|",
"14:31:10.8|-38:52:11|-1||5.97|1.06|K1III|",
"15:6:33.3|-30:55:8|-1||5.96|-0.08|A0pSi|",
"15:35:16.3|53:55:19|-1||5.97|1.18|gK4|",
"16:9:11.2|6:22:44|-1||5.97|1.0|K1.5IV|",
"16:44:39.8|-53:9:9|-1||5.96|1.26|G8III|",
"16:53:42.5|-43:3:3|-1||5.96|1.73|M3II-III|",
"17:0:36.9|-35:56:3|-1||5.97|1.16|K2IIICNII|",
"17:8:47.5|-30:24:13|-1||5.97|0.25|A/FmDelDel|",
"17:15:35.9|-38:35:38|-1||5.96|0.58|F7V+G2V|",
"17:15:41.6|23:44:34|-1||5.96|1.31|K2III|",
"17:51:32.8|-40:46:21|-1||5.96|1.59|M2III|",
"17:53:54.9|-34:45:9|-1||5.96|-0.01|B9V+B9V|",
"17:54:27.2|-34:27:59|-1||5.96|-0.01|B9.5V|",
"17:57:4.3|0:3:59|-1||5.97|0.1|A3V|",
"18:3:52.4|-24:21:38|71|9|5.97|0.0|O4V((f))|",
"18:29:46.8|-14:34:54|-1||5.96|-0.04|B9pSiCr|",
"19:6:55.6|-48:17:57|-1||5.97|-0.02|A0V|",
"19:5:41.2|-15:39:37|-1||5.97|-0.02|B9V|",
"19:31:10.9|-68:26:2|-1||5.96|1.64|K4-5III|",
"19:33:41.6|49:15:45|-1||5.96|1.64|M4.5IIIaS|",
"19:40:7.1|-23:25:43|-1||5.97|1.04|gK1|",
"19:41:48.9|50:31:31|30|16|5.96|0.64|G1.5Vb|",
"19:58:28.7|63:32:3|-1||5.96|0.09|A3V|",
"20:3:16.4|18:30:2|-1||5.96|1.42|K3II-III+G8IV|",
"20:39:5.0|15:50:17|-1||5.97|-0.14|B3V|",
"20:29:27.5|81:5:29|33|74|5.96|0.92|K0III+F8V|",
"20:56:34.7|44:55:30|-1||5.96|0.05|O6V((f))|",
"21:1:12.9|36:1:34|-1||5.97|0.98|G5III|",
"21:13:18.9|-36:25:26|-1||5.96|0.98|K0III|",
"21:18:52.0|11:12:12|-1||5.96|1.65|K5III|",
"21:32:14.6|-33:56:41|66|6|5.97|0.05|A2IV|",
"21:24:49.7|80:31:29|-1||5.97|0.92|gG6|",
"22:4:36.8|-26:49:21|-1||5.96|-0.14|B4IVne|",
"22:35:36.5|-23:59:28|-1||5.97|0.99|gK0|",
"22:40:48.9|-57:25:20|-1||5.97|1.46|K4III|",
"22:51:20.9|-29:32:10|66|21|5.97|0.91|G8/K0III|",
"23:2:44.3|-20:52:14|-1||5.97|0.94|K0III-IV|",
"23:34:49.4|-15:14:45|-1||5.96|1.36|K0|",
"23:39:55.1|9:40:38|-1||5.97|0.2|A2IVm|",
"23:49:39.4|28:50:33|61|79|5.97|0.19|A2m|",
"23:57:3.6|42:39:30|-1||5.97|0.69|F8III|",
"23:57:19.9|-62:57:23|-1||5.97|0.11|A1IV|",
"0:8:17.4|-8:49:26|-1||5.99|1.04|gG8|",
"0:27:14.7|-25:32:50|-1||5.98|1.03|G8III|",
"0:42:41.8|-60:15:45|-1||5.98|1.32|K5III|",
"0:47:23.6|6:44:27|65|60|5.99|0.94|G8III|",
"0:58:14.2|33:57:3|-1||5.98|1.0|K0|",
"1:2:54.3|41:20:42|0|39|5.98|0.16|A5m|",
"1:4:2.4|52:30:8|-1||5.99|1.47|K2|",
"1:14:7.6|16:8:1|65|87|5.98|-0.08|B8III|",
"1:41:39.2|30:2:50|-1||5.99|1.01|K0III|",
"2:18:4.5|57:31:0|62|7|5.98|1.05|G7III|",
"2:41:34.0|-14:32:58|-1||5.98|0.43|F5III:|",
"3:10:38.9|11:52:21|-1||5.98|-0.06|B8V|",
"3:29:39.1|-6:48:18|-1||5.99|1.02|G5|",
"3:33:39.0|54:58:29|-1||5.98|0.11|A3V|",
"3:30:37.0|-47:22:31|-1||5.99|0.11|A1V|",
"4:23:32.4|20:58:56|-1||5.99|0.03|B8IV-V|",
"4:24:57.1|19:2:30|-1||5.98|0.37|F4V|",
"4:41:50.3|38:16:49|-1||5.99|0.57|G0V|",
"4:54:50.7|0:28:3|-1||5.99|-0.12|B5V|",
"5:19:23.7|-27:22:8|-1||5.99|-0.04|A0V|",
"5:50:30.0|2:1:28|-1||5.98|0.91|G8III+A0IV|",
"5:52:40.1|33:55:3|-1||5.98|1.6|M1.5II-III|",
"5:56:28.0|9:30:35|-1||5.99|-0.07|A0IV|",
"6:1:10.2|31:2:5|-1||5.98|0.08|A2V|",
"6:15:29.7|-4:54:55|-1||5.99|0.09|A5IVs|",
"6:15:17.5|-18:28:36|-1||5.99|1.06|K0|",
"6:25:13.1|7:5:9|-1||5.98|1.22|F7Iab-K1Iab|",
"6:23:37.7|-52:10:52|-1||5.98|1.04|G8III|",
"7:3:51.6|12:35:40|-1||5.98|1.58|K5|",
"7:22:3.5|0:10:38|-1||5.99|-0.07|B8III|",
"7:51:56.7|19:19:31|-1||5.99|1.13|gK1|",
"7:58:31.5|16:31:7|-1||5.99|1.47|K0|",
"8:1:30.3|16:27:19|11|5|5.99|-0.02|B9.5Vn|",
"7:59:1.8|-45:12:58|-1||5.99|-0.14|B4V|",
"8:6:18.4|22:38:8|11|9μ1|5.99|1.66|M3III|",
"8:20:40.3|72:24:26|-1||5.98|1.54|M0III|",
"8:18:23.9|-12:37:55|-1||5.98|0.76|G7.5V|",
"8:20:32.1|24:1:20|11|19λ|5.98|-0.03|B9.5V|",
"8:25:55.6|-14:55:47|-1||5.98|0.17|A5m|",
"8:24:57.2|-42:46:10|-1||5.98|-0.17|B3V|",
"8:29:45.6|-46:19:55|-1||5.99|-0.15|B5III|",
"8:35:51.0|6:37:12|-1||5.99|0.52|F8V|",
"8:52:11.6|45:18:45|-1||5.99|1.26|K0III|",
"8:52:10.0|42:0:9|-1||5.99|1.25|K0III|",
"9:8:47.3|26:37:45|11|75|5.98|0.66|G5IV-V|",
"9:24:5.7|-61:38:56|-1||5.99|1.06|K0III|",
"9:37:28.3|-36:5:45|-1||5.98|1.12|K2III|",
"10:10:37.9|-41:42:54|-1||5.98|1.24|K2-3III|",
"10:53:42.0|-70:43:13|-1||5.99|-0.02|B6V|",
"11:19:16.5|-64:34:57|-1||5.99|0.46|F6IV|",
"11:34:29.5|-32:49:53|-1||5.98|0.81|K0V|",
"11:43:27.2|-37:11:25|-1||5.98|1.46|K3III|",
"12:41:16.2|-13:0:54|-1||5.98|0.42|F5V|",
"12:51:56.8|-39:40:51|-1||5.98|-0.1|B8V|",
"13:0:35.9|-3:22:7|85|46|5.99|1.12|K2III|",
"13:7:24.2|-59:51:38|-1||5.99|0.48|F8-G2+B9IV|",
"13:6:21.2|21:9:12|24|39|5.99|0.39|F4V|",
"13:37:6.0|-44:8:36|-1||5.98|0.94|G8-K0III|",
"13:42:55.0|-41:24:4|-1||5.98|1.02|K0III|",
"13:43:40.0|-42:4:3|-1||5.98|-0.08|B8III|",
"13:42:43.4|34:59:20|-1||5.98|0.85|G5III|",
"13:42:23.1|82:45:9|-1||5.98|1.01|G9III|",
"14:1:20.4|8:53:41|-1||5.99|0.09|A2V|",
"14:16:4.2|18:54:43|-1||5.98|0.26|A8III|",
"15:10:7.5|-38:47:33|-1||5.98|0.0|G8III|",
"15:14:6.1|31:47:17|-1||5.99|1.52|K5|",
"15:22:37.3|62:2:50|-1||5.98|-0.03|A0pSi|",
"16:14:33.5|73:23:42|-1||5.98|0.08|A3V|",
"16:43:51.7|34:2:20|-1||5.99|0.29|F2-3III-IV|",
"16:43:6.0|77:30:51|-1||5.98|0.42|F4V|",
"17:6:20.3|-37:13:39|-1||5.98|0.07|A2IV|",
"17:8:14.9|-17:36:33|-1||5.99|1.01|K0III|",
"17:15:20.3|-14:35:2|-1||5.99|1.1|K1III|",
"17:25:54.4|16:55:3|-1||5.98|1.62|M4IIIab|",
"17:41:21.8|51:49:5|-1||5.99|1.05|gK0|",
"17:50:48.4|22:18:59|-1||5.98|0.0|A9V|",
"18:0:36.4|33:12:50|-1||5.99|1.51|gK6|",
"18:18:7.7|18:7:53|-1||5.99|0.03|B9V|",
"18:19:52.1|29:39:58|-1||5.99|1.29|gK4|",
"18:44:18.2|61:2:53|-1||5.99|0.96|G7IV|",
"18:49:41.0|-5:54:46|-1||5.99|1.6|K2Ib|",
"19:11:46.0|31:17:0|51|19|5.98|-0.07|B9pSi|",
"19:36:52.5|11:16:24|-1||5.98|0.88|G0Ib|",
"20:8:1.8|0:40:42|4|64|5.99|1.02|K1IV|",
"20:41:16.2|14:34:59|31|10|5.99|1.24|gK4|",
"20:49:37.8|12:32:43|31|15|5.98|0.43|F5V|",
"20:51:25.7|-5:37:35|3|4|5.99|0.46|F5V+F7V|",
"21:0:3.9|7:30:59|-1||5.99|0.26|F1Vp|",
"21:17:14.3|55:47:53|-1||5.98|1.45|K3III|",
"21:22:56.3|-9:19:10|3|17|5.99|1.54|M0III|",
"21:44:1.0|-14:44:58|15|45|5.99|0.21|F0V|",
"22:27:46.2|31:50:25|-1||5.98|1.45|K2|",
"22:42:36.9|-47:12:38|-1||5.98|0.58|G0V|",
"23:7:28.7|21:8:3|-1||5.99|0.26|A5V|",
"23:27:40.4|25:10:2|61|69|5.98|-0.06|A0pHgMn|",
"23:39:21.1|74:0:10|-1||5.98|0.89|G8III|",
"1:4:52.6|5:39:23|65|73|6.0|1.51|gK5|",
"2:2:52.7|64:54:5|17|52|6.0|0.03|A1Vn|",
"2:30:45.2|0:15:19|-1||6.0|0.17|A7III-IVs|",
"3:55:16.3|-12:5:57|-1||6.0|0.32|A5pSrCrEu|",
"4:18:15.9|-20:42:56|-1||6.0|1.67|G8III|",
"5:30:48.6|41:27:43|-1||6.0|1.11|K0IIIp|",
"5:39:31.2|-3:33:53|-1||6.0|0.27|A8Vs|",
"5:46:45.5|15:49:21|77|129|6.0|-0.06|B8IIIpHgMn:|",
"5:54:44.1|0:58:6|-1||6.0|1.34|K0III|",
"6:16:35.6|-39:15:52|-1||6.0|0.16|A2Vm:|",
"6:22:36.5|12:34:12|-1||6.0|0.0|F0III|",
"6:59:2.8|38:3:8|7|62|6.0|1.23|K2III|",
"7:39:58.0|-37:34:46|-1||6.0|-0.04|B6IVe|",
"8:28:50.9|-9:44:54|-1||6.0|0.42|F2III|",
"8:50:21.0|-42:5:24|-1||6.0|-0.1|B1-2III|",
"8:54:17.9|-5:26:4|-1||6.0|0.67|G2V|",
"9:11:41.0|-39:15:32|-1||6.0|-0.11|B6V|",
"9:41:47.8|-55:12:51|-1||6.0|-0.13|B4V|",
"10:19:26.8|48:23:49|-1||6.0|1.02|K0|",
"10:20:31.2|54:13:1|-1||6.0|1.13|gK3|",
"10:19:16.8|-12:31:41|-1||6.0|0.26|A9V|",
"10:32:47.6|-58:40:1|-1||6.0|0.32|A2Iab|",
"10:45:4.0|67:24:41|-1||6.0|2.39|C5II|",
"10:48:5.4|-59:55:9|-1||6.0|0.27|A0Ia-Iab|",
"10:59:32.8|36:5:35|-1||6.0|1.59|M2III|",
"11:4:31.2|38:14:29|82|51|6.0|0.16|A3III-IV|",
"12:11:0.0|81:42:36|-1||6.0|1.62|gK5|",
"12:27:24.6|-63:47:21|-1||6.0|0.07|B8IV|",
"12:38:44.6|-18:15:1|-1||6.0|0.29|dA6|",
"12:43:9.1|-56:10:34|-1||6.0|-0.08|B7-8V|",
"12:54:18.7|-11:38:55|-1||6.0|0.08|A2V|",
"13:1:46.8|63:36:37|-1||6.0|0.41|F6V|",
"13:39:59.7|-49:57:1|-1||6.0|1.5|M5III|",
"13:42:56.1|-56:46:5|-1||6.0|-0.08|B0.5III|",
"13:56:33.0|-54:42:16|-1||6.0|0.78|G6IV-V|",
"13:58:39.9|14:38:58|-1||6.0|1.44|K5III|",
"14:9:35.0|-51:30:17|-1||6.0|-0.06|B9IV|",
"14:23:48.4|-53:10:36|-1||6.0|1.1|K1III|",
"15:39:22.2|36:38:12|26|7ζ1|6.0|0.0|B9V|",
"15:48:13.3|13:47:19|-1||6.0|1.25|gK2|",
"16:53:17.6|47:25:1|-1||6.0|1.32|K2III|",
"17:0:27.1|-48:38:52|-1||6.0|0.88|G8-K0III+G|",
"17:18:5.0|17:19:5|-1||6.0|0.01|A1V|",
"17:27:37.5|-29:43:28|-1||6.0|0.0|B9IV|",
"17:58:42.3|36:17:16|-1||6.0|0.94|gG5|",
"18:4:50.4|-35:54:5|-1||6.0|1.16|K2III|",
"18:16:53.1|-3:0:26|-1||6.0|0.89|G3III|",
"18:39:52.8|52:11:46|-1||6.0|-0.07|A0p:Hg:|",
"19:15:2.6|20:12:12|-1||6.0|0.88|G8III|",
"19:16:51.4|46:59:57|-1||6.0|0.44|F6IV:|",
"20:42:2.9|-76:10:50|57|μ1|6.0|0.44|F4III-IV|",
"21:20:9.5|-45:1:20|-1||6.0|2.33|C5II|",
"21:46:16.3|-9:16:33|15|47|6.0|1.66|M3III|",
"22:0:7.9|6:43:3|61|18|6.0|-0.12|B3III|",
"23:38:24.1|-76:52:12|-1||6.0|0.9|K0-2III|",
"23:55:33.7|57:24:44|-1||6.0|0.21|B0.5II+B0.5II|",
"23:55:33.6|47:21:21|-1||6.0|1.16|G8Ib|",
"0:9:20.2|79:42:53|-1||6.01|0.19|A7IV|",
"0:39:52.0|-44:47:48|-1||6.01|1.14|K1IIICNII|",
"0:43:50.2|-12:0:42|-1||6.02|1.1|K2III-IV|",
"1:16:18.8|33:6:53|-1||6.02|1.15|K1III|",
"1:29:52.9|18:21:20|65|97|6.02|0.14|A4IV|",
"1:35:15.2|-58:8:22|-1||6.01|0.38|F2V|",
"1:55:53.8|1:50:59|-1||6.01|0.56|F7V+G0V|",
"1:58:33.3|61:41:53|-1||6.02|-0.04|B5III|",
"2:11:12.0|25:56:13|6|16|6.02|1.36|gK4|",
"2:11:22.2|-10:3:8|-1||6.01|0.39|F5V|",
"2:42:6.6|-38:23:2|-1||6.01|0.92|G8III|",
"2:56:33.4|47:9:50|-1||6.02|1.34|gK3|",
"3:10:27.0|26:53:47|-1||6.02|1.28|K3III|",
"3:38:47.7|-27:56:35|36|τ|6.01|-0.02|A0V|",
"3:49:8.2|43:57:47|-1||6.02|0.29|A9IV|",
"4:7:42.0|15:9:46|-1||6.01|0.4|F3V|",
"4:21:31.3|-25:43:42|-1||6.01|0.35|F0IV-V|",
"4:31:51.8|15:51:6|77|85|6.02|0.34|F4V|",
"4:33:48.1|9:24:47|-1||6.01|1.06|G8III|",
"4:36:29.2|23:20:27|-1||6.02|0.38|F5IV|",
"4:46:16.8|18:44:6|-1||6.01|1.21|K4III|",
"5:10:18.9|37:18:7|-1||6.02|0.72|K3:+B2II:|",
"5:9:45.1|28:1:50|-1||6.01|0.27|A5m|",
"5:42:53.8|-6:47:46|-1||6.02|0.4|F3V|",
"5:56:56.1|24:14:59|-1||6.02|0.39|A0Ia|",
"6:53:3.4|35:47:19|-1||6.01|1.45|K3III:|",
"7:5:18.4|22:38:14|37|44|6.02|-0.03|B8Vn|",
"7:1:5.1|-58:56:24|-1||6.02|0.3|A8III|",
"7:13:23.9|-22:40:24|-1||6.01|1.48|K2III|",
"7:12:2.0|-63:11:24|-1||6.02|-0.02|A0IV-V|",
"7:20:55.0|-26:57:49|-1||6.01|-0.17|B2.5V|",
"7:23:28.2|22:56:43|37|58|6.02|-0.01|A1V|",
"7:40:7.0|5:13:51|-1||6.02|-0.04|A0III|",
"7:40:35.5|-8:11:9|-1||6.01|0.15|A3IV|",
"7:42:43.5|34:0:1|-1||6.02|0.0|F7V|",
"7:51:5.7|54:7:45|-1||6.02|0.46|F6V|",
"7:55:46.5|-43:50:42|-1||6.02|-0.11|B6V|",
"8:1:42.4|60:19:28|10|53|6.01|0.14|A2pSrCrEu|",
"7:59:35.1|13:14:32|-1||6.02|1.32|K2|",
"8:0:14.9|-48:58:53|-1||6.02|0.04|A2V|",
"8:12:12.7|17:38:52|11|16ζ1|6.02|0.54|F9V|",
"8:12:59.8|16:30:51|-1||6.01|0.89|G8III|",
"8:24:42.8|42:0:18|-1||6.02|1.59|K5III|",
"8:24:36.4|-4:43:1|-1||6.01|0.46|F2V|",
"8:25:19.1|-21:2:45|-1||6.01|0.4|F3V|",
"9:10:20.9|21:59:47|11|79|6.01|0.9|G5III|",
"9:15:17.5|-58:23:19|-1||6.02|-0.1|B7IV|",
"9:26:22.3|-1:27:50|-1||6.01|1.32|K2IIIb|",
"9:47:33.5|11:25:44|-1||6.02|1.3|M8IIIe|",
"9:51:14.0|-4:14:36|76|6|6.01|0.17|A8III|",
"9:52:12.2|2:27:15|76|7|6.02|-0.04|A0Vs|",
"10:14:29.7|21:10:4|-1||6.02|0.56|F9V|",
"10:27:28.0|41:36:3|-1||6.02|0.17|A2V|",
"10:27:25.3|-65:42:17|-1||6.01|0.09|A2V|",
"10:42:11.3|31:41:49|-1||6.02|1.62|M4III|",
"11:0:20.6|42:54:41|-1||6.02|0.57|F9V|",
"11:6:29.3|-58:40:31|-1||6.02|1.24|K2II-III|",
"11:22:51.3|64:19:50|-1||6.02|0.09|A1Vnp|",
"11:44:13.2|25:13:6|-1||6.02|1.53|K5III|",
"12:10:46.1|27:16:53|-1||6.01|0.11|A4Vn|",
"12:29:57.9|-41:44:10|-1||6.02|1.52|M2II-III|",
"12:51:36.9|3:3:24|85|37|6.02|1.29|gK4|",
"13:0:32.6|-33:30:19|-1||6.02|0.38|F0V|",
"12:58:47.3|75:28:21|-1||6.01|0.99|K0III|",
"13:9:38.7|37:25:23|-1||6.02|1.15|K3III|",
"13:19:4.2|35:7:41|-1||6.02|0.24|F0IV|",
"13:20:48.3|-55:48:2|-1||6.02|0.29|B0.5Ia|",
"13:32:2.8|-18:43:44|85|73|6.01|0.18|F0IV-V|",
"13:38:49.1|-57:37:23|-1||6.01|1.14|G5Ib|",
"13:43:54.7|52:3:52|-1||6.02|0.0|A1V|",
"13:50:24.7|5:29:50|-1||6.01|0.9|K0|",
"14:8:27.1|-74:51:1|-1||6.02|0.58|G2-3IV|",
"14:23:20.3|-50:46:20|-1||6.02|1.36|K2III|",
"14:30:45.4|4:46:20|-1||6.02|1.42|gK4|",
"14:32:20.2|26:40:38|-1||6.01|0.22|A7Vn|",
"14:38:19.6|-38:47:39|-1||6.02|1.43|K3III|",
"14:53:23.7|19:9:10|-1||6.01|0.83|K2V|",
"15:12:33.8|-72:46:13|-1||6.01|0.0|B8-9III|",
"15:7:20.4|18:26:30|-1||6.02|0.06|A3V|",
"15:24:5.1|45:16:16|-1||6.01|1.2|K2III|",
"15:27:38.9|25:6:6|-1||6.02|1.62|gM1|",
"15:40:59.2|16:1:29|75|19τ6|6.01|0.9|G8III|",
"15:47:29.0|-37:54:59|-1||6.01|0.72|G6V|",
"15:51:31.5|-47:3:38|-1||6.01|1.16|K2III|",
"16:3:34.3|-32:0:2|-1||6.01|0.47|F4IV|",
"16:45:0.2|-28:30:35|-1||6.02|0.09|A3IV|",
"16:55:24.7|-63:16:11|-1||6.02|0.05|A0III|",
"17:5:16.9|0:42:9|-1||6.01|0.58|F8.5IV-V|",
"17:12:58.7|-32:26:19|-1||6.01|0.07|B1II|",
"17:19:53.3|-17:45:23|-1||6.02|0.04|A2Vnn|",
"17:28:56.1|-36:46:42|-1||6.02|1.11|K0III|",
"17:36:36.7|30:47:7|-1||6.02|0.16|A5V|",
"17:44:55.8|-57:32:43|-1||6.01|0.9|G8III|",
"17:58:39.1|-28:45:33|-1||6.01|-0.08|B3IV|",
"17:56:48.4|45:21:3|-1||6.02|1.64|M5IIbS|",
"18:16:5.6|2:22:40|-1||6.01|1.59|M4IIIab|",
"18:43:36.1|36:33:24|-1||6.01|1.04|G8|",
"18:44:20.3|39:40:16|51|4ε1|6.02|0.0|F1V|",
"19:0:3.5|-66:39:12|-1||6.01|0.97|K0III|",
"18:54:52.5|33:58:7|-1||6.02|0.91|G8III+A2|",
"19:0:55.2|33:48:8|-1||6.01|0.97|gK0|",
"19:19:53.0|11:32:6|4|29ω2|6.02|0.08|A2V|",
"19:41:5.5|13:48:56|-1||6.01|-0.08|B5V|",
"19:56:44.2|36:15:3|-1||6.02|-0.15|B5IV|",
"20:1:23.9|-22:44:14|-1||6.01|0.97|G7V|",
"20:12:31.8|51:27:49|-1||6.01|1.14|K2.5III|",
"20:40:17.9|60:30:19|-1||6.01|0.46|F6IV|",
"20:58:41.9|-14:28:58|-1||6.01|0.23|F0IV|",
"21:30:20.4|52:57:29|-1||6.02|0.08|A2Vp|",
"21:45:28.8|-71:0:32|-1||6.01|-0.1|B8IV|",
"22:0:24.1|-55:52:58|-1||6.01|-0.1|B9IV-V|",
"22:10:33.8|-4:16:2|-1||6.01|0.98|K0III-IV|",
"22:53:3.8|60:6:4|-1||6.01|1.75|sgK2|",
"23:7:27.7|32:49:33|-1||6.02|0.12|A4Vn|",
"23:18:23.4|41:46:25|0|9|6.02|0.0|A7/8Vm|",
"23:31:27.0|-44:50:37|-1||6.02|1.02|K1III|",
"0:4:36.7|42:5:32|-1||6.01|0.0|B9III|",
"0:28:20.1|10:11:23|-1||6.04|0.43|F6Vavw|",
"0:41:36.0|24:37:45|-1||6.04|0.26|A7m|",
"1:0:3.6|44:42:48|-1||6.04|-0.01|B9.5Vn|",
"1:3:49.0|1:22:0|20|26|6.04|0.27|F1V|",
"1:14:42.4|6:59:43|65|88|6.03|1.08|gG6|",
"2:2:57.2|77:54:59|-1||6.04|1.14|K0|",
"2:32:54.1|15:2:5|6|29|6.04|0.54|F8V|",
"2:45:20.9|4:42:42|-1||6.03|0.31|gF0|",
"2:52:32.1|-12:46:10|-1||6.04|0.87|K2V|",
"2:52:19.2|-62:54:35|-1||6.03|1.25|K1III|",
"2:58:2.3|38:36:54|-1||6.04|1.41|gK3|",
"3:24:10.1|12:37:46|-1||6.04|1.23|K0III-IV|",
"3:28:26.6|22:48:15|6|66|6.03|0.95|K0IV|",
"4:13:44.9|72:7:35|-1||6.03|1.01|K1III|",
"4:48:44.6|3:35:18|-1||6.03|1.19|K1III|",
"5:1:35.9|61:4:41|-1||6.03|0.41|F4V|",
"5:6:29.7|61:10:12|-1||6.04|1.37|K5II|",
"5:1:34.5|-39:43:5|-1||6.03|0.88|G5III|",
"5:27:0.0|-68:37:22|-1||6.03|0.34|F0IV-V|",
"5:40:35.9|31:21:29|-1||6.04|0.04|B9.5III-IVp:|",
"5:47:26.7|-10:31:59|-1||6.03|0.16|A4V|",
"6:13:45.3|51:10:21|-1||6.04|1.06|K1III|",
"6:11:27.9|13:38:19|-1||6.04|0.0|A0Vnn|",
"6:32:23.3|11:40:25|-1||6.03|1.07|K0III|",
"6:39:5.3|22:1:51|-1||6.04|1.03|G9III|",
"6:39:33.1|28:15:47|7|54|6.03|-0.08|B7III|",
"6:37:1.9|-38:8:48|-1||6.04|1.03|K0III|",
"6:38:35.4|-16:52:25|-1||6.03|0.03|A1Vs|",
"6:53:33.9|-28:32:23|-1||6.04|0.71|G5IV|",
"6:54:58.8|-2:48:13|-1||6.04|1.1|gG6|",
"7:9:33.2|-16:14:5|-1||6.03|0.06|B1II|",
"7:14:28.2|-10:19:0|-1||6.03|-0.18|B0III|",
"7:45:18.1|-43:45:8|-1||6.03|-0.07|B6IV|",
"7:49:2.0|13:22:15|-1||6.04|1.38|K0|",
"7:51:2.3|33:14:1|-1||6.03|0.15|A2Vm|",
"7:51:40.3|-42:53:18|-1||6.04|-0.18|B2IV|",
"8:12:30.9|-46:15:51|-1||6.03|-0.11|B5V|",
"8:34:13.3|8:27:7|-1||6.03|0.33|F3IV|",
"8:53:3.8|-56:38:58|-1||6.03|-0.02|A0V|",
"9:16:4.2|-44:53:55|-1||6.04|0.28|A1Ib|",
"9:58:7.6|8:18:51|-1||6.04|1.36|gK3|",
"10:13:49.8|27:8:9|-1||6.04|0.85|G3IIIFe-1|",
"10:27:39.0|9:45:45|45|45|6.04|-0.06|A0pSiCr:|",
"10:36:16.7|-16:20:40|41|φ2|6.03|1.65|M1III|",
"10:38:50.4|-12:26:37|-1||6.04|0.0|A0Vn|",
"10:49:53.7|27:58:26|46|44|6.04|0.37|F3V|",
"10:56:14.5|42:0:30|-1||6.03|1.13|K2III|",
"11:49:14.9|16:14:34|-1||6.04|0.27|A3m|",
"12:25:15.1|23:55:34|-1||6.03|1.1|K0III|",
"12:28:18.9|-64:20:29|-1||6.04|0.02|A0Vn|",
"12:41:49.2|-19:45:31|-1||6.03|0.39|F3-5III|",
"13:3:5.2|-71:28:34|-1||6.03|0.05|B1.5IIIne|",
"13:19:18.9|-72:2:8|-1||6.04|1.35|K3III|",
"13:52:18.4|12:9:55|-1||6.04|0.04|A1V|",
"13:54:16.6|-28:34:11|-1||6.04|1.13|K2III|",
"14:37:46.3|-67:55:56|-1||6.04|0.5|F7V|",
"14:34:38.5|36:37:33|-1||6.03|1.38|gK5|",
"14:48:38.1|-36:38:5|-1||6.04|1.54|M3III|",
"15:16:10.5|-43:29:5|-1||6.04|-0.14|B3IV|",
"15:38:42.3|-39:7:41|-1||6.04|0.21|A3-5mA3-F2|",
"15:42:37.2|-49:29:22|-1||6.04|1.31|K2III|",
"15:56:6.5|-39:51:51|-1||6.03|0.15|B6V|",
"16:2:39.4|-29:8:9|-1||6.03|1.31|K3III|",
"17:0:58.5|-86:21:52|-1||6.04|0.05|A2V|",
"16:43:22.1|-67:25:57|-1||6.03|0.02|A0Vn|",
"16:45:29.7|1:1:13|58|16|6.03|-0.02|B9.5III|",
"16:48:27.0|-14:54:34|-1||6.03|0.2|A0Vn|",
"16:59:21.5|56:41:19|-1||6.03|1.16|gK1|",
"17:3:53.5|34:47:25|-1||6.04|0.22|A5V|",
"17:11:40.2|49:44:48|-1||6.04|0.0|A5III|",
"17:31:49.1|-46:2:11|-1||6.03|0.83|F8-G0Ib|",
"17:39:57.5|31:12:9|-1||6.03|1.58|M2IIIab|",
"17:52:57.9|-35:37:27|-1||6.03|0.34|F2III-IV|",
"17:52:4.7|39:58:56|-1||6.04|1.33|gK4|",
"18:0:3.4|80:0:3|33|40|6.04|0.51|F7|",
"18:13:4.8|38:46:25|-1||6.04|-0.08|B9IIIn|",
"18:31:3.0|-41:54:49|-1||6.04|0.14|A3V|",
"18:38:6.5|39:40:5|-1||6.04|1.65|M4.5-M5+II|",
"18:45:11.5|-61:5:42|-1||6.04|1.46|K3III|",
"19:6:52.3|-16:13:44|-1||6.03|-0.04|B8IV|",
"19:7:30.9|-28:38:13|-1||6.04|1.61|K3III|",
"19:24:30.1|-27:51:56|-1||6.04|-0.13|B2Vn|",
"19:49:2.2|-10:52:15|-1||6.04|1.24|K5III|",
"20:51:58.8|-33:10:38|53||β|6.04|0.03|A2Vn|",
"21:6:55.3|38:44:36|30|61|6.03|1.37|K7V|",
"21:15:6.6|-17:20:42|-1||6.04|0.96|G5|",
"21:21:22.0|32:36:46|-1||6.04|0.03|A1V|",
"21:26:45.0|52:53:55|-1||6.03|-0.12|B6V|",
"22:12:25.8|-14:11:38|3|39|6.03|0.38|F2V|",
"22:25:51.0|-75:0:56|-1||6.04|0.64|G3V|",
"22:23:39.6|20:50:54|61|33|6.04|0.0|F7V|",
"22:23:0.2|62:25:12|-1||6.04|0.05|A1V|",
"22:39:34.3|37:35:34|-1||6.03|0.86|G3Ib-IICN-1CH2Fe-1|",
"22:53:37.9|-48:35:53|38|τ1|6.04|0.62|G0V|",
"23:54:38.6|-40:18:0|-1||6.03|0.57|F8IV|",
"0:8:33.4|-17:34:39|-1||6.06|1.67|M0III|",
"0:18:17.2|11:12:21|-1||6.05|1.03|K0III|",
"0:28:12.7|16:26:42|65|48|6.06|1.58|K5III|",
"0:35:33.4|-54:49:19|-1||6.06|1.01|K0IV|",
"0:36:6.9|-22:50:33|-1||6.06|0.29|A6pSr|",
"0:42:42.9|-38:27:48|73|λ1|6.06|-0.03|A0V|",
"0:46:10.9|44:51:41|-1||6.05|-0.07|B9.5IIIpHgMnCr|",
"0:53:28.2|37:25:5|-1||6.06|1.14|gK3|",
"1:10:11.5|15:40:27|-1||6.06|1.49|M0III|",
"1:47:46.5|-80:10:36|42|τ2|6.06|0.34|F0IV|",
"1:55:46.4|-60:51:41|-1||6.06|0.37|F0IV-V|",
"2:9:25.3|81:17:45|-1||6.05|0.11|A1V|",
"2:14:2.6|47:29:3|-1||6.06|0.4|F4V|",
"2:41:48.3|-3:12:48|-1||6.05|1.17|gG9|",
"3:5:20.8|40:34:57|-1||6.05|1.01|K0III|",
"3:4:38.1|1:51:49|-1||6.05|1.04|K0III|",
"3:11:18.8|-3:48:42|-1||6.05|1.66|M1III|",
"3:16:35.1|32:11:1|-1||6.06|0.99|G8IV|",
"3:17:59.0|-66:55:37|-1||6.05|0.13|A3V|",
"3:44:6.4|48:31:25|-1||6.06|1.55|K4III|",
"3:57:3.8|23:10:32|77|33|6.06|0.02|B9.5IV|",
"3:58:42.9|-57:6:9|-1||6.05|0.44|F2IV|",
"4:26:21.1|8:35:25|-1||6.06|0.02|B6IV|",
"4:33:22.0|-10:47:9|-1||6.06|1.38|K0|",
"4:48:50.3|75:56:28|-1||6.06|0.28|A9IV|",
"4:45:55.4|-39:21:24|-1||6.05|1.07|K1III|",
"4:38:21.7|-77:39:22|-1||6.05|1.1|K2III|",
"5:2:20.1|74:16:9|-1||6.06|1.57|K5III|",
"5:4:54.5|-3:2:23|-1||6.05|-0.11|B5IV|",
"5:6:36.7|-13:7:19|-1||6.05|-0.06|A0V|",
"5:13:53.3|-52:1:52|-1||6.05|1.39|K3III|",
"5:37:27.4|-5:56:18|-1||6.05|-0.22|B1V|",
"5:43:1.6|56:34:54|10|24|6.05|0.95|K0III|",
"5:35:36.3|-78:49:15|52|ι|6.05|-0.02|B8III|",
"5:52:23.4|19:52:5|-1||6.06|0.54|G2IIIe+B8III|",
"6:1:0.4|27:34:20|-1||6.05|0.25|B9Iab|",
"6:2:48.7|49:54:20|-1||6.05|-0.06|B9.5IV|",
"6:1:13.1|-25:25:4|-1||6.05|0.02|A1V|",
"6:18:48.8|-15:1:29|-1||6.06|1.66|M0III|",
"6:25:32.9|23:19:37|-1||6.06|-0.03|A2Vn|",
"6:37:24.1|6:8:7|-1||6.06|0.05|O8p|",
"6:39:36.3|-23:41:44|-1||6.05|-0.03|A0|",
"6:45:23.3|-23:27:43|-1||6.05|1.2|K0|",
"6:57:13.2|57:33:48|-1||6.05|1.49|K3III|",
"7:20:21.4|-52:18:42|-1||6.05|0.42|F0-2IV-V|",
"7:25:19.9|-21:58:58|-1||6.05|0.23|A8I-II:|",
"7:29:21.9|-14:59:57|-1||6.05|0.47|F7V|",
"7:40:49.5|57:4:58|50|23|6.06|1.46|K5III|",
"7:39:0.4|-53:16:24|-1||6.06|-0.11|B9IV-Vp:Si:|",
"7:57:15.9|8:38:29|-1||6.05|1.0|K0III|",
"8:14:11.0|-32:8:27|-1||6.06|-0.16|B1.5V|",
"8:19:49.9|3:56:52|-1||6.05|0.97|G8III|",
"8:25:4.9|35:0:41|-1||6.06|1.27|K0|",
"8:26:25.2|-52:48:27|-1||6.05|0.06|A0V|",
"8:44:30.0|-65:49:32|-1||6.05|0.2|A4V|",
"8:43:12.4|-79:4:11|-1||6.05|0.23|A5V+A7V|",
"9:20:29.6|-37:34:53|-1||6.05|1.39|K3/4III|",
"9:24:16.3|-39:25:33|-1||6.06|0.2|A7V:|",
"9:26:44.2|-64:55:47|-1||6.05|0.15|A3Vn|",
"9:48:40.0|-56:24:43|-1||6.06|0.94|K0III|",
"9:57:42.5|-48:24:52|-1||6.05|-0.14|B3V|",
"10:28:44.0|-3:44:33|-1||6.05|0.05|A1pSr:|",
"10:31:48.6|-28:14:15|-1||6.05|0.51|F7V|",
"11:9:39.9|67:12:37|-1||6.06|0.22|F0pSr|",
"11:17:19.0|-67:49:25|-1||6.06|1.76|M2III|",
"11:23:18.0|0:7:54|-1||6.05|1.46|K3|",
"11:33:14.6|-16:16:50|-1||6.05|0.6|F9III|",
"11:54:11.5|-57:24:36|-1||6.06|0.05|A0-1:III|",
"11:59:10.9|-51:41:48|-1||6.05|1.28|K1-2III|",
"12:2:20.1|-85:37:54|-1||6.05|1.29|K3III|",
"12:6:23.1|-65:42:33|-1||6.06|0.65|G8-K0III+A3-5V|",
"12:10:33.8|-37:52:13|-1||6.06|0.2|A5V|",
"12:17:6.0|-65:41:34|-1||6.06|0.03|A0V|",
"12:17:3.3|-16:41:37|-1||6.05|0.1|A2IV|",
"12:23:47.0|42:32:34|12|4|6.06|0.33|F3III-IV|",
"12:31:21.4|7:36:15|-1||6.05|1.52|K5|",
"13:10:58.4|-52:34:1|-1||6.06|-0.09|ApSi|",
"13:22:52.6|-72:8:48|-1||6.05|0.09|B6V|",
"13:41:45.7|-33:35:49|-1||6.05|1.44|K0e-M4IIe|",
"13:47:13.5|-9:42:33|-1||6.05|1.42|K5III|",
"13:51:50.1|-32:59:41|18|3|6.06|-0.04|B8V|",
"14:10:30.9|-70:18:20|-1||6.05|1.74|K4II|",
"14:11:1.9|-69:43:11|-1||6.06|0.18|A6IV|",
"14:29:49.7|31:47:28|-1||6.06|-0.03|A0Vs|",
"14:47:13.7|-21:19:29|-1||6.06|1.65|K5III|",
"14:56:30.9|-32:38:12|-1||6.06|1.41|K3III|",
"15:59:4.4|49:52:52|-1||6.05|0.29|F0IV|",
"16:14:53.6|-25:28:37|-1||6.05|0.04|B7IV|",
"16:20:4.3|21:7:57|-1||6.05|0.94|G8IIIb|",
"16:29:45.0|-57:45:21|-1||6.06|1.48|G8Ib|",
"16:41:0.6|24:51:31|-1||6.06|1.31|K2|",
"16:43:47.6|-38:9:24|-1||6.05|-0.06|B9II-III|",
"16:45:11.7|43:13:2|-1||6.05|1.4|K4III|",
"17:3:41.7|-47:9:36|-1||6.06|0.0|A2-3V|",
"17:8:13.6|-1:4:46|-1||6.06|0.08|A1V+F3V|",
"17:26:19.0|7:35:44|-1||6.06|0.58|B9.5V+G0V|",
"17:31:44.4|-26:16:11|-1||6.05|-0.06|B9p|",
"17:52:49.2|-34:6:51|-1||6.06|1.23|K1III|",
"17:55:7.9|-36:28:33|-1||6.06|0.08|B9.5III|",
"18:17:0.9|-51:4:6|-1||6.06|-0.06|B9V|",
"18:36:13.3|65:29:19|-1||6.06|0.28|F0V|",
"18:49:43.5|-72:59:41|-1||6.06|0.0|B9.5IV-V|",
"18:47:57.5|31:45:25|-1||6.06|-0.13|B3IVp|",
"19:3:3.8|-19:14:43|-1||6.05|1.29|G6III|",
"19:4:58.3|30:44:0|-1||6.06|1.55|M2.5IIIab|",
"19:19:0.1|-15:32:11|-1||6.06|1.43|K3III|",
"19:22:33.4|33:31:5|-1||6.06|1.03|K0III|",
"19:30:33.1|3:26:40|-1||6.05|0.01|A0eShell|",
"19:21:40.2|79:36:10|-1||6.05|0.07|A3V|",
"19:35:48.3|36:56:40|30|11|6.05|-0.11|B8Vne|",
"19:43:9.5|30:40:43|-1||6.05|0.0|A1V|",
"19:43:51.4|34:9:45|-1||6.05|-0.06|B8III|",
"19:51:1.3|-65:36:18|-1||6.05|0.3|F2III-IV|",
"19:49:11.6|-28:47:20|-1||6.05|0.4|F2V|",
"19:50:47.0|37:49:35|-1||6.06|1.7|M4IIb|",
"19:53:35.4|59:42:32|-1||6.06|0.02|A3V|",
"20:19:43.3|-1:4:43|-1||6.06|1.09|K0|",
"20:39:33.3|40:34:46|-1||6.06|-0.16|B6IIIpMn|",
"20:55:40.7|4:31:58|-1||6.05|0.82|G6III-IV|",
"20:57:10.6|0:27:49|-1||6.05|1.22|K2III|",
"20:54:44.3|75:55:32|-1||6.05|0.93|G5III|",
"21:1:45.3|-26:52:52|-1||6.05|0.06|A7V:m:|",
"21:13:26.3|36:38:1|-1||6.05|0.21|F0III|",
"21:22:41.9|30:18:35|-1||6.05|1.08|K1III|",
"22:48:44.2|62:56:18|-1||6.06|1.2|K0|",
"22:54:39.4|-70:4:25|43|ρ|6.05|0.66|G2-3IV|",
"23:20:50.0|-50:18:24|-1||6.05|0.42|F5mDelDel|",
"23:30:39.7|38:39:43|-1||6.05|0.99|G9III|",
"23:33:55.5|20:50:27|-1||6.06|1.73|M3III|",
"0:8:12.1|-2:26:52|-1||6.07|1.38|K2III+F|",
"0:24:29.7|-2:13:9|-1||6.07|1.22|K1III|",
"0:44:32.3|-62:29:52|-1||6.07|0.44|F5III-IV|",
"0:51:16.4|61:48:21|-1||6.07|1.88|K2Ib-IICN-2|",
"1:23:46.8|78:43:33|-1||6.07|0.39|A0Iab|",
"2:14:29.1|66:31:28|17|55|6.07|0.63|G0II-III+B9V|",
"2:29:35.3|9:33:57|-1||6.07|1.02|K2III|",
"3:14:56.7|42:30:14|-1||6.07|1.07|K2III|",
"3:24:26.1|20:48:13|6|65|6.08|-0.04|A1V|",
"3:49:55.0|22:14:40|-1||6.07|-0.01|B8III|",
"4:15:1.8|57:27:37|-1||6.08|0.61|A4III|",
"4:18:37.4|-22:58:13|-1||6.07|0.3|Am|",
"4:44:12.9|40:47:13|-1||6.08|0.06|B8IVne|",
"4:49:44.1|15:54:15|77|96|6.08|1.6|gK3|",
"4:50:16.2|-41:19:15|-1||6.07|0.37|F2-3V|",
"4:54:51.3|44:3:39|-1||6.08|-0.02|A0V|",
"4:56:19.9|36:10:8|-1||6.07|0.41|B2Ib|",
"4:59:46.3|53:9:20|10|8|6.08|1.46|K4III|",
"5:6:12.2|59:1:16|10|12|6.08|1.12|K0III|",
"5:19:14.7|20:8:5|-1||6.08|1.01|G8II-III+G1IV-V|",
"5:23:37.7|16:41:58|77|110|6.08|0.14|A2IV|",
"5:24:55.6|-44:13:33|-1||6.08|1.2|K1III|",
"5:27:36.5|-21:22:32|-1||6.07|1.04|gG7|",
"5:48:22.4|20:52:10|-1||6.07|-0.08|B9Vn|",
"6:3:24.7|11:40:51|-1||6.08|-0.04|A0Vs|",
"6:6:22.5|29:30:45|-1||6.08|1.73|M3II+F7V|",
"6:16:19.0|23:58:12|37|8|6.08|0.9|G8III|",
"6:15:40.1|6:3:58|-1||6.07|-0.13|B6Ve|",
"6:17:3.5|-22:42:54|-1||6.07|0.56|G0V|",
"6:27:11.2|-25:51:24|-1||6.07|0.53|F9V|",
"6:47:1.5|-21:0:56|13|12|6.08|-0.19|B7IIIn|",
"7:6:52.3|-24:57:38|-1||6.08|1.34|K2|",
"7:45:29.1|-14:41:27|67|2|6.07|0.11|A2V|",
"8:11:16.6|9:49:16|-1||6.07|-0.1|B6III|",
"8:23:55.2|10:37:55|11|21|6.08|1.49|M2III|",
"9:1:48.9|27:54:10|11|67|6.07|0.0|A8Vn|",
"9:1:31.4|5:38:27|-1||6.07|1.11|K1II-III+F3IV|",
"9:0:22.2|-43:10:24|-1||6.07|-0.16|B2.5Vn|",
"9:23:59.5|-51:44:14|-1||6.08|0.57|A7Iab|",
"9:51:59.6|-16:32:5|-1||6.08|1.04|K0|",
"10:16:9.1|-11:12:12|-1||6.08|1.1|K0|",
"10:23:0.4|6:32:33|45|43|6.07|1.12|K3III|",
"10:35:10.5|-43:39:53|-1||6.08|0.94|G8II-IIICNVp|",
"10:39:16.6|-74:29:37|-1||6.07|1.71|K3II|",
"11:0:40.8|-31:50:22|-1||6.07|0.52|F8V|",
"11:43:55.1|-6:40:38|-1||6.07|0.96|gG8|",
"12:11:4.9|-61:16:39|-1||6.08|0.39|F2-3IV|",
"12:30:4.3|58:46:3|82|75|6.08|0.98|G8III-IV|",
"12:41:16.0|-13:0:49|-1||6.08|0.0|F3Vn|",
"12:42:49.6|-55:56:50|-1||6.08|-0.03|B9V|",
"12:41:33.9|62:42:47|82|76|6.07|0.01|A2III|",
"12:47:13.6|11:57:29|85|34|6.07|0.12|A3V|",
"13:16:44.8|-65:8:18|-1||6.07|0.44|F5V|",
"13:23:54.0|37:2:2|-1||6.07|1.68|M3III|",
"13:31:15.8|42:6:22|-1||6.08|1.05|K2III|",
"14:15:1.3|-29:16:55|-1||6.08|0.0|A1V|",
"14:29:36.8|-76:43:45|-1||6.07|1.18|K0-1III|",
"14:39:11.0|-46:35:3|-1||6.07|0.51|F7V|",
"14:45:11.7|-1:25:4|-1||6.07|1.61|M1III|",
"14:47:12.3|-52:12:20|-1||6.07|0.09|A1III-IV|",
"15:13:19.2|-19:38:51|48|25ι2|6.08|0.12|A3Vn|",
"15:23:12.3|30:17:16|26|2η|6.08|0.0|G3V|",
"15:35:53.4|11:15:56|-1||6.07|1.09|gK0|",
"15:48:50.3|-52:26:17|-1||6.07|1.38|K2-3III|",
"16:3:45.7|4:59:12|75|43|6.08|0.96|G9III|",
"16:11:28.7|16:39:56|-1||6.08|0.02|A0V|",
"16:26:50.1|2:20:51|-1||6.07|0.92|G8III|",
"16:40:51.4|12:23:42|-1||6.08|0.05|A3Vn|",
"16:55:2.1|25:43:50|39|56|6.08|0.92|G5III|",
"17:3:58.0|13:34:3|-1||6.08|1.03|K1III|",
"17:57:41.8|-76:10:39|-1||6.07|1.2|K2III|",
"18:11:4.5|-47:30:47|-1||6.07|1.2|K1IIICNII|",
"18:15:30.8|-18:39:41|-1||6.07|0.2|A0Ia|",
"18:27:50.3|3:44:55|-1||6.07|1.62|K3III|",
"18:46:13.0|41:26:30|-1||6.07|-0.13|B6V|",
"19:7:57.3|16:51:12|-1||6.07|0.7|G5V|",
"19:31:0.2|70:59:22|-1||6.07|1.41|K2|",
"20:5:32.8|-67:19:15|-1||6.07|0.64|G3V|",
"20:30:18.0|10:53:45|31|1|6.08|-0.03|A1eShell|",
"20:39:10.6|21:49:2|-1||6.08|-0.06|A0III|",
"20:40:36.2|29:48:19|-1||6.08|0.14|A2V|",
"21:3:4.8|38:39:27|-1||6.07|1.01|G8III|",
"21:10:31.2|10:2:56|34|6|6.07|0.02|A2Vs|",
"21:26:26.7|19:22:32|-1||6.07|0.22|A8m|",
"21:31:9.6|12:8:15|-1||6.08|-0.05|B9.5V|",
"21:39:28.1|-10:34:37|-1||6.08|1.03|K0|",
"21:42:1.1|35:30:37|-1||6.07|2.52|C6.3|",
"21:44:8.3|28:44:35|30|78μ2|6.08|0.36|G2V|",
"21:42:45.4|59:16:16|-1||6.08|1.34|K1III|",
"22:12:52.9|73:18:26|-1||6.08|1.01|K0II-III+A3V|",
"22:42:43.1|-44:14:52|-1||6.07|0.98|K0III|",
"22:59:35.7|-13:4:15|-1||6.07|1.45|K5III|",
"23:44:25.4|-70:29:25|-1||6.07|0.91|G8-K0IV|",
"23:47:33.2|46:49:57|-1||6.07|-0.14|B3IV|",
"23:48:32.5|-6:22:50|-1||6.07|1.45|K4III|",
"0:55:58.5|27:12:34|65|67|6.09|0.14|A5IV|",
"0:55:55.5|-27:46:32|-1||6.1|1.67|M0III|",
"1:53:23.2|-38:35:41|-1||6.1|1.12|K1II|",
"1:57:0.1|-51:45:58|-1||6.1|0.48|F6-7V|",
"1:59:25.9|12:17:41|-1||6.09|0.19|A6V|",
"1:59:41.1|-66:3:59|-1||6.1|1.17|K1III|",
"2:8:45.7|-17:46:46|-1||6.1|1.61|M2III|",
"2:10:53.7|39:2:35|0|59|6.1|-0.07|A1Vn|",
"2:30:32.8|-22:32:44|-1||6.1|1.61|M1III|",
"2:36:42.9|31:36:27|-1||6.1|1.05|K0|",
"2:42:8.5|-46:31:28|-1||6.1|0.88|K1III|",
"3:25:57.4|49:7:15|-1||6.09|-0.07|B7V|",
"3:44:28.1|20:55:43|-1||6.1|0.01|A0V|",
"3:47:32.2|55:55:21|-1||6.1|-0.03|B9Vnn|",
"3:55:23.0|31:2:45|-1||6.1|0.29|O9.5ep|",
"3:57:1.7|6:2:24|-1||6.09|0.06|A2Vn|",
"4:8:15.3|37:43:40|62|49|6.09|0.95|K1III|",
"4:12:31.4|17:16:39|-1||6.09|1.08|K0III|",
"4:18:40.0|-52:51:36|-1||6.09|0.49|F7IV-V|",
"4:27:6.0|-46:56:51|-1||6.1|0.46|F5-6V|",
"4:33:24.9|43:3:50|62|57|6.09|0.38|F0V|",
"4:34:14.2|-6:50:16|-1||6.09|1.38|K2III|",
"4:39:47.2|-1:3:10|-1||6.1|0.94|K0|",
"4:54:54.8|-39:37:43|-1||6.1|1.42|K3III|",
"4:58:59.4|14:32:34|-1||6.09|0.04|B7V|",
"5:10:3.2|0:33:55|-1||6.1|1.1|K0III|",
"5:13:31.6|1:58:5|-1||6.09|0.42|A5V|",
"5:21:16.9|-34:20:43|-1||6.09|-0.19|B5IVnpe|",
"5:36:52.4|40:10:56|-1||6.09|1.03|G3Ib+F|",
"5:45:1.9|4:0:29|-1||6.09|0.31|gF0n|",
"5:54:41.1|-49:37:37|-1||6.1|-0.13|B3V|",
"6:3:18.0|42:54:42|7|38|6.1|0.97|K0II|",
"6:11:36.6|48:42:40|7|41|6.09|0.1|A3V|",
"6:11:13.5|-26:28:56|-1||6.09|-0.04|A0V|",
"6:15:26.0|-9:2:7|-1||6.1|-0.08|B9III|",
"6:58:47.4|26:4:52|37|39|6.1|0.46|F7V|",
"7:4:47.1|-22:1:56|-1||6.09|1.22|K0|",
"7:11:51.3|5:39:17|-1||6.09|-0.02|A1V|",
"7:12:4.1|-30:49:18|-1||6.1|0.27|A8V|",
"7:19:2.0|-19:16:49|-1||6.09|0.62|F0Iab-Ib|",
"7:56:57.9|-42:24:22|-1||6.09|1.36|K3III|",
"8:1:22.9|-54:30:54|-1||6.1|-0.04|B2IV-V|",
"8:28:36.8|24:8:41|11|28|6.1|0.24|F0Vn|",
"8:40:18.3|31:56:31|-1||6.1|0.0|F5III|",
"8:45:49.3|-25:23:15|-1||6.1|0.08|A2V:|",
"8:48:4.9|-6:33:31|-1||6.09|1.28|K0|",
"9:26:44.8|-28:47:15|-1||6.1|-0.1|B6Ve|",
"9:32:14.6|-62:47:20|-1||6.1|1.43|M6-7IIIep|",
"9:49:50.1|21:10:46|45|20|6.09|0.25|A7IVn|",
"10:13:1.3|-59:55:5|-1||6.1|-0.08|B4Ve|",
"10:28:1.9|-49:24:20|-1||6.1|1.51|K4III|",
"10:31:56.6|-45:4:10|-1||6.09|-0.11|B8II|",
"10:34:57.7|-23:10:34|-1||6.1|0.5|F7V|",
"11:5:34.0|-11:5:20|-1||6.09|0.3|F0Vn|",
"11:28:18.2|-72:28:28|-1||6.09|0.16|B3V|",
"11:38:33.5|46:50:3|82|60|6.1|0.38|F5IIIs|",
"11:43:52.9|-62:52:42|-1||6.1|0.06|A2III-IV|",
"12:25:18.4|-27:44:57|-1||6.09|1.27|K1III|",
"13:30:25.7|-6:28:13|85|72|6.09|0.33|F2V|",
"13:38:45.7|-70:26:42|-1||6.1|1.42|K3III|",
"13:53:56.9|-47:7:41|-1||6.1|-0.07|B2IIIe|",
"14:0:32.8|-78:35:24|-1||6.09|0.03|B9III|",
"14:22:38.7|-48:19:13|-1||6.09|-0.13|B1III|",
"14:28:16.4|36:11:49|-1||6.1|0.0|K0III|",
"14:33:9.6|-30:42:51|-1||6.09|1.03|K0III|",
"14:30:46.1|63:11:8|-1||6.09|0.41|F4IV|",
"14:40:21.9|21:58:32|-1||6.1|0.4|G0V|",
"14:45:10.9|-55:36:7|-1||6.1|-0.06|B2III|",
"14:54:42.4|-65:59:29|22|ζ|6.09|-0.06|B3Vn|",
"14:59:27.1|-43:9:36|-1||6.1|0.6|F5III|",
"14:58:52.8|-4:59:21|-1||6.09|0.5|F8V|",
"15:8:53.4|13:14:6|-1||6.1|0.96|dG6|",
"15:13:7.4|-36:5:29|-1||6.1|-0.08|B8V|",
"15:28:27.2|-51:35:51|-1||6.1|1.09|G2II|",
"15:53:12.1|13:11:48|75|39|6.1|0.6|G0VFe-0.5|",
"15:53:34.9|16:4:30|-1||6.09|0.0|F5II-III|",
"15:59:54.0|-54:1:16|-1||6.1|0.0|B5IV|",
"16:4:17.8|-33:12:52|-1||6.1|0.34|A9IV|",
"16:15:51.5|-14:50:57|-1||6.09|0.06|A0V|",
"16:31:22.8|-26:32:16|-1||6.1|1.08|K1III|",
"16:38:1.6|-6:32:17|-1||6.09|0.16|A0pCrEu|",
"16:41:36.2|-24:28:5|-1||6.09|0.2|F0V|",
"16:47:9.8|2:3:52|58|19|6.1|0.14|A3V|",
"16:49:27.8|-15:40:3|-1||6.1|0.0|A5V|",
"16:58:52.4|-37:37:16|-1||6.09|0.19|A3V|",
"17:2:15.3|64:36:2|-1||6.1|0.96|G5V|",
"17:4:49.8|48:48:15|-1||6.09|1.09|K1III|",
"17:14:13.2|-56:53:18|-1||6.09|1.78|M1-2II-III+A|",
"17:16:42.8|-6:14:42|-1||6.09|1.1|K0|",
"17:35:20.0|-53:21:10|-1||6.1|0.02|B9III|",
"17:38:8.5|-42:52:50|-1||6.1|-0.06|B8V|",
"17:35:59.6|20:59:46|-1||6.1|0.19|A7IV|",
"17:35:42.4|37:18:6|-1||6.1|0.98|G9III|",
"17:51:11.0|-53:7:50|-1||6.09|0.0|B9.5III-IV|",
"17:55:23.7|55:58:17|-1||6.1|0.32|F0IV|",
"18:10:8.7|16:28:36|-1||6.09|0.0|B9V+F7III|",
"18:35:13.5|34:27:28|-1||6.1|-0.11|B5Vne|",
"18:40:56.3|62:44:59|-1||6.09|0.98|K0III|",
"18:51:22.1|-3:19:4|4|8|6.1|0.3|F2III|",
"18:51:36.5|36:32:19|-1||6.09|-0.11|B6IV|",
"19:2:52.6|19:39:40|-1||6.09|1.34|K1III|",
"19:6:22.2|8:13:48|-1||6.09|1.6|M7IIIe|",
"19:30:10.5|2:54:15|-1||6.09|1.82|K5Ib|",
"19:41:37.5|-65:51:15|-1||6.09|1.55|M0III|",
"19:39:45.0|33:58:45|-1||6.1|0.08|A3IV|",
"19:45:51.4|35:0:46|-1||6.09|1.06|K0II-III+A2V|",
"19:52:16.3|36:25:56|-1||6.1|1.43|K4III|",
"19:55:22.1|58:15:1|-1||6.09|1.02|G9III|",
"20:14:26.9|-63:24:57|-1||6.09|0.31|F0IV|",
"20:20:46.6|-14:47:6|-1||6.1|-0.02|A0III|",
"20:22:37.4|31:15:54|-1||6.09|1.35|K2|",
"20:25:47.9|-40:47:47|-1||6.09|1.36|K3III|",
"20:28:46.7|-35:35:45|-1||6.1|-0.11|B8II/III|",
"21:25:18.1|-71:47:58|-1||6.09|1.26|K2III|",
"21:27:25.3|59:45:0|-1||6.1|1.75|M3IIIaBa0.2|",
"21:42:33.0|10:49:29|-1||6.09|-0.11|B5IV|",
"21:42:38.9|49:36:1|-1||6.09|1.0|G8II|",
"22:11:2.4|-21:13:57|-1||6.09|0.5|F6V|",
"22:15:35.1|-44:27:7|-1||6.1|1.02|G8-K0III|",
"22:36:7.9|35:34:38|-1||6.1|1.0|K0|",
"22:55:51.4|-31:37:59|-1||6.1|1.36|K3III|",
"23:22:56.9|-60:3:21|-1||6.09|1.6|M3III|",
"23:23:45.4|-43:7:28|-1||6.1|1.46|K3III|",
"23:39:28.0|-46:38:16|63|θ|6.09|0.24|A8V+F0V|",
"23:44:1.4|-45:5:0|-1||6.09|0.98|K1III-IV|",
"23:55:16.6|-31:55:18|-1||6.1|-0.08|B6V|",
"0:16:34.1|8:14:24|65|36|6.11|0.92|G8II-III|",
"0:18:42.1|43:47:28|0|26|6.11|-0.08|B8V|",
"0:57:39.7|45:50:23|-1||6.12|1.02|K2III|",
"0:59:49.7|6:28:59|-1||6.11|1.67|M2III|",
"1:2:1.8|-57:0:9|63|ω|6.11|0.94|G8III|",
"1:5:36.8|-9:58:45|20|27|6.12|1.01|K0III|",
"1:6:33.6|12:57:22|65|75|6.12|0.96|G8III|",
"1:12:34.0|45:20:16|-1||6.11|1.64|M1III|",
"1:34:50.7|-31:53:32|-1||6.12|1.11|K0-1III|",
"1:33:39.2|-78:30:17|-1||6.11|0.97|K0III|",
"2:10:25.6|-50:49:28|-1||6.12|0.82|K1V|",
"2:20:41.4|47:18:39|-1||6.11|-0.08|B5V|",
"2:27:51.8|50:34:11|0|66|6.12|0.41|F4V|",
"2:28:35.4|-31:6:9|-1||6.11|1.11|K2IIICNII|",
"2:57:4.6|4:30:4|-1||6.11|1.69|M4IIIab|",
"3:0:11.8|38:7:54|-1||6.11|-0.06|B8Vne|",
"3:0:51.0|-2:52:43|35|7|6.11|1.77|M1III|",
"3:5:39.9|56:4:7|-1||6.11|1.02|G9III|",
"3:7:25.7|17:52:48|6|53|6.11|-0.12|B1.5V|",
"3:11:21.9|13:2:52|-1||6.12|1.02|K0IIIp|",
"3:10:27.4|-48:44:3|-1||6.12|1.12|K1III|",
"3:20:25.6|25:39:46|6|60|6.12|1.24|gK3|",
"3:30:13.6|-41:22:12|-1||6.12|0.48|F7V|",
"3:40:46.3|25:19:46|77|11|6.11|0.06|A2IV|",
"3:39:59.5|-1:7:14|-1||6.12|1.0|K1III-IV|",
"3:44:40.9|46:5:59|-1||6.11|0.28|A7IV|",
"4:12:51.2|22:24:49|-1||6.12|0.19|B9IIIp:Si:|",
"4:20:25.1|18:44:33|-1||6.12|0.37|F3:V|",
"4:26:57.0|-24:4:53|-1||6.11|0.14|A2|",
"4:51:43.4|9:58:30|-1||6.11|0.08|B5V|",
"4:54:53.0|-58:32:50|-1||6.12|0.44|F3V|",
"5:23:51.4|0:52:2|-1||6.11|0.5|F7V|",
"5:22:22.1|-56:8:4|64|κ|6.11|-0.1|B8-9V|",
"5:36:15.9|47:42:55|-1||6.11|0.26|dF0|",
"6:1:20.2|85:10:56|-1||6.11|1.57|M0III|",
"5:37:19.3|8:57:7|-1||6.12|-0.17|B2IV-V|",
"5:37:8.8|-11:46:32|-1||6.11|0.05|A2V|",
"5:36:2.7|-47:18:50|-1||6.11|1.16|K2III+F|",
"5:40:42.1|31:55:15|-1||6.11|2.12|M2IIIS|",
"5:54:13.4|10:35:13|-1||6.12|1.47|G9II|",
"5:59:1.0|-9:22:56|54|1|6.12|0.29|F2IV|",
"6:6:8.5|35:23:15|-1||6.12|0.6|G0V|",
"6:7:26.9|41:51:15|-1||6.12|1.22|K0III|",
"6:6:41.0|-42:17:55|23|π1|6.12|0.25|Am|",
"6:24:20.5|-12:57:45|-1||6.12|-0.08|B5Ve|",
"6:37:40.9|-12:59:6|-1||6.12|1.0|K0|",
"6:41:17.2|11:0:12|-1||6.11|1.68|M1III|",
"6:41:14.1|-40:20:59|-1||6.12|-0.14|B4V|",
"6:44:56.1|-70:26:2|-1||6.11|1.33|K3III|",
"6:53:1.5|38:52:9|7|59|6.12|0.37|F2VDelDel|",
"6:50:1.1|-60:14:57|-1||6.11|0.46|F7III-IV|",
"7:5:39.8|52:45:29|-1||6.12|0.11|A3Vs|",
"7:7:6.4|4:54:37|-1||6.11|-0.13|B9.5III|",
"7:6:2.3|-38:22:58|-1||6.11|0.7|G0IIaCH1|",
"7:13:36.3|-27:21:23|-1||6.12|-0.23|B0.5V|",
"7:34:12.8|-33:27:48|-1||6.11|0.29|A9IV|",
"7:45:35.6|-56:43:21|-1||6.12|0.39|F0II|",
"7:50:5.7|-19:31:25|-1||6.12|1.26|K0|",
"8:0:28.9|-48:52:17|-1||6.12|-0.11|A0pSi|",
"8:13:58.8|-36:20:28|-1||6.11|-0.18|B2IV-V|",
"8:22:46.8|-13:3:17|67|22|6.11|1.0|gG7|",
"8:21:7.7|-64:6:22|-1||6.12|0.93|G6-8III|",
"8:32:42.2|-73:21:24|-1||6.12|0.95|G8III|",
"8:44:55.2|-21:10:4|-1||6.11|0.22|A5V|",
"8:49:50.3|-72:33:3|-1||6.11|0.2|Am|",
"9:6:34.0|-55:48:12|-1||6.11|-0.15|B2IV-V|",
"9:12:26.0|-7:6:35|41|21|6.11|0.22|A3III:m+A0V:|",
"9:20:59.3|38:11:18|-1||6.12|0.38|F2V+F4V|",
"9:17:51.7|-67:3:3|-1||6.11|1.26|K2III|",
"9:32:41.4|1:51:51|-1||6.11|0.62|F7IV-V|",
"9:33:2.1|-8:30:19|-1||6.12|0.98|K0|",
"9:57:10.9|-52:38:20|-1||6.12|-0.13|B3IV|",
"10:3:41.0|-9:34:26|-1||6.12|1.66|K0|",
"10:3:20.5|-46:38:10|-1||6.12|0.02|A0V|",
"10:21:50.3|14:58:32|45|42|6.12|0.02|A1V|",
"10:30:26.6|64:15:27|-1||6.12|0.16|A7III|",
"10:38:50.3|-42:45:13|-1||6.11|0.66|Am+Am:|",
"10:53:24.9|-2:15:19|-1||6.12|0.9|K0III+G0V|",
"10:55:1.0|-42:15:4|-1||6.11|-0.08|A0pSiCr|",
"10:57:48.4|-59:43:55|-1||6.11|1.1|G3Ia|",
"11:12:56.9|-49:44:11|-1||6.11|1.06|G8II-III|",
"11:22:23.1|-44:38:45|-1||6.12|0.92|G8III|",
"11:24:22.1|-42:40:9|-1||6.12|-0.18|B2IV-V|",
"12:15:10.6|-10:18:45|-1||6.11|0.46|F5V|",
"12:25:8.5|-42:30:52|-1||6.11|0.65|G5III+F-G|",
"12:53:11.2|-3:33:11|85|38|6.11|0.5|F5V|",
"12:57:7.7|46:10:37|-1||6.12|1.01|K0III-IV|",
"13:13:12.4|18:43:37|-1||6.11|1.2|G8III|",
"13:29:7.6|-64:40:33|-1||6.11|0.11|ApSrEuCr|",
"13:32:48.1|24:20:47|-1||6.11|0.96|G8III|",
"13:52:0.9|-31:37:10|-1||6.12|0.48|F7V|",
"14:3:27.5|-41:25:24|-1||6.11|-0.11|ApSi|",
"14:11:15.1|32:17:44|-1||6.11|1.26|K4III|",
"14:13:39.9|-54:37:33|-1||6.11|0.05|B5Ve|",
"14:44:55.5|-58:28:40|-1||6.11|1.02|K0III|",
"14:55:58.7|32:18:1|-1||6.12|0.1|A2V|",
"15:23:43.7|-1:1:21|75|8|6.12|0.25|F0V|",
"15:35:33.2|17:39:20|75|15τ3|6.12|0.94|gG8|",
"15:38:48.9|34:40:30|-1||6.11|1.02|K0|",
"15:50:16.3|-45:24:6|-1||6.12|0.29|A9III|",
"16:20:32.6|-39:25:51|-1||6.12|-0.07|B9V|",
"16:26:11.5|11:24:27|-1||6.11|1.03|G8III|",
"16:43:53.9|-41:6:47|-1||6.12|-0.07|B6-7V|",
"16:50:59.8|-37:30:52|-1||6.11|0.12|B9pSi*|",
"17:1:47.4|-58:57:30|-1||6.11|-0.03|B2IVne|",
"17:16:21.5|-35:44:58|-1||6.12|0.48|G0IV-V|",
"17:38:57.8|13:19:45|-1||6.12|0.56|F6III|",
"17:48:38.1|-55:24:6|-1||6.11|0.28|A9IV|",
"17:51:44.5|-45:36:2|-1||6.11|0.95|G6III|",
"17:48:47.9|19:15:19|-1||6.12|0.02|A1V|",
"18:13:16.5|21:52:49|-1||6.12|1.47|K4III|",
"18:17:6.8|40:56:12|-1||6.11|0.99|G8.5IIIbFe-1CH0.5|",
"18:43:29.0|53:52:19|-1||6.11|0.12|A2IV|",
"18:48:16.1|48:46:3|-1||6.12|0.21|A7III|",
"18:58:21.3|-31:2:10|-1||6.12|1.35|K3III|",
"19:36:26.1|-18:51:10|-1||6.11|0.27|F0III|",
"19:48:3.0|-13:42:12|-1||6.11|0.2|A6m|",
"19:47:26.8|47:54:28|-1||6.12|1.64|M2III|",
"19:49:27.5|38:42:36|-1||6.11|0.9|G5-8III|",
"19:56:19.0|56:41:13|-1||6.12|0.0|A4Vn|",
"20:7:41.4|34:25:23|-1||6.11|0.16|B5Ib|",
"20:25:42.5|-2:48:1|-1||6.11|1.19|gK1|",
"20:31:4.3|-15:3:23|-1||6.12|0.79|gG5+F|",
"20:35:51.7|-69:36:40|-1||6.11|1.29|K2III|",
"20:34:50.4|51:51:15|-1||6.11|0.41|A9II|",
"20:59:59.7|-36:7:47|-1||6.11|0.39|F5V|",
"21:6:23.5|26:55:28|-1||6.12|1.05|K0II-III|",
"21:15:46.8|-36:12:39|-1||6.12|1.37|K3III|",
"21:20:33.5|60:45:25|-1||6.11|1.0|G5III|",
"21:26:15.4|-54:39:38|43|γ|6.12|0.34|F1III|",
"21:28:52.7|55:25:7|-1||6.12|0.14|B8III|",
"21:36:48.9|-33:2:53|66|7|6.11|0.22|A7Vn|",
"21:35:27.0|24:27:8|-1||6.11|0.0|A4V|",
"21:41:34.3|40:48:19|30|76|6.11|0.07|A2V|",
"21:48:29.4|38:38:55|-1||6.12|-0.08|B8V|",
"21:58:30.1|-59:0:44|43|κ1|6.12|0.46|F3V|",
"21:58:43.8|-21:10:58|-1||6.12|1.65|M4III|",
"22:8:17.2|25:32:37|-1||6.11|0.27|F1IV|",
"22:8:41.0|45:44:31|-1||6.11|0.72|G2IV+K0III|",
"22:13:49.5|63:9:45|-1||6.11|-0.08|B8Vn|",
"22:42:20.8|53:54:32|-1||6.12|1.62|K2|",
"22:48:47.8|54:24:54|-1||6.12|-0.07|B5Vne|",
"22:52:9.9|-63:11:19|-1||6.12|1.03|K0III|",
"22:54:35.7|16:56:30|-1||6.12|1.77|S4+/1+|",
"22:54:59.5|1:3:53|65|1|6.11|0.2|A7III|",
"23:8:23.7|-79:28:51|-1||6.12|0.14|A3-4V|",
"23:7:10.1|52:48:59|-1||6.11|1.05|K0III|",
"23:14:6.6|-62:42:0|-1||6.12|0.79|G8V|",
"23:14:40.2|-10:41:19|-1||6.12|1.49|K5III|",
"23:52:23.4|21:40:15|-1||6.11|1.59|M2III|",
"0:4:53.8|34:39:35|-1||6.12|0.62|G2V|",
"0:6:36.8|29:1:17|-1||6.13|0.75|K0V|",
"0:17:43.0|51:25:59|-1||6.14|-0.13|O9IIInn|",
"0:29:51.9|-14:51:51|-1||6.14|0.37|F2III|",
"0:33:23.3|-71:15:58|81|θ|6.13|0.23|A7IV|",
"0:40:32.9|-23:48:16|-1||6.14|0.7|G3V|",
"0:47:13.6|19:34:44|65|59|6.13|0.27|F0Vn|",
"1:6:7.7|-23:59:33|-1||6.14|1.09|G8-K0III|",
"1:24:39.8|-15:39:37|-1||6.14|0.91|G5|",
"1:27:46.6|-10:54:6|-1||6.13|1.32|K4III-IV|",
"1:30:52.3|66:5:53|-1||6.14|0.08|A2Vs|",
"1:50:20.2|-47:48:59|-1||6.14|1.01|K1IV|",
"2:49:51.0|-24:33:37|36|γ1|6.14|1.07|K1III|",
"2:58:47.4|-9:46:35|-1||6.14|0.22|A2m|",
"2:59:6.6|-28:54:25|-1||6.14|1.04|K1III|",
"3:16:35.7|-9:9:16|35|14|6.14|0.4|F1V|",
"3:30:11.3|59:21:58|-1||6.13|0.08|A2V|",
"3:43:47.2|19:39:54|77|14|6.14|1.01|G8III|",
"3:48:18.3|50:44:12|-1||6.14|0.06|B8Vne|",
"3:54:17.4|-2:57:10|35|32|6.14|0.09|A2V|",
"3:56:4.0|-63:27:49|-1||6.14|1.1|K1-2III|",
"4:4:41.0|-20:22:54|-1||6.13|1.16|K0|",
"4:35:0.5|-19:55:14|-1||6.13|1.17|K3III|",
"4:43:13.8|24:5:20|77|95|6.13|0.54|F7IV-V|",
"5:3:18.6|41:26:30|-1||6.14|0.16|A2IIIShell?|",
"5:4:14.5|30:29:41|-1||6.14|1.21|K0II-III|",
"5:19:27.8|58:7:2|10|15|6.13|-0.03|B5V|",
"5:18:18.9|33:46:2|7|17|6.14|-0.06|B9.5V|",
"5:49:4.9|62:48:29|-1||6.13|0.0|A4V|",
"5:52:17.4|58:57:51|10|30|6.14|-0.04|A0Vs|",
"5:59:48.1|54:32:50|-1||6.14|1.2|K2III|",
"6:31:9.5|11:15:3|-1||6.14|-0.08|B2V:nne|",
"6:38:20.5|-2:32:37|-1||6.14|1.48|K2|",
"6:42:45.8|-22:26:57|-1||6.13|0.34|F0|",
"6:55:14.7|43:54:36|-1||6.13|0.32|A9III|",
"6:53:21.7|-18:56:0|-1||6.14|0.15|A5m|",
"7:5:32.0|-34:46:40|-1||6.14|0.37|F2V|",
"7:48:8.5|-40:39:8|-1||6.14|1.58|M2III|",
"7:57:12.5|-63:17:49|-1||6.14|-0.1|B8V|",
"8:4:41.5|-19:43:41|67|14|6.13|-0.16|B3III|",
"8:5:44.9|-33:34:9|-1||6.14|1.11|G1Ib|",
"8:20:17.1|-5:19:45|-1||6.13|1.33|K2III|",
"8:20:27.4|-22:55:29|-1||6.13|1.04|K0|",
"8:25:49.9|17:2:46|11|25|6.14|0.41|F6V|",
"8:39:22.1|-36:36:25|-1||6.13|0.42|F1IV|",
"8:45:21.4|30:41:52|11|46|6.13|0.94|G5III|",
"8:45:1.3|5:40:50|41|10|6.13|0.2|A6V|",
"8:53:55.7|35:32:18|-1||6.14|0.04|A4III|",
"8:52:30.7|-13:14:1|-1||6.13|1.14|K0|",
"8:56:36.9|4:14:12|-1||6.14|1.0|G8II-III|",
"9:12:12.9|3:52:2|-1||6.14|-0.01|A0Vp|",
"9:12:12.3|-76:39:47|-1||6.14|1.09|K1III|",
"9:20:43.8|51:15:58|-1||6.13|0.42|F3V|",
"9:29:24.5|-2:12:19|-1||6.14|0.22|F0III|",
"9:31:38.9|-10:33:8|-1||6.14|0.24|F0Vn|",
"9:31:55.8|-10:22:14|-1||6.13|1.19|K0|",
"9:42:42.7|35:5:36|46|13|6.14|0.36|F3V|",
"10:5:10.5|52:22:15|-1||6.14|0.0|A5IV|",
"10:3:34.3|-61:53:2|-1||6.14|-0.04|B7IVne|",
"10:9:31.8|-35:51:24|-1||6.13|0.6|F8V|",
"10:22:12.9|-19:52:1|-1||6.13|0.03|A1V|",
"10:26:9.5|-42:44:20|-1||6.13|1.13|K1III|",
"10:33:25.3|-58:11:25|-1||6.14|0.35|B7Iae|",
"10:56:16.9|22:21:6|-1||6.14|1.55|K2|",
"10:57:15.7|-75:5:59|-1||6.13|1.53|K1II|",
"11:3:14.6|0:45:9|-1||6.14|0.26|F0V|",
"11:5:4.2|-49:23:33|-1||6.13|-0.02|B9.5V|",
"11:12:30.4|-18:30:0|28|ψ|6.13|-0.01|A0V|",
"11:16:58.2|-7:8:5|-1||6.14|0.2|A8IVpeSrCrSi|",
"11:37:53.0|50:37:6|-1||6.14|1.07|G9III:Ba2.5|",
"11:50:19.5|-15:51:50|-1||6.13|0.95|K0|",
"11:55:54.7|-39:41:21|-1||6.13|1.02|K0III|",
"12:5:39.7|62:55:59|-1||6.13|1.17|K2III|",
"13:6:22.7|62:2:31|-1||6.14|0.99|G7III|",
"13:43:45.2|22:42:1|-1||6.13|1.42|K4III|",
"13:56:19.8|-54:7:55|-1||6.14|0.07|A1V|",
"13:57:27.7|-23:1:22|-1||6.14|1.43|K0|",
"14:1:19.0|-40:13:20|-1||6.13|1.25|K1III|",
"14:36:24.2|-39:35:50|-1||6.13|1.05|K1III|",
"14:45:20.7|18:53:5|-1||6.13|0.83|K0|",
"14:48:54.1|0:50:52|-1||6.14|-0.04|B9VSi:Cr:|",
"14:48:23.3|24:22:0|-1||6.14|0.48|F2-6V|",
"15:3:57.8|65:55:11|-1||6.13|0.0|A2Vs|",
"15:14:10.3|42:10:17|-1||6.13|1.66|M2IIIa|",
"15:44:42.1|17:15:51|75|26τ8|6.14|0.0|A0V|",
"15:54:30.0|-27:20:19|-1||6.14|-0.07|B6Vp|",
"15:56:33.4|-14:49:45|-1||6.13|0.23|A2III|",
"16:1:6.4|-54:34:40|-1||6.13|0.25|A5V|",
"16:7:22.2|21:49:21|-1||6.14|1.37|K4III|",
"16:8:46.6|17:12:21|39|8|6.14|0.0|A0Vnn|",
"16:15:24.0|-42:53:59|-1||6.14|1.11|K2III|",
"16:15:47.4|27:25:20|-1||6.14|1.31|K2|",
"16:51:53.9|-65:22:32|-1||6.13|-0.02|B8II-III|",
"16:49:40.5|43:25:50|-1||6.13|1.26|K0IV|",
"16:50:43.1|32:33:13|-1||6.13|1.01|K0III|",
"17:6:28.4|-35:27:4|-1||6.13|0.5|O9.5Iab|",
"17:1:16.7|60:38:57|-1||6.13|1.0|K1III|",
"17:12:25.0|-27:45:43|-1||6.14|-0.04|B9Vn:|",
"18:4:37.3|1:55:9|-1||6.14|0.0|B0IIIn|",
"18:25:31.5|-63:1:17|-1||6.14|0.2|A3V|",
"18:21:28.5|5:26:9|-1||6.13|-0.04|B3Ve|",
"18:52:37.0|-29:22:46|-1||6.13|1.35|K1III|",
"18:52:1.9|13:57:56|-1||6.14|0.0|B8Vnn|",
"18:58:24.6|-22:31:46|-1||6.14|0.09|A2V|",
"19:9:48.1|-19:48:13|-1||6.13|1.16|K1III|",
"19:12:46.1|-50:29:11|-1||6.13|0.95|G8III|",
"19:29:52.6|-55:26:29|-1||6.13|0.98|K0-1III|",
"19:30:54.0|-21:18:44|-1||6.13|0.12|A2|",
"19:51:11.1|-2:27:39|-1||6.13|1.57|K5III|",
"19:52:3.5|11:37:44|-1||6.13|0.65|G0V|",
"20:0:26.5|-43:2:36|-1||6.14|1.64|M0II-III|",
"20:5:6.7|51:50:22|-1||6.14|1.6|M1IIIa|",
"20:13:42.8|43:22:45|-1||6.14|1.5|K4III|",
"20:16:19.7|21:35:55|70|18|6.13|1.04|K1III|",
"20:19:17.9|-47:34:49|-1||6.13|0.46|F5V|",
"20:20:20.5|14:34:9|-1||6.13|0.91|G8III|",
"20:28:24.9|-3:21:28|4|68|6.13|-0.06|B9V|",
"20:34:11.7|-13:43:16|-1||6.13|0.54|F6V|",
"20:31:46.5|56:46:48|-1||6.14|1.43|gK5|",
"21:17:2.0|53:59:51|-1||6.13|0.05|A1V|",
"21:26:28.1|1:6:12|-1||6.13|0.44|F5V|",
"21:55:20.7|61:32:31|-1||6.13|1.6|G8Ib|",
"22:5:16.4|46:44:41|-1||6.13|1.61|M4IIIab|",
"22:7:25.5|53:18:26|-1||6.14|0.43|A3Ib|",
"22:27:26.5|39:48:35|-1||6.14|-0.14|B2V|",
"22:31:18.4|-6:33:18|-1||6.14|0.56|F7V|",
"22:58:35.0|-35:31:23|-1||6.13|0.58|F8III-IV|",
"23:5:12.8|-17:4:45|-1||6.14|1.37|K0|",
"23:6:18.2|18:31:3|-1||6.13|0.44|F6Vs|",
"23:18:20.0|-67:28:16|-1||6.13|1.35|K2-3III|",
"23:20:44.0|44:6:59|-1||6.13|0.17|A5Vn|",
"0:11:59.1|48:9:9|-1||6.16|1.45|gK4|",
"0:16:21.6|43:35:41|-1||6.15|0.05|A2VpSi|",
"0:45:24.1|-4:37:45|-1||6.15|1.62|M0III|",
"0:45:0.0|-53:42:54|-1||6.15|0.53|F7III|",
"0:45:28.7|-12:52:51|20|18|6.15|0.61|G0V|",
"0:50:18.3|45:0:8|-1||6.15|0.01|A0pCr|",
"0:54:17.6|-8:44:27|20|21|6.16|0.92|G5IV|",
"1:20:27.8|-11:14:20|-1||6.15|1.11|K1III|",
"1:24:48.7|-2:50:55|-1||6.15|0.96|G8III|",
"1:55:50.5|-78:20:54|42|σ|6.16|0.44|F5-6IV-V|",
"2:6:49.2|25:42:17|6|11|6.15|-0.03|B9IV-Vn|",
"2:30:38.4|19:51:19|6|26|6.15|0.25|A9V|",
"2:44:10.7|-52:34:14|-1||6.15|0.09|A2V|",
"3:12:9.6|42:22:34|-1||6.15|-0.09|B4V|",
"3:7:49.2|-69:15:56|-1||6.15|1.02|K1III|",
"3:16:4.7|45:20:45|-1||6.16|1.67|M2III|",
"3:13:38.0|-29:48:15|-1||6.16|1.05|K1IICNIII|",
"3:24:2.5|-69:37:29|-1||6.15|0.48|G0-5+A3-5V|",
"3:39:25.7|16:32:12|-1||6.16|1.0|K0III|",
"3:57:26.4|24:27:43|-1||6.16|1.37|K0|",
"4:20:10.0|31:57:12|-1||6.16|1.71|K5|",
"4:28:3.6|1:51:31|-1||6.15|1.02|G9III|",
"4:29:20.0|-46:30:55|-1||6.16|1.06|K1III|",
"4:57:44.8|-14:13:53|-1||6.15|-0.21|B1V|",
"5:15:11.3|59:24:20|-1||6.15|1.18|K2III-IV|",
"5:15:18.4|-1:24:33|-1||6.15|0.39|F0IV|",
"5:26:54.3|35:27:26|-1||6.15|1.45|K2|",
"5:26:51.3|33:15:46|-1||6.15|1.15|K0|",
"5:25:47.0|0:31:15|-1||6.16|-0.18|B2.5V|",
"5:27:13.8|15:15:28|-1||6.16|0.08|A1IV|",
"5:37:15.1|64:9:17|10|19|6.15|0.01|A0V|",
"5:37:16.5|-27:52:17|23|ν1|6.16|0.34|F0IV|",
"5:44:8.6|61:28:36|10|23|6.15|0.9|gG5|",
"5:42:14.3|-17:31:49|-1||6.15|1.38|K0|",
"5:44:26.5|-22:25:18|-1||6.15|0.94|K2V|",
"6:11:1.3|-6:45:15|-1||6.15|0.01|A0pSrCr|",
"6:18:5.6|14:22:58|-1||6.16|0.01|A3V|",
"6:26:34.5|-4:35:50|-1||6.15|-0.14|B2.5V|",
"6:28:18.8|10:18:14|-1||6.15|1.15|K2III-IV|",
"6:29:14.9|2:38:46|-1||6.16|1.54|gM1|",
"6:30:34.7|-13:8:53|-1||6.16|-0.15|B1.5V|",
"6:31:10.6|-61:52:47|-1||6.15|-0.15|B3V|",
"6:37:52.7|4:57:26|-1||6.15|0.14|B1Ib|",
"6:49:3.7|1:0:7|-1||6.15|-0.13|B3II-III|",
"7:8:36.3|37:26:42|-1||6.16|1.21|K1III|",
"7:12:7.4|5:28:29|-1||6.16|1.14|K0III|",
"7:50:55.2|-11:7:43|-1||6.16|1.13|K0|",
"7:54:39.9|-34:50:49|-1||6.15|1.53|K4III|",
"8:4:45.2|18:50:32|-1||6.15|-0.05|B9V|",
"8:15:58.9|-35:54:10|-1||6.16|1.55|K2III|",
"8:17:23.1|-16:17:6|67|21|6.16|0.01|A2V|",
"8:22:30.2|-6:10:45|-1||6.15|0.22|A8IV|",
"8:21:24.2|-39:37:15|-1||6.16|0.17|A3V|",
"8:39:42.6|73:37:47|-1||6.15|1.02|G7III|",
"8:50:45.1|18:49:56|-1||6.16|-0.01|A2Vs|",
"9:8:43.5|-26:46:4|-1||6.15|0.17|A4IV|",
"9:21:27.2|32:54:7|-1||6.16|1.09|K3III|",
"9:43:27.5|-51:13:42|-1||6.15|-0.1|B6V|",
"10:12:23.0|-52:9:48|-1||6.16|1.17|K2IIICNII|",
"10:15:16.6|-54:58:27|-1||6.16|-0.17|B2IV-V|",
"10:27:0.5|19:21:52|-1||6.15|1.14|K0|",
"10:48:57.2|29:24:57|46|43|6.15|1.15|sgK1|",
"10:59:14.0|-61:19:13|-1||6.16|-0.06|B8IV|",
"11:0:8.6|-51:49:4|-1||6.15|0.18|A3III-IV|",
"11:31:50.4|81:7:38|-1||6.15|0.24|A2m|",
"11:32:23.3|-26:44:48|-1||6.16|1.66|M1III|",
"11:49:1.2|0:19:7|-1||6.15|0.52|F7V|",
"12:1:29.0|-57:30:13|-1||6.16|0.0|A0V|",
"12:14:43.4|53:26:5|-1||6.16|1.04|gK0|",
"12:17:47.3|-36:5:38|-1||6.15|0.01|A0V|",
"12:20:17.7|26:0:7|-1||6.15|0.3|F0IV|",
"12:28:33.4|-56:24:28|-1||6.15|0.92|K0-1III|",
"12:45:1.7|-68:49:52|-1||6.16|0.69|F6Ia|",
"12:51:57.9|-26:44:17|-1||6.15|0.23|A0III|",
"13:12:56.0|-59:49:0|-1||6.16|0.6|G0V|",
"13:13:57.5|-43:8:20|-1||6.16|1.38|K4III|",
"13:22:52.7|-47:56:35|-1||6.16|0.18|A4V|",
"13:32:5.3|-38:23:57|-1||6.16|1.04|K1III|",
"13:42:12.7|8:23:18|-1||6.16|0.42|F3Vp|",
"13:55:50.0|14:3:23|-1||6.16|0.5|F6V|",
"14:2:59.7|50:58:19|-1||6.15|0.01|A2V|",
"14:16:30.1|-3:11:47|-1||6.15|-0.01|A1V|",
"14:49:6.7|37:48:40|-1||6.16|0.36|F2V|",
"14:58:36.8|-39:54:24|-1||6.15|1.23|K2III|",
"15:7:40.3|5:29:53|-1||6.16|0.94|K0III|",
"15:28:44.5|47:12:5|-1||6.15|0.1|AmA3-F0V:|",
"15:54:52.6|-60:44:36|-1||6.15|0.1|B9II|",
"16:7:24.0|-56:11:29|-1||6.16|0.58|F2II|",
"16:25:22.0|-63:7:29|-1||6.15|0.03|A1V|",
"16:36:55.0|63:4:22|-1||6.16|1.53|K5|",
"16:42:58.4|55:41:25|-1||6.16|0.07|A2VpSr|",
"16:56:36.0|-40:49:25|-1||6.15|0.26|B0.5Ia|",
"17:25:2.7|-34:41:47|-1||6.16|0.02|A0VSiCr|",
"18:1:35.9|33:18:41|-1||6.15|1.55|K5III|",
"18:8:30.1|-45:46:2|-1||6.15|-0.08|B7-8II|",
"18:5:30.2|21:38:49|-1||6.15|1.23|gK3|",
"18:10:55.2|-33:47:59|-1||6.16|-0.14|B1V|",
"18:17:36.1|-34:6:26|-1||6.16|-0.11|B3V+A|",
"18:22:0.2|-28:25:48|-1||6.16|0.26|A3III|",
"18:25:21.7|-35:59:30|-1||6.15|1.0|K0III|",
"18:24:57.0|-1:34:46|-1||6.15|0.37|F6III+A9III|",
"18:42:36.1|-7:4:24|-1||6.15|1.0|K0-1III|",
"18:48:16.4|23:30:51|-1||6.15|0.49|F8V|",
"18:56:25.6|2:28:16|-1||6.15|0.97|G8III|",
"19:6:52.5|-37:48:37|-1||6.16|0.72|G5IV|",
"19:15:59.4|27:55:37|-1||6.16|0.61|F6Ib-II|",
"19:43:37.6|-37:32:20|-1||6.16|0.01|B8|",
"19:40:41.2|43:4:40|-1||6.16|1.56|M2III|",
"19:54:40.3|7:8:25|-1||6.15|0.03|A2V|",
"19:59:15.4|52:3:21|-1||6.15|-0.19|B5III|",
"20:4:28.8|48:13:47|-1||6.16|0.04|A2IV|",
"20:24:37.5|1:4:7|-1||6.15|-0.04|B9V|",
"20:29:31.3|-22:23:30|-1||6.16|1.55|M1III|",
"20:42:39.7|60:36:5|-1||6.15|0.01|A2IV|",
"20:58:30.8|41:56:25|-1||6.16|-0.08|B7III|",
"21:8:28.2|6:59:22|-1||6.15|1.66|K5III|",
"21:18:55.3|41:2:27|-1||6.15|0.3|A5IV|",
"21:13:21.5|81:13:51|-1||6.15|0.09|A3IV|",
"21:24:7.4|25:18:44|-1||6.15|0.0|A2V|",
"21:31:27.5|52:37:12|-1||6.16|0.9|G2Ib+B9V|",
"21:34:27.5|51:41:54|-1||6.15|0.02|B9IIIe|",
"21:38:45.0|25:29:56|-1||6.16|1.02|G9III|",
"21:37:38.7|54:2:32|-1||6.15|0.99|K1III|",
"21:51:41.8|-18:37:23|-1||6.16|0.36|F0III|",
"21:53:57.8|6:51:52|-1||6.15|0.8|G0IIIs|",
"22:11:55.3|-76:6:58|-1||6.15|1.0|K0III|",
"22:16:37.4|-25:53:54|-1||6.15|1.11|K1II/III|",
"22:16:33.6|-1:35:47|-1||6.15|0.19|A5Vn|",
"22:23:0.2|57:17:4|-1||6.16|-0.13|B8III-IV|",
"22:35:26.4|-78:46:18|-1||6.15|1.38|K1III|",
"22:31:18.4|-2:54:40|-1||6.16|1.08|K0|",
"22:58:15.5|-2:23:43|-1||6.16|0.74|G8IV|",
"23:2:32.6|-6:34:27|3|82|6.15|1.58|M2III|",
"23:8:35.7|-73:35:11|-1||6.15|1.42|K3III|",
"23:23:54.3|-53:48:30|-1||6.15|0.26|A4III|",
"23:56:41.5|22:38:53|-1||6.15|1.6|M2III|",
"0:6:50.1|-23:6:27|-1||6.18|0.38|A7V|",
"0:14:58.2|-34:54:16|-1||6.17|1.34|K3III|",
"0:17:47.7|1:41:20|-1||6.17|0.94|K0II|",
"0:31:25.3|66:31:10|17|13|6.18|-0.1|B6V|",
"0:42:31.1|58:45:12|-1||6.17|-0.01|B9.5III|",
"1:25:35.7|23:30:42|-1||6.18|0.43|F5III|",
"1:31:39.1|-45:34:32|-1||6.17|0.06|A2V|",
"1:36:44.8|-58:16:15|-1||6.18|1.61|M3III|",
"1:41:18.4|25:44:45|-1||6.17|0.44|F2III|",
"1:41:27.3|-38:7:59|-1||6.17|0.42|F2V|",
"1:47:16.8|-41:45:36|-1||6.18|1.54|K5-M0III|",
"2:24:33.8|-40:50:26|-1||6.18|0.66|G2V|",
"2:27:7.0|27:0:48|-1||6.18|1.43|K5III|",
"2:35:4.1|7:28:17|-1||6.18|1.06|gG6|",
"2:38:17.8|37:43:36|-1||6.18|0.47|F6III|",
"2:48:55.5|69:38:3|-1||6.18|0.18|A3V|",
"3:16:0.9|-5:55:7|-1||6.17|-0.02|B9V|",
"3:34:8.3|17:49:58|-1||6.17|0.89|K1IVFe-1|",
"3:49:43.5|23:42:42|-1||6.17|-0.05|B8V|",
"4:6:39.0|65:31:15|-1||6.17|0.14|A3m|",
"4:9:22.4|54:49:44|-1||6.18|0.0|F5V|",
"4:20:52.8|13:51:51|-1||6.17|0.46|F6V|",
"5:5:23.7|1:10:39|-1||6.17|3.45|C6II|",
"5:7:38.3|9:28:19|59|13|6.17|0.62|G1IV|",
"5:13:3.2|61:51:0|-1||6.17|0.02|A2III|",
"5:18:40.4|40:27:54|-1||6.18|1.37|K0|",
"5:20:56.6|19:48:51|-1||6.18|1.23|K0III|",
"5:39:43.7|75:2:38|-1||6.17|1.57|M0III|",
"5:33:38.8|20:28:27|-1||6.18|-0.07|B6V|",
"5:47:7.6|-16:14:16|-1||6.17|0.89|G2Ib-II|",
"5:47:13.0|-54:21:39|-1||6.18|1.4|K3III|",
"5:51:28.6|-22:55:34|-1||6.17|1.02|K0|",
"6:9:36.2|-5:42:40|-1||6.17|0.34|F3IVw|",
"6:11:43.7|-4:39:56|-1||6.18|-0.08|B9pHgMn|",
"6:37:40.3|2:42:15|-1||6.17|1.08|K1III|",
"6:38:0.6|-61:31:59|-1||6.18|0.62|G1-2V|",
"7:1:52.9|-1:20:44|-1||6.17|1.28|G5II|",
"7:39:11.9|24:13:21|-1||6.17|0.01|A2V|",
"7:39:54.1|32:0:35|-1||6.17|0.35|F6II|",
"7:41:23.6|-22:20:14|-1||6.18|1.62|M1III|",
"7:36:4.2|-77:38:3|-1||6.18|1.73|M0III|",
"7:48:33.6|23:8:28|37|82|6.18|0.0|G2III+A4V|",
"7:44:13.0|-69:49:17|-1||6.18|-0.06|A0IV-V|",
"7:50:47.4|3:16:38|-1||6.18|1.12|K1III|",
"7:56:23.9|4:29:9|-1||6.17|0.98|G8III|",
"8:20:13.1|0:54:34|-1||6.18|0.6|F9V|",
"8:31:19.9|37:15:57|-1||6.18|-0.03|A0V|",
"8:50:21.6|-28:37:5|-1||6.17|-0.08|B9V|",
"8:57:8.2|17:8:38|-1||6.17|1.0|K1III|",
"8:59:39.9|-19:12:29|-1||6.18|0.46|F6V|",
"9:6:59.9|1:27:46|-1||6.17|1.65|M1III|",
"9:30:46.1|-31:53:22|1|ζ1|6.18|0.03|A0V|",
"9:33:30.3|36:29:13|46|9|6.18|1.27|gK4|",
"9:36:25.3|-48:45:5|-1||6.17|0.27|ApSrEuCr|",
"9:47:18.0|79:8:12|-1||6.17|0.25|F0V:|",
"9:44:36.7|64:59:2|-1||6.17|0.0|F3Vn|",
"10:25:17.2|-42:28:5|-1||6.18|1.0|G8III|",
"10:59:17.9|51:52:56|-1||6.17|1.38|K0|",
"11:38:9.8|8:53:3|-1||6.17|1.08|K1III|",
"11:47:7.0|-35:54:25|-1||6.17|0.96|G8III|",
"11:53:26.8|-35:4:0|-1||6.17|0.08|A2V|",
"11:59:3.4|0:31:50|-1||6.17|1.26|K2IV|",
"12:0:18.6|80:51:11|-1||6.17|1.61|M2III|",
"12:10:2.5|-34:42:18|-1||6.17|0.03|A0V|",
"12:12:46.8|-70:9:7|-1||6.17|0.84|F6Ib|",
"12:55:53.3|-15:19:37|-1||6.17|0.0|A0Vn|",
"13:20:34.9|-59:46:24|-1||6.18|0.43|F3-F5II|",
"13:22:35.7|-60:58:20|-1||6.18|0.01|B2.5Vn|",
"13:30:0.1|7:10:44|-1||6.17|1.47|K5|",
"13:50:6.5|-29:4:53|-1||6.18|-0.03|A0V|",
"14:3:1.7|-31:41:2|-1||6.18|0.48|F8V|",
"14:5:46.5|-54:40:10|-1||6.17|0.23|A5III-IV|",
"14:8:51.9|-43:28:16|-1||6.17|-0.06|B9V|",
"14:27:24.4|-6:7:13|85|104|6.17|0.09|A2IV|",
"14:51:0.1|0:15:26|-1||6.18|1.4|K3III|",
"15:7:56.8|-65:16:32|-1||6.17|1.47|K3III|",
"15:6:27.1|-22:1:55|-1||6.17|1.05|gK1|",
"15:14:33.7|-17:46:7|48|26|6.17|-0.05|B9.5III|",
"15:10:44.1|67:46:53|-1||6.17|0.0|A8Vn|",
"15:18:41.3|-31:12:34|-1||6.18|1.23|G6-8III|",
"15:20:53.7|-18:9:31|48|28|6.17|1.02|G8III|",
"15:39:18.3|-77:55:5|-1||6.18|1.2|K2IIICN0.5Ba-1|",
"15:47:53.6|-65:26:33|-1||6.18|0.22|A5III-IV|",
"16:16:55.3|-3:57:12|-1||6.18|0.31|A9Vn|",
"16:38:52.7|-60:59:25|-1||6.18|-0.08|B7Vn|",
"16:40:50.5|-60:26:46|-1||6.18|0.48|F2III-IV|",
"17:4:41.3|19:35:57|-1||6.17|-0.01|B9.5V|",
"17:16:14.2|2:11:10|-1||6.17|0.22|A2V|",
"17:32:24.5|-34:16:47|-1||6.17|0.35|F2V|",
"17:33:31.7|57:33:32|-1||6.17|0.59|G5III+A5V|",
"17:44:34.0|2:34:46|58|61|6.17|0.07|A1IV-V|",
"17:47:45.6|-22:28:41|-1||6.18|1.49|G6IbHdel1|",
"17:50:43.5|11:56:48|-1||6.17|1.25|K1III-IV|",
"17:53:19.6|-34:43:50|-1||6.17|-0.03|B8V|",
"17:53:3.6|-10:53:59|-1||6.18|1.11|gK1|",
"18:19:40.2|-63:53:13|-1||6.18|0.58|F9V|",
"18:24:9.2|83:10:31|-1||6.17|0.05|A2V|",
"18:46:41.4|18:42:21|-1||6.17|1.59|K5|",
"18:51:35.9|28:47:1|-1||6.18|1.18|K1II-III|",
"19:11:23.1|40:25:45|-1||6.18|0.09|A3V|",
"19:24:21.4|-43:43:23|-1||6.17|1.6|M1-2III|",
"19:38:25.9|-57:59:0|-1||6.18|0.97|K0III|",
"19:46:35.0|32:53:19|-1||6.18|1.13|K3III|",
"19:54:17.7|-23:56:28|-1||6.18|1.02|K2V|",
"20:0:25.3|-49:21:4|-1||6.17|1.06|K0III|",
"19:59:22.7|1:22:40|-1||6.17|1.13|G8III|",
"20:8:31.3|-10:3:46|-1||6.18|0.06|B9.5III|",
"20:24:54.4|-83:18:38|-1||6.17|0.2|Am|",
"20:20:30.4|53:35:46|-1||6.18|1.56|K4III|",
"20:22:52.3|14:33:5|-1||6.17|0.51|F8V|",
"20:30:58.1|20:36:21|-1||6.18|0.15|A1m|",
"20:31:21.1|52:18:35|-1||6.18|1.01|K0III|",
"21:7:44.6|-17:27:19|-1||6.17|0.02|A0V|",
"21:14:10.3|29:54:4|-1||6.17|1.09|G6Ib-IIaCa1Ba0.3|",
"21:38:56.2|-79:26:33|-1||6.18|0.46|F4IV|",
"21:37:43.7|6:37:6|61|3|6.18|0.02|A2V|",
"21:42:8.4|45:45:57|-1||6.17|1.55|M4III:|",
"21:47:38.1|-5:55:2|-1||6.17|0.22|A7V|",
"21:49:19.0|61:16:22|-1||6.17|1.67|M1II-III|",
"21:51:4.9|39:32:12|-1||6.17|-0.08|B9pHgMn|",
"21:57:2.2|-37:44:49|-1||6.18|0.33|F1III-IV|",
"22:10:19.0|19:37:1|-1||6.18|0.69|G0V|",
"22:12:57.5|-26:19:40|-1||6.17|0.17|A3V|",
"22:16:59.8|-23:8:24|-1||6.17|1.05|G5|",
"22:18:56.2|37:46:10|-1||6.17|0.28|A9IIIp|",
"22:20:55.8|8:11:12|-1||6.17|0.44|F6V|",
"22:42:22.1|-29:21:39|66|19|6.17|1.54|M5III|",
"22:57:40.7|39:18:32|-1||6.18|-0.15|B2IV-V|",
"23:11:49.2|26:50:50|61|60|6.17|0.94|G8III-IV|",
"23:20:40.9|-5:54:29|-1||6.17|1.07|K0III|",
"23:29:0.6|-9:15:58|-1||6.18|1.44|K0|",
"23:30:7.4|49:7:59|-1||6.17|1.46|K3III|",
"23:34:46.7|38:1:26|-1||6.18|1.58|K7III|",
"23:44:28.9|-26:14:47|-1||6.17|0.5|F4V|",
"0:7:18.2|-17:23:11|-1||6.19|0.14|A6Vn|",
"0:8:41.0|36:37:36|-1||6.19|0.48|F8IV|",
"0:26:37.4|0:2:59|20|10|6.19|0.9|G8III|",
"0:30:27.8|-40:56:22|-1||6.19|0.33|F2III|",
"0:55:14.7|24:33:25|-1||6.2|1.62|M4IIIab|",
"1:4:27.6|29:39:31|-1||6.19|0.43|F7IV-V|",
"1:12:59.5|30:3:51|-1||6.19|1.0|G9III+G1V|",
"1:22:37.0|1:43:35|-1||6.2|1.52|K5IIIab|",
"1:28:22.9|7:57:41|-1||6.2|1.12|K1III|",
"1:43:54.8|-4:45:56|-1||6.19|1.54|K0|",
"2:29:13.6|23:28:8|-1||6.19|0.15|A5m|",
"3:2:9.3|-6:29:41|-1||6.19|0.6|G0IV-V|",
"3:7:50.9|-27:49:52|-1||6.19|0.16|A5V|",
"3:23:17.8|-7:47:39|-1||6.2|0.7|G2V|",
"3:33:56.8|-31:4:49|-1||6.2|0.48|F5V|",
"3:39:25.4|-10:26:14|-1||6.19|1.03|G5|",
"3:56:37.9|-9:45:3|-1||6.19|0.28|F1V|",
"4:22:57.9|59:36:59|-1||6.19|0.0|A4V|",
"4:46:25.8|-28:5:15|-1||6.19|0.19|A3IV|",
"5:2:50.4|66:49:22|-1||6.19|0.48|dF6|",
"5:4:21.6|21:16:41|-1||6.19|1.32|K0|",
"5:6:49.6|43:10:29|-1||6.2|0.43|F2IIp:|",
"5:14:44.3|53:12:50|-1||6.2|0.07|A0V|",
"5:30:15.9|-63:55:40|-1||6.19|0.22|F0IV|",
"5:37:53.4|-4:48:49|-1||6.19|-0.04|B2IV-V|",
"5:42:11.6|-30:32:8|-1||6.19|0.01|A0V|",
"5:52:55.5|68:28:17|-1||6.2|0.95|G9III|",
"5:30:13.9|-84:47:6|-1||6.2|-0.02|B9.5IV-V|",
"6:2:33.8|-14:29:50|-1||6.2|0.96|G5|",
"6:23:36.0|-9:52:28|-1||6.19|1.84|K5|",
"6:31:10.1|16:56:19|-1||6.2|1.16|K2III|",
"6:30:59.8|-40:54:59|-1||6.2|1.4|K3III|",
"6:33:26.1|-52:19:44|-1||6.19|1.09|G8III|",
"6:43:13.8|37:8:49|-1||6.19|1.03|K0|",
"6:43:6.5|3:2:0|-1||6.19|1.37|K0|",
"6:47:23.5|18:11:36|-1||6.2|0.07|A2V|",
"7:24:17.2|-22:54:46|-1||6.19|-0.09|B8|",
"7:38:32.6|-38:46:52|-1||6.19|1.02|G8III|",
"7:43:5.4|0:11:22|-1||6.19|1.02|K0III|",
"8:5:20.4|-46:58:44|-1||6.19|-0.15|B3Vnp|",
"8:9:10.2|-35:27:18|-1||6.2|0.89|G8III|",
"8:12:13.3|17:38:52|11|16ζ2|6.2|0.6|G5V|",
"8:33:4.8|-24:36:23|-1||6.19|0.27|A8IV|",
"8:37:27.1|-4:56:1|-1||6.19|1.05|K0|",
"8:48:49.4|66:42:29|-1||6.2|-0.11|B8V|",
"8:57:42.0|9:23:16|-1||6.19|0.98|G8III|",
"9:1:11.4|-26:39:50|-1||6.2|1.13|K1IIICNII|",
"9:26:28.5|-40:30:7|-1||6.2|0.25|A7III|",
"9:29:16.3|-38:24:14|-1||6.19|0.22|A7Vn|",
"9:36:46.3|-52:56:39|-1||6.19|1.05|K0III|",
"9:56:59.7|-69:6:7|-1||6.2|-0.1|B3V|",
"10:1:40.5|-53:21:52|-1||6.2|-0.13|B2.5V|",
"10:1:58.0|-57:20:59|-1||6.2|1.12|K1II|",
"10:2:59.9|-60:10:43|-1||6.19|0.17|A6II-III|",
"10:15:20.9|-36:31:5|-1||6.19|1.06|K0III|",
"10:24:44.3|-73:58:18|-1||6.19|0.07|A2-3V|",
"10:30:58.7|-7:38:15|-1||6.2|1.38|K5III+F6V|",
"10:30:8.7|-66:59:6|-1||6.19|0.01|B4IV|",
"10:54:42.2|25:29:27|46|48|6.2|0.28|A8V|",
"10:59:56.8|77:46:12|-1||6.2|0.97|G9III|",
"10:59:13.8|-84:35:38|57|η|6.19|0.11|A1V|",
"11:31:44.9|14:21:52|45|88|6.2|0.57|G0V|",
"11:39:50.4|-16:37:13|-1||6.19|1.62|M3.5IIIBa0.2Ca1|",
"12:22:10.8|24:46:26|-1||6.19|-0.01|A0V|",
"12:31:38.7|-5:3:9|-1||6.19|1.04|gG9|",
"12:35:58.6|-20:31:38|-1||6.2|0.33|F0III|",
"12:41:34.4|10:25:35|85|27|6.19|0.19|A7Vn|",
"13:0:38.8|18:22:23|-1||6.2|0.42|F6Vs|",
"13:7:53.6|27:33:21|-1||6.19|1.36|K4III|",
"13:15:9.7|-36:22:16|-1||6.19|0.97|K1III|",
"13:18:34.6|-51:17:10|-1||6.19|0.01|A0V|",
"13:16:28.6|68:24:29|-1||6.2|-0.06|B9.5V|",
"13:28:46.4|-69:37:41|-1||6.2|0.02|ApSi|",
"13:45:35.1|-15:46:3|85|85|6.19|0.05|A2Vn|",
"13:53:52.2|-35:18:52|-1||6.19|1.02|K1IV-V|",
"13:54:58.2|-8:3:32|-1||6.19|0.53|F8V+G0|",
"13:58:31.2|-65:48:2|-1||6.2|1.05|K0III|",
"14:2:31.8|9:41:11|-1||6.2|0.9|F8IV|",
"14:6:10.9|-43:5:31|-1||6.2|0.98|G8III|",
"14:17:21.1|51:18:26|-1||6.2|0.04|A2IV|",
"14:19:40.9|0:23:3|-1||6.19|0.2|A7V|",
"14:24:18.3|8:5:6|-1||6.19|1.2|K4III|",
"14:36:59.8|-12:18:19|-1||6.2|0.46|F5V|",
"14:59:56.0|-75:1:57|-1||6.2|-0.04|B9V|",
"15:13:35.6|38:15:53|-1||6.2|1.2|gK2|",
"15:19:31.6|-37:5:48|-1||6.2|0.96|G6III-IV|",
"15:21:35.3|-40:44:59|-1||6.2|0.07|A1V|",
"15:20:41.6|44:26:3|-1||6.19|0.39|F3-4IVs|",
"15:37:28.5|-26:16:48|-1||6.19|0.01|B7IV|",
"15:53:22.8|-62:36:25|-1||6.19|1.47|K3III|",
"15:51:38.4|-14:8:1|-1||6.19|1.0|G8III|",
"16:3:9.3|59:24:39|-1||6.19|1.58|M1III|",
"16:9:31.7|-32:38:59|-1||6.19|0.79|K0-2III|",
"16:43:45.5|-41:7:8|-1||6.2|0.14|A4V|",
"16:57:26.1|-10:57:48|-1||6.19|1.0|G8-K0III-IV|",
"17:5:48.6|-44:6:18|-1||6.19|0.28|A4III|",
"17:11:3.2|24:14:16|39|63|6.19|0.23|A8V|",
"17:25:6.2|-24:14:37|-1||6.19|1.1|gK1|",
"17:26:56.3|-51:56:57|-1||6.19|-0.03|B8-9V|",
"17:40:11.8|-2:9:9|-1||6.19|1.67|K2.5Ib|",
"17:44:17.3|14:24:37|-1||6.19|0.21|A3m|",
"17:52:52.7|-41:59:48|-1||6.2|0.54|F8IV-V|",
"17:54:54.0|-24:53:14|-1||6.2|0.04|O7.5II((f))|",
"18:17:24.0|-28:39:9|-1||6.19|0.18|A5/7V|",
"18:27:56.5|-17:48:0|-1||6.2|0.01|B8V|",
"18:36:45.6|43:13:19|-1||6.2|0.24|F0V|",
"18:53:2.5|-48:21:36|-1||6.19|0.14|A2V|",
"18:52:59.6|-46:35:9|-1||6.19|0.03|A1IV-V|",
"19:17:48.2|2:1:54|-1||6.19|0.02|A1Vn|",
"19:25:25.8|24:54:46|-1||6.19|0.51|F7V|",
"19:40:43.4|-16:17:36|71|54|6.2|1.13|K2III+F8V|",
"19:39:34.4|45:57:29|-1||6.2|0.9|G8-K0II-III|",
"19:41:52.0|50:31:3|-1||6.2|0.66|G2.5V|",
"19:51:19.4|47:22:38|-1||6.2|0.36|F2V|",
"20:1:15.3|37:5:56|-1||6.2|1.31|K0III|",
"20:5:9.8|38:28:42|-1||6.19|0.64|G5IV|",
"19:59:36.6|76:28:53|33|69|6.2|1.61|M3III|",
"20:22:55.5|42:59:0|-1||6.2|0.95|K0III|",
"20:30:59.2|36:56:9|30|44|6.19|1.01|F5Iab|",
"20:35:32.2|-16:31:33|-1||6.19|0.2|A7V|",
"20:37:23.6|38:19:43|-1||6.2|0.99|K0III|",
"20:29:3.1|83:37:32|-1||6.19|0.13|A3/4Vm|",
"21:2:24.1|44:47:28|-1||6.19|1.69|S4/1III|",
"21:11:20.7|-72:32:39|-1||6.2|1.08|K1III|",
"21:17:23.2|42:41:0|-1||6.19|-0.11|B7Vn|",
"21:38:2.9|-64:49:27|-1||6.2|0.03|A0-1IV|",
"21:37:27.9|44:41:48|-1||6.2|0.19|A7III|",
"21:40:43.3|54:52:20|-1||6.2|1.16|K0III|",
"21:56:14.0|-57:53:58|43|π|6.19|0.21|Am|",
"21:54:35.9|-3:18:4|-1||6.2|0.48|F5IV|",
"22:6:12.4|45:14:55|-1||6.19|0.09|A3V|",
"22:48:30.2|-10:33:20|3|70|6.19|0.28|A9III-IV|",
"22:49:0.7|68:34:13|-1||6.19|0.0|F5V|",
"22:54:34.1|-7:12:17|3|78|6.19|1.28|K3III|",
"23:1:30.7|57:6:20|-1||6.2|1.5|K1.5II|",
"23:24:7.8|-18:41:15|-1||6.19|1.02|G8III|",
"23:27:9.1|-50:9:26|-1||6.2|-0.08|B9V|",
"0:0:30.9|59:33:35|-1||6.19|1.01|G9III-IV|",
"0:30:55.0|77:1:10|-1||6.21|0.84|K0IV|",
"0:51:33.7|51:34:16|-1||6.21|0.0|B9.5V|",
"0:52:24.3|-69:30:16|81|λ1|6.22|0.56|F7IV-V|",
"0:56:12.9|57:59:48|-1||6.21|1.37|K3III|",
"1:2:42.9|-65:27:22|-1||6.21|1.64|M2III|",
"1:24:2.5|-8:0:27|20|44|6.21|0.23|F0V|",
"1:35:46.4|14:39:41|65|101|6.22|-0.04|B9.5III|",
"1:44:17.9|57:32:11|-1||6.21|0.1|A3V|",
"2:3:42.6|18:15:12|-1||6.21|1.42|gK4|",
"2:19:10.9|46:28:21|-1||6.21|0.0|A4V|",
"2:22:57.8|-18:21:16|-1||6.22|0.94|G5|",
"2:33:40.2|-20:0:7|-1||6.21|1.1|K0|",
"2:38:36.9|3:26:35|-1||6.21|1.0|G9III|",
"2:44:20.5|-32:31:30|-1||6.22|0.04|A1V|",
"2:56:50.6|51:15:39|-1||6.22|1.57|K5III|",
"2:54:6.5|-50:52:17|-1||6.21|1.58|K4III|",
"3:47:49.6|-36:6:21|-1||6.21|-0.1|B8V|",
"3:53:13.0|-18:26:4|-1||6.22|0.88|gK+F|",
"4:18:8.2|42:8:28|-1||6.22|-0.08|B9V|",
"4:30:38.3|32:27:29|-1||6.21|-0.04|B9.5Vn|",
"4:31:25.9|-13:38:42|-1||6.21|0.12|A3V|",
"4:39:23.1|25:13:6|-1||6.22|0.16|A5Vn|",
"5:0:49.0|-5:45:12|-1||6.22|1.06|K3V|",
"5:13:59.9|-14:36:24|-1||6.21|0.37|F2III|",
"5:30:19.8|4:12:15|-1||6.21|1.27|K2IIIe|",
"5:31:20.9|-6:42:30|-1||6.22|-0.17|B2V|",
"5:34:3.9|-1:2:8|-1||6.22|-0.17|B2.5V|",
"5:40:37.3|-2:49:30|-1||6.22|-0.2|B1.5V|",
"5:43:19.5|23:12:15|-1||6.21|-0.06|B2.5Ve|",
"5:41:41.5|-16:43:32|-1||6.21|-0.13|B3IVp|",
"5:47:4.7|-28:38:21|-1||6.22|-0.15|B5V|",
"5:57:54.2|1:13:28|-1||6.22|1.48|M0III|",
"6:0:19.0|44:35:31|-1||6.22|0.0|K2III+K0III|",
"5:58:11.7|0:59:39|-1||6.22|1.14|K0|",
"6:0:17.7|-12:53:59|-1||6.22|0.36|F0|",
"6:19:7.9|-8:35:11|-1||6.22|-0.04|B9V|",
"6:27:56.6|20:29:46|37|16|6.22|0.01|A2Vs|",
"6:38:38.1|1:36:49|-1||6.21|0.15|O9.5II|",
"6:46:12.1|-37:46:32|-1||6.21|-0.13|B4Vne|",
"6:54:42.1|-1:45:23|-1||6.21|0.56|B3IVe+K2II|",
"6:53:55.3|-24:32:21|-1||6.21|0.01|A1|",
"6:58:41.8|-45:46:5|-1||6.22|0.0|A0V|",
"7:9:20.3|-10:20:50|-1||6.21|0.03|O6.5V|",
"7:28:47.3|15:6:34|-1||6.22|-0.05|B9IV|",
"7:33:22.1|-14:20:18|-1||6.21|-0.04|B1V|",
"7:43:22.2|22:23:58|-1||6.21|0.93|K0III|",
"7:42:53.3|-58:13:48|-1||6.21|1.05|K0III|",
"7:57:20.0|-47:53:25|-1||6.22|-0.1|B5V|",
"8:1:50.7|8:54:50|-1||6.22|0.57|G0IV|",
"8:5:37.0|27:31:47|-1||6.21|0.01|A0V|",
"8:15:52.5|-30:55:33|-1||6.21|0.78|G5-8III+G:|",
"8:43:0.2|46:54:4|-1||6.22|0.96|G8III|",
"8:46:23.8|-41:7:32|-1||6.21|-0.05|B9Ve|",
"8:45:5.3|-58:43:30|-1||6.21|-0.09|B7III|",
"9:45:55.4|-58:47:39|-1||6.22|0.46|F5IV|",
"9:59:6.1|-23:57:1|-1||6.21|-0.1|B4Ve|",
"10:6:47.4|5:36:41|76|14|6.21|0.94|K1III|",
"10:16:3.1|-59:54:12|-1||6.22|0.2|A5V|",
"10:45:3.6|-59:41:3|16|η|6.21|0.61|pec|",
"11:14:54.0|-43:44:3|-1||6.21|1.61|K4III|",
"11:20:53.8|67:6:2|-1||6.21|1.01|G8|",
"11:38:24.1|-2:26:10|-1||6.22|1.12|G9III|",
"11:39:51.1|-14:28:7|-1||6.21|0.0|A1V|",
"11:42:3.5|-20:17:38|-1||6.22|0.95|K0|",
"11:56:53.2|61:32:57|-1||6.22|0.96|G8III|",
"11:57:3.7|-33:18:55|-1||6.21|-0.04|A0V|",
"12:2:51.6|-7:41:1|-1||6.22|1.49|K5|",
"12:8:24.6|-60:50:50|-1||6.22|1.74|K3-4II|",
"12:14:16.8|-64:24:31|-1||6.22|0.12|B1.5Ia|",
"12:16:23.5|-72:36:53|-1||6.22|-0.01|A0V|",
"12:20:28.0|-65:50:34|-1||6.21|-0.04|B9V|",
"12:27:51.6|-4:36:55|-1||6.22|0.44|A8n|",
"12:28:25.5|-61:47:43|-1||6.22|1.26|K2III|",
"12:30:2.9|51:32:8|12|7|6.21|0.51|F6-8V|",
"12:30:50.1|53:4:36|-1||6.21|0.54|F8-G0V|",
"12:35:29.0|-61:50:31|-1||6.22|0.73|G3III|",
"13:12:50.9|-42:41:59|-1||6.22|1.06|K0III|",
"13:21:29.9|-19:29:20|-1||6.21|0.09|A2V|",
"13:23:8.7|-33:11:24|-1||6.22|1.65|M1III|",
"13:40:15.6|31:0:43|-1||6.21|0.96|G5II:|",
"13:44:45.7|-25:30:3|-1||6.21|1.38|K0|",
"14:17:3.8|-18:35:7|-1||6.22|0.98|G5|",
"14:23:25.6|-11:42:51|48|2|6.21|0.99|G7III|",
"14:23:6.8|25:20:17|-1||6.22|0.37|F5V|",
"14:41:55.7|-58:36:58|-1||6.22|0.45|F4V|",
"15:1:58.1|-34:21:32|-1||6.22|0.24|A8IV|",
"15:30:36.3|-20:43:42|-1||6.22|0.17|A5m|",
"15:31:43.4|-20:9:53|-1||6.22|0.22|A8V|",
"15:32:9.7|16:3:22|75|12τ2|6.22|-0.05|B9V|",
"15:55:30.4|-31:5:1|-1||6.21|1.37|K4III|",
"16:0:53.7|-40:26:7|-1||6.21|0.01|A0V|",
"16:3:54.7|-24:43:35|-1||6.21|1.38|K0|",
"16:12:25.1|67:8:39|-1||6.21|0.99|G8III|",
"17:12:19.8|-70:43:16|-1||6.22|1.06|K1IVCNIII|",
"17:1:40.2|75:17:50|-1||6.21|0.0|F0IV-Vn|",
"17:15:51.5|-30:12:38|-1||6.21|-0.03|B9.5V|",
"17:24:37.1|-18:26:45|-1||6.21|0.03|B9Vn|",
"17:27:2.1|-12:30:45|-1||6.21|0.51|F7V|",
"17:48:20.2|3:48:15|-1||6.22|0.16|B9.5V|",
"17:52:38.8|-6:8:37|-1||6.21|1.4|F8Ib-G3Ib|",
"18:0:0.1|-20:20:21|-1||6.21|1.4|K0II-III|",
"18:2:30.1|22:55:23|39|97|6.21|-0.1|B3Vn|",
"18:3:9.0|48:27:52|-1||6.21|0.03|A2V|",
"18:23:2.9|16:41:17|-1||6.22|1.2|K0|",
"18:33:0.9|-39:53:32|-1||6.22|0.42|F5IV|",
"18:34:31.2|-52:53:31|-1||6.22|1.25|K2III|",
"18:35:53.2|16:58:32|-1||6.21|0.53|G2V+G2V|",
"18:45:23.7|-56:52:54|-1||6.22|1.38|K3III|",
"18:48:2.7|4:14:29|-1||6.21|1.51|K5|",
"18:56:22.7|-1:48:0|-1||6.22|-0.05|B9III|",
"18:53:46.3|57:29:13|-1||6.22|1.23|gK5|",
"18:58:23.8|6:14:25|-1||6.21|0.46|F5IV|",
"18:58:46.6|40:40:45|-1||6.22|-0.16|B3V|",
"18:53:33.2|75:47:15|-1||6.22|0.0|A1V|",
"19:19:1.2|37:26:43|-1||6.22|-0.03|A0III|",
"19:43:14.6|58:0:59|-1||6.22|0.56|G0V|",
"19:50:21.7|-61:3:41|-1||6.21|-0.14|B5V|",
"20:5:21.5|56:20:29|-1||6.21|0.43|F4V|",
"20:12:23.9|-42:46:50|-1||6.22|1.23|K1III|",
"20:11:3.5|21:8:5|-1||6.22|0.9|K0|",
"20:17:31.5|29:8:53|-1||6.22|1.01|G9III|",
"20:19:29.2|13:13:1|-1||6.21|1.63|M1III|",
"20:26:23.2|17:18:56|-1||6.22|1.01|K0|",
"20:28:16.8|2:56:13|-1||6.21|0.9|G8III|",
"20:39:51.4|-62:54:28|-1||6.22|1.1|K1III|",
"20:37:18.3|0:5:49|-1||6.22|-0.08|B8IIIp|",
"20:39:13.2|-2:24:46|-1||6.22|-0.1|B7IIIne|",
"20:41:58.2|17:31:17|-1||6.22|0.94|G8III|",
"20:49:20.5|-18:2:9|-1||6.21|1.42|K3III|",
"20:49:59.1|5:32:41|-1||6.21|0.98|K0|",
"21:0:33.8|-4:43:49|3|11|6.21|0.63|G1V|",
"21:15:14.7|-40:30:23|-1||6.21|1.14|K2III|",
"21:39:59.7|-52:21:33|-1||6.21|0.6|F7III|",
"21:43:13.5|-19:37:15|-1||6.22|0.27|A3m|",
"21:47:4.7|17:11:39|-1||6.21|0.34|F3V|",
"21:58:55.0|-4:22:23|-1||6.22|1.0|K2V|",
"22:15:59.8|8:32:58|-1||6.21|0.02|A1Vn|",
"22:23:54.2|38:34:25|-1||6.22|0.49|F5IV:|",
"22:39:47.0|19:40:52|61|41|6.21|0.0|A2V|",
"22:50:10.2|50:40:37|-1||6.21|1.14|G4Ib|",
"23:0:37.9|0:11:9|65|3|6.21|0.89|G4III|",
"23:1:23.6|-7:3:40|3|81|6.21|1.41|K5III|",
"23:7:57.2|64:13:21|-1||6.21|1.1|K0|",
"23:55:7.8|7:4:16|65|26|6.21|-0.07|B9V|",
"0:1:19.3|49:58:54|-1||6.22|0.97|G7II-III|",
"0:8:52.2|25:27:46|-1||6.23|0.97|K0III|",
"0:14:56.1|22:17:3|-1||6.24|-0.01|A1pSi|",
"0:22:25.5|13:28:57|65|42|6.23|1.22|K3III|",
"0:58:22.4|-60:41:47|-1||6.23|0.1|Am|",
"1:17:3.6|-66:23:53|-1||6.24|0.05|A0V|",
"1:20:34.5|-3:14:49|-1||6.23|1.02|K1III|",
"1:37:37.7|-9:24:14|-1||6.24|0.53|F7V|",
"1:54:53.8|40:42:7|-1||6.24|1.25|K2|",
"2:3:10.5|73:51:2|-1||6.23|0.0|A5III|",
"2:11:25.0|31:31:35|79|5|6.23|0.11|A1m|",
"2:30:54.4|17:42:14|6|27|6.23|0.9|G5III-IV|",
"2:33:54.6|-51:5:37|-1||6.24|0.52|F6V|",
"2:56:24.8|64:19:57|-1||6.24|2.03|K3Ib|",
"3:29:26.2|46:56:16|-1||6.24|0.13|B7V|",
"3:39:38.3|-3:23:35|-1||6.23|1.04|G5|",
"4:13:34.8|10:12:44|-1||6.23|0.05|B8Vn|",
"4:23:35.9|42:25:41|-1||6.23|0.0|A1pSi|",
"4:27:0.7|2:4:46|-1||6.23|1.09|K1III|",
"4:30:9.7|-13:35:32|-1||6.24|1.0|G5|",
"4:57:17.2|-1:4:2|-1||6.23|0.42|F2|",
"5:2:0.0|1:36:32|-1||6.24|-0.04|B8V|",
"5:26:2.4|-5:31:6|-1||6.23|-0.06|B9.5Vn|",
"5:29:40.6|29:11:11|-1||6.24|0.45|F6III|",
"5:35:22.5|-4:25:31|-1||6.24|-0.15|B2.5V|",
"5:41:20.3|53:28:52|-1||6.23|0.84|K1V|",
"6:2:55.1|32:38:9|-1||6.24|0.42|F4V|",
"6:5:34.0|33:35:57|-1||6.23|-0.08|B9pSi|",
"6:18:40.5|9:2:50|-1||6.24|0.87|K0|",
"6:23:46.0|-15:4:18|-1||6.24|1.53|K2|",
"6:25:28.1|14:43:19|-1||6.24|2.34|C5II|",
"6:28:28.0|16:14:18|-1||6.23|0.9|G5|",
"6:37:54.9|73:41:44|-1||6.24|0.38|F2|",
"6:32:46.9|-11:9:59|-1||6.24|1.11|G9.5III:Ba3|",
"6:53:22.5|10:59:47|-1||6.24|0.97|K0III|",
"6:57:42.4|-27:32:15|-1||6.23|-0.14|B2.5V|",
"6:57:17.6|-35:30:27|-1||6.23|0.46|F8IV-V|",
"7:10:9.3|-18:41:7|-1||6.23|0.4|F0|",
"7:18:4.1|30:57:21|-1||6.24|-0.03|A0Vn|",
"7:22:18.5|-2:58:44|-1||6.23|0.68|F5|",
"7:24:50.7|-19:0:44|-1||6.24|0.29|A2Ib|",
"7:30:51.1|-5:13:35|-1||6.24|1.18|K0|",
"7:40:47.3|13:46:15|-1||6.24|0.0|K0|",
"7:49:28.6|-13:21:12|-1||6.23|-0.09|B8III|",
"7:55:40.8|35:24:46|-1||6.23|0.28|A3IVp:|",
"8:6:27.5|-9:14:42|-1||6.23|-0.07|B9V|",
"8:10:58.8|14:37:46|-1||6.23|0.02|A1V|",
"8:32:33.5|53:6:53|-1||6.24|1.01|K0IV|",
"8:33:21.8|36:26:11|50|32|6.24|0.36|F5Vbvw|",
"8:33:30.4|-46:58:16|-1||6.24|1.56|K3III|",
"8:52:28.6|28:15:33|11|53|6.23|1.62|M3III|",
"9:29:49.9|-23:20:43|-1||6.24|1.57|K0|",
"9:33:20.1|-7:11:24|-1||6.24|1.17|K0|",
"9:45:30.8|78:8:5|-1||6.23|1.35|K2III|",
"9:41:38.5|25:54:46|45|13|6.24|1.25|gK2|",
"9:50:30.1|4:20:37|76|4|6.24|0.48|F7Vn|",
"9:54:31.7|-22:29:18|-1||6.24|0.04|A2|",
"10:8:15.9|31:36:15|-1||6.24|0.45|F4V|",
"10:9:56.5|-12:5:45|-1||6.24|0.18|A5m|",
"10:34:12.9|-60:59:16|-1||6.23|1.4|K2-3III|",
"10:42:31.3|-13:58:30|-1||6.24|1.54|K2|",
"11:2:24.4|-26:49:53|-1||6.23|0.31|F1V|",
"11:31:47.6|-20:46:36|-1||6.24|0.54|F7IV|",
"12:5:56.7|-35:41:38|-1||6.23|-0.08|B8V|",
"12:6:19.8|-68:39:3|-1||6.23|1.24|G3Ib|",
"12:11:31.4|-51:21:34|-1||6.23|0.82|G6III+G:|",
"12:18:31.6|30:14:57|-1||6.23|0.3|A9.5III|",
"12:26:24.2|71:55:47|-1||6.24|1.06|gG8|",
"12:33:47.4|33:23:5|-1||6.24|1.05|K0III|",
"12:50:19.6|-48:27:35|-1||6.24|0.05|A0V|",
"12:52:24.6|-53:49:46|-1||6.24|1.13|G8Ib-II|",
"13:40:39.1|28:3:55|-1||6.23|1.28|K3III|",
"14:1:10.5|27:23:12|8|11|6.23|0.17|A7III|",
"14:3:55.8|4:54:3|-1||6.24|0.39|F4V|",
"14:13:13.2|-26:36:44|-1||6.24|1.08|K0III|",
"14:14:23.5|41:31:8|-1||6.24|1.04|gK3|",
"14:49:6.9|-56:40:4|-1||6.23|1.13|K1III|",
"15:36:11.4|-33:5:34|-1||6.24|0.0|B8V|",
"15:40:58.3|-47:44:8|-1||6.23|1.63|K5-M0III|",
"15:46:45.4|-6:7:13|-1||6.24|1.17|K0|",
"16:22:38.9|-2:4:47|-1||6.23|0.07|B9V|",
"16:43:3.4|-46:4:14|-1||6.23|0.85|F5Iab|",
"16:41:11.5|-1:0:2|-1||6.24|0.3|A7III|",
"17:28:7.7|-63:2:11|-1||6.24|-0.09|B7-8V|",
"17:42:3.9|-50:30:38|-1||6.24|1.76|M3+II-III|",
"17:43:22.0|14:17:42|-1||6.24|0.42|F5II|",
"17:45:40.3|31:30:17|-1||6.23|0.0|A0Ib|",
"17:50:10.5|78:18:24|-1||6.24|1.44|K5|",
"18:41:51.6|-23:50:0|71|26|6.23|0.23|Am|",
"18:44:55.4|54:53:48|-1||6.23|0.82|G5III|",
"19:2:8.7|-41:54:36|-1||6.23|0.0|A0V|",
"19:1:37.8|-22:41:44|-1||6.24|1.66|K5|",
"19:8:3.6|21:41:56|-1||6.23|0.4|F3V|",
"19:41:57.5|40:15:14|-1||6.23|0.18|A6V|",
"19:54:40.4|-61:10:15|-1||6.24|0.16|A4V|",
"19:52:21.8|18:40:19|70|9|6.23|0.01|O7.5Iaf|",
"20:20:15.2|39:24:12|-1||6.23|0.06|A1V|",
"20:54:35.0|-50:43:40|-1||6.24|-0.12|B5IV|",
"20:56:17.0|56:53:15|-1||6.23|-0.18|B2.5IV|",
"22:14:38.6|-41:22:54|-1||6.23|0.65|G5V|",
"22:35:52.9|-57:53:1|-1||6.23|0.2|A5V|",
"22:38:22.2|-7:53:52|-1||6.23|0.78|G0III+F0V|",
"23:33:42.7|45:3:29|-1||6.24|0.98|G8II|",
"23:40:40.6|36:43:15|-1||6.23|0.39|F1V|",
"23:41:54.5|57:15:36|-1||6.24|0.0|G8III|",
"23:49:31.6|-15:51:40|-1||6.24|1.22|K2IIIbFe-0.5|",
"23:53:20.8|-24:13:45|-1||6.24|0.19|A3Shell|",
"0:3:25.7|63:38:31|-1||6.24|0.33|B3Ia|",
"0:14:2.3|33:12:22|-1||6.25|-0.01|A1V|",
"1:16:13.5|87:8:43|-1||6.25|1.12|gK2|",
"1:8:1.3|32:0:44|65|78|6.25|0.4|F5IV|",
"1:18:10.2|47:25:11|-1||6.25|1.35|K0|",
"1:44:46.1|57:5:21|-1||6.25|0.04|A2V|",
"2:25:16.0|56:36:36|62|10|6.25|0.31|B2Ia|",
"2:30:16.6|33:50:2|-1||6.25|1.07|K1III|",
"2:37:6.4|32:53:31|-1||6.25|0.48|F8V|",
"2:40:15.7|6:6:43|-1||6.25|0.4|F3V:|",
"2:46:58.3|35:59:1|-1||6.25|0.93|G8III|",
"2:49:30.8|57:5:3|-1||6.25|0.89|A5Ia|",
"3:1:52.3|5:20:10|-1||6.25|1.05|K0|",
"3:16:1.9|34:41:19|-1||6.25|0.28|A1m|",
"3:15:0.2|-26:6:1|-1||6.25|0.04|A5V|",
"3:34:37.4|-9:52:7|-1||6.25|0.02|A2V|",
"3:47:48.9|32:11:42|-1||6.25|0.47|G0|",
"3:52:4.3|31:10:6|-1||6.25|0.2|A5V|",
"4:13:49.9|12:45:12|-1||6.25|1.16|K0|",
"4:33:32.9|18:1:0|-1||6.25|0.07|B9IVn|",
"4:43:44.2|-41:3:53|-1||6.25|1.46|K3-4III|",
"5:10:58.0|-2:15:14|-1||6.25|0.98|K1-IVa|",
"5:26:5.7|16:42:1|77|113|6.25|-0.08|B2Vn|",
"5:43:30.2|-39:24:25|-1||6.25|0.37|F3V|",
"5:51:25.7|32:7:30|-1||6.25|1.75|M3III|",
"5:57:35.0|66:5:46|-1||6.25|1.36|K0|",
"6:16:58.7|23:44:27|37|9|6.25|0.45|B3Ib|",
"6:25:29.9|-35:3:50|-1||6.25|1.36|K3III|",
"7:54:29.3|47:23:10|50|25|6.25|1.15|gK2|",
"8:0:48.0|19:48:58|-1||6.25|1.11|K1III|",
"7:56:50.7|-59:7:35|-1||6.25|2.08|M0III|",
"8:46:6.9|-11:0:23|-1||6.25|1.61|K5III|",
"8:50:32.2|33:17:7|-1||6.25|0.49|F7Vn|",
"8:53:5.9|59:3:22|-1||6.25|0.0|F5IV-V|",
"8:59:15.7|-28:48:22|-1||6.25|1.0|G8III|",
"9:15:14.6|-45:33:20|-1||6.25|-0.08|B8V|",
"9:33:59.1|23:27:14|-1||6.25|1.46|gK7|",
"10:11:17.8|-7:19:0|-1||6.25|0.01|A2Vn|",
"10:15:7.7|59:59:8|-1||6.25|1.6|M0III|",
"10:13:19.4|-27:1:44|-1||6.25|0.31|A9mA8-F3|",
"10:46:16.8|-60:36:12|-1||6.25|0.04|A0IV|",
"11:27:53.7|-1:42:0|-1||6.25|1.04|gK2|",
"12:24:44.7|-41:23:3|-1||6.25|1.18|K2-3III|",
"12:38:52.5|-67:11:35|-1||6.25|0.06|B1Ia|",
"12:53:49.7|12:25:7|85|41|6.25|0.27|A7III|",
"13:12:25.4|80:28:17|-1||6.25|0.94|K0Ib|",
"14:16:32.8|20:7:17|-1||6.25|0.49|F8V|",
"14:42:3.2|61:15:43|-1||6.25|0.41|F2V|",
"15:32:4.4|-38:37:23|-1||6.25|0.2|A7V|",
"15:40:10.4|12:3:11|-1||6.25|0.94|G7.5IIIaFe-0.5|",
"16:2:52.4|-62:32:30|-1||6.25|-0.04|B9.5V|",
"16:8:4.9|17:3:16|39|7κ|6.25|1.14|K1III|",
"16:12:56.5|-4:13:15|-1||6.25|0.13|A1V|",
"16:31:2.8|35:13:30|-1||6.25|1.64|K5|",
"16:54:10.6|-1:36:44|-1||6.25|0.28|F0V|",
"17:16:35.6|-74:31:59|-1||6.25|-0.01|A0V|",
"18:21:31.4|-24:54:54|-1||6.25|1.84|M5III|",
"18:39:33.1|40:56:6|-1||6.25|-0.06|B9V|",
"18:49:37.1|0:50:9|-1||6.25|0.04|A1V|",
"19:9:45.8|65:58:43|33|55|6.25|0.0|A0V|",
"19:15:33.2|-24:10:45|-1||6.25|0.54|F9V|",
"19:16:32.8|-33:31:18|-1||6.25|0.02|G0Ipe(C1,0)|",
"19:24:22.1|16:56:16|70|2|6.25|0.08|A2III-IV|",
"19:29:18.0|0:14:46|-1||6.25|1.32|K2|",
"19:30:46.9|36:13:43|-1||6.25|-0.04|B9.5III|",
"19:39:42.0|-45:16:41|-1||6.25|0.28|F2IV|",
"19:48:55.1|-52:53:17|-1||6.25|1.13|K1III|",
"19:51:17.7|9:37:49|-1||6.25|0.1|A1m|",
"20:26:53.0|-37:24:11|-1||6.25|0.97|K2IV-V|",
"20:28:7.5|8:26:15|-1||6.25|1.08|G9III|",
"20:37:54.6|18:16:9|-1||6.25|1.48|M6III|",
"20:59:36.1|-19:2:7|15|20|6.25|-0.13|B9pSi|",
"21:3:10.2|-27:43:55|-1||6.25|0.95|K0III|",
"21:3:3.0|1:31:55|-1||6.25|0.48|F5V|",
"21:9:33.0|-20:33:23|15|27|6.25|0.38|F1IV|",
"21:33:17.9|45:51:15|-1||6.25|1.81|K1Ib|",
"21:37:33.8|0:23:25|-1||6.25|0.06|A2V|",
"22:45:28.2|19:22:0|61|45|6.25|1.05|gG6|",
"23:27:14.8|1:7:21|65|9|6.25|1.02|G7III|",
"23:29:32.1|-4:31:58|-1||6.25|1.09|K3III|",
"0:1:43.8|42:22:2|-1||6.25|-0.03|B9IIIpHg:Mn:|",
"0:2:57.6|-20:2:46|-1||6.25|0.53|F6V|",
"0:4:56.0|26:38:56|-1||6.25|1.4|K4IIIb|",
"0:28:56.6|36:54:0|-1||6.26|0.92|G5III|",
"0:28:43.1|-50:31:58|-1||6.26|1.09|K0III|",
"0:48:56.7|-46:41:52|-1||6.27|0.9|G8III|",
"0:53:47.6|52:41:21|-1||6.27|0.19|A5m|",
"0:55:5.2|48:40:43|-1||6.27|1.68|M2.5IIIa|",
"1:16:30.7|79:54:36|-1||6.26|0.42|F5Vs|",
"1:24:41.9|-44:31:42|-1||6.26|1.14|K1II|",
"1:27:6.2|34:22:39|-1||6.27|0.46|F7IVbvs|",
"1:44:55.8|20:4:59|65|109|6.27|0.75|G3Va|",
"1:52:50.8|51:28:29|-1||6.26|0.0|A3V|",
"1:54:57.5|37:7:42|-1||6.26|1.17|K0|",
"2:43:26.6|-66:42:52|-1||6.26|0.53|F5V|",
"2:53:21.2|48:34:10|-1||6.26|1.18|G5I|",
"3:8:21.2|18:47:42|6|54|6.27|1.58|M0III|",
"3:11:16.8|-16:1:31|-1||6.26|1.2|K0|",
"3:13:1.5|-35:56:38|-1||6.27|-0.08|B8V|",
"3:39:24.8|75:44:23|-1||6.27|0.97|G9III-IV|",
"4:5:56.5|-8:51:22|-1||6.26|0.06|A3V|",
"4:20:38.7|-6:14:44|-1||6.27|0.91|G8IV:|",
"4:31:24.0|40:0:37|-1||6.26|0.04|B8V|",
"4:48:7.0|55:36:9|-1||6.26|0.0|F0|",
"4:49:42.2|-13:46:11|-1||6.26|0.44|F5V|",
"5:5:0.6|-54:24:27|-1||6.27|1.54|M2III|",
"5:6:9.3|-73:2:16|-1||6.27|-0.01|A1V|",
"5:15:27.7|22:17:5|77|108|6.27|0.08|A2V|",
"5:24:46.2|-52:18:59|64|θ|6.27|0.07|A0V|",
"5:37:16.2|66:41:46|-1||6.26|0.0|A8Vn|",
"5:33:38.0|34:43:33|-1||6.27|0.15|A3IV|",
"5:35:55.5|27:39:44|-1||6.27|1.54|K0|",
"5:36:10.3|-28:42:28|-1||6.26|0.13|A2/3III/V:|",
"6:8:34.6|-44:21:22|-1||6.27|-0.15|B8II|",
"6:9:47.2|-26:42:3|-1||6.27|1.01|G8-K0III|",
"6:24:2.3|8:53:5|-1||6.26|-0.08|B8Vn|",
"6:26:44.9|-7:30:41|-1||6.27|-0.04|A0Vn|",
"6:23:1.3|-63:40:59|-1||6.27|1.6|M1III|",
"6:24:55.6|-63:49:40|-1||6.27|-0.13|B6V|",
"6:44:11.6|53:17:47|-1||6.27|1.08|K0|",
"6:53:7.6|44:50:22|-1||6.26|0.21|A8Vn|",
"6:54:2.3|-50:36:42|-1||6.26|0.99|K0-1III|",
"6:57:25.7|11:54:27|-1||6.27|0.34|F2Ib-II|",
"6:58:39.0|7:37:19|-1||6.27|0.11|A3V|",
"6:59:39.3|-21:36:12|-1||6.26|-0.15|B2-3IV-V:|",
"6:58:39.6|-55:43:46|-1||6.27|1.16|K2III|",
"7:0:42.6|-28:29:22|-1||6.27|0.45|F5V|",
"7:33:13.5|-40:3:32|-1||6.26|-0.12|B8IVpSi|",
"7:36:16.6|-8:18:41|-1||6.27|1.54|K2|",
"7:38:14.5|24:21:37|-1||6.27|0.0|F0|",
"8:7:9.9|43:15:37|50|28|6.26|-0.02|A1V|",
"8:9:23.1|42:25:50|-1||6.27|1.27|gK3|",
"8:8:42.4|13:38:27|11|12|6.27|0.43|F3V|",
"8:9:47.7|-42:38:26|-1||6.26|-0.04|B7V|",
"8:18:15.8|54:8:37|-1||6.27|1.54|K5|",
"8:55:19.3|-45:2:30|-1||6.26|-0.16|B3IV|",
"9:2:6.4|-39:24:9|-1||6.27|1.0|K1III-IV|",
"9:29:2.2|-1:15:25|-1||6.27|0.27|F0Vn|",
"9:29:32.4|-4:14:50|-1||6.26|0.84|G6IV|",
"9:31:32.9|-66:43:10|-1||6.27|1.35|K1III|",
"9:47:6.7|-65:4:21|16|υ|6.26|0.08|B7III|",
"9:55:3.4|61:6:58|-1||6.27|1.05|K0|",
"10:5:15.2|-36:23:2|-1||6.27|1.11|K1III|",
"10:8:35.5|-15:36:42|-1||6.27|-0.01|A0V|",
"10:23:13.1|-30:9:44|-1||6.27|0.31|F0III|",
"10:23:40.4|-41:57:12|-1||6.27|0.88|G8IV|",
"10:41:24.2|-1:44:30|76|33|6.26|0.88|K1IV|",
"10:44:14.5|19:45:31|-1||6.27|0.17|A5V|",
"10:44:19.4|-70:51:36|-1||6.26|0.2|A5IV-V|",
"10:44:26.5|-72:26:38|-1||6.27|0.49|F6V|",
"11:17:11.8|-38:0:52|-1||6.27|0.1|A3Vn|",
"11:19:36.3|-75:8:33|-1||6.27|-0.03|B9.5-A0V|",
"11:38:32.2|33:37:32|-1||6.27|1.32|K2III|",
"11:41:43.6|55:10:21|-1||6.27|1.49|K5|",
"11:45:12.6|-49:4:11|-1||6.26|1.17|K1III|",
"11:48:23.5|-10:18:48|-1||6.26|0.58|F7V|",
"11:51:9.4|33:22:30|-1||6.27|0.32|Am|",
"11:56:43.9|-47:4:21|-1||6.26|0.4|F5V|",
"12:4:28.1|85:35:14|-1||6.27|0.59|F6V|",
"12:15:30.5|-41:54:47|-1||6.26|1.01|K0III|",
"12:19:19.1|23:2:5|24|8|6.27|0.17|A5IIIvs|",
"12:26:48.2|-48:54:48|-1||6.26|0.68|G3-5V|",
"12:33:2.9|10:17:44|85|20|6.26|0.95|G8III|",
"12:33:22.4|-19:47:31|-1||6.26|0.29|F2V|",
"12:39:55.6|-66:30:42|-1||6.26|-0.05|B8V|",
"12:47:33.4|-6:18:7|-1||6.26|0.55|F7V|",
"12:48:41.8|48:28:1|12|11|6.27|0.18|A6m|",
"12:54:13.1|33:32:4|-1||6.26|0.2|A7IV|",
"13:4:48.1|-41:11:48|-1||6.26|1.68|M3-4III|",
"13:20:41.6|2:56:30|-1||6.26|0.1|A3V|",
"13:39:40.8|-39:44:53|-1||6.27|1.66|M4III|",
"14:2:12.2|45:45:13|-1||6.27|1.32|K2III|",
"14:3:36.8|7:32:47|-1||6.26|0.94|G9III|",
"14:23:15.3|1:14:30|-1||6.27|0.63|G1V|",
"14:25:29.2|38:23:35|-1||6.27|1.23|gK2|",
"14:31:42.8|60:13:32|-1||6.27|0.24|F0III|",
"14:33:38.3|79:39:37|-1||6.26|1.3|K3III|",
"15:6:13.9|-36:15:51|-1||6.27|1.65|K5III|",
"15:25:53.3|19:28:51|-1||6.27|0.6|G0IV-V|",
"15:55:39.8|18:37:14|-1||6.26|-0.11|B8III|",
"16:40:34.5|-20:24:31|-1||6.26|1.08|gG9|",
"16:57:4.0|-19:32:24|-1||6.27|0.07|B6V+B7V|",
"17:1:51.2|-18:53:8|58|29|6.26|1.38|K0III|",
"17:19:30.3|-50:3:48|-1||6.27|0.41|F8III+B9V|",
"17:37:26.8|-38:3:56|-1||6.26|1.25|G2Ib|",
"17:39:8.5|2:1:41|-1||6.26|1.03|K0III+F4IV|",
"18:0:57.2|15:5:36|-1||6.26|0.69|G5IV|",
"18:24:58.5|27:23:43|-1||6.27|0.05|A0V+A4V|",
"18:42:14.1|-81:48:28|-1||6.27|-0.13|B8V|",
"18:28:6.2|-26:45:26|-1||6.27|0.16|A3/4V|",
"19:16:28.5|-69:11:26|60|τ|6.27|0.17|A6IV-V|",
"19:15:19.3|50:4:15|-1||6.27|0.0|G8III|",
"19:21:37.1|-19:14:3|-1||6.26|-0.1|B5V|",
"19:19:36.5|54:22:34|-1||6.26|0.03|A1V|",
"19:35:33.6|-12:15:10|-1||6.27|1.09|K0|",
"19:40:18.3|-54:25:3|-1||6.26|1.0|K0III|",
"19:44:34.1|13:18:10|4|48ψ|6.26|-0.03|B9III-IV|",
"19:43:39.6|57:2:33|-1||6.27|0.88|K2III|",
"20:7:35.1|-55:0:59|-1||6.26|0.53|F8V|",
"20:4:44.6|63:53:26|-1||6.26|0.1|A2II-III|",
"20:11:21.1|21:52:32|-1||6.26|-0.02|B1Ibe|",
"20:12:35.2|0:52:3|-1||6.27|0.02|B9pCrEu:Sr:|",
"20:19:3.0|-63:13:52|-1||6.27|1.04|K0III|",
"20:16:3.4|38:53:52|-1||6.27|0.01|A1V|",
"20:20:32.3|-55:3:3|-1||6.27|1.59|M0-1III|",
"20:21:41.0|-49:59:58|-1||6.27|0.55|G0V|",
"20:30:0.7|72:31:54|-1||6.27|1.35|gK4|",
"20:47:3.6|-2:29:12|-1||6.27|1.55|K2|",
"20:47:52.8|52:24:26|-1||6.27|0.89|G7IV|",
"21:10:46.9|-9:21:14|-1||6.27|1.16|K0III|",
"21:13:28.8|15:58:57|-1||6.27|0.24|A7Vn|",
"22:5:51.2|48:13:54|-1||6.27|-0.06|B2V|",
"22:10:21.1|-3:53:39|-1||6.27|-0.01|A1Vnn|",
"22:25:40.7|18:26:40|-1||6.26|1.22|K0|",
"23:7:47.7|63:38:0|-1||6.26|-0.02|B3V|",
"23:37:39.8|16:49:32|61|74|6.26|0.0|A1V|",
"23:41:26.9|49:30:44|-1||6.26|0.19|A4V|",
"23:57:8.3|-26:37:25|-1||6.26|1.45|K3III|",
"23:58:21.2|-15:50:51|20|1|6.26|1.08|K0II-III|",
"0:5:3.8|0:30:11|-1||6.29|1.1|gG9|",
"0:49:33.4|-23:21:42|-1||6.28|0.13|A3V|",
"1:3:17.6|-29:31:33|-1||6.29|0.93|G5IV|",
"1:9:12.3|80:0:42|-1||6.29|0.0|sgG6|",
"1:23:37.5|34:14:45|-1||6.29|0.83|G8IV|",
"1:32:36.3|-49:43:40|-1||6.28|0.46|F4V|",
"2:6:29.3|0:2:6|-1||6.28|0.9|K0|",
"2:13:21.2|74:1:40|-1||6.29|0.91|G8III|",
"2:23:51.8|55:21:52|-1||6.28|0.86|F7Ib|",
"2:57:13.1|-29:51:19|-1||6.29|0.47|A2-3V:+G:|",
"3:8:38.7|8:28:15|-1||6.28|1.06|G9III|",
"3:27:18.7|12:44:6|-1||6.28|-0.02|A0Vs|",
"3:31:29.4|49:12:35|-1||6.29|0.09|A0Vn|",
"3:36:30.0|-78:19:23|-1||6.29|1.15|K2III|",
"4:9:27.6|59:54:29|-1||6.28|1.14|G8IIa|",
"4:24:12.2|-57:4:17|-1||6.29|0.66|G4V|",
"4:53:5.5|-72:24:27|-1||6.28|0.52|F6V|",
"5:0:13.2|-78:18:1|-1||6.29|1.51|K5-M0III|",
"5:24:38.3|31:13:26|-1||6.28|1.24|K1III|",
"5:30:43.4|22:27:45|-1||6.29|1.18|K0|",
"5:47:14.7|42:31:36|-1||6.29|1.35|K0|",
"5:50:56.4|51:30:53|-1||6.29|1.05|K1III|",
"5:55:35.4|-4:47:18|-1||6.28|0.06|A2III|",
"6:30:3.0|-65:34:6|-1||6.29|0.33|F0III|",
"6:41:21.8|16:23:51|-1||6.28|-0.01|A1V|",
"6:42:16.4|-38:23:55|-1||6.29|0.34|A3V+F/G|",
"6:48:12.3|55:42:16|-1||6.28|0.47|dF5|",
"6:50:42.3|-8:2:28|-1||6.29|0.0|A2pSrCrEu|",
"6:55:34.6|8:19:29|-1||6.29|0.04|A0V|",
"6:56:45.7|-35:20:30|-1||6.29|1.29|K2III|",
"7:8:13.3|33:49:56|-1||6.28|1.34|K1|",
"7:17:31.7|-6:40:48|-1||6.29|1.62|K2|",
"7:34:5.1|10:34:6|-1||6.28|-0.01|A1V|",
"7:34:39.5|-51:28:29|-1||6.28|0.08|A1III-IV|",
"8:1:31.5|-55:27:18|-1||6.28|-0.15|B4V|",
"8:3:29.5|-42:56:55|-1||6.29|1.01|G8II|",
"8:8:24.5|-63:48:4|-1||6.28|-0.06|B6Ve|",
"8:17:31.7|8:51:58|-1||6.29|0.98|G8III|",
"8:33:45.1|13:15:26|-1||6.28|1.17|K0III|",
"8:42:20.9|-55:46:27|-1||6.29|1.18|K2III|",
"8:57:58.7|30:14:1|11|61|6.29|0.43|F6V|",
"9:13:18.6|-42:16:25|-1||6.29|1.25|K2III|",
"9:19:32.6|-55:11:12|-1||6.28|-0.1|B5V|",
"9:27:51.6|75:5:54|-1||6.29|0.07|A5Vs|",
"9:25:44.2|63:56:27|-1||6.28|1.46|K2III|",
"9:25:32.5|16:35:8|-1||6.29|0.97|gG9|",
"9:56:46.5|-26:33:1|-1||6.28|0.22|A4V|",
"10:12:2.9|-28:36:23|-1||6.28|0.01|A1V|",
"10:36:21.4|36:19:37|46|35|6.28|0.39|F3V|",
"10:36:4.6|-26:40:30|-1||6.29|0.48|F5V|",
"10:45:9.4|2:29:17|76|36|6.28|1.21|K4III|",
"11:29:43.5|56:44:15|-1||6.28|0.15|A4m|",
"11:37:1.2|-32:59:17|-1||6.29|0.46|F6III-IV|",
"12:0:42.5|-21:50:14|-1||6.28|1.22|K0IV|",
"12:15:41.4|72:33:3|-1||6.29|1.14|K0IIIe+K0IIIe|",
"12:15:20.3|87:42:0|-1||6.28|0.35|F2V|",
"12:33:34.2|24:16:59|24|22|6.29|0.11|A4Vm|",
"13:9:42.0|38:32:2|12|15|6.28|-0.12|B7III|",
"13:13:26.8|-18:49:36|85|54|6.28|0.09|B9III|",
"13:27:20.8|-49:22:51|-1||6.28|-0.12|B3IV|",
"13:40:21.3|57:12:27|-1||6.29|0.1|A2VpSrCrEu|",
"14:4:27.0|-14:58:18|-1||6.28|1.08|G6III|",
"14:4:37.5|2:17:51|-1||6.28|1.02|K0|",
"14:45:13.7|32:47:18|-1||6.28|1.58|M1IIIb|",
"14:52:33.1|-30:34:37|-1||6.29|0.6|G1V|",
"14:57:13.6|-29:9:28|-1||6.29|-0.04|B9V|",
"15:9:25.5|-63:38:34|-1||6.28|0.06|A0pSrCrEu|",
"15:14:50.7|-5:30:10|-1||6.28|1.47|K2|",
"15:18:9.4|-41:3:39|-1||6.28|0.18|Am|",
"15:20:40.7|-67:28:53|-1||6.28|-0.09|B3V|",
"15:22:23.2|12:34:3|75|7|6.28|-0.02|A0V|",
"15:54:40.3|8:34:49|75|40|6.29|0.18|A7Vn|",
"15:56:13.9|-31:47:9|-1||6.29|0.43|F6V|",
"16:5:37.8|8:5:46|-1||6.29|0.08|A3m|",
"16:11:39.7|33:20:33|-1||6.29|1.2|K2III|",
"16:19:7.7|-20:13:4|-1||6.29|1.08|K5III|",
"16:28:43.4|51:24:28|-1||6.29|1.05|G9III|",
"16:50:36.1|41:53:48|-1||6.29|1.08|gK3|",
"16:57:31.0|25:21:10|39|57|6.28|0.9|gG5|",
"17:5:5.3|-45:30:6|-1||6.28|0.07|A2V|",
"17:6:53.2|-26:30:47|-1||6.29|-0.04|A0III|",
"17:10:30.6|52:24:32|-1||6.29|0.0|B9V|",
"17:22:51.3|-2:23:18|-1||6.29|0.68|G5IV|",
"17:24:27.1|36:57:7|-1||6.28|0.88|G5III+F0V|",
"17:35:34.9|-59:50:46|-1||6.28|-0.08|B5II-III|",
"17:40:41.2|31:17:15|-1||6.28|1.05|K0III|",
"17:57:57.8|-39:8:13|-1||6.29|0.01|A0IV-V|",
"17:56:56.0|6:29:16|-1||6.29|0.0|B9III|",
"18:1:23.1|-17:9:25|71|6|6.28|1.8|K3III|",
"18:7:11.4|-21:26:38|-1||6.28|0.12|B0.5Ib|",
"18:6:53.5|50:49:22|-1||6.29|1.04|K0III|",
"18:15:32.6|45:12:34|-1||6.29|0.62|G2V|",
"18:30:14.3|-5:43:27|-1||6.28|0.95|G8II-III|",
"18:37:9.0|16:11:54|-1||6.29|0.9|G8IV|",
"18:39:51.6|7:21:30|-1||6.28|0.96|G8III|",
"18:52:28.5|-26:39:1|-1||6.29|0.94|G8/K0III|",
"18:52:7.1|41:23:0|-1||6.28|-0.09|B9IIIpSi|",
"18:59:58.1|22:48:53|-1||6.29|1.75|M3.5IIIab|",
"19:7:8.5|-18:44:16|-1||6.29|-0.04|B8III|",
"19:33:10.1|60:9:31|-1||6.29|1.57|K4III|",
"19:43:55.9|27:8:8|-1||6.28|1.1|B7V+G1:III|",
"19:53:1.2|47:48:27|-1||6.29|-0.11|B0.5IIIn|",
"19:58:56.4|-30:32:17|-1||6.28|1.05|K1III|",
"20:1:26.4|-40:48:51|-1||6.29|0.11|A2-3V|",
"20:4:53.3|68:1:38|-1||6.28|1.65|M3IIIa|",
"20:17:29.1|42:43:19|-1||6.29|1.64|K4II:|",
"20:41:24.1|-26:0:0|-1||6.28|1.22|K2III|",
"20:42:53.0|-39:33:31|-1||6.29|1.08|K1III|",
"20:51:38.3|-62:25:45|-1||6.28|0.15|A2-3IV-V|",
"20:48:42.7|51:54:38|-1||6.29|-0.07|B8Vnp|",
"21:20:14.0|22:1:35|-1||6.29|-0.08|B6IV|",
"21:39:6.1|-33:40:45|-1||6.28|0.92|G8IV|",
"21:46:24.0|25:33:48|-1||6.28|1.21|K3III:|",
"21:49:26.9|20:27:45|-1||6.29|-0.1|B2V|",
"21:47:1.0|70:9:3|-1||6.29|0.0|A0V|",
"22:2:11.9|-17:54:13|-1||6.28|1.01|gG7|",
"22:26:10.7|-23:40:57|-1||6.29|-0.03|A0V|",
"22:28:19.7|64:5:8|-1||6.29|1.08|K0|",
"22:36:29.3|-40:34:58|38|σ1|6.28|0.12|A3Vn|",
"22:35:53.4|50:4:16|-1||6.29|-0.05|B3V|",
"22:47:19.1|-34:9:40|-1||6.28|1.16|K1III|",
"22:57:32.8|3:48:37|-1||6.28|1.12|K1III|",
"22:59:10.3|52:39:16|-1||6.29|1.42|K2|",
"23:0:24.6|-25:37:36|-1||6.29|1.13|K1III|",
"23:1:23.0|-22:47:27|-1||6.28|0.13|A5V|",
"23:22:40.5|20:49:43|61|65|6.29|-0.04|B9.5V|",
"23:31:42.1|-21:22:10|3|100|6.29|0.33|A9III|",
"23:53:4.8|2:5:26|65|25|6.28|-0.01|A1V|",
"0:0:19.2|-44:17:26|-1||6.29|0.76|G3IV|",
"0:3:51.9|66:42:44|-1||6.29|1.67|M4III|",
"0:13:24.0|26:59:14|-1||6.3|0.65|G0III|",
"0:13:44.2|-26:17:5|-1||6.31|1.48|K5III|",
"0:32:49.1|28:16:49|-1||6.3|1.0|K0III|",
"1:13:45.3|7:34:42|65|86ζ|6.3|0.49|F7V|",
"1:20:19.5|77:34:14|-1||6.31|0.92|G5III|",
"1:26:8.7|34:34:47|-1||6.31|0.47|F7V|",
"1:29:30.4|-46:45:23|-1||6.31|1.66|M2III|",
"2:6:12.3|8:14:51|-1||6.31|1.65|M2III:|",
"2:10:7.8|53:50:35|-1||6.31|0.95|G8III|",
"2:22:11.8|-43:12:0|-1||6.31|1.0|K0III|",
"2:32:14.8|-36:25:39|-1||6.3|1.02|G8III|",
"2:38:27.8|38:5:22|-1||6.3|-0.03|B9.5V|",
"2:42:28.9|10:44:30|-1||6.3|0.06|A2V|",
"2:47:3.5|35:33:18|-1||6.3|0.0|A9V|",
"2:53:11.7|16:29:0|-1||6.31|0.0|F5III|",
"2:59:38.3|-32:30:26|-1||6.31|0.0|A0V|",
"3:8:3.9|52:12:48|-1||6.31|-0.01|B5V|",
"3:15:47.0|32:51:23|-1||6.31|0.37|F4Vvw|",
"3:38:19.7|56:55:58|-1||6.3|-0.13|B9p|",
"3:44:33.8|-54:16:26|-1||6.3|1.04|K1III|",
"3:51:15.8|13:2:45|-1||6.3|-0.07|B9pSi|",
"3:58:29.1|38:50:25|-1||6.3|1.08|gK1|",
"4:6:36.6|54:0:31|-1||6.31|0.99|K0III-IV|",
"4:15:29.2|6:11:12|-1||6.31|0.59|G0IV|",
"4:19:37.5|10:7:17|-1||6.31|1.43|K0|",
"4:36:50.9|-30:43:0|-1||6.3|-0.1|B9IV-V|",
"5:3:54.0|-41:44:42|-1||6.31|0.53|F8V|",
"5:36:54.7|-66:33:37|-1||6.31|-0.07|B9.5V|",
"5:43:9.3|-1:36:47|-1||6.31|1.47|K4III|",
"5:54:15.7|3:13:31|-1||6.31|1.29|K0|",
"6:11:46.0|52:38:50|-1||6.3|0.14|A5IIIm|",
"6:10:39.9|-45:16:55|-1||6.31|-0.03|A0V|",
"6:21:25.8|2:16:7|-1||6.31|0.24|A4.5V|",
"6:24:44.5|-40:17:3|-1||6.31|-0.05|B9V|",
"6:44:12.6|36:6:35|-1||6.31|0.06|A2V|",
"6:43:23.3|-39:11:36|-1||6.3|0.26|A8:mDelDel|",
"6:53:13.4|38:26:17|7|60|6.3|0.49|dF5|",
"6:52:22.9|-5:18:58|-1||6.3|0.99|K0|",
"7:0:18.0|-5:22:1|-1||6.3|0.57|G0III-IV|",
"7:0:8.1|-20:9:32|-1||6.31|-0.15|B4III|",
"7:25:21.9|81:15:27|-1||6.31|-0.04|A0III|",
"7:19:13.7|-33:43:38|-1||6.3|1.31|K2-3III|",
"7:23:58.3|-35:50:16|-1||6.31|-0.15|B7III|",
"7:25:43.0|-31:44:19|-1||6.31|-0.17|B2V|",
"7:32:22.3|-35:57:41|-1||6.3|-0.1|B9V|",
"7:35:56.0|43:1:52|-1||6.3|0.0|F0|",
"7:47:5.8|-39:19:53|-1||6.31|-0.17|B8III|",
"7:52:7.2|3:16:38|-1||6.31|1.59|M4III|",
"8:1:43.8|25:5:23|11|4ω2|6.31|0.01|A1V|",
"8:4:42.9|-62:50:10|-1||6.3|-0.1|B2.5Vn|",
"8:26:47.0|26:56:7|11|23φ2|6.3|0.18|A3V|",
"8:32:53.4|69:19:12|-1||6.31|1.35|K0|",
"8:36:48.7|74:43:25|-1||6.31|0.0|A2m|",
"8:30:39.2|-44:44:14|-1||6.3|-0.02|B4IV|",
"8:31:24.6|-39:3:51|-1||6.31|-0.15|B4V|",
"8:34:29.3|-37:36:41|-1||6.3|1.56|K5III|",
"8:40:27.0|19:32:42|11|41ε|6.3|0.17|A8Vn|",
"8:48:0.2|-52:51:2|-1||6.3|-0.1|B8V|",
"9:13:25.9|-38:36:59|-1||6.31|0.0|A0V|",
"9:24:55.7|51:34:26|-1||6.31|0.75|G2III|",
"9:23:27.4|-60:18:9|-1||6.3|1.48|K1-2II-III|",
"9:35:33.7|-19:35:1|-1||6.31|0.06|A2V|",
"9:39:47.4|-10:34:13|41|37|6.31|-0.03|A0Vn|",
"9:50:23.7|65:35:36|-1||6.31|0.28|A9Vn|",
"9:52:58.0|-27:19:56|-1||6.3|0.62|G1V|",
"9:57:56.9|45:24:52|-1||6.3|1.11|K0III|",
"9:58:26.1|27:45:32|-1||6.3|0.0|F3V|",
"10:16:40.2|-51:12:18|-1||6.3|1.54|M4-5III|",
"10:18:37.8|-36:48:17|-1||6.3|1.28|K2-3III|",
"10:35:24.8|-76:18:33|-1||6.3|1.2|K2III|",
"10:52:36.1|0:12:5|-1||6.31|1.5|K5III|",
"10:55:37.3|24:44:56|45|54|6.3|0.0|A2Vn|",
"11:6:5.8|-51:12:45|-1||6.3|0.95|G8III|",
"11:11:43.7|14:24:1|-1||6.3|0.21|A5V|",
"11:16:27.7|-45:52:48|-1||6.31|0.4|F3V|",
"11:36:40.8|-37:14:16|-1||6.31|0.06|A1V|",
"11:53:50.3|0:33:7|-1||6.3|0.2|F0V|",
"12:1:1.8|-1:46:5|-1||6.31|1.21|gG8|",
"12:25:17.3|-65:46:14|-1||6.3|0.96|G8-K0IV|",
"12:48:47.0|24:50:25|-1||6.31|0.7|G7V|",
"12:52:27.6|16:7:21|-1||6.3|0.16|A7V|",
"12:57:33.2|-22:45:14|-1||6.31|1.07|G5|",
"13:4:49.7|73:1:31|-1||6.31|0.0|F0V|",
"13:27:6.3|-49:8:38|-1||6.31|0.0|A0III-IV|",
"13:42:28.8|41:40:27|-1||6.3|0.86|G6III|",
"14:3:53.1|-22:25:18|-1||6.3|0.45|F5III|",
"14:3:32.3|10:47:12|-1||6.3|0.74|G8V|",
"14:15:38.8|-45:0:3|-1||6.31|0.6|F9V|",
"14:40:32.8|-56:26:27|-1||6.3|1.18|K0-1II|",
"14:47:32.1|-43:33:27|-1||6.3|1.08|G8III|",
"15:10:44.6|-61:25:21|-1||6.3|0.63|G2V|",
"15:13:31.9|22:59:0|-1||6.3|0.06|A2V|",
"15:21:1.4|-15:32:54|48|29ο|6.3|0.41|F0III|",
"15:43:24.9|-15:2:36|-1||6.31|1.16|K0IV|",
"15:57:3.8|-48:9:44|-1||6.31|0.38|F1IV|",
"15:58:30.7|-37:30:11|-1||6.31|1.01|K0III|",
"15:55:49.7|58:54:42|-1||6.31|-0.02|A0V|",
"15:57:29.9|39:41:43|-1||6.31|1.07|K0|",
"16:11:58.6|-19:26:59|72|14ν|6.3|0.13|B8V+B9VpSi|",
"16:14:13.5|5:54:7|-1||6.31|1.15|K2III|",
"16:36:43.0|15:29:53|-1||6.3|-0.11|B9pSiCrSr:|",
"16:31:28.1|72:36:43|-1||6.3|1.32|K2III|",
"16:37:48.0|13:41:13|-1||6.31|0.41|F5IV|",
"17:1:33.0|14:56:58|-1||6.31|0.04|B9pCrEu|",
"16:56:16.8|73:7:40|-1||6.3|0.24|F0V|",
"17:4:45.3|-20:29:41|-1||6.3|-0.02|B6IV|",
"17:6:11.8|-21:33:53|-1||6.3|0.13|A3m|",
"17:12:16.5|-38:49:20|-1||6.3|1.05|K1IIICNII|",
"17:43:47.0|-7:4:46|-1||6.3|0.38|B1.5V|",
"17:57:14.3|23:59:45|-1||6.3|0.63|G2V|",
"18:1:48.3|-36:22:40|-1||6.3|-0.03|B7IV|",
"18:18:40.0|-42:17:18|-1||6.3|-0.11|B0.5Ia|",
"18:17:24.2|-9:45:31|-1||6.31|0.38|A8V|",
"18:18:2.9|13:46:37|-1||6.3|-0.03|B5V|",
"18:19:56.1|51:20:52|-1||6.3|1.1|gK1|",
"18:24:42.1|-7:4:31|-1||6.31|1.16|K0|",
"18:25:54.6|-33:56:43|-1||6.3|-0.08|B5IV|",
"18:27:43.8|-26:38:5|-1||6.31|0.26|A8V+F2V|",
"18:43:51.4|-6:49:7|-1||6.31|0.48|F7V|",
"18:44:40.2|23:35:23|-1||6.31|0.4|F6V|",
"18:53:12.1|-51:55:52|-1||6.31|-0.09|B4III|",
"18:57:34.7|-39:49:24|-1||6.31|0.2|A3|",
"18:58:59.6|50:48:34|-1||6.3|0.98|G8III|",
"19:2:21.6|8:22:27|-1||6.3|1.67|K2III|",
"19:2:7.0|52:15:40|-1||6.31|1.0|G8III|",
"19:5:47.1|29:55:18|-1||6.31|1.65|M0III|",
"19:8:14.6|-24:39:25|-1||6.3|0.04|B9III|",
"19:11:18.9|-29:30:8|-1||6.3|-0.04|B9|",
"19:18:37.7|49:34:11|-1||6.31|1.12|K1III|",
"19:19:38.9|37:19:50|-1||6.31|0.68|G8V|",
"19:20:33.1|35:11:10|-1||6.31|-0.12|B9V|",
"19:22:20.7|-8:12:4|-1||6.31|-0.1|B3IVp|",
"19:25:22.4|20:16:17|-1||6.31|-0.02|A0V|",
"19:30:34.5|-55:6:36|78|μ|6.3|0.45|F5V|",
"20:8:38.3|10:43:33|-1||6.31|-0.12|B3V|",
"20:15:50.6|-30:0:19|-1||6.3|1.51|K4III|",
"20:18:56.0|-47:42:39|-1||6.31|1.67|M1III|",
"20:15:43.4|50:13:58|-1||6.31|0.0|A2Vn|",
"20:20:28.1|-29:11:50|-1||6.3|0.17|A4/7V|",
"20:23:0.8|-9:39:17|-1||6.3|0.91|G5IIIa|",
"20:46:38.5|46:31:54|-1||6.3|0.03|A3V|",
"21:3:1.8|14:43:48|-1||6.31|1.67|M1III|",
"21:18:0.3|-64:40:54|-1||6.31|-0.07|B8V|",
"21:24:20.8|-46:36:54|-1||6.31|0.2|A7mSr:|",
"21:35:19.0|28:11:50|-1||6.31|0.35|F0IV|",
"21:44:29.5|-38:33:9|-1||6.3|1.12|G5III|",
"21:49:41.1|-12:43:23|-1||6.31|0.22|A3m|",
"22:11:56.9|59:5:5|-1||6.3|1.13|K0III|",
"22:37:4.7|12:34:38|-1||6.3|0.0|K5|",
"22:36:48.7|35:39:9|-1||6.3|1.37|K5|",
"22:39:44.0|-28:19:31|-1||6.31|1.01|K0IV|",
"22:40:48.0|-3:33:15|-1||6.31|0.52|F6V|",
"22:44:16.5|-60:29:58|-1||6.3|0.56|F3V|",
"22:47:56.2|-25:54:43|-1||6.3|0.91|G5III|",
"22:57:17.2|-4:48:36|-1||6.31|0.94|G9III|",
"23:6:31.9|19:54:39|-1||6.3|0.49|F7V|",
"23:14:14.3|50:37:4|-1||6.31|0.0|A0V|",
"23:23:31.9|0:17:29|-1||6.31|1.61|K2|",
"23:46:1.2|-40:10:57|-1||6.31|0.2|A7III-IV|",
"23:56:29.9|-24:44:14|-1||6.31|0.92|G5|",
"0:9:2.4|-54:0:7|-1||6.33|0.74|G4IV|",
"0:18:42.6|-43:14:7|-1||6.33|1.21|K2III|",
"0:19:41.6|40:43:47|-1||6.33|1.18|K1III|",
"0:46:39.0|69:19:30|-1||6.33|0.0|F3V|",
"0:57:54.5|13:41:45|-1||6.32|0.89|G8III|",
"1:41:21.3|-79:8:54|42|τ1|6.33|0.94|G6-8III|",
"1:47:48.0|46:13:47|-1||6.32|0.43|F6V|",
"1:47:47.8|-37:9:35|-1||6.32|1.02|K0III|",
"2:10:4.9|-43:48:56|-1||6.32|0.9|G8III|",
"2:15:57.9|47:48:41|-1||6.33|0.0|G9III-IV|",
"2:24:58.4|-2:46:48|20|71|6.33|0.0|A0III|",
"2:52:50.5|-9:26:28|-1||6.32|0.19|A7IV|",
"3:12:26.4|47:43:33|-1||6.33|1.43|K5III|",
"3:30:19.5|71:51:50|-1||6.32|1.8|M2III|",
"3:26:11.7|-41:38:13|-1||6.32|0.06|A0V|",
"3:40:11.4|-15:13:36|-1||6.33|0.88|G5|",
"3:51:41.8|68:30:27|-1||6.32|-0.08|B9IVp|",
"4:0:36.9|17:17:48|-1||6.32|0.06|A0V|",
"4:12:51.6|68:30:6|-1||6.32|1.18|K0|",
"4:15:46.3|15:24:2|77|48|6.32|0.4|F5V|",
"4:27:0.9|57:35:7|-1||6.32|0.04|A0III|",
"4:36:1.6|-3:36:43|-1||6.33|-0.1|B7III|",
"4:46:24.1|-2:57:16|-1||6.33|0.04|A2V|",
"5:0:39.8|-2:3:56|-1||6.32|0.28|A8IV|",
"5:13:47.2|0:33:37|-1||6.32|1.46|M0V|",
"5:20:59.3|27:57:26|-1||6.33|0.04|B9IV|",
"5:24:36.2|2:21:10|-1||6.32|-0.15|B4IVn|",
"5:30:20.7|-7:26:5|-1||6.33|-0.19|B2IV-V|",
"5:37:45.7|33:33:33|-1||6.33|1.31|K0|",
"5:34:57.6|-61:10:33|-1||6.32|0.85|G5IV|",
"5:47:18.6|-35:40:29|-1||6.32|1.18|K1III|",
"5:56:33.8|28:56:32|-1||6.32|0.3|A2II|",
"6:11:1.8|18:7:46|-1||6.33|1.35|K1II|",
"6:19:1.8|17:19:30|-1||6.32|-0.07|B9IIIpSiCr:|",
"6:24:52.9|16:3:25|-1||6.33|1.08|G9III|",
"6:28:42.3|-41:4:28|-1||6.32|0.4|F2-3V|",
"6:48:12.9|55:42:16|-1||6.33|0.0|dF6|",
"6:49:44.0|-24:4:33|-1||6.33|0.04|A1|",
"6:50:36.9|-25:46:41|-1||6.33|-0.18|B2V|",
"6:54:26.7|-42:21:56|-1||6.32|2.24|C3II|",
"7:13:57.2|-30:20:24|-1||6.33|-0.2|B2IV-V|",
"7:15:47.5|-23:44:26|-1||6.32|0.0|A0|",
"7:16:57.2|-30:53:48|-1||6.32|0.2|A9II|",
"7:45:9.3|20:18:59|37|79|6.33|0.0|A1V|",
"7:48:19.2|-56:28:16|-1||6.33|1.01|K0III+A1V|",
"7:49:28.2|-44:45:7|-1||6.32|0.96|K0III|",
"7:51:20.5|-43:5:44|-1||6.32|-0.17|B2IV-V|",
"7:56:22.8|-30:17:7|-1||6.33|1.66|M6III|",
"7:59:12.3|-49:58:36|-1||6.32|0.0|B2IV-V|",
"8:2:26.0|-6:20:14|-1||6.33|0.62|G0III|",
"7:59:40.2|-60:12:27|-1||6.33|-0.06|B5III|",
"8:8:56.9|-11:20:23|-1||6.32|0.01|A0Vn|",
"8:24:32.9|82:25:51|-1||6.32|0.01|A2Vn|",
"8:19:15.1|-10:9:57|-1||6.32|0.33|F3IIIpDelDel|",
"8:23:17.2|-38:17:9|-1||6.32|1.63|M1III|",
"8:27:36.8|45:39:11|-1||6.32|0.62|G5V|",
"8:26:46.8|26:56:4|11|23φ2|6.32|0.18|A6V|",
"8:27:16.4|-31:40:23|-1||6.33|0.9|G8III|",
"8:35:24.9|2:44:37|-1||6.33|1.02|G9III|",
"8:36:7.7|15:18:49|-1||6.32|0.0|F0IV|",
"8:38:40.3|-19:44:13|-1||6.33|1.59|K5III|",
"8:44:10.1|36:55:5|-1||6.33|0.0|F7V|",
"8:43:54.3|-68:12:42|-1||6.32|1.5|K3III:|",
"8:52:24.2|5:20:24|-1||6.33|0.12|A5V|",
"9:15:21.2|84:10:52|-1||6.33|0.3|F2III|",
"9:15:35.0|-57:34:41|-1||6.32|1.04|G8II|",
"9:17:42.3|-54:29:43|-1||6.33|1.41|K3III|",
"9:20:55.5|-15:37:4|-1||6.33|0.46|dF6|",
"9:56:54.0|-27:28:30|-1||6.32|0.17|A4V|",
"10:10:58.9|40:39:41|-1||6.32|1.25|gK3|",
"10:19:59.4|-9:3:32|-1||6.32|0.33|F1IV|",
"10:24:13.1|2:22:5|-1||6.32|1.0|G9V|",
"10:29:54.3|65:37:34|82|35|6.32|1.14|gK2|",
"10:52:27.5|-79:33:34|-1||6.33|1.46|K2II-III|",
"11:6:27.4|-50:57:24|-1||6.32|1.16|K2III|",
"11:13:40.2|41:5:19|-1||6.33|1.15|K2III|",
"11:26:25.5|33:27:2|-1||6.32|0.43|F7V|",
"11:41:1.2|-83:6:0|-1||6.33|1.08|K0III|",
"12:5:53.2|-65:32:50|-1||6.33|0.22|B6Iab-Ib|",
"12:13:36.7|-33:47:34|-1||6.33|0.08|A0V|",
"12:16:51.4|86:26:10|-1||6.33|0.43|F4V|",
"12:19:29.6|28:9:25|24|9|6.33|0.5|F8Vs|",
"12:25:37.5|-86:9:2|-1||6.33|1.08|K0III|",
"12:25:6.4|63:48:10|-1||6.32|0.91|G8III|",
"12:38:4.4|3:16:57|-1||6.33|0.01|A1V|",
"12:42:5.1|-69:24:27|-1||6.33|0.78|F7Ib-G2|",
"12:44:27.1|44:6:11|-1||6.33|0.43|F6IV|",
"12:52:5.3|-48:5:39|-1||6.33|0.03|A0IV|",
"12:52:12.3|17:4:26|24|32|6.32|1.59|M0III|",
"13:9:14.4|-9:32:18|-1||6.32|1.02|K0|",
"13:11:53.1|-63:18:10|-1||6.33|0.44|A8II-III|",
"13:12:8.4|24:15:29|-1||6.33|0.98|K1III|",
"13:34:28.9|-48:16:20|-1||6.33|-0.05|B8III|",
"13:40:23.2|50:31:10|-1||6.32|0.54|F7-9V|",
"13:46:57.1|6:21:2|-1||6.33|0.63|G0-1IV-V|",
"13:56:10.5|32:1:57|-1||6.32|0.37|F4IV-V|",
"14:17:49.2|48:0:6|-1||6.32|0.44|F5|",
"14:19:47.7|38:47:38|-1||6.33|0.05|A2V|",
"14:26:13.4|-42:19:9|-1||6.32|1.19|K2III|",
"14:34:11.7|32:32:4|-1||6.33|0.4|F5V|",
"14:45:57.8|-15:27:35|48|5|6.33|1.19|K1III|",
"15:13:1.0|-61:44:38|-1||6.32|1.9|K4Ib|",
"15:12:31.3|-48:13:7|-1||6.33|1.12|K2III|",
"15:19:30.2|32:30:55|-1||6.32|0.24|A2m|",
"15:38:15.7|-28:12:24|-1||6.32|1.17|K1III|",
"15:45:39.7|0:53:29|-1||6.33|1.19|K0III|",
"16:1:19.5|-31:53:22|-1||6.33|1.45|K4III|",
"16:7:3.4|-14:4:15|-1||6.32|0.66|G4IV-V|",
"16:7:51.9|-24:27:43|-1||6.33|-0.06|B7IIIp:|",
"16:9:2.9|57:56:16|-1||6.33|0.0|A1V|",
"16:14:39.1|-18:32:7|-1||6.32|1.09|K2III|",
"16:17:20.9|-53:5:12|-1||6.33|0.27|A8IV|",
"16:24:54.2|-45:20:57|-1||6.33|0.19|A2-3V|",
"16:52:17.4|-67:40:55|-1||6.32|1.28|K2III|",
"16:37:52.9|78:55:6|-1||6.32|1.14|G9III|",
"16:50:22.3|-2:39:14|-1||6.32|0.42|F1III-IV|",
"16:53:58.8|-41:59:41|-1||6.32|0.5|B1Ia|",
"16:56:8.9|-50:40:30|-1||6.33|-0.02|B3Vnep|",
"16:57:42.3|24:22:53|-1||6.32|1.1|K0III|",
"17:1:59.1|8:27:2|-1||6.33|0.09|A4V|",
"17:11:45.2|7:53:41|-1||6.33|1.04|K0III|",
"17:19:59.5|-5:55:2|-1||6.32|0.85|G9V|",
"17:16:29.4|60:40:14|-1||6.32|1.09|K1.5IIIb|",
"18:7:6.3|49:42:38|-1||6.32|0.0|A2V|",
"18:18:0.9|-68:13:45|-1||6.33|-0.04|B9V|",
"18:23:2.2|-10:13:7|-1||6.33|0.14|B9.5V|",
"18:23:47.8|53:18:3|-1||6.32|0.16|A3m|",
"18:33:23.3|-38:43:13|25|κ1|6.32|0.0|A0III|",
"18:44:7.7|-36:43:7|-1||6.32|0.98|K0III|",
"19:1:33.5|-15:16:57|-1||6.32|1.0|gG6|",
"19:18:52.7|9:37:5|-1||6.32|1.05|G9III|",
"19:23:4.6|-7:24:1|-1||6.32|1.45|K0|",
"19:27:33.9|14:16:57|-1||6.32|-0.06|B4III|",
"19:29:20.9|20:16:47|87|7|6.33|-0.1|B5Vn|",
"19:36:8.3|22:35:9|-1||6.32|-0.07|B9pSi:Cr:|",
"19:58:34.4|38:6:20|-1||6.32|-0.09|B5IV|",
"19:58:41.9|70:22:1|-1||6.33|0.88|G8III|",
"20:16:22.8|-12:20:13|15|3|6.32|0.01|B9pHg|",
"20:25:44.0|10:3:23|-1||6.33|1.56|K5III|",
"20:37:31.8|31:34:21|30|48|6.32|-0.09|B8IIIn|",
"20:43:13.5|57:6:51|-1||6.32|0.33|B2III|",
"20:46:21.2|52:59:43|-1||6.33|1.12|K0|",
"20:49:48.3|7:51:51|31|14|6.33|0.02|A1Vs|",
"20:49:54.7|46:39:40|-1||6.33|-0.07|B4Ve|",
"20:53:1.2|-23:46:59|-1||6.33|0.88|K0III|",
"21:4:45.4|2:16:11|-1||6.33|0.97|G5|",
"21:3:52.1|41:37:41|-1||6.33|0.38|F3IV|",
"21:3:43.3|46:51:43|-1||6.32|0.25|F0IVn|",
"21:24:23.1|24:31:44|-1||6.32|1.04|K0III|",
"21:34:17.0|-42:55:30|-1||6.32|1.09|K1IIICNII|",
"21:40:33.6|-55:44:15|-1||6.33|1.06|K0II-III|",
"21:58:13.3|-5:25:29|-1||6.33|0.37|F5IV|",
"22:7:9.6|58:50:27|-1||6.32|0.88|G6III|",
"22:10:22.2|14:37:48|-1||6.33|1.08|K0III|",
"22:10:51.6|30:33:11|-1||6.32|0.18|A8IV|",
"22:32:46.9|15:51:48|-1||6.32|1.19|K0|",
"22:49:59.1|-32:48:19|-1||6.33|0.31|F0V+F3V|",
"22:58:42.6|7:20:23|-1||6.33|0.06|A1V|",
"23:7:9.5|-49:36:24|-1||6.33|1.45|K4III|",
"23:19:8.1|-79:28:22|-1||6.33|0.91|K0III|",
"23:19:27.4|34:47:36|-1||6.32|-0.08|B8III|",
"23:19:41.6|48:22:51|-1||6.32|1.12|K1III|",
"23:28:0.7|-35:32:40|-1||6.32|1.2|K2III|",
"23:49:12.0|58:57:47|-1||6.33|0.4|F2IV|",
"0:2:24.2|8:57:25|65|31|6.32|0.18|A6V|",
"0:15:10.6|27:16:59|-1||6.35|-0.02|A1Vn|",
"0:16:14.0|76:57:3|-1||6.35|-0.07|B8Vnn|",
"1:5:49.2|4:54:30|65|77|6.35|0.38|F3V|",
"1:17:5.1|44:54:7|-1||6.34|0.0|K5|",
"1:21:5.2|64:39:30|17|35|6.34|0.09|A2Vnn|",
"1:22:30.5|-19:4:53|-1||6.35|0.48|F6IV|",
"1:42:58.4|61:25:18|-1||6.34|0.01|B7II|",
"1:43:16.5|45:19:20|-1||6.34|1.01|K2IV|",
"1:43:50.0|32:11:30|-1||6.34|0.0|G8III-IV|",
"1:44:26.5|46:8:23|-1||6.35|0.0|K5III|",
"1:49:19.5|-31:4:22|-1||6.34|1.22|K2-3III|",
"1:58:26.7|-33:4:0|-1||6.35|1.02|K0III|",
"2:18:58.5|-25:56:44|-1||6.34|0.73|G5V|",
"2:43:51.2|25:38:17|-1||6.35|0.08|A2Vp:|",
"3:22:16.3|-25:35:16|-1||6.35|0.01|A0V|",
"3:56:30.2|71:49:18|-1||6.34|0.3|A5m|",
"4:5:46.7|-20:30:44|-1||6.34|0.92|G5|",
"4:45:42.5|23:37:41|-1||6.35|0.06|B5III|",
"4:58:10.8|-2:12:45|-1||6.35|0.1|A2V|",
"5:4:26.1|-35:42:19|9|γ2|6.34|0.3|F1III|",
"5:19:35.2|-1:24:44|-1||6.34|-0.11|B1.5Vn|",
"5:20:20.6|-34:41:56|-1||6.34|0.33|F2IV-V|",
"5:23:31.1|5:19:21|-1||6.35|0.12|A2V|",
"5:27:4.8|-11:54:3|-1||6.35|0.51|dF7|",
"5:28:34.8|13:40:44|-1||6.35|0.15|A4V|",
"5:39:27.0|21:45:46|-1||6.34|0.06|A1Vn|",
"5:41:27.0|-33:24:2|-1||6.34|-0.04|A0V|",
"5:44:28.4|-20:7:35|-1||6.34|0.58|G0|",
"5:46:2.8|-4:16:6|-1||6.34|1.05|K1III+G0IV|",
"5:50:28.6|-52:46:4|-1||6.35|0.76|K0-1III+A4V+A|",
"6:5:8.3|59:23:35|-1||6.34|1.1|K1III-IV|",
"6:5:2.6|37:57:51|-1||6.34|0.0|K0III+A2|",
"6:4:28.4|-45:2:12|-1||6.35|0.52|G0IV-V|",
"6:9:20.3|-18:7:34|-1||6.35|-0.03|B9Vn|",
"6:21:25.9|17:45:49|-1||6.35|0.0|g:G9|",
"6:23:14.4|-31:47:24|-1||6.34|0.89|G8III|",
"6:25:47.1|-3:53:21|-1||6.35|1.02|G9III|",
"6:31:35.0|-36:56:24|-1||6.34|1.63|M1III|",
"6:35:54.0|-36:5:20|-1||6.35|0.48|G0V|",
"6:36:40.9|-22:36:54|-1||6.35|-0.11|B5V|",
"6:36:51.3|-41:33:25|-1||6.34|1.15|K0II|",
"6:55:15.2|45:49:35|-1||6.34|0.94|K0III-IV|",
"6:57:0.1|-8:10:44|-1||6.34|0.64|K0II-III+A2V|",
"6:59:20.1|7:19:1|-1||6.35|-0.11|B7III|",
"7:6:0.6|-30:39:20|-1||6.34|-0.16|B3V|",
"7:13:58.1|71:49:0|-1||6.35|1.12|K0|",
"7:22:17.2|59:54:7|10|47|6.35|0.0|A8m|",
"7:21:3.1|42:39:20|-1||6.35|1.46|K0|",
"7:36:7.8|-22:9:38|-1||6.34|0.99|G5|",
"7:47:38.5|-15:59:27|-1||6.34|1.78|K1Ia-Iab|",
"7:58:16.6|43:58:39|-1||6.34|1.06|K0|",
"7:57:16.2|1:7:37|-1||6.35|0.5|F7V|",
"8:1:0.7|23:34:59|-1||6.34|0.0|K1III-IV|",
"8:1:55.1|35:24:47|-1||6.34|1.56|K0|",
"7:59:13.4|-49:58:25|-1||6.34|0.0|B2IV-V|",
"8:2:6.2|-37:3:2|-1||6.34|1.62|M1III|",
"7:59:16.1|-73:14:41|-1||6.34|0.14|A3III|",
"8:31:29.6|-54:23:39|-1||6.34|1.31|K3III|",
"8:40:43.6|-57:32:43|-1||6.34|0.2|A3V|",
"9:11:55.6|5:28:6|-1||6.35|0.32|A9IVDelDel|",
"9:15:24.9|-15:1:29|-1||6.35|0.02|A0V|",
"9:45:55.4|63:39:12|82|28|6.34|0.31|F2V|",
"9:52:12.0|0:4:32|-1||6.35|0.94|G9III|",
"9:56:9.7|-71:23:22|-1||6.35|-0.08|B9Ib|",
"10:13:56.6|-40:18:38|-1||6.35|0.94|G8III|",
"10:23:50.9|-57:57:14|-1||6.35|1.52|K4III|",
"10:28:36.5|45:12:44|-1||6.35|1.32|K0|",
"10:46:22.5|57:21:57|82|41|6.34|1.56|M1III|",
"10:56:34.4|25:30:0|46|50|6.35|1.03|K0|",
"11:0:57.2|-15:47:34|-1||6.34|1.18|K0|",
"11:3:36.5|-13:26:4|-1||6.34|0.88|G5|",
"11:11:29.5|-71:26:11|-1||6.35|1.37|K2-3III|",
"11:18:34.3|-79:40:7|-1||6.35|0.26|A8IIIm:|",
"11:30:25.0|46:39:27|-1||6.35|1.27|K2IIICN-1|",
"11:50:55.3|12:16:44|-1||6.35|0.27|F0IVms|",
"11:51:21.9|-12:11:16|-1||6.35|0.4|F1III-IV|",
"12:9:47.3|74:39:41|-1||6.35|0.5|F6IV|",
"12:13:55.7|-78:34:25|-1||6.35|1.24|K2-3IIICNII|",
"12:17:44.3|15:8:39|-1||6.34|1.37|K4III|",
"12:27:49.4|-16:37:55|-1||6.35|0.84|G3III|",
"12:30:4.8|-13:23:35|-1||6.35|0.56|G0V|",
"12:47:2.3|5:57:3|-1||6.34|-0.05|A0pSrEuCr|",
"13:22:3.8|43:54:11|-1||6.35|0.24|A7m|",
"13:27:59.5|52:44:45|-1||6.34|0.23|F0|",
"13:39:11.9|-75:41:2|-1||6.34|0.01|B8IV|",
"13:51:36.6|-36:26:0|-1||6.35|0.48|F6IV-V|",
"14:1:50.6|68:40:43|-1||6.34|1.4|K5|",
"14:8:56.3|-59:16:36|-1||6.34|0.05|B5IV|",
"14:12:24.5|-24:21:51|-1||6.34|1.35|K0|",
"14:26:49.9|-39:52:26|-1||6.35|-0.08|B7IV|",
"14:29:36.8|41:47:45|-1||6.35|0.7|G5V|",
"14:47:54.9|-12:50:23|-1||6.35|1.1|K0III|",
"14:58:8.8|-48:51:47|-1||6.35|0.71|G3-5V|",
"15:6:35.1|36:27:20|-1||6.35|0.52|F8V|",
"15:20:47.1|-2:24:48|-1||6.35|1.06|K0V|",
"15:39:21.3|-23:9:1|-1||6.34|0.02|A0V|",
"15:40:15.4|-31:12:49|-1||6.34|1.43|K2III|",
"16:39:39.1|-9:33:16|-1||6.35|0.48|F3V|",
"16:30:38.8|77:26:48|-1||6.34|1.0|K1III|",
"16:48:8.9|13:35:26|-1||6.35|0.87|G5III|",
"16:54:36.0|-30:35:14|-1||6.35|0.21|A7IIIm:|",
"16:55:16.0|13:37:11|-1||6.34|0.34|F3Vs|",
"16:57:50.2|42:30:45|-1||6.34|1.28|K3III|",
"17:3:52.7|19:41:26|-1||6.35|1.52|K4III|",
"17:7:46.7|40:30:58|-1||6.34|0.03|A2IV|",
"17:21:33.4|16:43:51|-1||6.35|1.61|M2.5IIIab|",
"17:21:31.2|28:45:29|-1||6.35|0.7|G0III|",
"17:24:33.8|15:36:22|-1||6.35|-0.02|B9V|",
"17:41:11.0|15:10:41|-1||6.34|0.03|A1V|",
"17:43:5.6|44:5:4|-1||6.34|1.54|K4III|",
"17:48:27.8|-26:58:30|-1||6.35|0.12|B4IVe|",
"18:5:26.7|-81:29:11|-1||6.35|1.5|K3-4III|",
"17:51:59.5|-1:14:12|-1||6.35|1.12|K0|",
"18:0:52.9|6:16:6|-1||6.34|-0.08|B2IV|",
"18:4:40.2|23:56:33|-1||6.34|0.3|F0IV-V|",
"18:6:7.4|0:26:48|-1||6.34|1.06|G8IIp|",
"18:5:0.8|41:56:48|-1||6.34|0.26|F0V|",
"18:42:55.2|-19:17:2|-1||6.35|1.75|M4III|",
"18:53:1.9|-9:34:34|-1||6.34|0.2|A7Vn|",
"19:9:51.6|0:25:41|-1||6.34|-0.04|B5Vn|",
"19:24:5.4|-68:22:16|-1||6.34|1.23|K2III|",
"19:22:9.6|-42:0:58|-1||6.34|1.14|K1III|",
"19:22:48.4|9:54:47|-1||6.35|0.44|F6V|",
"19:27:36.5|37:56:28|-1||6.34|-0.14|B3Ve|",
"19:35:29.8|-7:27:37|-1||6.34|1.12|K0|",
"19:39:49.4|-23:25:40|71|53|6.34|0.03|B9.5V+A3IV|",
"19:38:49.0|3:22:54|-1||6.35|0.04|B3III|",
"19:42:12.8|12:11:36|4|46|6.34|-0.03|B9IIIpHgMn|",
"19:44:49.0|40:43:0|-1||6.34|1.64|M4-III|",
"19:46:44.7|68:26:18|-1||6.34|0.28|F0III|",
"20:5:5.4|-11:35:58|-1||6.34|0.52|F1III|",
"20:5:26.5|15:30:1|-1||6.34|1.64|M2.5III|",
"20:11:57.9|-12:23:33|15|1ξ1|6.34|1.21|K0III|",
"20:31:58.2|25:48:16|-1||6.34|0.26|Am|",
"20:53:25.0|-30:43:7|-1||6.35|1.09|K1III|",
"20:53:7.4|29:38:58|-1||6.34|1.09|K2|",
"21:7:33.6|15:39:31|-1||6.34|1.01|K2IV|",
"21:24:24.6|10:10:27|-1||6.35|0.47|F5III|",
"21:57:51.0|74:59:48|-1||6.35|1.56|K5|",
"22:7:30.0|18:0:2|-1||6.35|1.64|M1|",
"22:20:36.2|-57:30:36|-1||6.34|1.37|K3-4III|",
"22:26:34.4|-16:44:33|3|53|6.35|0.61|G1V|",
"22:31:34.2|29:32:34|-1||6.35|0.19|A5m|",
"22:32:18.8|54:2:15|-1||6.35|0.0|G8III|",
"22:33:17.0|70:22:26|-1||6.34|0.0|A0V|",
"22:41:31.4|30:57:57|-1||6.34|0.0|K5|",
"22:49:17.4|-70:20:52|-1||6.34|0.07|A2V|",
"22:53:11.3|40:10:2|-1||6.34|-0.08|B7III-IV|",
"23:13:4.0|29:26:30|-1||6.35|0.93|G8III|",
"23:17:40.0|-11:42:47|-1||6.34|0.05|A1Vn|",
"23:29:5.6|23:2:52|-1||6.35|0.0|G9III|",
"23:36:30.5|32:54:15|-1||6.35|0.46|F6V|",
"23:48:53.9|59:58:44|-1||6.34|-0.01|A0V|",
"23:54:21.4|-27:2:32|-1||6.35|0.2|A2V+F2V|",
"0:51:18.3|3:23:6|-1||6.37|1.07|K0III|",
"0:56:55.6|68:46:34|-1||6.37|0.38|F4III|",
"0:58:18.9|21:24:16|-1||6.37|0.09|A2V|",
"1:7:13.1|-23:59:47|-1||6.37|0.23|A7V|",
"1:38:31.7|45:24:0|-1||6.36|0.04|B9pCrEu|",
"1:42:17.8|58:37:40|-1||6.37|-0.02|B8III|",
"1:49:48.8|-38:24:14|-1||6.37|0.52|F8V|",
"1:57:53.6|-65:25:29|-1||6.37|0.9|G8II-III|",
"2:11:29.0|57:38:45|62|5|6.36|0.33|B5Ia|",
"2:19:22.7|48:57:19|-1||6.37|0.0|F4V|",
"2:19:24.7|-41:50:54|-1||6.37|1.16|K2III|",
"2:28:4.4|-64:17:59|-1||6.37|-0.04|A0V|",
"2:35:27.9|39:39:52|-1||6.36|-0.1|B9pHgMn|",
"2:43:20.3|-40:31:39|-1||6.36|-0.02|B9V|",
"2:52:52.0|52:59:52|-1||6.36|0.07|B8III|",
"2:50:47.9|-39:55:54|-1||6.36|0.05|A0V|",
"3:3:30.3|28:16:11|-1||6.36|0.0|F0V|",
"3:17:31.6|65:39:31|-1||6.36|0.09|A3V|",
"3:33:41.2|57:52:8|-1||6.37|0.51|F7V|",
"3:59:40.7|10:19:51|-1||6.37|0.42|F5V|",
"4:13:35.7|-40:21:28|-1||6.37|1.46|K3III|",
"4:16:21.1|-60:56:55|-1||6.37|0.07|ApEuCrSr:|",
"4:19:3.0|-33:54:18|-1||6.37|0.13|A3V|",
"4:23:59.8|24:18:4|77|62|6.36|0.17|B3V|",
"4:35:42.7|19:52:54|-1||6.36|0.0|G5II-III+A-F|",
"4:35:14.0|-9:44:12|-1||6.37|0.11|A1m|",
"4:50:36.4|70:56:30|-1||6.37|-0.08|A0IV|",
"4:47:49.6|-30:1:13|9|ζ|6.37|1.07|K1IV|",
"4:54:58.3|19:29:7|-1||6.37|0.29|F3IV|",
"4:56:15.6|24:35:32|-1||6.37|0.33|F0|",
"5:14:35.6|76:28:22|-1||6.37|-0.02|A0V|",
"5:13:33.3|-8:8:52|-1||6.37|-0.13|B5V|",
"5:19:17.5|-18:31:12|-1||6.36|-0.16|B3V|",
"5:30:45.1|39:49:33|-1||6.37|0.97|G9III|",
"5:38:57.4|26:37:4|-1||6.37|0.0|G9III|",
"5:42:3.9|22:39:37|-1||6.36|0.0|K2|",
"5:54:14.1|-29:8:52|-1||6.36|0.37|F3V|",
"5:51:23.0|-64:2:1|-1||6.36|0.86|G8III|",
"5:56:34.5|-23:12:56|-1||6.36|1.07|K0|",
"6:1:41.6|22:24:3|-1||6.37|-0.07|B8V|",
"6:8:23.0|41:3:20|-1||6.36|1.05|G9III|",
"6:15:54.0|1:10:9|-1||6.37|0.46|F5IV:|",
"6:41:59.3|6:20:42|-1||6.37|-0.05|O6.5V|",
"6:43:36.8|-73:7:5|-1||6.37|0.96|G8III|",
"6:55:54.8|-31:47:24|-1||6.36|0.0|B3V|",
"6:58:7.6|-27:9:53|-1||6.37|-0.19|B2.5III|",
"7:13:48.3|-22:54:23|-1||6.36|-0.21|B2IV+G5IV|",
"7:26:27.9|10:36:30|-1||6.37|0.09|A2IV|",
"7:37:16.8|-23:46:30|-1||6.37|0.54|F0II|",
"7:51:40.9|-12:49:10|67|8|6.36|0.39|F2|",
"8:8:43.5|-20:21:47|-1||6.36|0.16|A7IV|",
"8:8:37.6|-37:40:53|-1||6.37|-0.04|B4V|",
"8:13:41.1|-33:34:9|-1||6.37|1.14|K2III|",
"8:29:36.3|-55:11:28|-1||6.36|0.8|G0V|",
"8:33:0.1|24:5:5|11|32υ2|6.36|1.02|G9III|",
"8:32:58.6|-34:38:2|-1||6.36|0.95|K0V|",
"8:39:13.2|-60:19:2|-1||6.36|0.0|A0V|",
"8:43:59.7|4:20:5|-1||6.37|-0.06|B9.5III-IV|",
"8:46:49.2|-34:37:22|-1||6.37|-0.13|B4V|",
"8:47:40.5|-41:44:14|-1||6.36|0.58|G0Ia-0:|",
"9:1:40.6|39:42:48|-1||6.36|0.3|A9Vn|",
"9:6:7.6|-64:29:59|-1||6.37|1.35|K3III|",
"9:35:52.9|14:22:47|45|7|6.36|0.01|A1V|",
"9:40:20.1|-10:46:9|-1||6.37|0.08|A2V|",
"9:49:51.3|-36:16:7|-1||6.37|1.01|K0III|",
"10:8:34.3|83:55:6|-1||6.37|1.52|K0|",
"9:56:21.9|-51:20:10|-1||6.37|-0.17|B2IV-V|",
"10:5:40.9|15:45:27|-1||6.37|0.37|F2Vn|",
"10:8:1.7|-37:20:1|-1||6.36|0.98|K0III|",
"10:19:32.2|-5:6:21|-1||6.37|0.9|K0|",
"10:40:51.6|-35:44:30|-1||6.37|0.92|G8-K0III+F-G|",
"10:46:5.7|6:22:23|-1||6.37|1.12|gK1|",
"10:47:38.7|-57:28:4|-1||6.36|1.62|M1II|",
"11:25:50.0|3:51:36|45|80|6.37|0.33|F3IV|",
"11:40:27.4|57:58:14|-1||6.37|-0.12|B9pHgMn:|",
"12:5:59.8|-3:7:54|-1||6.37|1.0|gG8|",
"12:8:4.8|-50:45:48|-1||6.37|-0.05|B9V|",
"12:23:13.8|-67:37:54|-1||6.36|0.89|G8-K0IV|",
"12:27:42.1|8:36:37|-1||6.37|0.93|G8III|",
"12:38:46.3|40:52:28|12|9|6.37|0.18|A7Vn|",
"13:15:25.7|-69:40:47|-1||6.37|1.21|K2-3III|",
"13:17:29.9|0:40:36|-1||6.37|0.26|F0V|",
"13:33:35.7|-65:37:57|-1||6.37|-0.02|A0V|",
"13:34:21.8|38:47:21|-1||6.37|0.21|F0IV|",
"13:57:32.1|61:29:34|-1||6.37|0.0|K3V|",
"14:14:21.3|-5:56:51|-1||6.36|0.6|F9V|",
"14:25:39.5|-66:10:24|-1||6.36|0.13|A3V|",
"14:41:51.1|-30:56:0|-1||6.37|-0.09|ApSi|",
"14:56:35.8|-39:24:58|-1||6.36|0.06|A0-1V|",
"15:0:38.7|47:16:40|-1||6.37|-0.14|B9pSiSrCr|",
"15:30:27.9|36:48:15|-1||6.37|0.0|K0|",
"15:34:20.9|-39:20:58|-1||6.36|-0.03|B9V|",
"15:52:56.2|17:24:13|-1||6.36|0.0|K0|",
"15:56:14.4|-14:23:58|-1||6.37|0.48|F7V:|",
"16:55:57.8|-33:30:26|-1||6.37|1.71|K5III|",
"16:56:1.8|-16:48:22|-1||6.37|0.92|K0IV|",
"16:57:32.0|13:53:3|-1||6.37|0.94|K0V|",
"17:2:17.2|31:53:5|-1||6.36|1.13|K0|",
"17:6:9.7|9:44:0|-1||6.37|1.45|K5III|",
"17:6:13.1|10:27:15|-1||6.37|0.87|G8III-IV|",
"17:8:54.5|-3:52:58|-1||6.36|0.69|G5-8IV-V|",
"17:18:20.4|-32:33:12|-1||6.36|0.15|B5Vn|",
"17:28:2.3|-8:12:30|-1||6.37|0.58|F5IV|",
"17:29:47.4|-5:55:11|-1||6.37|0.93|K0III|",
"17:38:49.7|32:44:22|-1||6.37|0.0|gG5|",
"17:41:5.5|24:30:48|-1||6.36|1.2|K1III+F4V|",
"17:43:17.8|-27:53:3|-1||6.36|0.47|A9V:|",
"17:57:26.9|11:2:39|-1||6.36|0.11|A1V|",
"18:0:15.5|0:37:46|-1||6.37|0.15|A3pSrCrEu|",
"17:54:26.6|75:10:15|-1||6.36|0.98|K0|",
"18:8:33.7|14:17:5|-1||6.37|0.17|A5m|",
"18:11:14.8|-19:50:32|-1||6.36|0.16|A4V|",
"18:12:42.6|41:8:49|-1||6.36|1.03|K0III|",
"18:15:58.0|-3:37:3|-1||6.36|0.2|A4V|",
"18:14:41.1|56:35:18|-1||6.37|0.34|F1V|",
"18:23:57.4|38:44:21|-1||6.36|0.0|K4III|",
"18:25:55.4|14:58:0|-1||6.37|0.01|B9V|",
"18:29:12.9|-43:50:45|-1||6.36|0.9|G8III|",
"18:32:20.8|-14:38:39|-1||6.37|0.22|A4V|",
"18:33:22.9|-5:54:41|-1||6.36|0.02|A0Vn|",
"18:35:59.7|-29:41:57|-1||6.37|1.27|K1III|",
"18:42:22.5|-64:38:35|-1||6.37|0.15|A5V|",
"18:40:2.0|30:50:58|-1||6.36|0.0|K0|",
"18:45:18.7|-21:0:5|-1||6.36|0.45|F5V|",
"18:59:26.8|-18:34:1|-1||6.37|0.99|G3II|",
"19:0:24.8|-24:56:32|-1||6.36|1.25|gK0|",
"19:3:7.0|-19:6:12|-1||6.37|0.48|F5IV-V|",
"19:11:1.8|-39:0:18|-1||6.36|0.01|B7IIIMn|",
"19:11:30.9|26:44:9|-1||6.36|0.41|F5V|",
"19:23:34.0|33:13:20|-1||6.37|0.81|G8V|",
"19:24:6.1|36:27:7|-1||6.36|0.0|K1III|",
"19:31:13.6|55:43:55|-1||6.37|1.16|K2II-IIIe+A0V|",
"19:41:14.9|22:27:10|-1||6.36|1.53|K0I|",
"20:11:7.2|-57:31:26|-1||6.37|0.06|B7V+A3V|",
"20:26:23.5|56:38:20|-1||6.36|0.0|B9V|",
"20:32:52.4|-24:56:38|-1||6.36|-0.01|A0|",
"20:37:52.1|-25:6:32|-1||6.36|0.33|F0III|",
"20:40:11.7|-23:46:26|-1||6.37|0.72|G8V|",
"20:50:47.1|-32:3:16|-1||6.36|1.54|K5III|",
"21:1:28.1|-68:12:35|-1||6.37|0.1|A2V|",
"21:3:26.0|50:21:7|-1||6.37|0.98|K0|",
"21:24:51.7|-3:23:54|3|20|6.36|0.33|F0III|",
"21:36:13.9|30:3:20|-1||6.36|0.0|G8III-IV|",
"21:51:37.3|65:45:10|-1||6.37|0.0|A1m|",
"22:2:26.6|-16:57:51|3|29|6.37|0.42|A2V+K0III|",
"22:2:1.4|10:58:26|-1||6.37|-0.1|B5IIIn|",
"22:8:42.7|-33:7:32|-1||6.37|0.2|A2III/IV|",
"22:10:15.3|72:6:40|-1||6.37|-0.06|B9pHgMn:|",
"22:16:29.7|27:48:15|-1||6.37|0.99|G9III|",
"22:30:17.4|-14:35:9|3|56|6.37|-0.04|B8Vs|",
"22:48:21.4|-61:41:3|-1||6.37|1.06|K0III|",
"22:47:23.2|58:28:58|-1||6.36|-0.04|B9.5IV|",
"22:58:23.7|-1:24:37|-1||6.37|0.35|F0-2V|",
"23:14:36.5|24:6:11|-1||6.36|0.0|K2III|",
"23:19:43.2|-33:42:29|-1||6.37|1.3|K2III|",
"23:28:5.2|-11:26:59|-1||6.37|0.9|G0V|",
"23:43:49.5|-15:17:4|-1||6.36|1.58|M7IIIpe|",
"0:22:51.8|-12:12:34|20|9|6.39|0.66|G2V|",
"0:37:30.5|3:8:7|-1||6.39|1.33|K4III|",
"0:46:42.4|59:34:28|-1||6.39|1.09|G0Ib|",
"0:50:57.4|51:30:29|-1||6.39|0.28|F2IV|",
"1:0:31.0|70:58:59|-1||6.39|0.13|A4IV|",
"1:7:9.5|53:29:54|-1||6.38|0.0|K2III|",
"1:21:59.1|76:14:20|-1||6.38|0.28|F0IVn|",
"1:32:7.6|34:48:0|-1||6.39|-0.12|B7IIIpHgMn|",
"1:35:52.5|41:4:35|-1||6.38|1.11|K1III|",
"1:40:13.1|53:52:6|-1||6.39|1.61|K5III|",
"1:46:1.0|-27:20:57|-1||6.39|0.36|F2Vn|",
"2:38:0.8|7:41:43|-1||6.39|0.44|F6IV|",
"3:10:35.4|-23:44:18|-1||6.38|0.93|K0IV|",
"3:20:45.2|-26:36:23|-1||6.39|0.54|F7V|",
"3:21:33.3|-47:46:37|-1||6.39|1.0|K0III|",
"3:23:39.1|4:52:55|-1||6.38|0.86|G5III|",
"3:25:55.8|-35:55:15|36|χ1|6.39|0.08|A1IV|",
"3:31:49.1|49:24:3|-1||6.39|0.09|B9III|",
"3:31:53.9|-25:36:51|-1||6.38|0.12|A3V|",
"3:37:47.8|15:25:51|-1||6.39|0.17|A5IV|",
"3:59:40.0|38:49:14|-1||6.38|0.1|A1Vp:|",
"4:4:8.7|-16:35:20|-1||6.39|1.26|K2|",
"4:7:21.6|-64:13:21|-1||6.38|0.64|G3V|",
"4:23:7.7|-35:32:42|-1||6.39|1.24|K1III|",
"4:25:19.1|-44:9:39|-1||6.39|0.44|F6V|",
"4:32:4.8|5:24:36|-1||6.39|0.42|F5V|",
"5:20:26.4|-5:22:0|-1||6.39|-0.03|B8III|",
"5:28:56.7|-3:18:27|-1||6.39|-0.01|A0Vn|",
"5:35:31.1|-4:21:53|-1||6.38|-0.14|B2.5IV|",
"5:39:16.3|-17:50:58|-1||6.38|-0.12|B7V|",
"5:43:41.1|-45:49:59|-1||6.39|0.29|A9V|",
"5:49:34.1|-44:52:31|-1||6.38|1.27|K1III|",
"6:6:39.2|63:27:13|-1||6.39|0.0|K0|",
"6:12:19.1|22:54:30|37|6|6.39|2.24|M1-2Ia-Iab|",
"6:13:45.1|-23:51:43|-1||6.39|0.72|G5|",
"6:16:23.8|17:10:53|-1||6.39|1.58|K5II|",
"6:18:16.9|46:21:38|7|43|6.38|1.11|K2III|",
"6:24:43.9|-28:46:48|-1||6.39|0.62|G2IV|",
"6:37:36.9|10:51:11|-1||6.38|0.0|K0|",
"6:39:31.4|24:36:0|-1||6.38|0.53|F8IV|",
"6:51:39.3|3:2:30|-1||6.38|0.04|A2Vs|",
"7:5:9.0|47:46:30|-1||6.38|-0.04|B9IIIn|",
"7:28:51.3|-31:50:54|-1||6.38|-0.17|B3V|",
"7:28:51.3|-64:30:36|-1||6.39|1.56|K5III|",
"7:37:17.8|40:1:31|-1||6.38|0.0|M1|",
"7:36:1.7|-55:53:15|-1||6.39|1.18|K1-2IIICNII|",
"7:37:45.2|-38:0:38|-1||6.38|1.48|K4III|",
"7:46:44.9|-12:40:31|-1||6.39|-0.02|A0V|",
"7:44:43.9|-66:4:19|-1||6.38|0.95|G6-8III|",
"7:52:36.6|55:12:34|-1||6.38|0.0|A0Vn|",
"7:55:0.5|-52:34:59|-1||6.38|-0.01|B8III|",
"8:14:21.0|13:2:54|-1||6.38|0.0|G8III|",
"8:28:29.2|-2:31:2|-1||6.39|0.33|A5m|",
"8:32:33.3|-15:1:46|-1||6.38|0.27|F0Vn|",
"8:31:10.8|-47:52:0|-1||6.39|-0.15|B2.5V|",
"8:32:51.5|-31:30:3|-1||6.38|0.79|K0V|",
"8:40:6.4|20:0:28|11|39|6.39|0.98|G8III|",
"8:51:1.5|15:21:2|11|54|6.38|0.64|G1V|",
"8:49:52.4|-39:8:30|-1||6.39|0.23|A5III|",
"8:52:40.8|-52:7:45|-1||6.39|0.0|A0V|",
"8:55:55.9|-23:49:6|-1||6.39|0.16|A7V:n|",
"8:54:54.0|-58:14:24|-1||6.38|-0.11|B5V|",
"8:59:10.8|18:8:5|-1||6.38|1.55|M4III|",
"9:4:9.9|27:53:54|11|70|6.38|0.0|A1V|",
"9:19:47.9|-34:6:12|-1||6.39|-0.1|B8V|",
"9:42:43.1|48:25:52|-1||6.39|-0.01|A1V|",
"10:13:24.8|-33:1:55|-1||6.38|0.59|G1V|",
"10:23:41.8|29:36:57|-1||6.39|1.09|G8III|",
"10:48:50.0|65:7:56|-1||6.39|-0.02|A1V|",
"10:52:13.7|1:1:31|-1||6.38|0.08|A3V|",
"10:53:32.9|-15:26:44|-1||6.38|1.16|K3IV|",
"11:1:5.8|63:25:16|-1||6.39|0.16|A2Vm|",
"11:12:14.8|-32:26:2|-1||6.38|1.7|M1III|",
"11:31:15.0|-61:16:42|-1||6.38|0.52|A3Iae|",
"11:42:55.4|-79:18:23|-1||6.39|0.9|K0III-IV|",
"12:10:31.6|16:48:33|24|3|6.39|0.06|A4V|",
"12:33:59.2|-49:54:34|-1||6.38|0.46|F3III-IV|",
"12:39:2.1|22:39:34|-1||6.38|1.1|K1III|",
"12:43:58.7|-36:20:57|-1||6.39|-0.06|A0V|",
"12:43:4.2|61:9:20|-1||6.38|1.26|K0|",
"13:23:2.6|-48:33:46|-1||6.38|-0.07|B6IV|",
"13:49:45.0|36:37:58|-1||6.38|0.0|A7IV-V|",
"14:4:14.6|-5:22:53|-1||6.39|1.32|K0|",
"14:15:21.2|-53:30:35|-1||6.39|1.57|K3III|",
"14:16:34.2|-59:54:50|-1||6.39|2.04|M5IIe|",
"14:14:41.0|21:52:24|-1||6.39|0.18|A7V|",
"14:16:24.2|39:44:41|-1||6.38|0.36|F2IV|",
"14:30:56.5|-40:50:42|-1||6.39|1.44|K3III|",
"14:36:6.9|23:15:1|-1||6.38|1.06|K0|",
"14:39:24.7|-49:3:20|-1||6.39|0.44|F3IV|",
"14:41:54.2|21:7:25|-1||6.38|0.0|G8III-IV|",
"15:0:52.4|22:2:44|-1||6.38|0.0|K0|",
"15:8:19.5|50:3:18|-1||6.39|1.03|K0III|",
"15:21:6.9|24:57:28|-1||6.39|1.23|K0|",
"15:29:21.2|62:5:59|-1||6.38|0.0|K5|",
"15:31:22.4|36:36:59|-1||6.38|0.5|F6III|",
"15:47:53.7|-65:26:33|-1||6.39|0.24|F0-2IV|",
"16:12:32.2|75:12:38|83|20|6.39|0.0|K2IV|",
"17:10:6.3|-61:40:32|-1||6.39|-0.04|B8II-III|",
"17:6:52.9|-1:39:23|-1||6.38|0.2|A9V|",
"17:29:25.7|-38:31:0|-1||6.39|0.09|A2V|",
"17:30:22.4|11:55:30|-1||6.39|0.06|A1V|",
"17:36:7.9|28:11:5|-1||6.38|0.0|K5|",
"17:43:48.6|-13:30:31|-1||6.39|0.37|F0V|",
"17:53:45.5|-34:47:9|-1||6.38|0.0|B9V|",
"17:52:1.0|46:38:36|-1||6.38|1.09|K0III|",
"17:54:14.2|11:7:50|-1||6.38|0.45|F5Vn|",
"18:9:57.6|-59:2:24|-1||6.38|1.55|K4III|",
"18:9:43.4|-13:56:4|-1||6.39|1.42|K0|",
"18:9:10.2|30:28:10|-1||6.38|1.19|gK1|",
"18:24:3.5|-3:35:0|-1||6.38|0.34|F6III-IV|",
"18:47:49.4|-77:52:2|-1||6.39|0.6|F8V|",
"18:39:36.9|5:15:51|-1||6.38|0.78|F8Ib-II|",
"18:45:38.1|79:56:33|-1||6.39|0.28|A8V|",
"19:1:5.5|19:18:35|-1||6.39|0.0|K1III|",
"19:1:48.3|33:37:17|-1||6.39|-0.12|B5IV|",
"19:18:9.4|-53:23:12|-1||6.38|0.49|F7V|",
"17:16:56.8|89:2:16|83|λ|6.38|1.57|M1III|",
"19:26:26.5|62:33:26|-1||6.38|1.39|K5III|",
"19:39:52.1|-66:41:8|-1||6.39|0.02|A1V|",
"19:35:25.2|2:54:48|-1||6.38|0.41|F6IV|",
"19:36:15.8|14:23:30|-1||6.38|1.04|K0II-III|",
"19:39:25.4|16:34:17|-1||6.38|2.07|K4Ib|",
"19:56:1.5|-81:20:59|-1||6.39|1.4|K3-4III|",
"19:49:54.6|28:26:26|-1||6.38|-0.06|B5V|",
"19:58:53.0|-68:45:44|-1||6.39|0.16|A0V+F5IV|",
"20:16:23.7|-36:27:16|-1||6.39|1.54|M4III|",
"20:22:3.0|41:7:53|-1||6.39|1.07|G5III+A|",
"20:27:7.7|34:19:44|-1||6.39|0.48|F1II|",
"20:30:56.8|-29:6:45|-1||6.39|0.21|A5V|",
"20:45:28.2|18:5:25|-1||6.38|1.68|M5II-III|",
"20:53:5.6|-11:34:25|-1||6.38|0.67|G1V|",
"21:14:37.0|0:5:32|-1||6.38|1.61|M1III|",
"21:13:42.6|64:24:14|-1||6.39|0.6|G2IV+G2IV|",
"21:21:16.4|-49:56:16|-1||6.38|1.32|K3III|",
"21:33:54.4|-82:40:59|-1||6.38|0.13|B3IV|",
"21:24:7.9|-22:44:49|-1||6.38|1.02|gK0|",
"21:29:0.3|-53:42:21|-1||6.39|1.14|K2IIICNIb|",
"21:50:13.1|-16:50:41|-1||6.38|1.42|K0|",
"21:54:17.4|19:43:6|-1||6.39|0.97|K0III+F7V|",
"22:4:34.4|32:56:31|-1||6.38|1.1|G5Ia|",
"22:6:13.5|56:20:35|-1||6.39|-0.1|A0III|",
"22:12:43.8|-4:43:15|-1||6.39|0.5|F7V|",
"22:18:4.3|0:14:16|-1||6.39|0.44|F3V|",
"22:31:41.3|-10:54:20|3|58|6.38|0.28|A8III|",
"22:35:51.8|56:4:12|-1||6.38|0.12|A3V|",
"22:43:4.5|47:10:7|-1||6.39|0.47|A1V+G:|",
"23:2:45.2|44:3:32|-1||6.39|0.0|B2V|",
"23:5:17.6|1:18:25|-1||6.39|0.94|G9III|",
"23:17:18.9|75:17:57|-1||6.38|0.03|A2Vs|",
"23:20:34.6|62:12:47|-1||6.39|1.61|K2III|",
"23:31:1.1|-6:17:18|-1||6.39|1.26|K0|",
"23:31:57.6|-1:5:9|65|13|6.38|1.18|K1III|",
"23:35:32.1|-7:27:52|-1||6.39|0.88|gG5|",
"23:52:25.1|75:32:41|-1||6.39|0.98|K3V|",
"0:0:43.7|45:15:12|-1||6.38|-0.07|B9pSiEu|",
"0:34:55.3|13:22:16|-1||6.4|0.0|K0|",
"0:35:54.7|13:12:24|-1||6.41|0.52|F7V|",
"0:39:47.3|82:29:38|-1||6.4|0.55|dF6|",
"0:37:18.1|-54:23:39|-1||6.41|1.0|K0II-IIICNIV|",
"1:10:12.0|-8:54:22|20|32|6.4|1.04|K0III|",
"1:10:7.4|-57:41:40|-1||6.41|0.89|G6II-III|",
"1:13:9.9|61:42:21|-1||6.41|0.01|B9V|",
"1:26:27.3|0:23:55|-1||6.41|1.24|K0IV|",
"2:25:26.3|-66:29:41|-1||6.41|1.54|M5III|",
"2:51:55.3|-30:48:52|-1||6.4|0.48|F8IV-V|",
"2:57:32.7|-38:11:28|-1||6.41|-0.03|A0Vn|",
"3:7:47.4|47:18:30|-1||6.41|0.12|A3Vnn|",
"3:33:32.1|58:45:54|-1||6.4|0.14|A4III|",
"3:32:39.1|44:51:20|-1||6.41|0.03|B2IV|",
"3:34:33.5|-31:52:29|-1||6.4|1.4|K3III|",
"3:32:51.6|-61:1:1|-1||6.41|1.04|K0III|",
"4:1:14.7|36:59:24|-1||6.41|-0.01|A0V|",
"3:42:32.1|-85:15:44|-1||6.41|-0.01|B9.5IV|",
"4:28:51.9|30:21:41|-1||6.4|0.52|F7V|",
"4:53:9.8|52:50:27|-1||6.41|0.0|A2V|",
"4:53:30.5|-66:40:32|-1||6.41|1.63|M0-1III|",
"5:9:36.7|69:38:22|-1||6.41|1.11|K1III|",
"5:3:52.0|-14:22:10|-1||6.41|-0.18|B2.5IV|",
"5:9:44.5|64:55:10|-1||6.41|0.4|F6V|",
"5:10:44.5|-25:54:34|-1||6.41|1.25|K1III|",
"5:28:1.6|1:17:54|-1||6.41|-0.18|B2V|",
"5:35:35.8|-3:15:10|-1||6.4|-0.12|B3IV|",
"6:5:9.3|75:35:9|-1||6.4|0.0|K5|",
"6:17:51.7|-52:43:59|-1||6.41|1.46|K2-3III|",
"6:23:18.5|3:45:52|-1||6.4|-0.15|B3V|",
"6:25:58.8|-7:53:39|-1||6.4|0.14|A4V|",
"6:31:37.4|15:54:12|37|19|6.4|0.0|A8V|",
"6:33:26.6|-20:55:26|-1||6.4|0.83|G5|",
"6:39:58.0|44:0:50|-1||6.41|0.0|K1III|",
"6:53:0.1|-26:57:27|-1||6.4|1.53|M4III|",
"6:54:8.5|-5:51:9|-1||6.41|0.17|A6Vn|",
"6:52:45.4|-59:20:28|-1||6.41|0.18|A3m|",
"6:59:27.9|25:54:51|37|40|6.4|-0.11|B8III|",
"7:0:49.8|-33:27:55|-1||6.4|1.05|G8II-III|",
"7:15:19.3|0:9:41|54|24|6.41|0.9|G5III|",
"7:22:13.4|38:59:46|-1||6.4|1.22|K0|",
"7:34:39.7|80:53:48|-1||6.41|0.0|gG7|",
"7:24:27.7|15:31:2|-1||6.41|-0.18|B2Ve|",
"7:26:41.3|11:0:33|-1||6.41|-0.13|B6IV|",
"7:41:21.8|-44:37:56|-1||6.41|0.0|B7IV-V|",
"7:43:42.9|-38:12:7|-1||6.4|-0.16|B9VpSi|",
"7:58:5.8|7:12:49|-1||6.41|-0.04|A0V|",
"8:2:30.8|63:5:25|-1||6.4|0.59|G1III|",
"8:5:49.6|0:34:25|-1||6.41|1.05|K0|",
"8:22:44.1|60:37:52|-1||6.41|0.97|K0III|",
"8:45:20.8|-2:36:3|-1||6.41|0.52|F2IV|",
"9:3:5.2|-53:32:59|-1||6.4|-0.09|B6V|",
"9:7:26.9|22:58:52|-1||6.4|0.0|F4V|",
"9:17:51.4|11:30:4|-1||6.41|0.07|A2IV|",
"9:23:31.8|25:10:59|-1||6.41|0.82|G5IV|",
"9:37:51.5|-9:25:28|41|34|6.4|-0.04|A1V|",
"9:42:41.4|-35:30:6|-1||6.41|-0.06|ApSi|",
"9:56:5.4|-40:49:29|-1||6.41|1.61|M1III|",
"10:11:35.2|-58:49:41|-1||6.4|1.66|M3III|",
"10:18:1.1|73:4:24|-1||6.4|0.23|F2V|",
"10:13:21.2|-61:39:32|-1||6.41|-0.11|B2V|",
"10:19:0.7|24:42:42|-1||6.4|0.0|K0|",
"11:6:24.2|-64:50:23|-1||6.41|0.12|A3V|",
"11:12:11.0|68:16:19|-1||6.4|0.0|A3V|",
"11:12:32.2|35:48:49|-1||6.41|0.61|G0V|",
"11:12:34.6|-21:44:57|-1||6.4|1.38|K0|",
"11:20:3.9|-71:59:40|-1||6.41|0.05|B4V|",
"11:30:12.9|54:21:42|-1||6.41|0.0|K0III|",
"11:33:56.3|36:48:56|-1||6.4|1.05|K0III|",
"12:22:32.0|5:18:20|85|17|6.4|0.6|F8V|",
"12:23:36.9|-39:18:11|-1||6.4|0.29|F2V|",
"12:43:28.2|-58:54:11|-1||6.4|1.09|K0-1III|",
"12:44:26.0|80:37:16|-1||6.4|0.12|A5m|",
"12:47:51.4|3:34:22|85|35|6.41|1.6|M3IIIb|",
"12:51:22.9|-10:20:18|-1||6.41|1.02|G8III|",
"13:27:14.7|-40:9:47|-1||6.4|0.98|G8/K0III|",
"13:42:54.6|-50:47:26|-1||6.41|1.67|M0III|",
"13:50:59.2|68:18:55|-1||6.4|1.17|K2IV|",
"13:59:49.3|-3:32:59|-1||6.4|0.49|F8V|",
"14:8:14.3|-63:12:29|-1||6.4|1.02|G8-K0III|",
"14:35:17.2|-60:0:57|-1||6.4|1.26|K2III|",
"14:46:10.9|-21:10:34|-1||6.4|0.58|F7V|",
"14:53:23.3|15:42:16|-1||6.4|0.57|F9V|",
"15:4:42.9|-40:51:41|-1||6.41|1.46|M6III|",
"15:52:12.8|-29:53:12|-1||6.4|0.98|K1III|",
"16:1:10.7|-63:46:36|-1||6.41|0.78|F8II|",
"16:5:59.8|-6:8:22|-1||6.41|1.03|K0|",
"16:13:45.7|-24:25:19|-1||6.41|0.04|B5V|",
"16:14:28.8|-21:6:27|-1||6.41|-0.01|A0V|",
"16:18:9.4|68:33:16|-1||6.41|0.0|K0|",
"16:22:56.5|32:19:59|-1||6.4|0.08|A4Vn|",
"16:35:26.3|17:3:26|-1||6.41|0.05|A2V|",
"16:56:25.2|65:2:21|33|20|6.41|0.38|F1-3V|",
"16:59:2.6|69:11:11|-1||6.4|0.0|K0|",
"17:22:39.4|-37:48:18|-1||6.41|0.64|B4Ia|",
"17:26:0.9|26:52:44|-1||6.41|0.1|A5IV|",
"17:30:43.8|57:52:35|-1||6.4|0.0|K2III|",
"17:34:27.2|16:30:14|-1||6.4|0.0|A8Vn|",
"17:43:6.9|-33:3:4|-1||6.4|1.81|M1III|",
"18:7:48.3|-64:33:0|-1||6.41|1.26|K2-3III|",
"18:9:37.5|38:27:27|-1||6.4|0.87|K2V|",
"18:17:23.7|-28:17:21|-1||6.4|0.54|G0V|",
"18:21:7.1|49:43:32|-1||6.4|1.07|K1III|",
"18:34:47.5|10:53:30|-1||6.4|0.08|A1V|",
"18:38:21.0|8:50:2|-1||6.4|1.32|M6IIIe+K1III|",
"18:41:41.3|31:37:4|-1||6.41|-0.04|B8V|",
"18:47:40.0|49:4:30|-1||6.4|0.0|A1V|",
"19:1:4.3|-37:3:43|-1||6.4|-0.03|B8V-IV|",
"18:59:12.3|39:13:4|-1||6.41|-0.17|B5IV|",
"19:1:49.5|22:15:50|-1||6.4|0.16|A4V|",
"19:12:28.0|-21:39:29|-1||6.41|1.13|gG8|",
"19:18:50.9|0:20:21|4|24|6.41|1.05|K0-IIIa:Ba0.4CH1|",
"19:23:46.9|20:15:52|-1||6.4|0.01|B9.5V|",
"20:26:1.2|19:51:54|-1||6.41|1.02|K0III|",
"20:28:43.6|-15:44:30|-1||6.41|0.99|K0III|",
"20:29:59.9|45:55:43|-1||6.41|1.13|K2III|",
"20:34:47.4|-30:28:25|-1||6.4|-0.08|B8V|",
"20:36:8.3|25:52:57|87|26|6.41|0.21|A5III|",
"20:47:47.8|3:18:24|-1||6.4|-0.02|A0Vn|",
"20:47:20.8|45:34:47|-1||6.4|1.61|K3III|",
"20:44:33.1|69:45:7|-1||6.41|0.0|G8III|",
"20:54:6.8|-27:55:32|-1||6.41|1.6|M4III|",
"21:17:13.5|-13:16:44|-1||6.4|0.04|A2V|",
"21:18:54.4|-28:45:56|-1||6.4|0.97|G8IV|",
"21:24:16.7|-69:44:3|-1||6.41|2.82|C5II|",
"21:21:1.4|40:20:44|-1||6.4|0.53|F8V|",
"21:28:24.8|8:11:44|-1||6.4|1.64|M1|",
"21:33:17.7|-52:44:15|-1||6.41|1.48|K4III|",
"21:34:53.0|-29:41:46|-1||6.41|-0.11|B8III|",
"21:35:15.9|-23:27:15|-1||6.4|1.1|gG7|",
"21:45:44.5|35:51:26|-1||6.4|1.0|G8III|",
"21:55:55.6|-30:36:23|-1||6.41|0.93|G8III|",
"22:1:52.1|-77:39:45|-1||6.41|0.22|A5IV-V|",
"21:56:24.0|21:14:23|-1||6.4|1.7|K5V|",
"22:21:50.9|42:4:42|-1||6.41|-0.08|B5V|",
"22:30:1.5|-12:54:54|-1||6.4|0.32|F3IV|",
"22:30:6.5|49:21:22|-1||6.4|1.15|K2IIIe|",
"22:36:36.4|11:41:49|-1||6.4|0.0|A1III|",
"22:38:17.5|45:10:59|-1||6.4|0.0|G2III+A4V|",
"22:43:14.3|-6:57:46|3|67|6.41|-0.04|A0Vn|",
"22:50:39.1|19:8:27|-1||6.4|0.0|K0|",
"22:55:14.9|-36:23:19|-1||6.4|1.31|K2III|",
"23:4:1.0|6:37:0|-1||6.41|0.39|F2V|",
"23:7:10.4|59:43:39|-1||6.4|-0.01|B2V|",
"23:12:12.0|-80:54:46|-1||6.41|1.5|K4III|",
"23:14:21.7|29:46:18|-1||6.41|0.45|F6IVw|",
"23:31:43.1|28:24:13|-1||6.41|0.01|A1pSrCr:Eu:|",
"23:42:31.5|61:40:46|-1||6.4|1.24|K2III|",
"23:48:39.0|64:52:35|-1||6.41|0.06|A0pSrSi:Cr:|",
"0:4:20.3|-29:16:7|-1||6.4|0.0|A0V|",
"0:7:44.1|-2:32:56|-1||6.43|-0.14|B8IIIpSi|",
"0:28:21.1|-20:20:6|-1||6.43|0.59|G0V|",
"0:33:19.3|70:58:54|-1||6.42|-0.01|A0Vn|",
"0:36:37.4|-65:7:29|-1||6.42|1.26|K2-3III|",
"1:7:0.2|56:56:6|-1||6.43|1.18|K2III|",
"1:14:5.0|28:31:47|-1||6.43|1.7|S3+/2-|",
"2:2:28.1|-29:39:54|-1||6.42|0.14|A3III|",
"2:8:33.6|44:27:34|-1||6.42|0.0|G8III-IV|",
"2:9:23.1|17:13:28|-1||6.43|0.0|F5V|",
"3:10:8.8|27:49:12|-1||6.42|0.01|A0V|",
"3:38:0.2|42:34:59|-1||6.42|-0.06|B8Vn|",
"3:46:2.9|24:31:41|77|22|6.43|-0.02|A0Vn|",
"4:50:56.3|-53:27:35|64|ι|6.42|0.0|F4V:|",
"5:16:41.1|1:56:50|-1||6.42|-0.02|A0V|",
"5:26:38.8|6:52:9|-1||6.42|-0.02|A0Vn|",
"5:33:44.4|-54:54:8|-1||6.43|0.55|F8V|",
"5:41:21.0|29:29:15|-1||6.43|-0.11|B8IV|",
"5:41:40.3|-2:53:46|-1||6.42|0.3|A9IV-V|",
"6:2:53.6|43:22:43|-1||6.42|0.0|K0|",
"6:21:12.1|29:32:28|-1||6.43|0.06|A1Vs|",
"6:16:18.5|-59:12:49|-1||6.43|0.59|G0V|",
"6:27:35.5|32:33:47|-1||6.43|1.26|K0|",
"6:33:42.7|33:1:27|-1||6.42|0.03|A3V|",
"6:41:21.0|28:11:47|37|25|6.42|1.09|G5Ib|",
"6:51:32.8|-48:17:33|-1||6.42|1.21|K2-3III|",
"6:58:43.8|-30:59:52|-1||6.42|-0.14|B3V|",
"7:2:15.6|-43:24:15|-1||6.43|-0.04|A0V|",
"7:10:6.7|21:14:49|-1||6.43|0.89|G9V|",
"7:12:49.0|27:13:29|-1||6.43|0.49|F8V|",
"7:22:2.0|-8:58:45|-1||6.43|-0.19|O9V|",
"7:44:14.0|12:51:34|-1||6.43|0.0|K0|",
"7:42:10.2|-58:37:51|-1||6.43|-0.1|B2.5V|",
"7:47:45.2|-16:0:52|-1||6.43|1.7|M2II-III|",
"8:12:51.5|-37:55:28|-1||6.43|0.1|A3V|",
"8:19:29.4|-34:35:25|-1||6.43|-0.08|B9pHgMn|",
"8:17:55.8|-59:10:1|-1||6.42|0.39|F5V|",
"8:28:19.7|-8:48:58|-1||6.43|1.2|K0|",
"8:34:31.7|-32:35:55|-1||6.43|0.75|G5IV-V|",
"8:39:0.0|52:55:30|-1||6.42|0.0|K0|",
"8:42:57.0|-35:56:36|-1||6.42|0.02|A0V|",
"8:48:8.8|-42:27:50|-1||6.43|-0.2|B2IV-V|",
"8:52:38.6|-36:32:44|-1||6.42|0.56|G8III+A3-5V|",
"9:37:56.2|73:4:50|-1||6.42|0.0|F2V+F1V|",
"9:33:7.8|-39:7:44|-1||6.43|0.33|F0IV|",
"9:51:21.6|-6:10:54|-1||6.42|0.58|F8V|",
"10:2:49.4|-62:9:23|-1||6.42|1.72|K3Ib|",
"10:4:23.4|-39:58:33|-1||6.43|1.3|K1III|",
"10:18:59.0|46:45:39|-1||6.43|0.0|K1III|",
"10:30:39.2|-61:21:22|-1||6.43|1.76|M2IIIe|",
"10:41:17.6|-59:40:37|-1||6.42|0.08|WN7-A|",
"11:0:25.6|51:30:7|-1||6.43|0.0|G9III|",
"11:21:49.3|57:4:30|-1||6.43|0.15|A7Vn|",
"11:21:57.1|-77:36:30|-1||6.43|0.2|A5III-IV|",
"11:30:52.9|47:55:45|-1||6.42|0.88|G9IV|",
"11:39:0.4|-24:43:16|-1||6.42|0.82|G5|",
"11:58:7.2|32:16:26|-1||6.42|0.29|A9V|",
"11:58:54.4|-25:54:32|-1||6.43|0.03|A0-1V|",
"12:2:28.6|-71:29:20|-1||6.42|1.17|K1III|",
"12:11:44.9|57:3:16|82|68|6.43|0.0|gK5|",
"12:24:26.7|25:34:58|-1||6.42|0.27|A7V+F4V|",
"12:31:16.7|-57:4:52|29|γ|6.42|0.16|A3V|",
"12:50:17.4|22:51:48|-1||6.43|1.0|K0III|",
"13:5:30.8|-52:6:54|-1||6.43|1.7|M1III|",
"13:29:14.9|-1:21:52|-1||6.43|1.11|K0III|",
"13:28:45.7|50:43:6|-1||6.43|0.37|F0IV|",
"13:38:7.6|-58:24:54|-1||6.42|1.12|K1III|",
"14:6:25.1|-59:42:56|-1||6.42|0.12|B0Ia|",
"14:11:31.2|1:21:44|-1||6.43|0.48|F7V|",
"14:24:23.3|-82:50:55|-1||6.42|0.02|B8Ve|",
"14:33:20.3|36:57:34|-1||6.43|0.0|F8IVw|",
"15:28:56.8|55:11:42|-1||6.43|0.08|A3m|",
"15:35:49.3|38:22:26|-1||6.42|0.0|K2|",
"15:47:25.4|-40:11:39|-1||6.42|0.88|G5III-IV|",
"17:5:5.0|43:48:44|-1||6.43|0.09|A3IV|",
"17:18:19.2|-16:18:43|-1||6.43|1.66|M2IIIFe1|",
"17:20:33.6|48:11:18|-1||6.43|0.43|F4V|",
"17:25:0.2|67:18:23|-1||6.43|0.76|K0V|",
"17:30:40.3|38:52:56|-1||6.43|0.49|F6III|",
"17:32:15.0|11:55:49|-1||6.42|-0.01|B9.5VpHgMn|",
"17:36:39.7|69:34:15|-1||6.42|0.58|F9V|",
"17:47:7.3|-38:6:42|-1||6.43|-0.02|B9V+A1V|",
"17:47:8.1|47:36:44|-1||6.43|0.11|A2Vs|",
"17:53:58.1|-34:49:54|-1||6.42|0.01|ApSi*|",
"17:56:55.8|-40:18:20|-1||6.43|1.43|K3III|",
"18:9:59.9|-32:43:11|-1||6.43|1.02|K0IV|",
"18:27:42.3|59:32:57|-1||6.43|0.0|K0IV|",
"18:32:7.0|3:39:35|-1||6.43|-0.04|A0pSiCr|",
"18:33:23.3|8:16:6|-1||6.42|-0.03|B8IIIpSiSr:|",
"18:37:12.6|11:25:18|-1||6.42|-0.02|B9V|",
"18:41:42.5|-14:33:51|-1||6.42|0.81|F2Ib|",
"18:46:1.2|-19:36:23|-1||6.42|1.65|M4III|",
"19:5:9.9|49:55:24|-1||6.43|0.0|K3III|",
"19:21:25.4|57:46:1|-1||6.43|0.0|K2|",
"19:37:9.4|29:20:1|-1||6.43|-0.09|B5V|",
"19:45:39.6|36:5:28|-1||6.43|-0.03|B9.5VpSi|",
"19:56:45.1|50:54:9|-1||6.43|-0.01|A1V|",
"19:57:56.2|42:15:39|-1||6.43|0.0|A3V|",
"20:7:50.3|9:23:59|-1||6.43|0.46|F3V|",
"20:8:6.5|16:39:51|-1||6.42|1.91|M3III|",
"20:39:51.8|11:14:59|-1||6.42|0.55|F8IV:|",
"21:4:41.7|2:56:31|-1||6.42|1.05|K0|",
"21:16:29.6|42:15:5|-1||6.43|0.0|K2|",
"21:17:18.8|58:36:42|-1||6.42|0.2|B2IIIe|",
"21:32:33.3|-24:35:26|-1||6.43|0.2|A7V|",
"21:57:2.2|48:40:7|-1||6.42|-0.08|B8V|",
"21:57:11.1|66:9:22|-1||6.43|-0.05|B2V|",
"22:9:58.0|-48:6:26|-1||6.43|1.39|K3III|",
"22:8:16.5|49:47:47|-1||6.42|0.0|K5III|",
"22:20:39.6|50:58:51|-1||6.42|0.0|K2|",
"22:30:53.7|-26:4:25|66|ζ|6.43|1.08|K1III|",
"22:32:35.5|20:13:48|61|39|6.42|0.32|F1V|",
"22:42:55.5|37:48:10|-1||6.43|-0.09|B1V|",
"22:58:35.1|9:21:25|-1||6.43|0.64|G2V+G4V|",
"22:59:9.0|59:48:53|-1||6.43|0.03|B9III|",
"23:3:21.6|58:33:53|-1||6.43|0.9|G8IV|",
"23:9:49.6|-14:30:38|-1||6.42|0.01|A0Vn|",
"23:17:16.6|45:9:51|-1||6.43|1.07|K0IV|",
"23:29:0.8|-44:29:52|-1||6.43|1.18|K2III|",
"23:49:49.6|-25:19:53|-1||6.42|0.12|A3V|",
"0:15:7.0|31:32:9|-1||6.45|0.0|K5|",
"0:17:32.6|-19:3:4|-1||6.45|0.37|F4IV-V|",
"0:36:3.0|-14:58:25|-1||6.45|1.06|G9III|",
"1:3:1.5|47:22:34|-1||6.45|0.25|A9IV|",
"1:23:21.6|58:8:35|-1||6.45|0.0|F4V|",
"1:53:48.5|55:35:53|-1||6.45|0.18|A5m|",
"2:13:41.5|58:33:40|-1||6.44|0.6|A3Iab|",
"2:24:20.1|-25:50:51|-1||6.44|1.32|K3III|",
"2:28:0.0|1:57:39|-1||6.45|0.97|K0III|",
"2:49:27.1|37:19:34|-1||6.45|0.43|F6III-IV|",
"2:51:45.5|58:18:53|-1||6.45|0.1|A1m|",
"3:17:11.4|40:29:0|-1||6.45|0.0|B9VpSi|",
"3:44:6.2|-40:39:37|-1||6.45|1.06|K1III|",
"4:10:45.8|-35:16:26|-1||6.44|1.07|K1+IIIaCH-1.5|",
"4:13:59.6|37:58:1|-1||6.45|0.0|G9III|",
"4:13:38.2|-1:8:59|-1||6.44|-0.13|B5IV|",
"4:28:9.4|-41:57:36|-1||6.44|1.64|M1III|",
"4:39:4.3|-51:40:22|-1||6.44|1.32|K2III|",
"4:43:48.3|32:51:55|-1||6.45|0.0|A8V|",
"5:5:32.1|19:48:23|-1||6.44|0.21|A5m|",
"5:52:39.5|39:34:28|-1||6.45|0.09|A2V|",
"5:51:59.5|-29:26:55|-1||6.45|1.48|K3III|",
"5:59:45.7|55:19:15|-1||6.44|0.31|A5m|",
"5:56:49.0|-31:58:34|-1||6.44|1.07|G8III|",
"5:57:14.4|-53:25:34|-1||6.45|1.48|K5-M0III|",
"6:4:29.1|51:34:24|-1||6.45|0.18|A7III|",
"6:2:9.2|-60:5:49|-1||6.45|1.58|M4III|",
"6:13:12.6|10:37:39|-1||6.45|0.67|G2V|",
"6:34:32.8|55:21:11|50|7|6.45|0.0|K0III:|",
"6:34:46.4|7:34:21|54|14|6.45|-0.02|A0Vs|",
"6:33:10.3|-38:37:31|-1||6.44|1.0|G8III|",
"6:37:27.2|24:35:27|-1||6.44|0.1|A3V|",
"6:44:51.9|-27:20:29|-1||6.45|0.54|G2V|",
"6:58:36.2|-56:23:41|-1||6.45|0.39|F2II|",
"7:6:1.3|59:48:7|-1||6.44|0.0|G8III:|",
"7:3:57.3|-10:7:27|-1||6.45|-0.08|B9IIIn|",
"7:20:6.9|15:8:34|-1||6.45|-0.02|A2Vn|",
"7:51:0.0|-24:31:42|-1||6.45|-0.01|A0|",
"7:50:42.4|-44:34:47|-1||6.45|0.9|G6III|",
"7:55:13.7|-30:55:3|-1||6.44|0.0|K4III|",
"7:58:21.4|-51:26:55|-1||6.44|0.25|A8-9IV|",
"8:11:1.6|-37:17:32|-1||6.44|-0.01|O9.5II|",
"8:15:50.5|60:22:50|-1||6.45|0.2|A7Vm|",
"8:15:23.3|-50:26:58|-1||6.44|1.49|K3-4III|",
"8:17:58.3|-30:0:12|-1||6.45|1.04|K0III|",
"8:25:39.4|-17:26:22|-1||6.44|0.0|K0|",
"8:39:24.6|8:1:2|-1||6.45|1.08|K1III|",
"8:40:22.1|19:40:12|-1||6.44|1.02|G9III|",
"8:42:9.8|-11:57:58|-1||6.45|0.16|A5m|",
"9:0:30.8|37:36:16|-1||6.44|0.0|K5|",
"9:6:43.1|59:20:40|-1||6.45|0.04|A2V|",
"9:4:48.0|-57:51:9|-1||6.44|0.25|A8III|",
"9:29:47.6|55:44:44|-1||6.45|0.0|F3Vs|",
"9:45:21.8|-30:12:10|-1||6.45|-0.13|B0.5IIIn|",
"9:47:25.9|11:34:6|45|19|6.45|0.43|A7Vn|",
"10:4:8.4|3:12:4|76|13|6.45|0.4|F4V|",
"10:11:38.2|13:21:18|45|34|6.44|0.46|F7V|",
"10:12:37.8|-19:9:13|-1||6.44|0.5|F6V|",
"10:20:14.8|53:46:45|-1||6.45|0.54|F9V|",
"10:28:3.8|48:47:5|-1||6.44|0.6|F9V|",
"10:33:43.6|53:29:51|-1||6.45|0.0|A1V|",
"10:52:31.9|52:30:13|-1||6.44|1.11|K2III|",
"10:55:11.6|-20:39:54|-1||6.44|1.1|K0|",
"11:17:39.2|-34:44:14|-1||6.45|0.4|F4V|",
"11:27:58.5|-35:19:43|-1||6.45|0.0|K5III:|",
"11:35:3.8|20:26:29|-1||6.45|1.01|G9III|",
"11:38:44.9|45:6:31|-1||6.44|0.56|G0V|",
"11:41:8.4|-29:11:47|-1||6.44|0.66|G0V|",
"11:52:58.8|37:43:7|-1||6.45|0.75|G8Vp|",
"12:3:44.3|-74:12:50|-1||6.44|1.23|G6III|",
"12:39:16.9|35:57:7|-1||6.45|0.06|A0pSrCrEu|",
"12:43:26.3|-40:10:40|-1||6.44|0.25|A8V:|",
"12:47:53.7|-24:51:6|-1||6.44|-0.06|B8III|",
"12:53:38.1|-4:13:26|-1||6.44|1.1|K0|",
"13:16:14.3|19:3:6|-1||6.45|0.98|G8III|",
"13:16:32.3|19:47:7|-1||6.45|0.25|F0V|",
"13:24:30.5|12:25:55|-1||6.44|1.06|K0III|",
"13:32:34.5|-29:33:55|-1||6.45|0.44|F3IV|",
"13:34:43.6|-33:18:39|-1||6.44|1.26|K2III|",
"13:50:19.4|-39:54:4|-1||6.44|0.99|K1III|",
"13:51:20.4|-24:23:27|-1||6.45|0.69|G5V|",
"14:6:56.4|74:35:37|83|3|6.45|0.14|A7V|",
"14:14:53.0|3:20:10|-1||6.45|1.6|M4IIIab|",
"14:16:21.5|-6:37:19|-1||6.44|0.28|A9III|",
"14:20:8.7|30:25:45|-1||6.44|0.15|A5III|",
"14:28:43.5|-59:11:52|-1||6.45|0.14|A0II-III|",
"15:11:34.9|-45:16:39|-1||6.44|1.04|K1III|",
"15:13:28.7|-25:18:33|48|23|6.45|0.7|G4V|",
"15:26:32.5|54:1:12|-1||6.45|0.05|A2IV|",
"15:33:52.8|17:8:16|-1||6.45|0.0|F3III|",
"15:40:11.5|-70:13:40|-1||6.44|0.08|A1V|",
"15:39:9.5|57:55:28|-1||6.45|1.09|K1III|",
"15:48:2.0|31:44:9|-1||6.44|0.0|K5|",
"16:30:6.0|48:57:39|39|34|6.45|0.03|A1V|",
"16:54:11.8|-41:51:1|-1||6.45|0.2|O9Ib|",
"17:1:46.1|-51:7:51|-1||6.45|0.27|A7V|",
"17:17:35.9|23:5:27|-1||6.45|0.0|K2|",
"17:25:57.9|-1:39:6|-1||6.44|0.46|F3V|",
"17:26:55.2|-25:56:36|-1||6.44|-0.06|A0V|",
"17:31:47.4|-33:42:10|-1||6.44|1.19|K2III|",
"18:1:34.1|-85:12:53|-1||6.45|0.44|F5IV|",
"17:52:55.9|-35:1:7|-1||6.45|0.02|B9.5V|",
"18:20:55.3|-37:29:15|-1||6.45|1.31|K2II|",
"18:33:29.5|-58:42:33|-1||6.44|0.68|G5IV|",
"18:40:12.2|38:22:2|-1||6.45|0.21|A6m|",
"18:43:16.7|39:18:1|-1||6.45|1.59|K5|",
"18:43:10.2|70:47:34|-1||6.44|0.0|K2|",
"18:57:17.4|62:23:48|-1||6.45|0.93|G5IV+G8V|",
"19:49:53.3|-66:48:46|-1||6.45|1.48|K4III|",
"19:48:30.4|10:41:39|-1||6.44|0.96|F8Ib-II|",
"19:48:50.6|33:26:14|-1||6.44|0.2|B0.5Ib|",
"20:3:44.3|-22:35:44|-1||6.45|0.5|F6V|",
"20:8:20.5|-66:21:17|-1||6.45|1.58|K5III|",
"20:4:58.6|23:12:37|-1||6.45|0.0|A5Vn|",
"20:14:5.0|36:36:19|-1||6.45|0.0|A0V|",
"20:18:49.6|46:19:22|-1||6.45|-0.13|B2V|",
"20:25:5.1|59:36:0|-1||6.44|0.09|A2IVs|",
"20:34:55.5|-38:5:23|-1||6.44|0.26|A8III:|",
"20:40:45.2|19:56:7|-1||6.45|0.63|G5V|",
"20:49:17.4|64:2:32|-1||6.45|0.07|B0.5V|",
"20:52:0.3|32:50:57|-1||6.44|-0.15|B3III|",
"20:53:58.4|-6:53:23|-1||6.44|0.37|F1IV|",
"21:9:58.3|2:56:36|-1||6.45|0.37|F5IV|",
"21:32:4.2|-84:48:36|-1||6.45|1.4|K3III|",
"21:28:59.9|17:54:21|-1||6.44|1.39|K5|",
"21:45:19.0|-49:29:55|-1||6.45|1.15|K1III|",
"22:5:50.6|45:6:44|-1||6.44|-0.03|A0V|",
"22:10:0.1|-28:17:33|-1||6.44|0.15|A5V|",
"22:43:3.5|-8:18:42|-1||6.45|0.17|A5V|",
"23:5:6.3|16:33:47|-1||6.44|0.83|G8IV|",
"23:20:14.3|61:58:12|-1||6.45|0.0|K1V|",
"23:27:7.2|-66:34:52|-1||6.45|1.47|K4III|",
"23:35:55.9|24:33:40|-1||6.45|1.73|M1III|",
"23:50:22.3|51:37:18|-1||6.44|0.37|F3V|",
"0:3:7.7|-24:8:43|-1||6.44|1.18|G5|",
"0:16:42.5|-20:12:38|-1||6.47|-0.09|B8III|",
"0:18:41.8|-8:3:10|-1||6.46|0.68|G0V|",
"0:37:7.2|24:0:51|-1||6.47|0.0|K2III|",
"0:45:41.7|-16:25:27|-1||6.47|0.31|F1IVn|",
"0:53:12.4|-24:46:37|-1||6.46|0.44|F6IV-V|",
"1:33:50.4|89:0:56|-1||6.46|0.11|A3V|",
"1:2:18.4|51:2:6|-1||6.47|0.0|A3V|",
"1:18:47.0|37:23:10|-1||6.46|0.23|A5m|",
"1:27:26.6|41:6:2|-1||6.46|0.27|A7m|",
"2:18:58.0|23:10:4|-1||6.46|0.34|A1V+F3III|",
"2:20:4.4|30:11:18|-1||6.47|0.0|K0|",
"2:44:19.1|17:45:50|6|36|6.46|1.07|K2III|",
"2:47:11.2|-22:29:8|-1||6.47|0.39|F2|",
"3:35:0.8|60:2:28|-1||6.46|0.39|F3V|",
"3:49:19.6|57:7:5|-1||6.46|0.06|A0Vn|",
"3:54:34.0|-52:41:26|-1||6.46|0.16|A4V|",
"4:3:24.7|-20:8:39|-1||6.46|-0.18|B2.5V|",
"4:25:37.3|15:56:27|77|70|6.46|0.49|F7V|",
"4:38:29.6|26:56:24|-1||6.47|0.0|F2V:|",
"4:44:57.9|-63:13:47|-1||6.46|1.08|K0-1III|",
"5:23:22.9|28:56:12|7|22|6.46|-0.04|B9Vs|",
"5:33:7.2|-1:43:6|-1||6.46|-0.09|B4Vn|",
"5:57:4.9|49:1:46|-1||6.47|0.99|G8III|",
"6:28:56.6|26:58:4|-1||6.47|0.0|F5|",
"6:24:26.3|-63:25:44|-1||6.46|0.66|G3III-IV|",
"6:41:37.7|35:55:55|-1||6.46|0.49|F8III|",
"6:45:54.2|12:41:37|37|32|6.46|0.0|A9III|",
"6:46:41.5|-54:41:41|-1||6.46|0.86|G6III|",
"6:52:47.1|-43:58:33|-1||6.46|-0.1|B8V|",
"7:5:16.5|-50:21:37|-1||6.46|0.0|K3III|",
"7:6:14.1|-68:50:14|-1||6.47|1.04|K0III|",
"7:17:47.9|-26:47:51|-1||6.46|-0.15|B2IV-V|",
"7:27:25.8|66:19:54|-1||6.47|-0.09|B9III|",
"6:46:58.7|-87:1:30|-1||6.47|0.42|F3V|",
"7:44:7.4|2:24:18|-1||6.47|0.2|F0III:|",
"8:14:11.1|17:40:33|-1||6.47|0.3|A0VnDelDel|",
"8:32:39.9|10:3:58|11|34|6.46|-0.02|A1V|",
"8:35:12.6|-39:58:12|-1||6.47|0.58|G1V|",
"8:38:44.9|-53:5:26|-1||6.47|-0.1|B8Vn|",
"8:49:44.9|-21:2:55|-1||6.47|0.23|A7Vn|",
"8:53:50.7|-40:26:51|-1||6.47|0.96|K0II-III+A5|",
"9:4:55.2|32:22:37|-1||6.46|0.24|A8V|",
"9:36:6.8|74:19:4|-1||6.46|-0.1|B9V|",
"9:32:18.5|-28:37:41|-1||6.46|0.33|A9V|",
"9:43:7.0|54:21:49|-1||6.47|0.13|A5m|",
"9:45:40.5|-57:11:8|-1||6.46|-0.11|B8III-IV|",
"9:51:2.0|13:3:58|45|23|6.46|1.58|M0III|",
"10:15:6.3|31:28:5|46|22|6.46|0.0|G8III|",
"10:44:32.1|-70:51:18|-1||6.46|0.23|A6IV|",
"11:3:16.1|-31:57:39|-1||6.46|1.62|M1III|",
"11:7:39.7|23:19:25|45|64|6.46|0.16|A5m|",
"11:38:49.2|64:20:49|-1||6.46|0.0|A5IV|",
"11:54:25.8|-37:44:56|-1||6.46|0.52|F7V|",
"12:32:4.5|-32:32:1|-1||6.46|0.2|A3V|",
"13:28:26.2|40:43:47|-1||6.47|0.92|G8III|",
"13:31:33.3|-28:6:46|-1||6.47|0.1|A1V|",
"13:44:15.9|-51:0:47|-1||6.47|-0.13|A0pSiCr|",
"13:50:27.7|58:32:22|-1||6.46|0.09|A3V|",
"14:9:0.6|-10:20:4|85|96|6.47|1.0|G8III|",
"14:8:46.0|59:20:16|-1||6.46|1.02|K0III|",
"14:16:54.9|-77:39:50|-1||6.47|1.42|K2IIp|",
"14:18:0.6|-7:32:33|-1||6.47|0.73|G5IV|",
"14:59:13.9|-37:52:53|-1||6.47|-0.08|B8V|",
"15:13:17.5|-24:0:30|-1||6.47|-0.04|B9|",
"15:31:50.3|-32:52:52|-1||6.46|0.09|B7V|",
"15:30:22.7|31:17:10|-1||6.46|0.19|A4IV|",
"16:9:55.2|-18:20:27|-1||6.47|0.44|F4V|",
"16:23:56.7|-33:11:58|-1||6.47|0.01|A0V+A0V|",
"16:35:7.9|-45:14:41|-1||6.46|1.34|K2-3III|",
"16:43:38.7|-32:6:22|-1||6.46|-0.08|B8V|",
"16:50:35.9|-50:2:44|-1||6.47|0.31|A5III+F7III|",
"17:8:17.1|50:50:32|-1||6.46|0.0|A1V|",
"17:20:52.7|-10:41:46|-1||6.46|0.33|F1III|",
"17:22:38.0|-35:54:36|-1||6.47|0.54|F7V|",
"17:49:18.9|1:57:40|-1||6.47|1.24|K0III|",
"17:51:58.5|15:19:33|-1||6.46|0.0|K0III|",
"17:51:14.0|40:4:21|-1||6.46|0.0|G0V|",
"18:14:16.2|-63:41:22|-1||6.47|1.41|K4III|",
"18:38:4.6|-14:0:17|-1||6.47|0.21|B9IV|",
"18:42:8.1|34:44:48|-1||6.47|-0.13|B5V|",
"18:48:45.3|-18:36:5|-1||6.47|0.0|G5III:+A0V:|",
"18:57:28.4|58:13:31|-1||6.46|0.08|A2IV|",
"19:9:39.7|-39:49:41|-1||6.46|1.06|K0III|",
"19:37:56.7|49:17:4|-1||6.47|0.99|G6V|",
"19:55:5.1|-33:2:47|-1||6.46|1.48|K2/3III|",
"20:6:12.2|-4:4:42|-1||6.47|1.16|K0|",
"20:20:51.9|-35:40:25|-1||6.46|1.31|K3-4III|",
"20:43:24.2|35:35:16|-1||6.47|1.23|F7Ib-G8Ib|",
"21:10:31.0|47:41:31|-1||6.46|-0.01|B6IV|",
"21:15:36.8|47:58:25|-1||6.46|-0.15|B4IV|",
"21:23:48.3|37:21:5|-1||6.47|0.0|K5|",
"21:33:20.6|-80:2:21|-1||6.47|0.04|A0V|",
"21:25:51.5|0:32:4|-1||6.46|0.16|A1IV|",
"21:34:34.0|22:45:17|-1||6.47|0.51|F7V|",
"21:48:8.3|36:34:50|-1||6.47|0.0|K5|",
"22:0:26.8|33:0:22|-1||6.46|0.0|F5III|",
"22:4:23.9|-29:55:0|66|13|6.47|1.63|K5III|",
"22:10:30.2|20:58:41|61|28|6.46|0.12|A3III|",
"22:21:0.1|26:56:7|-1||6.47|1.59|M4III|",
"22:26:45.7|37:26:38|-1||6.46|-0.13|B2V|",
"22:38:44.7|-28:44:52|-1||6.47|1.04|K1III|",
"22:51:44.9|-59:52:53|-1||6.46|1.13|K1IIICNII|",
"22:52:52.3|50:24:43|-1||6.46|-0.04|B8V|",
"23:2:34.0|-36:25:15|-1||6.47|0.94|K1III|",
"23:10:11.7|-66:51:27|-1||6.47|0.95|K0III|",
"23:16:49.8|-41:11:40|-1||6.47|1.08|K0III|",
"23:48:49.3|2:12:51|-1||6.46|0.44|F5III-IV|",
"23:57:33.5|60:1:25|-1||6.47|0.01|B9III-IV|",
"0:0:23.9|26:55:6|-1||6.46|0.5|F7-8IV-V|",
"0:15:55.2|-75:54:41|-1||6.49|1.0|G8-K0III|",
"0:34:24.9|66:45:1|17|16|6.48|-0.08|B9III|",
"0:40:28.6|-16:31:1|-1||6.49|0.92|G5|",
"0:50:3.7|-43:23:41|-1||6.48|0.29|A9-F0III|",
"1:22:34.8|0:26:59|20|43|6.49|1.08|gK0|",
"1:25:46.5|70:58:48|-1||6.49|0.0|A0Vnn|",
"2:9:34.8|-24:20:45|-1||6.48|0.29|F4III|",
"2:16:51.7|57:3:19|-1||6.48|0.28|B1Iab|",
"2:38:24.8|-37:59:26|-1||6.49|0.52|G0IV|",
"2:43:1.9|48:15:56|-1||6.48|0.0|G5II|",
"2:46:45.2|-21:38:23|-1||6.49|0.38|F3IV|",
"3:4:40.7|15:51:22|-1||6.49|0.0|K3III|",
"3:28:23.6|60:15:20|-1||6.49|0.02|B9V+A1|",
"3:34:49.2|6:25:4|-1||6.49|0.63|G0|",
"3:41:13.8|-11:48:11|-1||6.49|0.36|F5II|",
"3:44:50.6|-48:3:41|-1||6.49|1.02|G8-K0III|",
"4:30:2.4|10:15:45|-1||6.48|1.03|G8III|",
"4:46:0.3|76:36:40|-1||6.49|0.51|F7V|",
"5:19:23.6|33:59:8|7|18|6.49|0.24|A7V|",
"5:15:38.9|-52:10:55|-1||6.49|1.21|K2III|",
"5:23:12.0|-26:42:21|-1||6.49|0.5|F6V|",
"5:32:33.8|57:13:16|10|18|6.48|0.57|F8V|",
"5:33:27.5|32:48:4|-1||6.48|0.09|A2m|",
"5:36:30.2|25:56:22|-1||6.49|0.43|F5III|",
"5:56:14.4|51:48:14|-1||6.49|0.0|A5V|",
"6:9:23.3|-49:33:46|-1||6.49|0.52|F7V|",
"6:23:46.9|-58:32:38|-1||6.48|0.12|A3V|",
"6:28:16.8|1:54:44|-1||6.48|-0.07|B9V|",
"6:27:7.5|-37:53:44|-1||6.48|0.39|F3V|",
"6:53:57.0|38:30:18|7|61ψ8|6.48|-0.05|B9.5pSi|",
"7:0:39.3|-9:12:11|-1||6.49|0.21|B1Ib|",
"7:7:25.0|28:10:38|-1||6.48|-0.09|B9V|",
"7:5:49.7|-10:39:40|-1||6.49|-0.05|B0.5V+F5III|",
"7:6:35.9|-12:23:38|-1||6.48|-0.1|O7.5V|",
"7:46:27.4|62:49:50|10|49|6.49|0.26|F0pSrEu|",
"8:16:53.8|84:3:28|-1||6.49|0.03|A3IV|",
"8:2:35.8|57:16:25|-1||6.49|0.62|F8V|",
"8:20:29.1|53:34:28|-1||6.49|0.28|F0IV|",
"8:33:19.9|-38:22:16|-1||6.49|-0.18|B2.5V|",
"8:39:10.2|59:56:22|-1||6.48|0.0|A2Vn|",
"8:37:29.7|-33:44:45|-1||6.48|0.33|F0IV-V|",
"9:9:46.4|11:33:52|-1||6.48|0.34|F2Vp|",
"9:9:45.1|-49:25:29|-1||6.48|0.17|A9Vn|",
"9:13:37.3|21:17:0|-1||6.48|0.02|A2V|",
"9:23:44.8|-37:45:26|-1||6.48|0.18|A1mA5-F0|",
"9:35:11.8|-35:49:26|-1||6.49|0.42|F7III-IV|",
"9:53:0.0|-55:22:24|-1||6.48|-0.14|B1IV|",
"10:16:28.1|28:40:57|46|24|6.49|0.6|G0V|",
"10:35:38.9|-18:34:9|-1||6.49|0.2|A7V|",
"11:8:15.8|-29:58:22|-1||6.49|0.03|A1V|",
"11:47:15.7|-30:17:13|-1||6.48|0.68|G5V|",
"11:50:37.1|-27:16:40|-1||6.48|0.98|G8III|",
"11:55:14.1|36:45:23|-1||6.49|1.58|M3III|",
"12:12:1.2|28:32:10|-1||6.49|0.36|F5V|",
"12:19:2.1|26:0:28|-1||6.48|0.18|A5-7mIV-V|",
"12:39:14.5|-75:22:10|-1||6.49|0.08|B8Vne|",
"13:23:52.3|-49:49:23|-1||6.48|0.96|G8III|",
"13:33:14.8|-77:34:6|-1||6.48|0.48|F6V|",
"13:35:33.3|10:12:17|-1||6.49|1.03|K1III+F6V|",
"13:36:39.8|49:29:12|-1||6.49|0.0|K1III|",
"13:37:43.0|50:42:53|-1||6.48|1.55|M2II-III+K3III:|",
"13:39:2.3|18:15:55|-1||6.48|1.2|K3III|",
"14:0:17.3|-61:28:53|-1||6.49|0.33|F1III-IV|",
"14:24:40.9|-11:40:11|-1||6.49|0.42|F4III|",
"14:25:47.7|-26:51:9|-1||6.48|0.94|G7IV|",
"14:34:15.9|57:3:55|-1||6.48|0.49|F6-8V|",
"15:28:19.1|-88:7:59|-1||6.48|0.3|Am|",
"14:57:3.6|21:33:19|-1||6.49|-0.01|A1V|",
"15:21:30.1|-38:13:9|-1||6.48|-0.06|A0pSi|",
"15:38:40.1|-8:47:28|-1||6.48|0.52|F6V|",
"15:43:55.1|-60:17:14|-1||6.48|1.05|G0Ib|",
"15:43:10.6|13:40:4|-1||6.48|0.86|G5III|",
"15:59:58.0|-40:39:10|-1||6.49|1.52|K1II-III|",
"16:9:26.0|55:49:44|-1||6.49|0.0|K0|",
"16:18:51.9|-57:53:59|-1||6.49|1.0|F8-G0Ib|",
"16:28:48.9|-8:7:44|-1||6.48|0.4|F2V|",
"16:52:19.1|-41:51:16|-1||6.49|0.23|WN7-A|",
"17:24:2.2|38:34:58|-1||6.49|0.73|F8IV|",
"17:35:43.0|-37:26:24|-1||6.48|0.01|A0V|",
"17:33:42.8|14:50:30|-1||6.48|1.6|M4IIIa|",
"17:44:19.7|-72:13:15|-1||6.49|0.48|F7IV+F5V|",
"17:53:18.4|-65:29:21|-1||6.49|1.08|K0-1III|",
"17:58:52.3|45:28:34|-1||6.48|-0.08|B9pSiSr|",
"18:11:7.1|60:24:34|-1||6.49|0.0|A1Vnn|",
"18:35:21.3|-20:50:27|-1||6.48|0.28|F0IV|",
"18:38:23.7|-3:11:37|-1||6.49|0.55|F9IV|",
"18:41:30.6|-48:5:42|-1||6.49|1.22|K2III-IVCNII|",
"18:56:54.7|-62:48:4|-1||6.48|1.53|K3III|",
"18:59:11.1|-39:32:5|-1||6.49|-0.04|A0|",
"19:8:52.1|-55:43:13|-1||6.49|1.1|K1III|",
"19:6:17.0|41:24:50|-1||6.49|-0.15|B3V|",
"19:8:40.2|16:51:5|-1||6.48|0.52|F5IV-V|",
"19:13:44.1|5:30:57|-1||6.49|0.09|A2Vp|",
"19:21:29.9|-34:59:2|-1||6.48|0.63|G5V|",
"19:38:17.5|20:46:58|-1||6.48|1.08|K0III|",
"19:42:49.1|29:19:54|-1||6.49|0.33|F1III|",
"19:42:4.1|55:27:48|-1||6.48|1.61|M5IIIa|",
"19:45:52.2|-2:53:0|-1||6.48|0.05|B3III|",
"19:53:6.4|-14:36:11|-1||6.48|0.14|A0V+F8IV|",
"19:54:38.1|-8:14:14|4|57|6.49|-0.04|B8V|",
"19:57:0.2|20:59:53|-1||6.48|0.07|A2IV|",
"20:9:56.6|20:54:55|70|17θ|6.48|0.38|F5IV|",
"20:11:10.1|-8:50:32|-1||6.49|-0.15|B1V|",
"20:16:28.2|37:3:23|-1||6.48|-0.09|B6III|",
"20:34:10.0|20:59:7|-1||6.48|-0.14|B3IV|",
"20:33:48.4|41:46:20|-1||6.49|1.0|K0III-IV|",
"20:37:32.6|31:31:19|-1||6.49|0.34|F0V|",
"20:39:0.2|56:0:18|-1||6.48|0.0|F2Vn|",
"20:46:18.6|-36:7:13|-1||6.49|0.39|F3IV|",
"21:2:48.5|45:50:56|-1||6.48|-0.15|B3Vn|",
"21:11:41.3|-14:28:20|-1||6.48|0.28|F0DelDel:|",
"21:16:39.6|-1:36:28|-1||6.48|0.98|K0|",
"21:41:46.1|-25:6:7|-1||6.49|1.19|K0|",
"21:49:40.1|41:8:56|-1||6.48|0.42|A2Ib|",
"22:46:28.3|-49:41:9|-1||6.48|1.14|K1III|",
"22:56:24.0|-31:33:56|-1||6.48|1.1|K4V|",
"23:15:46.3|28:14:52|61|61|6.49|0.85|G5II-III|",
"23:17:56.1|45:29:20|-1||6.48|-0.03|B9pSi|",
"23:31:31.5|-4:5:14|-1||6.49|0.54|F8V|",
"0:36:20.0|27:15:17|-1||6.5|-0.09|B8IIIpHgMn:|",
"2:19:40.8|-4:20:44|-1||6.5|0.08|A3V|",
"2:37:0.5|24:38:51|6|30|6.5|0.41|F6III|",
"3:23:44.6|-32:42:26|-1||6.5|1.37|K3III|",
"3:28:11.5|-35:51:12|36|χ3|6.5|0.13|A1V|",
"3:39:0.1|20:54:57|-1||6.5|0.15|Am,A5-F0|",
"4:43:18.1|59:31:15|-1||6.5|0.0|A7IV|",
"4:55:58.4|5:23:57|-1||6.5|0.02|A0V|",
"5:13:31.3|62:41:29|10|14|6.5|0.21|A7Vn|",
"5:17:17.8|53:35:10|-1||6.5|1.66|M7IIIe|",
"5:39:30.8|-9:42:24|-1||6.5|-0.1|B7V|",
"7:5:51.8|70:43:55|-1||6.5|0.0|K0III|",
"7:39:26.9|-26:51:47|-1||6.5|-0.1|B7V|",
"8:21:20.2|-1:36:8|-1||6.5|0.02|A2Vpn:EuSrCr:Si|",
"8:52:26.1|-32:30:33|-1||6.5|1.46|K2/3III|",
"9:8:4.1|32:32:26|-1||6.5|0.36|F2V|",
"9:19:55.8|74:0:59|-1||6.5|0.0|G8III|",
"9:44:30.0|18:51:49|-1||6.5|0.0|K0|",
"10:21:28.7|-23:42:39|-1||6.5|0.2|A3|",
"11:16:4.0|52:46:23|-1||6.5|0.43|F6V+F9V|",
"11:26:45.3|3:0:47|45|83|6.5|0.79|K0IV|",
"11:59:57.2|34:2:6|-1||6.5|0.22|A9III|",
"12:13:13.0|-34:7:32|-1||6.5|1.66|M4III|",
"13:11:39.2|-26:33:6|-1||6.5|0.19|A5Vn|",
"13:25:59.9|63:15:40|-1||6.5|0.74|G6V|",
"13:36:50.5|-34:28:4|-1||6.5|1.03|K0III|",
"13:45:13.2|55:52:46|-1||6.5|0.47|F7IV-V|",
"14:34:50.7|-20:26:21|-1||6.5|0.14|A4V|",
"15:4:6.4|5:29:33|-1||6.5|0.31|F0V|",
"15:24:30.9|37:20:52|8|51μ2|6.5|0.59|G1V|",
"15:27:40.8|62:16:32|-1||6.5|0.14|A5IV|",
"15:38:40.0|-8:47:40|-1||6.5|0.53|F6IV-V|",
"16:12:45.3|26:40:15|-1||6.5|0.39|F3V|",
"16:30:29.9|-7:30:54|-1||6.5|0.37|A7Ib|",
"18:0:27.7|19:30:21|-1||6.5|-0.06|B8Vne|",
"18:3:14.7|19:36:47|-1||6.5|0.01|A0V|",
"18:28:57.4|-26:34:54|-1||6.5|0.11|A3III|",
"18:30:41.6|20:48:55|-1||6.5|0.79|G8IV|",
"18:58:45.1|19:47:39|-1||6.5|-0.04|B7III-IV|",
"19:36:56.6|38:23:2|-1||6.5|-0.15|B5II-III|",
"19:40:28.3|20:28:36|-1||6.5|0.39|B0.5Iae|",
"19:52:39.0|-54:58:36|-1||6.5|0.1|A2V|",
"20:19:56.1|46:50:15|-1||6.5|-0.06|B8/9IIIpSi|",
"20:45:13.2|-27:14:50|-1||6.5|0.94|G8III|",
"21:2:59.6|0:55:29|-1||6.5|-0.1|B6V|",
"21:29:3.8|-31:14:19|66|5|6.5|0.03|A0|",
"23:0:34.4|45:22:30|-1||6.5|0.0|A3V|",
"23:2:43.8|55:14:11|-1||6.5|-0.08|B9IIIHewk|",
"23:19:2.4|45:8:14|-1||6.5|0.0|A5Vn|",
"0:20:5.2|48:51:55|-1||6.52|0.0|A0Vs|",
"0:46:15.1|55:18:19|-1||6.52|0.0|A2III|",
"1:12:23.4|-30:48:8|-1||6.52|0.48|F7IV|",
"2:4:40.1|65:6:12|-1||6.52|0.0|A0V|",
"2:29:25.0|55:32:11|-1||6.51|0.09|A2pShell|",
"2:30:13.8|-25:11:11|-1||6.51|0.29|dA9n|",
"2:40:2.5|-30:38:2|-1||6.52|1.04|K0III|",
"2:47:33.7|-35:33:3|36|η1|6.51|0.96|K0-1III|",
"3:25:48.4|53:55:18|-1||6.51|0.29|A9III-IV|",
"3:25:9.4|41:15:26|-1||6.51|0.0|A0V|",
"4:0:15.7|-51:33:53|-1||6.51|1.64|M1III|",
"4:13:31.3|8:53:26|-1||6.51|0.16|A2m|",
"5:31:48.0|85:56:19|-1||6.51|0.32|A5m|",
"5:6:0.9|35:56:11|-1||6.52|0.16|A5V|",
"5:8:14.8|-35:43:6|-1||6.52|1.08|K1III|",
"5:12:25.7|-81:32:30|-1||6.51|1.11|K1III|",
"5:40:46.0|-10:24:34|-1||6.52|-0.16|B9.5IIIpSi4200|",
"5:54:10.7|-50:21:43|-1||6.52|0.9|G8IV|",
"6:7:1.9|-45:5:29|-1||6.51|1.16|K1III|",
"6:12:46.3|-17:45:47|-1||6.52|-0.17|B3III|",
"6:17:34.7|46:25:27|7|42|6.52|0.27|F0V|",
"6:25:46.6|2:16:20|-1||6.51|-0.03|A0V|",
"6:24:48.2|-52:48:23|-1||6.51|1.7|K5-M0III|",
"6:40:31.8|6:22:18|-1||6.51|-0.14|B8IIISi|",
"6:40:57.8|-71:46:32|-1||6.51|1.11|K1IIICNII|",
"6:52:39.7|-42:30:16|-1||6.52|0.42|F5II-III|",
"7:33:13.3|-43:5:11|-1||6.52|0.92|G8III|",
"8:0:44.1|-2:52:54|-1||6.51|-0.07|B2.5Ve|",
"8:12:46.0|-29:54:39|-1||6.52|0.06|A1V|",
"8:28:35.9|-23:4:18|-1||6.51|0.05|A2|",
"8:38:20.3|-6:39:45|-1||6.51|0.44|A1V+G|",
"8:58:27.5|35:48:9|-1||6.51|-0.01|A2V|",
"9:12:17.6|14:59:46|11|81π1|6.51|0.73|G9V|",
"9:34:19.6|46:54:8|-1||6.52|0.22|F0V|",
"10:0:34.4|-56:56:48|-1||6.52|0.98|K0III|",
"10:6:7.1|-52:11:17|-1||6.52|0.98|K1III|",
"10:18:10.3|27:24:55|-1||6.52|-0.02|A0V|",
"10:21:7.8|-17:59:6|-1||6.51|0.4|F3III-IV|",
"10:21:36.0|-22:31:42|-1||6.51|0.07|A0|",
"10:36:1.7|80:29:40|-1||6.52|0.95|gG4|",
"10:30:51.4|-26:29:2|-1||6.51|0.54|F7III|",
"10:37:11.6|-11:44:55|-1||6.52|0.29|F0V|",
"13:29:57.6|6:0:48|-1||6.51|0.96|K0|",
"13:38:7.9|14:18:6|-1||6.52|0.25|A9Vs|",
"13:43:54.3|-5:29:56|-1||6.51|0.05|A1V|",
"13:47:10.7|-62:35:24|-1||6.51|1.98|K00-Iae|",
"13:55:44.5|-31:17:6|-1||6.51|0.9|G8III|",
"14:49:32.3|51:22:29|-1||6.51|0.4|F5IV|",
"15:7:8.7|-71:54:19|-1||6.52|1.59|K4III|",
"15:14:51.9|68:56:43|-1||6.51|0.0|A1Vn|",
"15:36:17.4|-65:36:48|-1||6.51|0.35|F3IV-V|",
"15:34:20.8|-5:41:42|-1||6.51|0.58|F7V|",
"15:36:33.7|0:33:42|75|14|6.51|0.72|G8III+A|",
"15:36:53.4|29:59:28|-1||6.52|0.0|F5V:|",
"15:46:12.8|-28:3:42|-1||6.51|0.32|F2IV|",
"16:52:4.9|14:58:27|39|49|6.52|-0.05|B9.5pCr:|",
"17:3:10.4|14:30:40|-1||6.52|0.76|G5IV:|",
"17:18:52.8|6:5:7|-1||6.51|0.39|F0-2IV-Vn|",
"17:20:34.2|-19:19:58|-1||6.52|0.58|G3IV|",
"17:26:4.9|58:39:7|-1||6.51|0.14|A4V|",
"17:45:53.7|38:52:53|-1||6.52|1.0|K0|",
"17:55:55.0|-18:48:8|-1||6.52|0.05|A4V|",
"18:4:43.2|40:5:3|-1||6.52|0.46|F7V|",
"18:11:58.2|-28:54:5|-1||6.51|-0.01|B9IVpSrEuCr|",
"18:18:41.7|-25:36:17|-1||6.51|1.34|gK1|",
"18:34:32.8|-24:13:21|71|25|6.51|0.54|F3II-III|",
"18:45:35.7|21:59:6|-1||6.51|0.02|B9pSiCr:|",
"18:46:59.0|46:18:54|-1||6.52|0.07|A2IV|",
"19:3:42.5|21:16:4|-1||6.52|0.32|F2III|",
"18:58:52.6|69:31:52|-1||6.52|-0.15|A0pSi|",
"19:19:46.1|64:23:27|-1||6.52|-0.04|B9IVpHgMn|",
"19:25:1.6|-4:53:3|-1||6.52|0.33|A9V|",
"19:23:23.8|50:16:17|-1||6.51|-0.08|B9III|",
"19:35:55.9|50:14:19|-1||6.52|1.06|G9III|",
"19:40:13.0|60:30:26|-1||6.51|0.22|A5V|",
"19:50:17.5|7:54:9|-1||6.51|-0.1|B2.5IVe|",
"19:55:19.6|-6:44:3|-1||6.51|0.39|F2V|",
"20:24:32.4|53:33:7|-1||6.51|0.01|B9.5III|",
"20:40:36.0|-26:38:42|-1||6.51|0.57|F7V|",
"20:41:0.4|39:4:56|-1||6.51|-0.12|B6III|",
"20:50:37.0|18:3:5|-1||6.52|0.04|A1Vs|",
"22:43:42.7|10:56:21|-1||6.51|0.46|G8IV|",
"22:56:51.5|11:50:54|-1||6.51|0.18|A3Vs|",
"23:10:46.6|-29:31:30|-1||6.51|0.27|F1III-IV|",
"23:37:5.4|-31:52:15|-1||6.52|1.26|K1III|",
"23:44:48.3|55:47:59|-1||6.51|0.0|gG4|",
"23:58:49.2|32:22:54|-1||6.52|-0.11|B6IVe|",
"0:47:54.8|20:55:31|65|61|6.54|0.5|F8V|",
"1:4:46.8|51:0:36|-1||6.54|-0.08|B3V|",
"1:6:22.8|62:45:42|-1||6.54|0.19|A5Vn|",
"2:23:6.5|-37:34:35|-1||6.53|1.61|K2III|",
"2:37:20.8|39:53:45|-1||6.54|-0.12|B5V|",
"3:58:3.1|34:48:52|-1||6.53|0.23|A8V|",
"4:18:24.5|9:29:12|-1||6.54|0.16|A4III|",
"4:20:49.0|9:13:32|-1||6.53|0.15|A4V|",
"4:40:18.3|-58:56:37|-1||6.53|0.68|G5V|",
"5:20:39.3|46:57:50|-1||6.54|0.6|GIII+A2V|",
"5:19:18.3|-18:30:35|-1||6.54|-0.11|B8/9III/IV|",
"5:33:52.1|-29:50:56|-1||6.53|-0.02|A0V|",
"5:36:15.0|-5:38:53|-1||6.54|-0.18|B3V|",
"5:50:34.0|56:55:8|10|29|6.54|0.0|A4IV-V|",
"5:47:48.1|-72:42:8|52|λ|6.53|1.08|K0III|",
"6:13:33.3|-29:23:46|-1||6.54|-0.1|B7V|",
"6:20:52.3|11:45:23|-1||6.54|-0.1|B5III|",
"6:40:16.8|79:35:58|-1||6.54|0.0|A1V|",
"6:45:2.4|-30:35:10|-1||6.54|-0.11|B8IV|",
"7:0:19.3|-22:7:10|-1||6.53|-0.17|B2IV-Vne|",
"7:22:50.9|55:17:4|50|19|6.53|0.0|B9V|",
"7:26:50.2|21:32:9|-1||6.54|0.46|F6V|",
"7:31:55.7|38:53:47|-1||6.54|0.07|A2V|",
"7:32:50.6|22:53:16|-1||6.54|1.01|K0II-III+F8V|",
"7:37:38.9|-14:26:28|-1||6.53|-0.01|B9IIIe|",
"7:41:58.0|-38:31:44|-1||6.54|-0.09|B7V|",
"7:45:4.6|-37:53:16|-1||6.54|-0.1|B3IV|",
"7:48:58.9|4:19:58|-1||6.53|0.78|G2III|",
"8:12:22.1|14:0:14|-1||6.54|0.0|A7III|",
"8:26:17.6|-39:3:34|-1||6.53|-0.09|B9V|",
"8:27:27.4|-55:0:42|-1||6.53|-0.02|A0V|",
"8:38:5.2|9:34:29|11|37|6.53|-0.02|A1V|",
"9:10:23.0|-23:10:36|-1||6.53|0.0|A1-2V:|",
"9:21:15.4|15:22:16|-1||6.53|-0.01|A1V|",
"9:22:50.9|-9:50:20|-1||6.53|0.22|A5pSrCrEu|",
"9:22:36.7|-39:46:29|-1||6.54|1.13|K1III|",
"9:27:14.6|-9:13:25|41|29|6.54|0.05|A2V|",
"9:33:18.3|28:22:5|-1||6.53|0.12|A3Vnn|",
"9:36:33.7|-24:42:10|-1||6.53|0.38|F2|",
"10:2:49.3|-30:34:39|-1||6.54|1.19|K1III|",
"10:8:45.7|-10:53:5|-1||6.53|0.02|A2V|",
"10:23:14.6|5:41:39|-1||6.54|0.46|F6V|",
"11:7:54.4|-30:10:29|-1||6.54|0.6|G2V|",
"11:55:5.7|46:28:37|82|65|6.54|0.1|A3Vn|",
"12:15:47.0|-23:21:13|-1||6.54|0.45|F3V|",
"12:18:9.6|-3:56:55|-1||6.54|0.33|F2V|",
"12:28:38.1|26:13:36|-1||6.54|0.17|A2m|",
"13:2:40.4|59:42:58|-1||6.53|0.05|A3Vn|",
"13:6:54.3|-35:51:43|-1||6.54|-0.02|A0IV-III|",
"13:6:10.2|29:1:46|-1||6.54|0.05|A3IV|",
"13:9:50.2|62:13:45|-1||6.54|-0.02|A1V|",
"13:12:35.9|18:45:6|-1||6.53|0.88|G8III|",
"13:48:55.1|-35:42:14|-1||6.53|0.57|G3IV-V|",
"13:50:34.5|-19:53:50|-1||6.53|0.51|G5III-IV:+A5:|",
"14:18:23.8|-33:13:14|-1||6.54|0.27|F0V|",
"14:18:55.8|54:51:51|-1||6.53|0.0|A5Vn|",
"15:52:56.7|-65:9:9|-1||6.54|0.19|A5IV|",
"16:5:44.5|-6:17:30|-1||6.53|0.48|F2IV|",
"16:11:29.7|9:42:45|-1||6.53|0.24|F0IV|",
"16:36:14.1|52:55:27|33|17|6.53|-0.06|A1Vnn|",
"17:12:13.6|-25:15:17|-1||6.54|-0.04|A0pHg|",
"17:20:12.8|-70:2:44|-1||6.53|0.6|G0-1IV:|",
"18:17:28.5|-18:27:48|-1||6.54|0.11|O7III:(n)((f))|",
"18:26:40.9|26:26:58|-1||6.53|-0.11|B3V|",
"18:46:59.1|-50:5:40|-1||6.54|0.28|F0V|",
"19:5:18.6|-1:30:46|-1||6.53|0.35|F1V|",
"18:57:57.2|77:3:3|-1||6.54|0.38|F2V|",
"19:15:57.0|27:27:20|-1||6.54|-0.06|B8V|",
"19:24:22.4|28:5:16|-1||6.53|-0.08|B5V|",
"19:15:7.8|83:27:46|-1||6.53|0.1|A3V|",
"19:48:43.9|35:18:41|-1||6.53|0.44|F4V|",
"19:52:15.6|10:21:5|-1||6.54|-0.01|B7V|",
"19:53:22.6|4:24:2|-1||6.53|0.02|B9.5Vn|",
"19:56:57.7|-57:55:32|-1||6.53|1.53|K4II|",
"20:5:32.1|-33:0:0|-1||6.53|-0.08|B8|",
"20:7:11.5|50:13:45|-1||6.54|0.13|A3V|",
"20:16:26.5|-35:11:52|-1||6.53|0.37|F2V|",
"21:11:3.9|36:17:57|-1||6.54|-0.14|B1Vp|",
"21:9:28.9|63:17:44|-1||6.54|-0.13|B7III|",
"21:46:16.6|43:3:39|-1||6.54|0.28|G0:III+A4V|",
"22:49:32.3|10:28:44|-1||6.54|0.29|F0IV-V|",
"23:0:54.7|38:42:29|-1||6.54|-0.11|B3Vpe|",
"23:16:26.8|61:57:47|-1||6.53|0.23|B0Vn|",
"23:40:2.8|37:39:9|-1||6.53|0.35|F2IV|",
"23:55:23.0|25:57:18|-1||6.54|0.0|K5|",
"23:58:46.5|46:24:47|-1||6.54|-0.09|B4Ven|",
"0:20:54.5|10:58:37|-1||6.56|0.0|A0V|",
"0:23:12.6|-31:2:10|-1||6.55|0.0|B9IVMn|",
"1:46:35.3|17:24:47|-1||6.55|0.25|A9III|",
"2:15:28.3|-9:27:56|-1||6.55|-0.02|A0V|",
"2:17:10.4|23:46:4|-1||6.55|1.02|G9III|",
"2:39:31.7|-64:16:55|-1||6.55|-0.08|B8V|",
"2:54:20.9|-64:26:8|-1||6.56|1.39|K2-3III|",
"3:47:20.1|-29:54:7|-1||6.55|0.49|F8V|",
"4:24:56.4|-34:45:28|-1||6.55|0.44|F2III|",
"5:16:48.1|-17:8:30|-1||6.56|-0.16|B3IV|",
"5:29:25.7|77:58:39|-1||6.56|0.14|A7III|",
"5:21:51.0|-13:45:22|-1||6.56|-0.09|B8V|",
"5:25:13.0|34:51:19|-1||6.55|1.11|K1πII-IV+F6V|",
"5:33:28.7|42:6:32|-1||6.55|-0.02|B9IIIp:Hg:|",
"5:35:21.8|-4:29:36|-1||6.56|-0.13|B1.5V|",
"5:53:22.9|-42:55:17|-1||6.55|1.37|K3III|",
"6:8:47.2|8:40:12|-1||6.55|-0.07|B9V|",
"6:11:51.4|21:52:7|-1||6.56|2.25|M0-1Iab|",
"6:27:51.1|47:24:19|-1||6.56|-0.04|A0V|",
"6:36:0.0|4:29:51|-1||6.55|-0.06|B9III|",
"6:49:57.8|-45:27:0|-1||6.55|1.51|K5-M0III|",
"7:21:16.9|-8:52:42|-1||6.55|0.54|F5|",
"7:26:40.7|-23:42:44|-1||6.56|0.01|A1|",
"7:34:46.0|2:43:30|-1||6.55|0.22|A7III|",
"7:40:52.7|-31:39:39|-1||6.56|1.18|G20-Ia|",
"7:43:39.1|-25:30:14|-1||6.55|0.06|A3|",
"7:56:17.3|80:15:56|-1||6.56|0.73|G8V|",
"7:49:45.2|-20:12:25|-1||6.56|0.58|G3V|",
"8:13:41.7|23:8:16|-1||6.56|0.11|A4IVn|",
"8:27:33.3|-20:50:38|-1||6.56|0.04|A2V|",
"8:37:19.9|-40:8:51|-1||6.55|0.6|G4IV-V|",
"8:51:27.9|-42:30:16|-1||6.55|0.04|A1Vn|",
"9:14:3.2|71:39:21|-1||6.55|0.96|G8III-IV|",
"9:36:5.1|-64:57:2|-1||6.56|0.1|A2V|",
"10:16:16.1|17:44:25|-1||6.55|0.0|A9IV|",
"10:59:41.1|11:42:21|-1||6.55|0.43|F5V|",
"11:31:10.2|48:47:21|-1||6.56|0.93|G9III|",
"11:34:10.0|11:1:25|-1||6.55|0.18|A2m|",
"11:35:43.4|10:54:40|-1||6.56|0.13|A4Vn|",
"12:35:6.3|18:22:38|24|24|6.56|0.25|A9Vm|",
"12:48:14.3|13:33:11|24|28|6.56|0.01|A1V|",
"14:5:14.0|-16:20:9|-1||6.56|0.1|A4V|",
"14:16:18.3|-33:14:29|-1||6.55|0.3|F0V|",
"15:35:4.6|1:40:8|-1||6.56|0.28|F0III|",
"16:56:6.4|50:2:20|-1||6.56|1.62|M2IIIab|",
"17:1:9.6|27:11:47|-1||6.55|0.41|F5V|",
"17:32:1.1|34:16:15|-1||6.56|0.65|G5V|",
"17:44:35.4|2:34:44|-1||6.56|0.0|A0V|",
"18:14:44.0|29:12:26|-1||6.56|0.54|F8V|",
"18:32:11.4|52:6:56|-1||6.56|-0.07|B9.5V|",
"18:50:45.6|10:58:35|-1||6.55|0.0|K5III+K3III|",
"19:7:9.1|0:38:30|-1||6.56|0.05|B9III|",
"19:9:36.4|-36:9:53|-1||6.56|-0.02|A0IV|",
"19:57:41.3|-38:3:30|-1||6.55|0.39|F4V|",
"20:5:26.4|-12:39:55|71|65|6.55|0.04|A1Vn|",
"20:13:40.6|24:14:20|-1||6.56|0.29|A1m|",
"20:29:21.1|20:5:16|-1||6.55|0.23|A3m|",
"20:33:53.6|10:3:35|-1||6.56|0.08|A2Vnn|",
"20:41:43.7|-75:21:2|57|μ2|6.55|0.62|G5III|",
"20:55:8.1|-1:22:24|-1||6.55|0.29|A9Vn|",
"20:54:22.4|28:31:19|-1||6.56|-0.13|B2IIIe|",
"21:19:45.8|-26:21:11|-1||6.56|0.73|G5V|",
"22:10:42.5|-75:52:50|-1||6.55|1.18|K2IIICNII|",
"22:29:43.9|35:43:32|-1||6.56|0.0|A2V|",
"22:44:49.2|52:31:2|-1||6.55|0.0|K2|",
"22:46:43.7|-46:56:22|-1||6.56|0.3|A9IIIm:|",
"23:8:12.3|44:33:42|-1||6.56|0.17|A2IV|",
"23:42:20.8|64:30:56|-1||6.56|1.88|M2III|",
"23:51:57.6|77:35:58|-1||6.55|0.44|F5V|",
"0:29:48.9|-32:7:0|-1||6.57|1.34|K4III|",
"1:26:53.5|3:32:7|-1||6.58|-0.04|B9V+A8V|",
"1:28:43.3|-33:45:49|-1||6.58|0.3|F0IV|",
"1:37:22.5|74:18:3|-1||6.58|0.03|B9Ve|",
"3:27:3.2|18:45:23|-1||6.57|0.15|A3Vnp|",
"3:35:12.4|73:20:49|-1||6.57|0.03|A0Vn|",
"3:47:52.6|33:36:0|-1||6.57|0.08|B2.5V|",
"5:0:23.2|39:39:18|7|6|6.58|0.0|K4I|",
"5:11:35.9|-37:23:43|-1||6.57|1.62|K5III|",
"5:21:19.3|4:0:43|-1||6.57|-0.09|B5Vp|",
"5:25:31.2|0:32:39|-1||6.57|-0.05|B9pHgSi|",
"5:45:49.5|40:30:26|-1||6.58|0.25|A3DelDel|",
"5:54:34.7|-4:3:50|-1||6.57|-0.18|B1.5V|",
"6:4:46.9|-48:27:31|-1||6.58|0.72|G6V|",
"6:13:33.4|18:40:49|-1||6.58|-0.08|B8Vnn|",
"6:16:58.4|7:3:11|-1||6.57|-0.12|B7III|",
"6:30:5.5|9:1:45|-1||6.57|0.14|A0III|",
"6:38:49.5|4:42:2|-1||6.57|-0.07|B8IIIn|",
"6:39:56.9|-38:9:32|-1||6.58|1.18|K1IIICNIb|",
"6:45:26.1|-52:12:4|-1||6.57|1.08|G6Iab|",
"6:52:46.9|-54:5:24|-1||6.57|1.08|G5Ib-II|",
"7:4:20.2|1:29:18|-1||6.57|0.01|A0V|",
"7:28:22.8|-37:48:37|-1||6.58|0.06|A1IV|",
"7:43:6.9|-49:59:34|-1||6.57|0.07|A2V|",
"7:46:33.4|-40:3:35|-1||6.57|-0.13|B2V|",
"8:11:21.6|38:43:53|-1||6.58|0.59|G0|",
"8:35:19.4|19:35:24|11|35|6.58|0.68|G0III|",
"8:46:40.0|28:45:55|11|48ι|6.57|0.04|A3V|",
"9:57:15.2|-64:29:22|-1||6.58|1.13|K0-1III|",
"10:16:45.6|-20:40:14|-1||6.57|0.48|F3V|",
"10:36:17.4|-10:35:0|-1||6.57|0.29|F0V|",
"12:54:22.0|-58:25:50|-1||6.58|0.76|F7Ib-II|",
"13:34:42.8|76:32:48|-1||6.57|0.0|K5III:|",
"14:15:16.9|52:32:9|-1||6.58|0.1|A4V|",
"15:30:55.4|8:34:45|-1||6.57|0.37|F4Vw|",
"15:38:32.7|-39:9:39|-1||6.57|-0.07|B9V|",
"15:29:11.0|80:26:55|-1||6.58|0.67|G0IV-V+G8IV-V|",
"17:15:59.3|-87:33:59|-1||6.57|0.91|G5III|",
"16:45:53.6|-83:14:20|-1||6.57|1.57|K4III|",
"16:44:17.3|-27:27:22|-1||6.58|0.1|A2V|",
"16:54:40.3|-11:47:33|-1||6.57|0.14|A2IV|",
"17:10:45.8|12:28:2|-1||6.57|0.08|A1m|",
"17:35:18.5|-22:2:38|58|52|6.57|0.01|B8p|",
"18:9:22.4|-36:40:21|-1||6.58|-0.03|B1II|",
"18:34:19.6|20:27:59|-1||6.57|0.11|A3V|",
"19:12:9.8|-37:34:58|-1||6.57|1.02|G2III|",
"19:12:5.0|49:51:22|-1||6.57|0.65|G4V|",
"19:20:26.2|-31:49:4|-1||6.58|1.67|M0III|",
"19:18:48.5|19:36:38|-1||6.58|0.03|B8III+K:|",
"19:44:38.2|34:24:50|-1||6.57|0.0|M1III|",
"19:55:6.5|30:11:43|-1||6.57|-0.08|B6V+A5V|",
"20:2:20.3|64:38:4|33|65|6.57|0.0|gG7|",
"20:19:48.3|37:7:57|-1||6.57|0.0|A0III|",
"20:39:23.1|45:40:1|-1||6.58|-0.06|B5IV|",
"20:56:18.3|-3:33:41|-1||6.57|-0.1|B8Vn|",
"21:8:47.9|-76:12:45|-1||6.58|1.23|K1III|",
"21:23:23.0|37:24:24|-1||6.58|0.0|F6II-III|",
"21:24:55.5|49:19:24|-1||6.58|-0.03|B9pSi:Cr:Sr:|",
"21:29:59.6|-19:8:52|-1||6.57|0.41|F0V|",
"22:45:28.6|-88:49:6|-1||6.57|0.28|F0IV-V|",
"22:26:34.2|-16:44:29|3|53|6.57|0.0|G2V|",
"22:26:59.2|56:26:0|-1||6.57|-0.1|B5III|",
"23:2:33.1|31:46:50|-1||6.57|0.35|F2IV|",
"23:37:58.6|46:11:59|-1||6.58|0.66|G5|",
"23:42:14.8|44:59:31|-1||6.57|0.0|gK5|",
"23:59:29.2|33:43:28|-1||6.58|0.55|G0V|",
"23:59:29.2|33:43:28|-1||6.58|0.0|G0V|",
"1:27:47.0|40:20:8|-1||6.6|-0.04|A0III|",
"1:33:3.5|-9:0:53|-1||6.59|-0.04|A0III|",
"2:20:12.9|64:20:14|-1||6.6|-0.03|B9.5V|",
"3:41:22.4|-19:35:5|-1||6.59|0.09|A3V|",
"4:7:25.1|-42:55:1|-1||6.59|0.93|K0III|",
"4:8:33.9|-45:51:53|-1||6.59|0.38|F2V|",
"5:4:37.9|27:41:46|-1||6.6|0.24|F0III|",
"5:43:48.7|85:40:5|-1||6.6|0.0|A2V|",
"5:29:17.4|-62:18:52|-1||6.59|1.53|K4-5III|",
"5:33:57.6|1:24:28|-1||6.59|-0.17|B2V|",
"5:41:54.6|23:19:35|-1||6.59|-0.06|B8p|",
"5:54:32.2|11:45:45|-1||6.59|0.03|A2V|",
"5:56:3.5|13:55:31|-1||6.6|0.65|G5IV|",
"6:2:17.1|1:41:40|-1||6.59|-0.05|B8V|",
"6:17:33.3|14:3:30|-1||6.59|-0.03|A0V|",
"6:20:6.1|-48:44:28|-1||6.6|0.66|G3V|",
"6:23:47.6|-19:47:7|-1||6.6|-0.15|B8IIIHewk|",
"6:29:0.0|11:1:10|-1||6.59|0.0|A9IV|",
"7:1:17.2|32:24:52|-1||6.59|0.27|A9IV|",
"7:1:55.0|5:33:27|-1||6.59|-0.02|B2IV-V|",
"7:12:24.1|-27:28:27|-1||6.59|0.19|A5IV-V|",
"7:13:47.1|-31:5:2|-1||6.6|-0.17|B2IV|",
"7:20:21.7|-52:18:35|-1||6.6|0.59|G0V:e|",
"7:23:54.3|-30:13:1|-1||6.6|-0.2|B2IV-V|",
"7:37:44.8|-35:16:38|-1||6.6|1.14|K1III|",
"7:38:24.2|-39:59:29|-1||6.59|-0.05|A0|",
"8:16:54.2|-21:19:13|-1||6.6|0.02|A0|",
"8:27:17.2|-6:24:35|-1||6.59|0.51|F4III|",
"8:58:8.2|1:32:30|-1||6.59|0.06|A2V|",
"10:4:7.6|-81:33:57|21|μ2|6.6|0.92|G6-8III|",
"11:7:8.4|-32:35:14|-1||6.59|0.34|F1III|",
"11:42:5.2|22:12:39|-1||6.59|0.0|F2IV-V|",
"13:3:54.4|-3:39:48|85|48|6.59|0.29|F0V|",
"13:13:32.0|72:47:56|-1||6.59|0.08|A2V|",
"13:40:0.6|-70:47:18|-1||6.59|1.3|K0III|",
"13:41:30.9|-23:26:59|-1||6.59|0.06|A0|",
"14:34:8.0|-42:5:59|-1||6.6|0.06|A2IV|",
"14:58:13.4|-11:9:18|48|17|6.6|0.01|A1V|",
"15:3:36.5|34:33:58|-1||6.59|1.02|G8III-IV|",
"15:52:51.5|-50:36:55|-1||6.6|1.53|K3III|",
"16:54:19.6|-41:49:12|-1||6.59|0.21|WC7+O5-8|",
"16:58:41.6|-14:52:11|-1||6.59|0.4|F3IV|",
"17:0:29.4|6:35:1|-1||6.59|0.23|A7V|",
"17:14:27.7|-39:46:1|-1||6.6|2.21|G5Ia|",
"17:40:37.6|43:28:15|-1||6.59|0.0|K2|",
"18:13:10.0|-4:0:42|-1||6.59|0.27|A2m|",
"18:29:22.0|-25:15:23|-1||6.59|0.07|B2IVpe|",
"18:33:23.1|30:53:33|-1||6.59|-0.12|B4Ve|",
"18:31:14.8|65:26:10|-1||6.59|0.3|A8m|",
"18:49:14.4|25:2:47|-1||6.59|0.0|A1V|",
"18:54:32.3|-49:52:43|-1||6.6|0.08|A2V|",
"19:19:3.8|33:23:20|-1||6.6|-0.19|B2IVe|",
"19:30:14.7|-32:5:32|-1||6.6|0.39|F3IV-V|",
"19:25:46.7|58:1:38|-1||6.6|-0.15|B8IVHewk|",
"20:32:52.3|43:11:30|-1||6.6|-0.11|B4III|",
"20:51:38.8|-62:25:45|-1||6.59|0.17|A2-3IV-V|",
"21:53:36.0|-10:18:42|-1||6.59|-0.12|B9V|",
"21:59:23.0|57:39:30|-1||6.59|0.03|A0III-IV|",
"22:33:2.9|69:54:49|-1||6.6|0.32|A9III|",
"23:0:42.5|31:4:59|-1||6.6|-0.04|B9IIIpMn|",
"23:15:57.9|24:46:16|-1||6.6|0.4|F5V|",
"23:41:7.0|-24:9:37|-1||6.6|1.57|M1III|",
"23:49:44.7|-62:50:22|-1||6.59|1.48|K5III|",
"23:56:27.7|83:11:28|-1||6.59|0.05|A3V|",
"1:6:26.5|-35:39:39|-1||6.61|0.14|A1V|",
"1:16:24.5|48:4:56|-1||6.61|-0.05|B9IIIpSi|",
"4:53:55.8|1:34:10|-1||6.61|0.04|A1Vn|",
"5:4:36.9|32:19:13|-1||6.62|0.27|A4m|",
"5:20:2.3|44:25:32|-1||6.62|0.0|K0|",
"5:47:58.1|-40:39:9|-1||6.61|1.12|K1III|",
"6:12:44.4|-2:30:16|-1||6.62|0.05|A2V|",
"6:46:3.3|-39:32:24|-1||6.62|-0.13|B6Vnne|",
"6:57:14.8|-22:12:12|-1||6.61|-0.19|B1-2III:|",
"7:7:0.1|-26:39:28|-1||6.62|-0.17|B2IV-V|",
"7:20:53.2|-22:51:6|-1||6.61|-0.15|B2.5V|",
"7:31:42.8|-35:53:16|-1||6.61|-0.08|A0V|",
"8:0:19.6|-45:27:25|-1||6.61|1.27|K1Ib-II|",
"8:27:53.5|-26:7:57|-1||6.62|0.11|A2IV-V|",
"9:19:33.7|-11:18:51|-1||6.62|0.08|A2Vs|",
"10:49:17.3|-4:1:27|76|40|6.61|0.22|A2IV|",
"11:57:14.6|40:20:37|-1||6.62|0.46|F6V|",
"12:11:2.9|-45:25:22|-1||6.61|1.08|K0III|",
"12:56:30.1|-26:27:37|-1||6.62|0.68|F3Ia|",
"13:18:51.1|3:41:16|-1||6.62|0.06|A1IV|",
"14:25:29.8|-19:58:11|-1||6.61|0.14|A2V|",
"15:2:44.9|-3:1:53|-1||6.61|0.2|A5m|",
"16:16:58.8|-21:18:14|-1||6.61|0.02|B9V|",
"18:8:54.1|-25:28:21|-1||6.61|0.02|B3III|",
"18:49:17.2|-34:44:55|-1||6.62|1.08|K1IVCNIII|",
"18:50:50.5|-22:9:44|71|30|6.61|0.38|A7III|",
"18:58:20.5|-24:52:36|-1||6.62|0.08|A0|",
"19:29:21.5|-7:2:38|-1||6.61|1.1|F7-G1I-II|",
"19:33:36.4|38:45:44|-1||6.61|0.03|A3Vn|",
"19:39:55.7|-39:26:0|-1||6.61|0.23|A2m|",
"19:46:39.5|25:8:2|-1||6.62|0.27|A7IV|",
"21:28:13.9|-11:34:6|-1||6.61|0.49|F3V|",
"22:22:43.9|-45:56:52|38|π1|6.62|2.01|S5,7e|",
"22:46:8.0|-48:58:44|-1||6.62|0.63|F9V|",
"23:21:58.2|26:36:32|-1||6.62|0.37|F5V|",
"0:10:38.6|-73:13:28|-1||6.64|0.37|F2V+F6V|",
"1:41:41.1|-50:2:20|-1||6.64|0.12|A3V|",
"2:19:37.3|39:50:6|-1||6.63|-0.09|B8V|",
"5:54:11.9|-64:28:56|-1||6.63|0.38|F0III|",
"5:59:37.7|-1:26:40|-1||6.63|-0.07|B8IIIn|",
"6:15:47.0|4:17:1|-1||6.64|-0.17|B3IV|",
"6:16:21.2|1:4:49|-1||6.63|-0.05|B6V|",
"6:15:5.9|-71:42:10|-1||6.64|0.56|F8V|",
"7:1:41.4|4:49:5|-1||6.63|0.06|A3Vs|",
"8:41:1.6|-9:3:7|-1||6.63|-0.02|A1Vn|",
"8:55:22.9|17:13:53|-1||6.64|3.36|C6II|",
"11:12:44.5|54:53:39|-1||6.63|0.0|A4V|",
"13:27:18.3|-74:41:31|55|ι2|6.63|-0.06|B9V|",
"14:27:27.3|41:1:30|-1||6.63|0.37|F1IV|",
"14:57:1.4|-51:26:49|-1||6.64|1.7|M2III|",
"16:24:39.6|-29:42:12|-1||6.63|0.59|G0IV|",
"18:7:48.4|13:4:16|-1||6.63|0.07|A2Vn|",
"18:17:4.8|1:0:21|-1||6.63|0.31|F2V|",
"18:18:7.7|23:17:48|-1||6.63|0.0|K5|",
"18:29:16.8|-38:51:4|-1||6.63|-0.02|B8|",
"18:49:44.0|31:37:45|-1||6.64|0.02|A0Vs|",
"18:52:41.7|-30:44:3|-1||6.63|-0.05|B8V|",
"18:56:3.9|17:59:42|-1||6.63|-0.04|B9pSi|",
"19:23:8.2|14:55:16|-1||6.64|0.27|F1V|",
"19:40:39.7|23:43:3|-1||6.64|0.01|B6IV|",
"20:20:26.1|-6:21:42|-1||6.63|1.55|K5|",
"20:56:12.9|51:4:30|-1||6.63|-0.1|B5V|",
"21:2:12.6|-43:0:7|-1||6.64|0.68|G3IV+K0IV|",
"21:9:58.6|45:30:9|-1||6.63|-0.16|B4IVpe|",
"21:18:16.1|-75:20:48|-1||6.63|0.03|A1V|",
"21:22:46.9|38:38:3|-1||6.63|0.01|A1V|",
"3:16:11.3|-30:49:39|-1||6.65|-0.07|A0V|",
"5:4:13.0|73:45:50|-1||6.66|0.0|K0|",
"5:0:33.9|3:36:58|-1||6.66|-0.07|B9Vn|",
"5:15:47.0|-34:55:36|-1||6.66|0.15|A2III-IV|",
"5:38:47.1|-2:35:39|-1||6.65|-0.19|B2Vp|",
"6:6:51.9|-11:10:25|-1||6.66|-0.15|B3V|",
"6:25:18.4|1:30:4|-1||6.66|-0.04|B9V|",
"6:44:30.2|82:6:55|-1||6.65|0.17|A5V|",
"6:31:39.2|11:47:32|-1||6.65|-0.12|B6III|",
"6:40:49.3|-47:40:29|-1||6.65|1.58|M2III|",
"7:8:49.3|-24:2:39|-1||6.65|-0.19|B2V|",
"7:17:17.8|6:40:50|-1||6.65|-0.11|B8III|",
"7:30:42.4|-37:20:23|-1||6.65|0.63|G4V|",
"7:34:28.8|-26:7:0|-1||6.65|-0.01|A0V|",
"8:9:6.7|-30:19:21|-1||6.65|1.4|K5III|",
"9:27:38.4|-35:0:28|-1||6.65|0.2|A3|",
"10:17:50.6|71:3:38|-1||6.66|0.32|A7m|",
"10:21:2.0|2:17:23|76|23|6.66|-0.08|B2.5IV|",
"10:52:30.8|52:33:55|-1||6.65|0.0|gG8|",
"11:18:21.0|11:59:5|-1||6.66|0.07|A2V|",
"12:28:44.6|25:53:57|-1||6.65|0.22|Am(A2/A9V/F0)|",
"13:27:4.6|64:44:8|-1||6.66|0.37|F0|",
"13:51:4.5|34:46:21|-1||6.65|0.12|A5IV|",
"15:3:6.6|44:38:40|-1||6.65|0.46|F6IV|",
"16:8:34.4|-39:5:35|-1||6.65|-0.07|A0-3III|",
"16:14:40.8|33:51:30|26|17σ|6.66|0.0|G1V|",
"17:0:32.3|-45:27:6|-1||6.65|1.8|K4III|",
"17:12:54.4|0:21:7|-1||6.65|0.5|F6III|",
"17:19:24.5|-44:13:23|-1||6.65|0.2|B9.5V+A6III|",
"17:51:12.5|-30:33:26|-1||6.66|0.04|A0Vn|",
"18:38:19.1|-1:6:48|-1||6.66|0.42|F1IV-V|",
"19:0:19.0|40:41:3|-1||6.65|0.0|M4IIIa|",
"20:42:22.2|35:27:22|-1||6.66|-0.16|B2IV-Ve|",
"20:53:26.4|42:24:37|-1||6.66|-0.04|A1V|",
"20:59:50.8|16:49:27|-1||6.66|0.38|F4III|",
"22:0:39.3|62:29:17|-1||6.66|0.06|B0IV|",
"22:18:20.4|76:29:17|-1||6.66|0.0|A1Vn|",
"22:39:8.4|-52:41:32|-1||6.65|0.35|F1III|",
"23:7:18.1|46:4:5|-1||6.66|-0.05|B2V|",
"23:32:24.6|34:57:9|-1||6.65|-0.06|B8V|",
"0:32:34.5|27:34:50|-1||6.67|0.0|A2IV|",
"5:11:41.4|0:30:53|-1||6.67|-0.07|B9Vn|",
"6:15:57.2|-29:47:18|-1||6.67|1.55|K4III|",
"6:23:22.7|-4:41:14|-1||6.67|0.06|A2V|",
"7:31:25.8|-36:9:10|-1||6.68|-0.12|B4V|",
"8:28:53.3|-20:57:1|-1||6.67|-0.06|B8III|",
"8:55:29.6|-7:58:16|41|17|6.67|0.22|A2m|",
"9:24:22.5|36:35:13|-1||6.67|0.21|F0V|",
"10:47:38.0|-15:15:43|-1||6.67|-0.01|A0III|",
"11:15:57.8|12:50:41|-1||6.67|0.27|A9Vp|",
"11:17:43.0|-36:32:4|-1||6.68|0.98|G8-K0III|",
"13:16:25.5|-1:23:26|-1||6.68|0.31|F1IV|",
"13:33:0.7|-7:11:42|-1||6.68|1.28|M7IIIe|",
"15:5:47.7|-25:47:23|-1||6.67|-0.01|B8V|",
"15:12:43.5|19:17:9|-1||6.68|0.68|G5V|",
"17:45:58.5|39:19:21|-1||6.68|1.39|K3III+F7V|",
"17:50:3.3|48:23:39|39|88|6.68|-0.11|BepShell|",
"18:31:53.3|-19:7:30|-1||6.68|1.13|G1.5Ib|",
"19:18:0.8|31:1:20|-1||6.68|0.08|A3V|",
"19:36:8.0|11:9:0|-1||6.68|0.0|A3V|",
"19:34:39.9|48:9:53|-1||6.67|0.24|A9V|",
"21:10:32.0|22:27:17|-1||6.68|0.03|A1V|",
"23:3:57.3|-4:47:43|-1||6.68|0.58|F8V|",
"0:5:9.9|45:13:45|-1||6.7|0.07|A1Vn|",
"0:32:26.8|43:29:41|-1||6.7|-0.01|A1Vn|",
"0:39:57.9|-33:57:42|-1||6.69|0.51|F8V|",
"0:52:53.4|38:32:55|-1||6.69|0.02|A2V|",
"1:38:50.0|-25:1:19|-1||6.7|-0.08|B9Vn|",
"2:17:33.4|44:18:25|-1||6.7|0.0|M7-8Se|",
"4:43:35.1|-8:47:46|35|55|6.7|0.92|G8III|",
"5:35:17.3|-5:23:16|59|41θ1|6.7|0.09|B0.5Vp|",
"5:52:47.7|-38:31:33|-1||6.7|1.08|K1III|",
"5:53:57.4|-19:38:18|-1||6.69|0.1|A4V|",
"8:18:12.6|-37:22:27|-1||6.7|0.23|A0IV+G:|",
"8:29:27.6|-27:19:57|-1||6.7|-0.13|B4V|",
"8:30:29.6|-36:43:16|-1||6.69|1.95|M2Iab|",
"9:38:40.7|-39:36:51|-1||6.7|0.49|F5|",
"9:59:43.1|3:23:5|76|12|6.7|0.27|F0V|",
"10:3:41.4|-25:19:0|-1||6.7|0.0|A0III-IV|",
"14:13:27.7|51:47:16|8|17κ1|6.69|0.39|F1V|",
"16:25:47.7|18:53:33|-1||6.7|0.0|M7IIIe|",
"17:3:30.2|35:24:51|39|61|6.69|0.0|M4IIIab|",
"18:30:5.1|4:3:55|-1||6.69|0.11|B2V|",
"19:1:3.2|-37:3:39|-1||6.69|0.0|B9V|",
"19:1:22.6|20:50:1|-1||6.69|0.02|B2IV-V|",
"19:26:24.6|-14:33:4|-1||6.7|0.05|A1V|",
"20:54:22.3|40:42:11|-1||6.7|-0.07|B8Vnne|",
"21:32:27.1|23:23:40|-1||6.7|-0.09|B9pSiSrCr|",
"23:23:47.5|32:31:53|-1||6.69|0.45|F4Vw|",
"1:4:36.4|39:59:28|-1||6.72|0.31|F0Vn|",
"1:42:3.0|61:2:18|-1||6.71|-0.03|B8IIIpSi|",
"4:12:31.6|-44:22:6|-1||6.71|1.48|K3-4III|",
"4:48:33.8|-43:58:48|-1||6.72|0.95|G8III|",
"4:55:30.2|-25:43:40|-1||6.72|0.27|F0-2III|",
"5:53:19.1|20:17:57|-1||6.71|-0.07|B9V|",
"6:24:52.6|29:42:26|-1||6.71|-0.06|B8IIIn|",
"6:23:46.5|4:35:44|-1||6.72|0.45|F5V|",
"6:26:58.7|0:50:27|-1||6.71|0.04|A1Vn|",
"7:39:7.1|-18:40:45|-1||6.72|-0.1|B6Vn|",
"7:49:54.8|-60:3:4|-1||6.72|1.24|K0II|",
"7:56:26.8|56:30:16|-1||6.72|0.0|A2IV|",
"10:59:12.9|-81:33:22|-1||6.71|0.55|F7IV|",
"16:46:51.3|-25:31:43|72|25|6.71|1.18|gG6|",
"19:1:34.9|25:1:33|-1||6.72|0.0|K2|",
"20:4:1.2|-7:28:11|-1||6.72|0.35|F4III|",
"20:14:21.6|42:6:13|-1||6.71|-0.04|B9IV-V|",
"22:47:47.1|-38:13:19|-1||6.71|0.48|F4IV|",
"23:24:35.0|41:6:46|-1||6.72|0.06|B8III|",
"0:10:29.7|57:9:56|-1||6.74|-0.08|B7IV|",
"0:12:50.4|37:41:36|-1||6.73|-0.13|B2V|",
"1:17:24.1|31:44:41|-1||6.73|0.0|K0|",
"3:0:53.4|52:21:8|-1||6.74|0.0|B9V|",
"5:35:15.9|-5:23:14|59|41θ1|6.73|0.02|B0.5V|",
"8:26:50.8|-29:12:55|-1||6.73|-0.05|B9.5V|",
"9:3:8.8|-25:30:16|-1||6.74|-0.03|B8|",
"9:7:14.7|-51:12:43|-1||6.73|1.62|K4III|",
"15:36:4.1|52:4:11|-1||6.74|0.32|F4IIIp|",
"18:3:1.7|-22:43:6|-1||6.74|-0.05|B0.5III|",
"18:14:24.1|-70:45:5|-1||6.73|-0.03|B7-8II-III|",
"18:25:8.8|5:5:5|-1||6.74|0.02|B9V|",
"19:4:10.7|3:19:50|-1||6.73|0.13|A5m|",
"19:9:4.4|34:36:2|-1||6.74|0.63|G1V|",
"19:12:34.4|16:50:47|-1||6.73|-0.01|B9IV|",
"20:29:52.5|-18:35:12|15|12ο|6.74|0.22|A7V|",
"22:49:40.9|-77:3:2|-1||6.73|0.11|A4V|",
"23:3:23.7|60:26:43|-1||6.74|-0.02|B2V|",
"3:34:24.7|-65:45:52|-1||6.75|0.17|A3V|",
"5:29:6.7|-30:7:0|-1||6.75|1.06|G8/K0III|",
"5:35:2.4|-58:52:16|-1||6.75|1.45|K4III|",
"6:17:35.2|-10:43:31|54|6|6.75|0.35|F0DelDel|",
"12:50:12.0|-60:24:3|-1||6.75|0.35|A3II|",
"18:49:35.5|-19:8:32|-1||6.75|0.2|A1m|",
"18:59:17.5|10:8:27|-1||6.75|0.25|B2Vp|",
"19:12:4.6|49:51:15|-1||6.75|0.65|G4V|",
"0:16:49.0|-78:46:50|-1||6.77|0.46|F3III|",
"2:29:55.4|-22:40:58|-1||6.77|0.19|A9V|",
"2:33:33.6|-62:35:13|-1||6.77|-0.06|B9V|",
"4:22:50.9|-82:53:57|-1||6.76|0.2|A7IV-V|",
"7:26:3.5|-4:32:15|-1||6.76|-0.01|A0IV|",
"7:33:58.5|-39:54:21|-1||6.76|1.13|K2III|",
"7:40:43.4|-27:56:45|-1||6.76|-0.16|B3-5IV-V:|",
"9:33:7.2|49:26:19|-1||6.76|0.0|A4V|",
"9:35:22.4|39:57:48|-1||6.76|0.35|F2V|",
"11:6:38.7|-28:43:40|-1||6.77|0.04|A1V|",
"11:58:20.6|61:27:53|-1||6.76|0.0|K0III|",
"17:40:36.2|57:18:37|-1||6.77|0.92|K0|",
"18:2:46.3|-5:21:31|-1||6.76|0.16|B9V|",
"21:14:16.7|-10:36:19|-1||6.77|-0.08|B9pHgMn|",
"22:23:41.3|78:14:36|-1||6.76|-0.06|B9|",
"1:57:56.4|41:41:40|-1||6.78|-0.06|B8III|",
"4:29:42.9|10:31:18|-1||6.79|0.09|B5V|",
"7:3:58.8|-43:36:42|-1||6.79|0.8|K0V|",
"7:56:24.3|-40:44:11|-1||6.78|-0.18|B2V|",
"11:58:20.3|-40:56:50|-1||6.79|0.97|K1III|",
"3:5:26.7|25:15:19|6|52|6.8|-0.02|B7V|",
"13:28:11.7|50:35:14|-1||6.8|0.0|F1IV|",
"17:18:0.5|-24:17:3|58|39ο|6.8|0.51|F6IV-V|",
"18:50:20.0|-7:54:27|-1||6.8|3.09|C5II|",
"23:13:15.0|-49:37:8|-1||6.8|0.92|G8-K0III|",
"3:51:36.6|22:1:54|-1||6.83|0.0|K0III|",
"4:43:34.6|-8:47:37|35|55|6.82|0.39|F4IIIpSr|",
"5:23:39.0|-37:20:12|-1||6.82|1.04|K1III|",
"6:11:36.5|48:42:47|7|41|6.82|0.0|A8V|",
"8:31:54.6|9:48:52|-1||6.83|-0.07|B9p:Hg:|",
"9:20:44.2|-31:45:38|-1||6.82|0.0|B9.5V|",
"9:44:15.8|-39:34:16|-1||6.82|0.3|F2-3V|",
"19:44:48.7|29:15:53|-1||6.82|0.64|F2I|",
"23:55:16.6|-31:53:3|-1||6.83|-0.08|B8V|",
"0:38:40.8|-73:8:14|-1||6.85|0.11|A1m|",
"1:0:3.4|44:42:40|-1||6.84|0.0|A2Vn|",
"1:38:48.2|-53:26:20|-1||6.84|0.44|F5IV-V|",
"2:45:16.5|-46:17:14|-1||6.85|1.36|K2III|",
"5:32:0.5|0:17:4|59|34δ|6.85|-0.16|B2V|",
"7:24:47.3|-37:17:27|-1||6.84|0.27|F0V:|",
"13:35:14.1|44:11:49|-1||6.84|0.2|A7-F0III|",
"18:18:43.3|-18:37:10|-1||6.84|0.31|B0Ib|",
"3:50:37.6|-36:25:31|-1||6.86|-0.04|B9.5V|",
"4:45:49.6|-34:0:18|-1||6.86|0.0|A0V|",
"14:18:55.7|38:46:3|-1||6.86|1.06|G9IV|",
"14:23:22.6|8:26:42|-1||6.86|0.43|F0V+F2V|",
"7:14:26.6|24:42:39|-1||6.89|-0.03|A1pSrCr|",
"7:43:7.0|-38:51:51|-1||6.89|1.02|G6/8III|",
"7:45:28.7|-14:41:10|67|2|6.89|0.0|A8V|",
"11:10:54.7|-58:27:19|-1||6.88|-0.08|B7III|",
"21:52:18.2|21:16:23|-1||6.89|0.0|M4III|",
"23:47:23.3|-68:23:39|-1||6.89|0.46|F2V|",
"0:51:52.1|-43:42:33|-1||6.9|0.35|F2V+F5V|",
"2:47:56.0|-12:27:38|-1||6.9|1.56|M4III|",
"6:54:13.0|-23:55:42|-1||6.91|-0.28|WN5-B|",
"8:55:29.5|-7:58:13|41|17|6.91|0.0|A7m|",
"19:4:24.2|-5:41:6|-1||6.9|4.19|C5II|",
"4:15:25.8|6:11:59|-1||6.93|0.7|G5IV|",
"6:15:39.0|36:8:55|-1||6.92|0.45|F4IV|",
"14:32:32.9|-56:53:16|-1||6.93|0.91|F5Ia|",
"16:40:35.1|4:12:26|39|36|6.93|0.13|A3IV|",
"20:12:3.8|47:44:13|-1||6.92|-0.12|B7V|",
"5:45:39.4|20:41:42|-1||6.95|3.03|C5II|",
"6:5:45.7|-24:11:44|-1||6.95|1.63|M6III|",
"7:24:47.2|-37:17:24|-1||6.97|0.22|F0V:|",
"4:7:51.1|62:19:48|-1||6.99|0.42|B0III|",
"5:13:46.5|-35:49:32|-1||6.98|1.47|K4III|",
"12:18:9.1|-3:57:16|-1||6.99|0.36|F3V|",
"21:58:12.7|82:52:11|-1||6.98|0.52|F6IV-V|",
"0:49:52.8|27:42:39|65|65|7.0|0.36|F4III|",
"3:5:26.7|25:15:19|6|52|7.0|0.0|B7V|",
"9:30:45.4|-31:53:29|1|ζ1|7.0|0.09|A2V|",
"15:33:9.1|-24:29:22|-1||7.0|0.27|A3+F0V:|",
"4:3:36.8|-20:9:30|-1||7.01|1.22|K2II|",
"8:26:39.8|24:32:3|11|24|7.02|0.32|F0III|",
"5:0:32.6|3:36:55|-1||7.03|0.0|B9Vn|",
"6:18:46.8|-50:21:33|-1||7.04|0.83|G2Ib|",
"6:50:6.0|-27:20:2|-1||7.04|-0.18|B2IV|",
"11:55:11.2|46:28:11|82|65|7.03|0.01|A1pCrEuSr:|",
"13:27:10.7|64:43:10|-1||7.04|0.39|F0|",
"15:25:6.6|-38:10:10|-1||7.03|0.09|A2V|",
"17:59:5.5|-30:15:12|-1||7.04|1.06|G8II|",
"18:5:43.3|12:0:14|-1||7.04|0.3|A3IV|",
"16:8:34.2|-39:6:19|-1||7.05|0.36|A7IVe|",
"21:18:15.7|-17:27:44|15|31|7.05|0.34|F2V|",
"10:31:51.0|-81:55:16|-1||7.07|-0.08|B5III-IV|",
"12:38:30.0|6:59:18|-1||7.08|1.44|M4.5IIIe|",
"0:49:53.2|27:42:37|65|65|7.1|0.0|F5III|",
"2:36:57.7|24:38:54|6|30|7.09|0.5|F4V|",
"22:3:17.2|-29:54:15|-1||7.1|0.32|F0IIIn|",
"0:2:7.3|-14:40:34|-1||7.1|1.8|S7.3e|",
"14:28:33.3|28:17:27|-1||7.12|-0.03|A1V|",
"20:31:13.0|11:15:38|-1||7.11|0.03|B8V|",
"7:28:51.5|-31:50:49|-1||7.13|-0.15|B4V|",
"8:16:33.9|11:43:35|-1||7.13|1.56|M7IIIe|",
"12:20:41.3|27:3:17|-1||7.13|0.36|F3V+F3V|",
"19:36:37.7|20:19:58|-1||7.14|1.32|F2-F8Iab|",
"7:35:21.7|-74:16:32|-1||7.16|-0.02|B9IV|",
"18:51:57.9|-83:18:59|-1||7.16|1.26|K1IIICNII:|",
"5:6:22.0|54:24:21|-1||7.24|0.0|G5|",
"1:5:51.4|4:54:34|65|77|7.25|0.49|F6V|",
"8:26:18.2|-39:3:37|-1||7.25|0.08|A2V:|",
"8:35:51.3|6:37:21|-1||7.25|0.71|G5V|",
"7:35:21.8|-74:16:32|-1||7.26|0.0|B9IV|",
"18:54:14.3|41:13:32|-1||7.3|0.0|F5|",
"21:4:4.6|-5:49:24|3|12|7.31|0.0|A3V|",
"0:4:30.7|-72:53:52|-1||7.31|0.44|F2V|",
"21:9:32.0|68:29:25|-1||7.33|1.49|M7IIIe|",
"0:24:2.0|38:34:38|-1||7.39|1.97|S6.5IIIeZr6Ti2|",
"15:11:31.9|-45:16:46|-1||7.39|1.08|K0III|",
"13:48:57.2|39:32:34|-1||7.4|0.0|M6IIIe|",
"23:35:12.7|-64:41:22|-1||7.4|0.0|F2IV-V|",
"17:16:48.6|49:41:28|-1||7.48|0.0|K2|",
"14:28:31.5|28:17:21|-1||7.62|-0.01|A1V|",
"7:7:21.4|22:42:13|-1||7.68|2.21|S3.9e|",
"4:59:36.5|-14:48:21|-1||7.71|5.74|C6IIe|",
"8:26:40.1|24:32:7|11|24|7.81|0.52|F7V|",
"1:16:12.1|71:44:38|-1||7.83|0.78|K1V|",
"5:35:16.1|-5:23:7|59|41θ1|7.96|0.24|B0V|"};
*/
}